const receiptPreferences = createReceiptPreferencesController();

function createReceiptPreferencesController(){
    const timeout = 20 * 60 * 1000;
    const selector = '#firmante_cobro, #metodo_cobro, #moneda_cobro, #firmante_pago, #metodo_pago, #moneda_pago';
    let deadline = null;
    let timer = null;

    function recordActivity(){
        deadline = Date.now() + timeout;
        clearTimeout(timer);
        timer = setTimeout(checkExpiry, timeout);
    }

    function checkExpiry(){
        if(deadline === null || Date.now() < deadline){
            return;
        }
        // Keep the submitted selections intact while a receipt is being processed.
        if(document.querySelector('.cont_loader_cobros.loading, .cont_loader_pagos.loading')){
            clearTimeout(timer);
            timer = setTimeout(checkExpiry, 1000);
            return;
        }
        deadline = null;
        clearTimeout(timer);
        const selects = document.querySelectorAll(selector);
        selects.forEach(select => { select.value = ''; });
        selects.forEach(select => { select.dispatchEvent(new Event('change')); });
    }

    function validate(panel){
        checkExpiry();
        const fields = [
            ['.panel_firmante select', 'el firmante'],
            ['.cont_monedas select', 'la moneda'],
            ['.cont_metodos select', 'el metodo de pago']
        ];
        const missing = fields.filter(([selector]) => {
            const select = panel.querySelector(selector);
            return !select || !select.value;
        });
        if(missing.length){
            showAlert('error', 'Selecciona ' + missing.map(([,label]) => label).join(', ') + ' antes de generar el comprobante');
            return false;
        }
        return true;
    }

    function init(){
        recordActivity();
        document.addEventListener('change', event => {
            if(deadline === null && event.target.matches(selector) && event.target.value){
                recordActivity();
            }
        }, true);
        window.addEventListener('focus', checkExpiry);
        document.addEventListener('visibilitychange', checkExpiry);
        document.addEventListener('click', checkExpiry, true);
    }

    return {init, validate, recordActivity};
}

document.addEventListener('DOMContentLoaded',function(){
    receiptPreferences.init();
    darkMode();
    seePasswordConfig();
    seePasswordLogin();
    loginModalLanding();
    menuSeccionesLanding();
    simuladorLanding();
    initPanelInformes();
    switchPanels();
    initCobrosPanelSkeleton();
    switchPanelsConfig();
    switchPanelCuota();
    listenImportMembersButtom();
    showMemberForms();
    showCampaForms();
    initCampVerificationPanel();
    showEventsForms();
    showRamasActions();
    createMemberByForm();
    editMemberByForm();
    deleteMemberByForm();
    confirmMemberByForm();
    tableSearchMembers();
    tableSearchCamps();
    tableSearchEvents();
    loaderMembersForm();
    createCampByForm();
    editCampByForm();
    deleteCampByForm();
    createEventByForm();
    editEventByForm();
    deleteEventByForm();
    createRamaInTable();
    editRamaInTable();
    deleteRamaInTable();
    createMontoInTable();
    createCategoryInTable();
    createSignerInTable();
    sortMembersList();
    sortCampsList();
    sortEventList();
    addRamaSettingForm();
    initPanelCobros();
    // dynamicPanelPagos();
    completePagosDetail();
    initRemainingCustomSelects();
    saveUserSettings();
    saveNewPassword();
    dynamicReceiptConfigTable();
    initReceiptPaymentTooltip();
    dynamicZClosureConfigTable();
    dynamicReceiptReport();
    dynamicMonthlyFee();
    dynamicPaymentMethodList();
    dynamicCurrencyList();
    dynamicPeriodChange();
    openDebtReviewScreenOptimized();
    createAdminUser();
    listenCashClosing();
    callOpenReceiptWindow();
    performZClosure();
    syncRamaNameOverflowMarquee();
    syncMontoNameOverflowMarquee();
    syncCategoryNameOverflowMarquee();
    syncCobrosGeneralLegendOverflowMarquee();
    syncCobrosEventLegendOverflowMarquee();
    window.addEventListener('resize', () => syncRamaNameOverflowMarquee());
    window.addEventListener('resize', () => syncMontoNameOverflowMarquee());
    window.addEventListener('resize', () => syncCategoryNameOverflowMarquee());
    window.addEventListener('resize', () => syncCobrosGeneralLegendOverflowMarquee());
    window.addEventListener('resize', () => syncCobrosEventLegendOverflowMarquee());
})

function initRemainingCustomSelects(scope = document){
    const selects = scope.querySelectorAll(`
        .form_miembro_indv:not(.delete) select.opcion_ramas,
        .form_cierre_caja select#firma_cierre,
        .panel_config select#select_mes_recibo,
        .panel_config select#select_mes_cierre
    `);

    selects.forEach((select)=>initAppCustomSelect(select));
}

function initAppCustomSelect(select){
    if(!select || select.dataset.customSelectReady === 'true'){
        return;
    }
    select.dataset.customSelectReady = 'true';

    const wrapper = select.parentElement;
    if(!wrapper){
        return;
    }
    wrapper.classList.add('custom_select_ready','custom_select_app_wrapper');

    const customSelect = document.createElement('div');
    customSelect.className = 'custom_select_app';
    customSelect.innerHTML = `
        <button type="button" class="custom_select_app_btn"></button>
        <div class="custom_select_app_list"></div>
    `;
    wrapper.appendChild(customSelect);

    const button = customSelect.querySelector('.custom_select_app_btn');
    button.addEventListener('click',(event)=>{
        event.stopPropagation();
        closeOtherAppCustomSelects(customSelect);
        customSelect.classList.toggle('open');
    })

    select.addEventListener('change',()=>{
        syncAppCustomSelect(select);
    })

    syncAppCustomSelect(select);
}

function syncAppCustomSelect(select){
    if(!select || select.dataset.customSelectReady !== 'true'){
        return;
    }
    const wrapper = select.parentElement;
    const customSelect = wrapper ? wrapper.querySelector('.custom_select_app') : null;
    if(!customSelect){
        return;
    }

    const button = customSelect.querySelector('.custom_select_app_btn');
    const list = customSelect.querySelector('.custom_select_app_list');
    const selected = select.options[select.selectedIndex];
    button.textContent = selected ? selected.textContent : '-';
    list.innerHTML = '';

    Array.from(select.options).forEach((option)=>{
        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'custom_select_app_option';
        item.classList.toggle('active', option.value === select.value);
        item.dataset.value = option.value;
        item.textContent = option.textContent;
        item.addEventListener('click',(event)=>{
            event.stopPropagation();
            select.value = option.value;
            customSelect.classList.remove('open');
            select.dispatchEvent(new Event('change'));
        })
        list.appendChild(item);
    })
}

function closeOtherAppCustomSelects(currentSelect){
    document.querySelectorAll('.custom_select_app.open').forEach((customSelect)=>{
        if(customSelect !== currentSelect){
            customSelect.classList.remove('open');
        }
    })
}

document.addEventListener('click',()=>{
    document.querySelectorAll('.custom_select_app.open').forEach((customSelect)=>{
        customSelect.classList.remove('open');
    })
})

function initReceiptPaymentTooltip(){
    const panelRecibos = document.querySelector('.panel_config .config_recibos');
    if(!panelRecibos){
        return;
    }

    const tooltip = document.createElement('div');
    tooltip.className = 'metodo_pago_tooltip_floating';
    tooltip.setAttribute('role', 'tooltip');
    document.body.appendChild(tooltip);

    let activeTrigger = null;

    const getTrigger = (target) => {
        if(!target || typeof target.closest !== 'function'){
            return null;
        }

        const trigger = target.closest('.campo_total p');
        if(!trigger || !panelRecibos.contains(trigger)){
            return null;
        }

        return trigger.querySelector('.metodo_pago_tooltip') ? trigger : null;
    };

    const positionTooltip = () => {
        if(!activeTrigger){
            return;
        }

        const rect = activeTrigger.getBoundingClientRect();
        const spacing = 9;
        const tooltipWidth = tooltip.offsetWidth;
        const tooltipHeight = tooltip.offsetHeight;
        let top = rect.top - tooltipHeight - spacing;
        let placement = 'top';

        if(top < 8){
            top = rect.bottom + spacing;
            placement = 'bottom';
        }

        const left = Math.min(
            Math.max(rect.left + (rect.width / 2), (tooltipWidth / 2) + 8),
            window.innerWidth - (tooltipWidth / 2) - 8
        );

        tooltip.dataset.placement = placement;
        tooltip.style.left = `${left}px`;
        tooltip.style.top = `${top}px`;
    };

    const showTooltip = (trigger) => {
        const sourceTooltip = trigger.querySelector('.metodo_pago_tooltip');
        const text = sourceTooltip ? sourceTooltip.textContent.trim() : '';
        if(text === ''){
            return;
        }

        activeTrigger = trigger;
        tooltip.textContent = text;
        tooltip.classList.add('visible');
        positionTooltip();
    };

    const hideTooltip = () => {
        activeTrigger = null;
        tooltip.classList.remove('visible');
    };

    panelRecibos.addEventListener('mouseover', (event) => {
        const trigger = getTrigger(event.target);
        if(trigger){
            showTooltip(trigger);
        }
    });

    panelRecibos.addEventListener('mouseout', (event) => {
        const trigger = getTrigger(event.target);
        if(trigger && !trigger.contains(event.relatedTarget)){
            hideTooltip();
        }
    });

    panelRecibos.addEventListener('focusin', (event) => {
        const trigger = getTrigger(event.target);
        if(trigger){
            showTooltip(trigger);
        }
    });

    panelRecibos.addEventListener('focusout', (event) => {
        const trigger = getTrigger(event.target);
        if(trigger && !trigger.contains(event.relatedTarget)){
            hideTooltip();
        }
    });

    window.addEventListener('resize', positionTooltip);
    document.addEventListener('scroll', positionTooltip, true);
}

function seePasswordConfig(){
    const eye = document.querySelector('#seePassConfig');
    if(eye){
        const newPass = document.querySelector('#newPass');
        const oldPass = document.querySelector('#oldPass');

        eye.addEventListener('click',()=>{
            const typeNew = newPass.getAttribute('type') === 'password' ? 'text' : 'password';
            newPass.setAttribute('type', typeNew);
            const typeOld = oldPass.getAttribute('type') === 'password' ? 'text' : 'password';
            oldPass.setAttribute('type', typeOld);

            if(eye.classList.contains('fa-eye-slash')){
                eye.classList.add('fa-eye');
                eye.classList.remove('fa-eye-slash');
            }else{
                eye.classList.remove('fa-eye');
                eye.classList.add('fa-eye-slash');
            }
        })
    }

}

function seePasswordLogin(){
    const eye = document.querySelector('#seePassLogin');
    if(eye){
        const passWord = document.querySelector('.login__input.password');

        //console.log(passWord)
        eye.addEventListener('click',()=>{
            const typeNew = passWord.getAttribute('type') === 'password' ? 'text' : 'password';
            //console.log(typeNew)
            passWord.setAttribute('type', typeNew);

            if(eye.classList.contains('fa-eye-slash')){
                eye.classList.add('fa-eye');
                eye.classList.remove('fa-eye-slash');
            }else{
                eye.classList.remove('fa-eye');
                eye.classList.add('fa-eye-slash');
            }
        })
    }

}

function loginModalLanding(){
    const modal = document.querySelector('#loginModal');
    if(!modal) return;

    const form = modal.querySelector('#loginModalForm');
    const errorMsg = modal.querySelector('.login_modal__error');
    const submitBtn = form.querySelector('.login__button');
    let lastTrigger = null;

    const showError = (msg) => {
        errorMsg.textContent = msg;
        errorMsg.hidden = !msg;
    };

    const openModal = (trigger) => {
        lastTrigger = trigger;
        showError('');
        modal.classList.add('login_modal--open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('login_modal_abierto');
        setTimeout(() => form.querySelector('input[name="user"]').focus(), 50);
    };

    const closeModal = () => {
        modal.classList.remove('login_modal--open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('login_modal_abierto');
        if(lastTrigger) lastTrigger.focus();
    };

    document.querySelectorAll('[data-login-modal]').forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            openModal(link);
        });
    });

    modal.querySelectorAll('[data-login-modal-close]').forEach(el => {
        el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (e) => {
        if(e.key === 'Escape' && modal.classList.contains('login_modal--open')) closeModal();
    });

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        showError('');
        submitBtn.disabled = true;
        submitBtn.value = 'Ingresando...';

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                credentials: 'same-origin'
            });
            const data = await response.json();

            if(data.ok){
                window.location.href = data.redirect || '/';
                return;
            }
            showError((data.errores || []).join(' ') || 'No se pudo iniciar sesión.');
        } catch (error) {
            showError('No se pudo conectar con el servidor. Intentá nuevamente.');
        }

        submitBtn.disabled = false;
        submitBtn.value = 'Iniciar Sesión';
    });
}

// LANDING: marca en el menú la sección que se está viendo
function menuSeccionesLanding(){
    const tabs = document.querySelectorAll('.landing__menu .landing__tab');
    if(!tabs.length || !('IntersectionObserver' in window)) return;

    const tabsById = {};
    tabs.forEach(tab => { tabsById[tab.getAttribute('href').slice(1)] = tab; });

    const marcar = (id) => {
        tabs.forEach(tab => {
            const activo = tab === tabsById[id];
            tab.classList.toggle('activado', activo);
            if(activo){
                tab.setAttribute('aria-current', 'true');
                // En celular el menú se desliza: mantener visible la pestaña activa
                const cont = tab.parentElement;
                cont.scrollTo({ left: tab.offsetLeft - (cont.clientWidth - tab.offsetWidth) / 2, behavior: 'smooth' });
            } else {
                tab.removeAttribute('aria-current');
            }
        });
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => { if(entry.isIntersecting) marcar(entry.target.id); });
    }, { rootMargin: '-45% 0px -50% 0px' });

    Object.keys(tabsById).forEach(id => {
        const seccion = document.getElementById(id);
        if(seccion) observer.observe(seccion);
    });

    // Al volver al hero no queda ninguna pestaña activa
    const hero = document.getElementById('inicio');
    if(hero){
        new IntersectionObserver((entries) => {
            if(entries[0].isIntersecting) marcar(null);
        }, { rootMargin: '-45% 0px -50% 0px' }).observe(hero);
    }
}

// LANDING: simulador de cobro con datos de ejemplo (no guarda nada)
function simuladorLanding(){
    const root = document.querySelector('#simuladorLanding');
    if(!root) return;

    const MESES = ['Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
    const NOMBRES = ['Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
    const CUOTA = 3000;
    const CIERRE_ANTERIOR = 158900;
    // Mes actual dentro del año scout (marzo = 0); fuera del año se toma como diciembre
    const hoy = new Date();
    const ACTUAL = Math.min(Math.max(hoy.getMonth() - 2, 0), MESES.length - 1);
    const FECHA = hoy.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    const MIEMBROS = [
        { id: 'bruno', nombre: 'Bruno Ibáñez', rama: 'Castores', clase: 'cas' },
        { id: 'juana', nombre: 'Juana Ríos', rama: 'Manada', clase: 'man' },
        { id: 'lucia', nombre: 'Lucía Ferreyra', rama: 'Unidad', clase: 'uni' },
        { id: 'tomas', nombre: 'Tomás Acosta', rama: 'Caminantes', clase: 'cam' }
    ];
    const FIRMAS = ['Jefe/a de Grupo', 'Tesorero/a', 'Coordinador/a de Zona'];
    const EGRESOS = [
        { concepto: 'Compra de materiales', monto: 4500 },
        { concepto: 'Fotocopias de autorizaciones', monto: 1800 },
        { concepto: 'Garrafa para el campamento', monto: 9200 }
    ];

    const esc = (value) => String(value ?? '')
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    const money = (n) => `$ ${n.toLocaleString('es-AR')}`;
    const rango = (n) => Array.from({ length: n }, (_, i) => i);
    const hora = () => new Date().toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' });

    const inicial = () => ({
        tab: 'cobros',
        miembro: 'bruno',
        tocado: false,
        // Cuotas pagas de cada miembro, relativas al mes actual para que siempre haya deuda que mostrar
        pagos: {
            bruno: rango(Math.max(ACTUAL - 4, 1)),
            juana: rango(Math.max(ACTUAL - 1, 1)),
            lucia: rango(ACTUAL + 1),
            tomas: rango(Math.max(ACTUAL - 2, 1))
        },
        sel: [],
        metodo: 'Efectivo',
        firma: FIRMAS[0],
        movs: [
            { hora: '18:05', concepto: `Cuota ${NOMBRES[ACTUAL]} · Lucía Ferreyra`, metodo: 'Transferencia', tipo: 'ingreso', monto: CUOTA },
            { hora: '18:20', concepto: EGRESOS[0].concepto, metodo: 'Efectivo', tipo: 'egreso', monto: EGRESOS[0].monto }
        ],
        recibo: null,
        nro: 1248,
        egresoN: 1,
        vioCaja: false
    });

    let s = inicial();

    const deuda = (id) => rango(ACTUAL + 1).filter(i => !s.pagos[id].includes(i)).length;
    const claseEstado = (d) => d === 0 ? 'ok' : (d <= 2 ? 'debe' : 'alerta');

    const tab = (accion, valor, label, activo, extra = '') =>
        `<button type="button" class="simulador__tab ${extra} ${activo ? 'activado' : ''}" data-accion="${accion}" data-valor="${esc(valor)}" aria-pressed="${activo}">${esc(label)}</button>`;

    const total = (leyenda, valor, color) =>
        `<div class="landing__total"><p class="leyenda">${leyenda}</p><p class="total total--${color}">${valor}</p></div>`;

    const vistaCobros = () => {
        const m = MIEMBROS.find(x => x.id === s.miembro);
        const pagos = s.pagos[m.id];

        const miembros = MIEMBROS.map(x => {
            const d = deuda(x.id);
            const activo = x.id === s.miembro;
            return `
                <button type="button" class="simulador__miembro ${activo ? 'activado' : ''}" data-accion="miembro" data-valor="${x.id}" aria-pressed="${activo}">
                    <span class="simulador__miembro-info">
                        <span class="landing__punto ${x.clase}"></span>
                        <span><strong>${esc(x.nombre)}</strong><small>${esc(x.rama)}</small></span>
                    </span>
                    <span class="simulador__estado ${claseEstado(d)}">${d === 0 ? 'Al día' : `Debe ${d}`}</span>
                </button>`;
        }).join('');

        const meses = MESES.map((label, i) => {
            const pagado = pagos.includes(i);
            const sel = s.sel.includes(i);
            const debe = !pagado && i <= ACTUAL;
            const clase = pagado ? 'pago' : (debe ? 'debe' : 'futuro');
            const estado = pagado ? 'Pagó' : (sel ? 'A cobrar' : (debe ? 'Debe' : 'Próxima'));
            return `
                <button type="button" class="simulador__mes ${clase} ${sel ? 'seleccionado' : ''}" data-accion="mes" data-valor="${i}" aria-pressed="${sel}" ${pagado ? 'disabled' : ''} aria-label="${NOMBRES[i]}: ${estado}">
                    <strong>${label}</strong><small>${estado}</small>
                </button>`;
        }).join('');

        return `
            <div class="simulador__fila">
                <div class="simulador__bloque simulador__miembros">
                    <div class="simulador__bloque-cabecera"><p>Miembros</p></div>
                    <div class="simulador__lista">${miembros}</div>
                </div>
                <div class="simulador__columna">
                    <div class="simulador__bloque">
                        <div class="simulador__bloque-cabecera">
                            <p>Deuda de ${esc(m.nombre)}</p>
                            <span class="landing__rama ${m.clase}">${esc(m.rama)}</span>
                        </div>
                        <div class="landing__totales">
                            ${total('Total del año', money(MESES.length * CUOTA), 'azul')}
                            ${total('Pagado en el año', money(pagos.length * CUOTA), 'verde')}
                            ${total('Deuda actual', money(deuda(m.id) * CUOTA), 'rojo')}
                        </div>
                    </div>
                    <div class="simulador__bloque">
                        <div class="simulador__bloque-cabecera">
                            <p>Cuotas ${hoy.getFullYear()} · ${money(CUOTA)} por mes</p>
                            <span class="aclaracion">Tocá las cuotas que querés cobrar</span>
                        </div>
                        <div class="simulador__meses">${meses}</div>
                        <div class="simulador__leyenda">
                            <span class="pago">Pagó</span><span class="debe">Debe</span>
                            <span class="futuro">Próxima</span><span class="seleccionado">A cobrar</span>
                        </div>
                    </div>
                    <div class="simulador__bloque simulador__pago">
                        <div>
                            <span class="simulador__etiqueta">Método de pago</span>
                            <div class="simulador__metodos">
                                ${['Efectivo', 'Transferencia'].map(mp => tab('metodo', mp, mp, s.metodo === mp, 'simulador__tab--chico')).join('')}
                            </div>
                        </div>
                        <div>
                            <label class="simulador__etiqueta" for="simuladorFirma">Firma</label>
                            <select id="simuladorFirma" class="simulador__select" data-accion="firma">
                                ${FIRMAS.map(f => `<option value="${esc(f)}" ${f === s.firma ? 'selected' : ''}>${esc(f)}</option>`).join('')}
                            </select>
                        </div>
                        <div class="simulador__saldar landing__total">
                            <p class="leyenda">Importe a saldar</p>
                            <p class="total total--celeste">${money(s.sel.length * CUOTA)}</p>
                        </div>
                        <button type="button" class="boton_landing boton_landing--verde" data-accion="generar" ${s.sel.length ? '' : 'disabled'}>
                            <i class="fa-solid fa-check-to-slot"></i> Generar comprobante
                        </button>
                    </div>
                </div>
            </div>`;
    };

    const vistaCaja = () => {
        const ingresos = s.movs.filter(mv => mv.tipo === 'ingreso').reduce((acc, mv) => acc + mv.monto, 0);
        const egresos = s.movs.filter(mv => mv.tipo === 'egreso').reduce((acc, mv) => acc + mv.monto, 0);
        const filas = s.movs.slice().reverse().map(mv => `
            <tr>
                <td>${esc(mv.hora)}</td>
                <td>${esc(mv.concepto)}</td>
                <td>${esc(mv.metodo)}</td>
                <td class="monto ${mv.tipo}">${mv.tipo === 'ingreso' ? '+' : '−'} ${money(mv.monto)}</td>
            </tr>`).join('');

        return `
            <div class="simulador__bloque">
                <div class="simulador__bloque-cabecera"><p>Caja de hoy · ${FECHA}</p></div>
                <div class="landing__totales">
                    ${total('Ingresos', money(ingresos), 'verde')}
                    ${total('Egresos', money(egresos), 'azul')}
                    ${total('Cierre del día', money(ingresos - egresos), 'caja')}
                    ${total('Cierre anterior', money(CIERRE_ANTERIOR), 'gris')}
                    ${total('Caja total', money(CIERRE_ANTERIOR + ingresos - egresos), 'caja')}
                </div>
            </div>
            <div class="simulador__bloque">
                <div class="simulador__bloque-cabecera">
                    <p>Movimientos</p>
                    <button type="button" class="boton_landing boton_landing--azul" data-accion="egreso">
                        <i class="fa-solid fa-plus"></i> Registrar egreso de ejemplo
                    </button>
                </div>
                <div class="simulador__tabla-cont">
                    <table class="simulador__tabla">
                        <thead><tr><th>Hora</th><th>Concepto</th><th>Método</th><th class="monto">Monto</th></tr></thead>
                        <tbody>${filas}</tbody>
                    </table>
                </div>
            </div>`;
    };

    const vistaComprobante = () => {
        if(!s.recibo){
            return `
                <div class="simulador__bloque">
                    <p class="simulador__vacio">Todavía no generaste ningún cobro. Andá a Cobros, marcá una cuota y tocá «Generar comprobante».</p>
                </div>`;
        }
        const r = s.recibo;
        return `
            <div class="simulador__bloque">
                <div class="simulador__recibo">
                    <div class="simulador__recibo-top">
                        <span>DOCUMENTO NO VÁLIDO COMO FACTURA</span>
                        <span class="simulador__recibo-tipo">COBRO<small>COMPROBANTE</small></span>
                    </div>
                    <p class="simulador__recibo-org">GS 000 · Grupo Scout Ejemplo</p>
                    <p class="simulador__recibo-codigo">${esc(r.codigo)} · ${esc(r.fecha)}</p>
                    <p class="simulador__recibo-nombre">${esc(r.nombre)}</p>
                    <table>
                        <thead><tr><th>Detalle</th><th class="derecha">Monto</th></tr></thead>
                        <tbody>${r.items.map(it => `<tr><td>${esc(it.detalle)}</td><td class="derecha">${esc(it.monto)}</td></tr>`).join('')}</tbody>
                    </table>
                    <p class="simulador__recibo-total">TOTAL: <strong>${esc(r.total)}</strong></p>
                    <p class="simulador__recibo-detalle">Pago: ${esc(r.metodo)} · Firma: ${esc(r.firma)}</p>
                    <p class="simulador__recibo-pie">COBRA SCOUT · SISTEMA DE COBROS Y PAGOS</p>
                </div>
                <div class="simulador__botones">
                    <button type="button" class="boton_landing boton_landing--azul" data-accion="tab" data-valor="caja">Ver cómo quedó la caja</button>
                    <button type="button" class="simulador__tab" data-accion="tab" data-valor="cobros">Hacer otro cobro</button>
                </div>
            </div>`;
    };

    const render = () => {
        const pasos = [
            ['Elegí un miembro', s.tocado],
            ['Marcá las cuotas', s.sel.length > 0 || !!s.recibo],
            ['Generá el comprobante', !!s.recibo],
            ['Mirá la caja', s.vioCaja && !!s.recibo]
        ];
        const vistas = { cobros: vistaCobros, caja: vistaCaja, comprobante: vistaComprobante };

        root.innerHTML = `
            <div class="simulador__barra">
                <div class="simulador__tabs" role="tablist" aria-label="Paneles del simulador">
                    ${[['cobros', 'Cobros'], ['caja', 'Caja'], ['comprobante', 'Comprobante']].map(([id, label]) => tab('tab', id, label, s.tab === id)).join('')}
                </div>
                <button type="button" class="simulador__reiniciar" data-accion="reiniciar">
                    <i class="fa-solid fa-rotate-left"></i> Reiniciar
                </button>
            </div>
            <div class="simulador__panel">
                <ol class="simulador__pasos">
                    ${pasos.map(([texto, hecho], i) => `<li class="${hecho ? 'hecho' : ''}"><i class="fa-${hecho ? 'solid fa-circle-check' : 'regular fa-circle'}"></i>${i + 1}. ${texto}</li>`).join('')}
                </ol>
                ${vistas[s.tab]()}
            </div>`;
    };

    const generar = () => {
        if(!s.sel.length) return;
        const m = MIEMBROS.find(x => x.id === s.miembro);
        const sel = s.sel.slice().sort((a, b) => a - b);
        const totalCobro = sel.length * CUOTA;
        s.nro += 1;
        s.pagos[m.id] = s.pagos[m.id].concat(sel);
        s.movs.push({ hora: hora(), concepto: `Cuota ${sel.map(i => NOMBRES[i]).join(', ')} · ${m.nombre}`, metodo: s.metodo, tipo: 'ingreso', monto: totalCobro });
        s.recibo = {
            codigo: `C${String(s.nro).padStart(7, '0')}`,
            fecha: FECHA,
            nombre: m.nombre,
            items: sel.map(i => ({ detalle: `Cuota ${NOMBRES[i]}`, monto: money(CUOTA) })),
            total: money(totalCobro),
            metodo: s.metodo,
            firma: s.firma
        };
        s.sel = [];
        s.tab = 'comprobante';
    };

    root.addEventListener('click', (e) => {
        const btn = e.target.closest('button[data-accion]');
        if(!btn || btn.disabled) return;
        const { accion, valor } = btn.dataset;

        switch(accion){
            case 'tab':
                s.tab = valor;
                if(valor === 'caja') s.vioCaja = true;
                break;
            case 'miembro':
                s.miembro = valor;
                s.sel = [];
                s.tocado = true;
                break;
            case 'mes': {
                const i = Number(valor);
                s.sel = s.sel.includes(i) ? s.sel.filter(x => x !== i) : s.sel.concat(i);
                s.tocado = true;
                break;
            }
            case 'metodo':
                s.metodo = valor;
                break;
            case 'generar':
                generar();
                break;
            case 'egreso': {
                const eg = EGRESOS[s.egresoN % EGRESOS.length];
                s.egresoN += 1;
                s.movs.push({ hora: hora(), concepto: eg.concepto, metodo: 'Efectivo', tipo: 'egreso', monto: eg.monto });
                break;
            }
            case 'reiniciar':
                s = inicial();
                break;
            default:
                return;
        }
        render();

        // Devolver el foco al mismo control después de redibujar (teclado)
        const selector = `[data-accion="${accion}"]${valor !== undefined ? `[data-valor="${CSS.escape(valor)}"]` : ''}`;
        const mismo = root.querySelector(selector);
        if(mismo && !mismo.disabled) mismo.focus({ preventScroll: true });
    });

    root.addEventListener('change', (e) => {
        if(e.target.matches('[data-accion="firma"]')) s.firma = e.target.value;
    });

    render();
}

// PANEL INFORMES
function initPanelInformes(){
    const dataEl = document.querySelector('#informesData');
    const contenido = document.querySelector('.informes_contenido');
    if(!dataEl || !contenido) return;

    let data;
    try {
        data = JSON.parse(dataEl.textContent);
    } catch (error) {
        console.error('Error al leer los datos de informes:', error);
        return;
    }

    const mesesCortos = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
    const mesesLargos = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
    // Bordes de los totales (mismos tonos que los totales de Caja)
    const bordes = { ingreso: '#3ec62f', egreso: '#2f76c9', caja: '#36884d', deuda: '#b42318', info: '#54ade4' };

    const mesActual = data.mesActual; // 0 = el período todavía no empezó
    const ramasById = Object.fromEntries(data.ramas.map((r) => [r.id, r]));
    let vista = 'grupo';
    let rango = 'mes';
    let seccion = 'ingresos'; // Movimientos del grupo: 'ingresos' | 'egresos'

    const esc = (value) => String(value ?? '')
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    const money = (value) => `${esc(data.signo)} ${Math.round(Number(value) || 0).toLocaleString('es-AR')}`;
    const compact = (value) => {
        if(value >= 1000000) return `${data.signo}${(value / 1000000).toLocaleString('es-AR', { maximumFractionDigits: 1 })}M`;
        if(value >= 1000) return `${data.signo}${Math.round(value / 1000)}k`;
        return `${data.signo}${Math.round(value)}`;
    };
    const pct = (part, total) => total > 0 ? Math.round(part / total * 100) : 0;
    const sum = (list) => list.reduce((acc, value) => acc + value, 0);
    const deudaCuotas = (miembro) => miembro.deuda + miembro.deudaAnterior;
    const deudaTotal = (miembro) => deudaCuotas(miembro) + (miembro.deudaGenerales || 0) + (miembro.deudaActividades || 0);
    const plural = (n, uno, varios) => `${n} ${n === 1 ? uno : varios}`;

    // Índices de meses (0-11) del rango elegido y del rango anterior para comparar
    const getRango = () => {
        if(mesActual === 0) return { actual: [], anterior: [], etiqueta: '' };
        const ultimo = mesActual - 1;

        if(rango === 'mes'){
            return {
                actual: [ultimo],
                anterior: ultimo > 0 ? [ultimo - 1] : [],
                etiqueta: ultimo > 0 ? mesesLargos[ultimo - 1] : ''
            };
        }
        if(rango === 'trimestre'){
            const inicio = Math.floor(ultimo / 3) * 3;
            const actual = [];
            for(let i = inicio; i <= ultimo; i++) actual.push(i);
            return {
                actual,
                anterior: inicio >= 3 ? [inicio - 3, inicio - 2, inicio - 1] : [],
                etiqueta: 'el trimestre anterior'
            };
        }
        const actual = [];
        for(let i = 0; i <= ultimo; i++) actual.push(i);
        return { actual, anterior: [], etiqueta: '' };
    };

    const comparar = (actual, anterior, etiqueta) => {
        if(!etiqueta || anterior <= 0) return rango === 'anio' ? 'Acumulado del año' : 'Sin referencia anterior';
        const variacion = Math.round((actual - anterior) / anterior * 100);
        const flecha = variacion >= 0 ? '▲' : '▼';
        return `${flecha} ${Math.abs(variacion)}% vs. ${etiqueta}`;
    };

    // ---------- Piezas reutilizables ----------
    const bloque = (titulo, cuerpo, extra = '', clase = '') => `
        <section class="informes_bloque ${clase}">
            <div class="informes_bloque_header">
                <h3>${titulo}</h3>
                ${extra}
            </div>
            ${cuerpo}
        </section>`;

    const total = (label, value, note, borde, notaClase = '') => `
        <div class="informes_total">
            <p class="informes_total_label">${esc(label)}</p>
            <p class="informes_total_valor" style="border-color: ${borde}">${value}</p>
            <p class="informes_total_nota ${notaClase}">${esc(note)}</p>
        </div>`;

    const marca = (color) => `<span class="informes_marca" style="background-color: ${color}"></span>`;

    const barraApilada = (items) => `
        <div class="informes_apilada">
            ${items.map((item) => `<div style="width: ${item.w}%; background-color: ${item.color}"></div>`).join('')}
        </div>`;

    // attrs: atributos extra para filas clickeables (ej. abrir una categoría en "Gasto por categoría")
    const leyendaFila = (color, label, valor, extra = '', attrs = '') => `
        <div class="informes_leyenda_fila${attrs ? ' informes_leyenda_fila--link' : ''}" ${attrs}>
            <span class="informes_leyenda_nombre">${marca(color)}${esc(label)}</span>
            <span class="informes_leyenda_valor">${valor}${extra ? `<small>${extra}</small>` : ''}</span>
        </div>`;

    const progreso = (nombre, w, color, detalle, tag = '') => `
        <div class="informes_progreso">
            <div class="informes_progreso_top">
                <span>${esc(nombre)}</span>
                ${tag}
            </div>
            <div class="informes_pista"><div style="width: ${w}%; background-color: ${color}"></div></div>
            ${detalle ? `<span class="informes_progreso_detalle">${detalle}</span>` : ''}
        </div>`;

    const tagActividad = (tipo) => `<span class="informes_tag informes_tag--${tipo === 'Campamento' ? 'campa' : 'evento'}">${esc(tipo)}</span>`;

    const ramaNombre = (ramaId, sinRama = 'Sin rama') => {
        const rama = ramasById[ramaId];
        return `<span class="informes_rama_nombre"><span class="informes_dot" style="background-color: ${rama ? rama.color : '#9a9a9a'}"></span>${esc(rama ? rama.nombre : sinRama)}</span>`;
    };

    const sinDatos = (texto) => `<p class="informes_sin_datos">${texto}</p>`;

    const ingresosDetalle = data.ingresosDetalle || [];
    const egresosLista = data.egresos || [];
    const nombreGenerales = data.nombreGenerales || 'Afiliaciones';

    const coloresConcepto = { Cuotas: '#3ec62f', Campamentos: '#54ade4', Eventos: '#f5a524', [nombreGenerales]: '#279361' };
    const coloresCategorias = ['#2f76c9', '#54ade4', '#8e38db', '#f5a524', '#36884d'];
    const coloresDeuda = { cuotas: '#b42318', generales: '#f5a524', actividades: '#7a7a7a' };

    const colorMetodo = (nombre, i) => {
        const n = nombre.toLowerCase();
        if(n.includes('efectivo')) return '#3ec62f';
        if(n.includes('transfer')) return '#2f76c9';
        return ['#54ade4', '#f5a524', '#8e38db', '#9a9a9a'][i % 4];
    };
    const colorConcepto = (nombre, i) => coloresConcepto[nombre] || ['#8e38db', '#9a9a9a'][i % 2];
    const colorCategoria = (nombre, i) => nombre === 'Otras' ? '#9a9a9a' : coloresCategorias[i % coloresCategorias.length];

    // Suma montos agrupando por una clave, de mayor a menor: [[clave, monto], ...]
    const agrupar = (lista, clave) => {
        const totales = {};
        lista.forEach((item) => { totales[item[clave]] = (totales[item[clave]] || 0) + item.monto; });
        return Object.entries(totales).filter(([, monto]) => monto > 0).sort((a, b) => b[1] - a[1]);
    };
    const enMeses = (lista, meses) => lista.filter((item) => meses.includes(item.mes));
    const porMesDe = (lista) => mesesCortos.map((_, i) => sum(lista.filter((item) => item.mes === i).map((item) => item.monto)));
    const topConOtras = (pares, max = 5) => pares.length <= max + 1 ? pares : [...pares.slice(0, max), ['Otras', sum(pares.slice(max).map((p) => p[1]))]];
    const sufijoDe = () => ({ mes: 'del mes', trimestre: 'del trimestre', anio: 'del año' }[rango]);

    // ---------- Piezas de esta vista ----------
    const subtitulo = (texto) => `<p class="informes_subtitulo">${texto}</p>`;
    const monto = (valor, tipo) => `<span class="informes_monto informes_monto--${tipo}">${valor}</span>`;

    const desglose = (pares, colorDe, vacio, attrsDe = () => '') => {
        const totalPares = sum(pares.map((p) => p[1]));
        if(totalPares <= 0) return sinDatos(vacio);
        const items = pares.map(([nombre, valor], i) => ({ nombre, valor, color: colorDe(nombre, i), w: pct(valor, totalPares) }));
        return `
            ${barraApilada(items)}
            <div class="informes_leyenda">
                ${items.map((item) => leyendaFila(item.color, item.nombre, money(item.valor), `${item.w}%`, attrsDe(item.nombre))).join('')}
            </div>`;
    };

    // Gráfico de barras de una sola serie; los meses fuera del rango quedan atenuados.
    // Por defecto son los 12 meses del período; etiquetas/titulos permiten otras columnas.
    const grafico = (valores, color, resaltados, chico = false, etiquetas = mesesCortos, titulos = mesesLargos) => {
        const max = Math.max(1, ...valores);
        const barras = valores.map((valor, i) => `
            <div class="informes_barras_mes${resaltados.includes(i) ? '' : ' informes_barras_mes--fuera'}" data-informes-tip-titulo="${esc(titulos[i])}" data-informes-tip-valor="${money(valor)}" aria-label="${esc(titulos[i])}: ${money(valor)}">
                <div class="informes_barra informes_barra--sola" style="height: ${valor / max * 100}%; background-color: ${color}"></div>
            </div>`).join('');
        return `
            <div class="informes_caja informes_scroll">
                <div class="informes_grafico${chico ? ' informes_grafico--chico' : ''}">
                    <div class="informes_eje">
                        <span>${compact(max)}</span><span>${compact(max * .75)}</span><span>${compact(max * .5)}</span><span>${compact(max * .25)}</span><span>${esc(data.signo)}0</span>
                    </div>
                    <div class="informes_grafico_area">
                        <div class="informes_barras">${barras}</div>
                        <div class="informes_meses">${etiquetas.map((m, i) => `<span class="${resaltados.includes(i) ? 'resaltado' : ''}">${esc(m)}</span>`).join('')}</div>
                    </div>
                </div>
            </div>`;
    };

    const porRama = (pares, sinRama, vacio) => {
        if(pares.length === 0) return sinDatos(vacio);
        const max = Math.max(1, ...pares.map((p) => p[1]));
        return pares.map(([ramaId, valor]) => {
            const rama = ramasById[ramaId];
            return progreso(rama ? rama.nombre : sinRama, valor / max * 100, rama ? rama.color : '#9a9a9a', money(valor));
        }).join('');
    };

    const deudaPorTipo = (miembros) => {
        const tipos = [
            ['Cuotas', sum(miembros.map(deudaCuotas)), coloresDeuda.cuotas],
            [nombreGenerales, sum(miembros.map((m) => m.deudaGenerales || 0)), coloresDeuda.generales],
            ['Campamentos y eventos', sum(miembros.map((m) => m.deudaActividades || 0)), coloresDeuda.actividades]
        ];
        const totalTipos = sum(tipos.map((t) => t[1]));
        if(totalTipos <= 0) return sinDatos('No hay deudas registradas.');
        return `
            ${barraApilada(tipos.map(([, valor, color]) => ({ w: pct(valor, totalTipos), color })))}
            <div class="informes_leyenda">
                ${tipos.map(([nombre, valor, color]) => leyendaFila(color, nombre, money(valor), `${pct(valor, totalTipos)}%`)).join('')}
            </div>`;
    };

    const incluyeDeuda = (m) => [
        deudaCuotas(m) > 0 ? 'Cuotas' : '',
        m.deudaGenerales > 0 ? nombreGenerales : '',
        m.deudaActividades > 0 ? 'Campamentos y eventos' : ''
    ].filter(Boolean).join(' · ');

    const tablaEgresos = (lista) => {
        const filas = [...lista].sort((a, b) => b.monto - a.monto).slice(0, 5);
        if(filas.length === 0) return `<div class="informes_caja">${sinDatos('No hay egresos en este rango.')}</div>`;
        return `
            <div class="informes_scroll informes_tabla_cont">
                <table class="informes_tabla">
                    <thead><tr><th>Fecha</th><th>Concepto</th><th>Categoría</th><th>Rama</th><th>Método</th><th class="informes_num">Monto</th></tr></thead>
                    <tbody>
                        ${filas.map((e) => `
                            <tr>
                                <td>${esc(e.fecha)}</td>
                                <td class="informes_nombre">${esc(e.detalle || e.categoria)}</td>
                                <td>${esc(e.categoria)}</td>
                                <td>${ramaNombre(e.rama, 'Grupo')}</td>
                                <td>${esc(e.metodo)}</td>
                                <td class="informes_num informes_importe">${money(e.monto)}</td>
                            </tr>`).join('')}
                    </tbody>
                </table>
            </div>`;
    };

    const listaEgresos = (lista) => {
        const filas = lista.slice(0, 6); // ya vienen ordenados por fecha, del más nuevo al más viejo
        if(filas.length === 0) return sinDatos('No hay egresos en este rango.');
        return `
            <div class="informes_leyenda">
                ${filas.map((e) => `
                    <div class="informes_leyenda_fila">
                        <span class="informes_leyenda_nombre">${esc(e.fecha.slice(0, 5))} · ${esc(e.detalle || e.categoria)}</span>
                        <span class="informes_leyenda_valor">${money(e.monto)}<small>${esc(e.metodo)}</small></span>
                    </div>`).join('')}
            </div>`;
    };

    const renderActividades = (ramaId, grilla = false) => {
        const items = data.actividades.map((act) => {
            const participantes = ramaId ? act.participantes.filter((p) => p.rama === ramaId) : act.participantes;
            if(participantes.length === 0) return '';
            const recaudado = sum(participantes.map((p) => p.pagado));
            const esperado = participantes.length * act.precio;
            const pagaron = participantes.filter((p) => p.completo).length;
            const detalle = `${money(recaudado)} de ${money(esperado)} · ${pagaron} de ${participantes.length} pagaron`;
            const color = act.tipo === 'Campamento' ? bordes.ingreso : bordes.egreso;
            return progreso(act.nombre, Math.min(pct(recaudado, esperado), 100), color, detalle, tagActividad(act.tipo));
        }).join('');

        return `<div class="informes_caja informes_caja--lista${grilla ? ' informes_caja--grilla' : ''}">${items || sinDatos('No hay campamentos ni eventos activos con miembros anotados.')}</div>`;
    };

    // ---------- Gasto por categoría (pestaña Egresos) ----------
    // Los pagos se piden al servidor (/api/getInformesCategoria.php) porque los plazos
    // pueden salir del período cargado ("Desde que se creó", "Año anterior", personalizado).
    // El estado vive acá afuera para que no se pierda cuando se vuelve a dibujar la vista.
    const categoriasPago = data.categoriasPago || [];
    const categoriaPorNombre = Object.fromEntries(categoriasPago.map((c) => [c.nombre, c.id]));
    const plazosCategoria = [
        ['mes', 'Último mes'],
        ['trimestre', 'Últimos 3 meses'],
        ['periodo', `Período ${data.period}`],
        ['anioAnterior', 'Año anterior'],
        ['creacion', 'Desde que se creó'],
        ['personalizado', 'Personalizado']
    ];
    const categoria = { id: '', plazo: 'mes', desde: '', hasta: '', resultado: null, cargando: false, error: '' };
    let pedidoCategoria = 0;

    const fechaCorta = (iso) => iso.split('-').reverse().join('/');
    const hoyIso = () => {
        const hoy = new Date();
        return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;
    };

    // Agrupa los pagos por mes entre desde y hasta (o por año si son más de 24 meses)
    const columnasCategoria = ({ desde, hasta, pagos }) => {
        const [y1, m1] = desde.split('-').map(Number);
        const [y2, m2] = hasta.split('-').map(Number);
        const cantMeses = (y2 - y1) * 12 + (m2 - m1) + 1;
        const porAnio = cantMeses > 24;
        const variosAnios = y1 !== y2;
        const columnas = [];

        if(porAnio){
            for(let y = y1; y <= y2; y++) columnas.push({ clave: `${y}`, etiqueta: `${y}`, titulo: `${y}`, valor: 0 });
        }else{
            for(let i = 0; i < cantMeses; i++){
                const y = y1 + Math.floor((m1 - 1 + i) / 12);
                const m = (m1 - 1 + i) % 12;
                columnas.push({
                    clave: `${y}-${String(m + 1).padStart(2, '0')}`,
                    etiqueta: variosAnios ? `${mesesCortos[m]} ${String(y).slice(2)}` : mesesCortos[m],
                    titulo: `${mesesLargos[m]} ${y}`,
                    valor: 0
                });
            }
        }

        const indice = Object.fromEntries(columnas.map((c, i) => [c.clave, i]));
        pagos.forEach((p) => {
            const i = indice[porAnio ? p.fechaIso.slice(0, 4) : p.fechaIso.slice(0, 7)];
            if(i !== undefined) columnas[i].valor += p.monto;
        });
        return { columnas, cantMeses };
    };

    const resultadoCategoria = () => {
        if(!categoria.id) return `<div class="informes_caja">${sinDatos('Elegí una categoría para ver cuánto se gastó.')}</div>`;
        if(categoria.cargando) return `<div class="informes_caja">${sinDatos('<i class="fa-solid fa-spinner fa-spin"></i> Buscando pagos…')}</div>`;
        if(categoria.error) return `<p class="informes_alerta">${esc(categoria.error)}</p>`;
        if(!categoria.resultado) return '';

        const res = categoria.resultado;
        const totalCat = sum(res.pagos.map((p) => p.monto));
        const { columnas, cantMeses } = columnasCategoria(res);
        const filas = res.pagos.slice(0, 50);
        const encabezado = subtitulo(`${esc(res.categoria)} <small>· del ${fechaCorta(res.desde)} al ${fechaCorta(res.hasta)}</small>`);

        if(res.pagos.length === 0){
            return `${encabezado}<div class="informes_caja">${sinDatos('No hay pagos de esta categoría en este plazo.')}</div>`;
        }

        return `
            ${encabezado}
            <div class="informes_totales">
                ${total('Total gastado', money(totalCat), plural(cantMeses, 'mes', 'meses'), bordes.egreso)}
                ${total('Pagos', String(res.pagos.length), `${money(totalCat / res.pagos.length)} en promedio`, bordes.info)}
                ${total('Promedio por mes', money(totalCat / cantMeses), cantMeses > 24 ? 'el gráfico agrupa por año' : 'contando meses sin pagos', bordes.caja)}
            </div>
            ${grafico(columnas.map((c) => c.valor), bordes.egreso, columnas.map((_, i) => i), true, columnas.map((c) => c.etiqueta), columnas.map((c) => c.titulo))}
            <div class="informes_scroll informes_tabla_cont">
                <table class="informes_tabla">
                    <thead><tr><th>Fecha</th><th>Concepto</th><th>Rama</th><th>Método</th><th class="informes_num">Monto</th></tr></thead>
                    <tbody>
                        ${filas.map((p) => `
                            <tr>
                                <td>${esc(p.fecha)}</td>
                                <td class="informes_nombre">${esc(p.detalle || res.categoria)}</td>
                                <td>${ramaNombre(p.rama, 'Grupo')}</td>
                                <td>${esc(p.metodo)}</td>
                                <td class="informes_num informes_importe">${money(p.monto)}</td>
                            </tr>`).join('')}
                    </tbody>
                </table>
            </div>
            ${res.pagos.length > filas.length ? `<p class="informes_aclaracion">Se muestran los ${filas.length} pagos más recientes de ${res.pagos.length}.</p>` : ''}`;
    };

    const cuerpoCategoria = () => {
        if(categoriasPago.length === 0) return `<div class="informes_caja">${sinDatos('Todavía no hay categorías de pago. Se crean en Ajustes.')}</div>`;
        return `
            <div class="informes_cat_filtros">
                <label class="informes_campo">
                    <span>Categoría</span>
                    <select data-informes-cat-select>
                        <option value="">Elegí una categoría</option>
                        ${categoriasPago.map((c) => `<option value="${c.id}"${String(c.id) === String(categoria.id) ? ' selected' : ''}>${esc(c.nombre)}</option>`).join('')}
                    </select>
                </label>
                <div class="informes_rango" role="group" aria-label="Plazo">
                    ${plazosCategoria.map(([id, label]) => `
                        <button type="button" class="informes_pestania${categoria.plazo === id ? ' activado' : ''}" aria-pressed="${categoria.plazo === id}" data-informes-cat-plazo="${id}">${label}</button>`).join('')}
                </div>
                ${categoria.plazo === 'personalizado' ? `
                    <div class="informes_cat_fechas">
                        <label class="informes_campo"><span>Desde</span><input type="date" value="${categoria.desde}" data-informes-cat-fecha="desde"></label>
                        <label class="informes_campo"><span>Hasta</span><input type="date" value="${categoria.hasta}" data-informes-cat-fecha="hasta"></label>
                        <button type="button" class="informes_exportar" data-informes-cat-buscar><i class="fa-solid fa-magnifying-glass"></i> Ver</button>
                    </div>` : ''}
            </div>
            <div class="informes_cat_resultado">${resultadoCategoria()}</div>`;
    };

    // Redibuja solo este bloque (no toda la vista)
    const pintarCategoria = () => {
        const cont = contenido.querySelector('[data-informes-categoria]');
        if(cont) cont.innerHTML = cuerpoCategoria();
    };

    const buscarCategoria = async () => {
        if(!categoria.id) return;
        if(categoria.plazo === 'personalizado' && (!categoria.desde || !categoria.hasta)){
            categoria.resultado = null;
            categoria.error = 'Elegí las dos fechas.';
            pintarCategoria();
            return;
        }

        const pedido = ++pedidoCategoria; // si llega una respuesta vieja, se descarta
        categoria.cargando = true;
        categoria.error = '';
        pintarCategoria();

        try {
            const respuesta = await fetch('/api/getInformesCategoria.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ categoria: categoria.id, plazo: categoria.plazo, desde: categoria.desde, hasta: categoria.hasta })
            });
            const json = await respuesta.json();
            if(pedido !== pedidoCategoria) return;
            if(json.response === 200){
                categoria.resultado = json.data;
            }else{
                categoria.resultado = null;
                categoria.error = json.error || 'No se pudo consultar la categoría.';
            }
        } catch (error) {
            if(pedido !== pedidoCategoria) return;
            console.error('Error al consultar la categoría:', error);
            categoria.resultado = null;
            categoria.error = 'No se pudo consultar la categoría. Revisá la conexión e intentá de nuevo.';
        }

        categoria.cargando = false;
        pintarCategoria();
    };

    const abrirCategoria = (id) => {
        categoria.id = String(id);
        buscarCategoria();
        const cont = contenido.querySelector('[data-informes-categoria]');
        if(cont) cont.closest('.informes_bloque').scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    // Filas de "Egresos por categoría" que abren el bloque con esa categoría
    const attrsCategoria = (nombre) => categoriaPorNombre[nombre] !== undefined
        ? `role="button" tabindex="0" title="Ver el detalle de ${esc(nombre)}" data-informes-cat-ir="${categoriaPorNombre[nombre]}"`
        : '';

    // ---------- Vista: todo el grupo ----------
    const renderGrupo = () => {
        const { actual, anterior, etiqueta } = getRango();
        const miembros = data.miembros;
        const sufijoRango = sufijoDe();
        const ingresos = sum(actual.map((i) => data.porMes[i].ingresos));
        const egresos = sum(actual.map((i) => data.porMes[i].egresos));
        const ingresosAnt = sum(anterior.map((i) => data.porMes[i].ingresos));
        const egresosAnt = sum(anterior.map((i) => data.porMes[i].egresos));
        const conDeuda = miembros.filter((m) => deudaTotal(m) > 0);
        const deuda = sum(miembros.map(deudaTotal));
        const ramasConMiembros = new Set(miembros.map((m) => m.rama)).size;
        const ultimoCierre = data.cierres[0];
        const ingRango = enMeses(ingresosDetalle, actual);
        const egRango = enMeses(egresosLista, actual);

        // Estado de cuotas
        const alDia = miembros.filter((m) => m.mesesDeuda === 0).length;
        const debeUnoDos = miembros.filter((m) => m.mesesDeuda > 0 && m.mesesDeuda < 3).length;
        const tresOMas = miembros.filter((m) => m.mesesDeuda >= 3).length;

        const ramasConDatos = data.ramas.map((rama) => {
            const deRama = miembros.filter((m) => m.rama === rama.id);
            return {
                rama,
                miembros: deRama.length,
                deuda: sum(deRama.map(deudaTotal)),
                deudores: deRama.filter((m) => deudaTotal(m) > 0).length,
                alDia: deRama.filter((m) => m.mesesDeuda === 0).length
            };
        }).filter((r) => r.miembros > 0);
        const deudaRamas = [...ramasConDatos].sort((a, b) => b.deuda - a.deuda);
        const maxDeudaRama = Math.max(1, ...deudaRamas.map((r) => r.deuda));
        const alDiaRamas = [...ramasConDatos].sort((a, b) => pct(b.alDia, b.miembros) - pct(a.alDia, a.miembros));

        const mayores = [...conDeuda].sort((a, b) => deudaTotal(b) - deudaTotal(a)).slice(0, 6);

        const vistaIngresos = `
            <div class="informes_seccion${seccion === 'ingresos' ? '' : ' oculto'}" data-informes-panel="ingresos">
                <div class="informes_fila">
                    ${bloque(`${marca(bordes.ingreso)} Ingresos por mes`, `
                        ${grafico(data.porMes.map((m) => m.ingresos), bordes.ingreso, actual)}
                        <div class="informes_separado">
                            ${subtitulo(`De dónde vienen los ingresos <small>· ${sufijoRango}</small>`)}
                            ${desglose(agrupar(ingRango, 'concepto'), colorConcepto, 'No hay cobros en este rango.')}
                        </div>`,
                        monto(money(ingresos), 'ingreso'), 'informes_bloque--ancho')}
                    <div class="informes_columna informes_bloque--angosto">
                        ${bloque(`Medios de pago <small>· ${sufijoRango}</small>`, `
                            <div class="informes_caja informes_caja--lista">${desglose(agrupar(ingRango, 'metodo'), colorMetodo, 'No hay cobros en este rango.')}</div>`)}
                        ${bloque(`Cobrado por rama <small>· ${sufijoRango}</small>`, `
                            <div class="informes_caja informes_caja--lista">${porRama(agrupar(ingRango, 'rama'), 'Sin rama', 'No hay cobros en este rango.')}</div>`)}
                    </div>
                </div>
                ${bloque('Ingresos de campamentos y eventos', renderActividades(null, true))}

                <div class="informes_fila">
                    ${bloque('Deudas', `
                        <div class="informes_fila">
                            <div class="informes_caja informes_caja--lista informes_caja--tipo">
                                ${subtitulo('Por tipo')}
                                ${deudaPorTipo(miembros)}
                            </div>
                            <div class="informes_caja informes_caja--lista informes_caja--ramas">
                                ${subtitulo('Por rama')}
                                <div class="informes_grilla_ramas">
                                    ${deudaRamas.map((r) => progreso(
                                        r.rama.nombre,
                                        r.deuda / maxDeudaRama * 100,
                                        r.rama.color,
                                        `${money(r.deuda)} · ${r.deudores} de ${r.miembros} con deuda`
                                    )).join('') || sinDatos('Todavía no hay miembros cargados.')}
                                </div>
                            </div>
                        </div>`,
                        monto(`Total ${money(deuda)}`, 'deuda'), 'informes_bloque--ancho')}

                    ${bloque('Estado actual de cuotas', `
                        <div class="informes_caja informes_caja--lista">
                            <div class="informes_conteos">
                                <div><strong class="informes_estado--ok">${alDia}</strong><span>Al día</span></div>
                                <div><strong class="informes_estado--debe">${debeUnoDos}</strong><span>Deben 1–2 meses</span></div>
                                <div><strong class="informes_estado--grave">${tresOMas}</strong><span>Deben 3+ meses</span></div>
                            </div>
                            ${barraApilada([
                                { w: pct(alDia, miembros.length), color: '#3ec62f' },
                                { w: pct(debeUnoDos, miembros.length), color: '#f5a524' },
                                { w: pct(tresOMas, miembros.length), color: '#b42318' }
                            ])}
                            <p class="informes_aclaracion">${pct(alDia, miembros.length)}% del grupo al día · cuota mensual ${money(data.valorCuota)}</p>
                        </div>
                        <div class="informes_caja informes_caja--lista">
                            ${subtitulo('Al día por rama')}
                            ${alDiaRamas.map((r) => progreso(
                                r.rama.nombre,
                                pct(r.alDia, r.miembros),
                                pct(r.alDia, r.miembros) >= 65 ? '#3ec62f' : '#f5a524',
                                `${r.alDia} de ${r.miembros} · ${pct(r.alDia, r.miembros)}%`
                            )).join('') || sinDatos('Todavía no hay miembros cargados.')}
                        </div>`,
                        '', 'informes_bloque--angosto')}
                </div>

                ${bloque('Mayores deudas', mayores.length ? `
                    <div class="informes_scroll informes_tabla_cont">
                        <table class="informes_tabla">
                            <thead><tr><th>Miembro</th><th>Rama</th><th>Cuotas adeudadas</th><th>Incluye</th><th class="informes_num">Deuda</th></tr></thead>
                            <tbody>
                                ${mayores.map((m) => `
                                    <tr>
                                        <td class="informes_nombre">${esc(m.nombre)}</td>
                                        <td>${ramaNombre(m.rama)}</td>
                                        <td class="informes_estado ${m.mesesDeuda >= 3 ? 'informes_estado--grave' : 'informes_estado--debe'}">${m.mesesDeuda > 0 ? plural(m.mesesDeuda, 'mes', 'meses') : '—'}${m.deudaAnterior > 0 ? ' + deuda anterior' : ''}</td>
                                        <td>${esc(incluyeDeuda(m))}</td>
                                        <td class="informes_num informes_deuda">${money(deudaTotal(m))}</td>
                                    </tr>`).join('')}
                            </tbody>
                        </table>
                    </div>` : `<div class="informes_caja">${sinDatos('Ningún miembro tiene deudas.')}</div>`)}
            </div>`;

        const vistaEgresos = `
            <div class="informes_seccion${seccion === 'egresos' ? '' : ' oculto'}" data-informes-panel="egresos">
                <div class="informes_fila">
                    ${bloque(`${marca(bordes.egreso)} Egresos por mes`, `
                        ${grafico(data.porMes.map((m) => m.egresos), bordes.egreso, actual)}
                        <div class="informes_separado">
                            ${subtitulo(`Cómo se pagaron <small>· egresos ${sufijoRango}</small>`)}
                            ${desglose(agrupar(egRango, 'metodo'), colorMetodo, 'No hay egresos en este rango.')}
                        </div>`,
                        monto(money(egresos), 'egreso'), 'informes_bloque--ancho')}
                    ${bloque(`Egresos por categoría <small>· ${sufijoRango}</small>`, `
                        <div class="informes_caja informes_caja--lista">${desglose(topConOtras(agrupar(egRango, 'categoria')), colorCategoria, 'No hay egresos en este rango.', attrsCategoria)}</div>
                        ${categoriasPago.length ? '<p class="informes_aclaracion">Tocá una categoría para ver su detalle.</p>' : ''}`,
                        '', 'informes_bloque--angosto')}
                </div>
                ${bloque('Gasto por categoría', `<div class="informes_cat" data-informes-categoria>${cuerpoCategoria()}</div>`)}
                <div class="informes_fila">
                    ${bloque(`Mayores egresos <small>· ${sufijoRango}</small>`, tablaEgresos(egRango), '', 'informes_bloque--ancho')}
                    ${bloque(`Gastado por rama <small>· ${sufijoRango}</small>`, `
                        <div class="informes_caja informes_caja--lista">${porRama(agrupar(egRango, 'rama'), 'Grupo', 'No hay egresos en este rango.')}</div>
                        <p class="informes_aclaracion">"Grupo" son los pagos que no quedaron asociados a un miembro de una rama.</p>`,
                        '', 'informes_bloque--angosto')}
                </div>
            </div>`;

        contenido.innerHTML = `
            <section class="informes_bloque">
                <h3 class="informes_titulo_bloque">Estado de cuenta</h3>
                <div class="informes_totales">
                    ${total(`Ingresos ${sufijoRango}`, money(ingresos), comparar(ingresos, ingresosAnt, etiqueta), bordes.ingreso)}
                    ${total(`Egresos ${sufijoRango}`, money(egresos), comparar(egresos, egresosAnt, etiqueta), bordes.egreso)}
                    ${total('Saldo en caja', money(data.saldoCaja), ultimoCierre ? `Último cierre Z: ${ultimoCierre.fecha}` : 'Sin cierres de caja', bordes.caja)}
                    ${total('Deudas', money(deuda), `${plural(conDeuda.length, 'miembro', 'miembros')} con deuda`, bordes.deuda, 'informes_total_nota--alerta')}
                    ${total('Miembros activos', String(miembros.length), `en ${plural(ramasConMiembros, 'rama', 'ramas')}`, bordes.info)}
                </div>
            </section>

            <section class="informes_bloque informes_movimientos">
                <div>
                    <h3 class="informes_titulo_bloque">Movimientos de caja</h3>
                    <p class="informes_aclaracion">Elegí qué querés ver en detalle</p>
                </div>
                <div class="informes_secciones" role="group" aria-label="Ver movimientos">
                    ${[['ingresos', 'Ingresos', 'fa-arrow-trend-up'], ['egresos', 'Egresos', 'fa-arrow-trend-down']].map(([id, label, icono]) => `
                        <button type="button" class="informes_pestania informes_pestania--grande${seccion === id ? ' activado' : ''}" aria-pressed="${seccion === id}" data-informes-seccion="${id}">
                            <i class="fa-solid ${icono}"></i> ${label}
                        </button>`).join('')}
                </div>
            </section>

            ${vistaIngresos}
            ${vistaEgresos}

            ${bloque('Últimos cierres de caja', data.cierres.length ? `
                <div class="informes_cierres">
                    ${data.cierres.map((c) => `
                        <div class="informes_cierre">
                            <div>
                                <strong>Cierre Z ${esc(c.codigo)}</strong>
                                <span>${esc(c.fecha)}${c.firmante ? ` · ${esc(c.firmante)}` : ''}</span>
                            </div>
                            <strong class="informes_cierre_monto">${money(c.monto)}</strong>
                        </div>`).join('')}
                </div>` : `<div class="informes_caja">${sinDatos('Todavía no hay cierres de caja.')}</div>`)}`;
    };

    // ---------- Vista: una rama (ingresos y egresos juntos) ----------
    const renderRama = (ramaId) => {
        const rama = ramasById[ramaId];
        if(!rama) return;
        const miembros = data.miembros.filter((m) => m.rama === ramaId);

        const cabecera = (detalle, avance) => `
            <div class="informes_rama_header">
                <div class="informes_rama_titulo">
                    <span class="informes_dot informes_dot--grande" style="background-color: ${rama.color}"></span>
                    <div>
                        <h3>${esc(rama.nombre)}</h3>
                        <p>${detalle}</p>
                    </div>
                </div>
                ${avance}
            </div>`;

        if(miembros.length === 0){
            contenido.innerHTML = `<section class="informes_bloque">${cabecera('Esta rama todavía no tiene miembros activos.', '')}</section>`;
            return;
        }

        const { actual, anterior, etiqueta } = getRango();
        const sufijoRango = sufijoDe();
        const ingRama = ingresosDetalle.filter((i) => i.rama === ramaId);
        const egRama = egresosLista.filter((e) => e.rama === ramaId);
        const ingMes = porMesDe(ingRama);
        const egMes = porMesDe(egRama);
        const ingresos = sum(actual.map((i) => ingMes[i]));
        const egresos = sum(actual.map((i) => egMes[i]));
        const ingresosAnt = sum(anterior.map((i) => ingMes[i]));
        const egresosAnt = sum(anterior.map((i) => egMes[i]));
        const ingRango = enMeses(ingRama, actual);
        const egRango = enMeses(egRama, actual);
        const balance = ingresos - egresos;

        const mesesTranscurridos = [];
        for(let i = 0; i < mesActual; i++){
            if(data.mesesActivos[i]) mesesTranscurridos.push(i);
        }
        const cobradoCuotas = sum(miembros.map((m) => sum(mesesTranscurridos.map((i) => m.pagado[i]))));
        const esperadoCuotas = data.valorCuota * miembros.length * mesesTranscurridos.length;
        const avance = Math.min(pct(cobradoCuotas, esperadoCuotas), 100);
        const deuda = sum(miembros.map(deudaTotal));
        const conDeuda = miembros.filter((m) => deudaTotal(m) > 0).length;
        const alDia = miembros.filter((m) => m.mesesDeuda === 0).length;

        const estadoCelda = { p: 'Pagó', d: 'Debe', n: 'Sin cuota', f: 'Todavía no corresponde' };
        const ordenados = [...miembros].sort((a, b) => deudaTotal(b) - deudaTotal(a) || a.nombre.localeCompare(b.nombre));
        const filas = ordenados.map((m) => {
            const estado = m.mesesDeuda === 0
                ? '<span class="informes_estado informes_estado--ok">Al día</span>'
                : `<span class="informes_estado ${m.mesesDeuda >= 3 ? 'informes_estado--grave' : 'informes_estado--debe'}">Debe ${plural(m.mesesDeuda, 'mes', 'meses')}</span>`;
            return `
                <tr>
                    <td class="informes_nombre">${esc(m.nombre)}</td>
                    ${m.celdas.map((c, i) => `<td class="informes_celda_td"><span class="informes_celda informes_celda--${c}" title="${mesesCortos[i]}: ${estadoCelda[c]}"></span></td>`).join('')}
                    <td>${estado}${m.deudaAnterior > 0 ? '<small class="informes_anterior">+ deuda anterior</small>' : ''}</td>
                    <td class="informes_num ${deudaTotal(m) > 0 ? 'informes_deuda' : 'informes_sin_deuda'}">${deudaTotal(m) > 0 ? money(deudaTotal(m)) : '—'}</td>
                </tr>`;
        }).join('');

        contenido.innerHTML = `
            <section class="informes_bloque">
                ${cabecera(
                    `${plural(miembros.length, 'miembro activo', 'miembros activos')} · cuota mensual ${money(data.valorCuota)}`,
                    `<div class="informes_rama_avance">
                        <span>Cuotas cobradas en el año</span>
                        <div class="informes_pista"><div style="width: ${avance}%; background-color: ${rama.color}"></div></div>
                        <strong>${avance}%</strong>
                    </div>`
                )}
                <div class="informes_totales">
                    ${total(`Ingresos ${sufijoRango}`, money(ingresos), comparar(ingresos, ingresosAnt, etiqueta), bordes.ingreso)}
                    ${total(`Egresos ${sufijoRango}`, money(egresos), comparar(egresos, egresosAnt, etiqueta), bordes.egreso)}
                    ${total('Balance de la rama', money(balance), 'Ingresos menos egresos', bordes.caja, balance < 0 ? 'informes_total_nota--alerta' : '')}
                    ${total('Deudas', money(deuda), `${plural(conDeuda, 'miembro', 'miembros')} con deuda`, bordes.deuda, 'informes_total_nota--alerta')}
                    ${total('Miembros al día', `${alDia} de ${miembros.length}`, `${pct(alDia, miembros.length)}% de la rama`, bordes.info)}
                </div>
            </section>

            <div class="informes_fila">
                ${bloque(`${marca(bordes.ingreso)} Ingresos de ${esc(rama.nombre)}`, `
                    ${grafico(ingMes, bordes.ingreso, actual, true)}
                    <div class="informes_caja informes_caja--lista">
                        ${subtitulo(`De dónde vienen <small>· ${sufijoRango}</small>`)}
                        ${desglose(agrupar(ingRango, 'concepto'), colorConcepto, 'No hay cobros en este rango.')}
                    </div>
                    <div class="informes_caja informes_caja--lista">
                        ${subtitulo(`Medios de pago <small>· ${sufijoRango}</small>`)}
                        ${desglose(agrupar(ingRango, 'metodo'), colorMetodo, 'No hay cobros en este rango.')}
                    </div>`,
                    monto(money(ingresos), 'ingreso'), 'informes_bloque--mitad')}

                ${bloque(`${marca(bordes.egreso)} Egresos de ${esc(rama.nombre)}`, `
                    ${grafico(egMes, bordes.egreso, actual, true)}
                    <div class="informes_caja informes_caja--lista">
                        ${subtitulo(`Por categoría <small>· ${sufijoRango}</small>`)}
                        ${desglose(topConOtras(agrupar(egRango, 'categoria')), colorCategoria, 'No hay egresos en este rango.')}
                    </div>
                    <div class="informes_caja informes_caja--lista">
                        ${subtitulo(`Últimos egresos <small>· ${sufijoRango}</small>`)}
                        ${listaEgresos(egRango)}
                    </div>`,
                    monto(money(egresos), 'egreso'), 'informes_bloque--mitad')}
            </div>

            <div class="informes_fila">
                ${bloque(`Cuotas de cada miembro <small>· ordenado por deuda</small>`, `
                    <div class="informes_scroll informes_tabla_cont">
                        <table class="informes_tabla informes_tabla--cuotas">
                            <thead>
                                <tr>
                                    <th>Miembro</th>
                                    ${mesesCortos.map((m) => `<th class="informes_celda_td">${m}</th>`).join('')}
                                    <th>Estado</th>
                                    <th class="informes_num">Deuda</th>
                                </tr>
                            </thead>
                            <tbody>${filas}</tbody>
                        </table>
                    </div>`,
                    `<div class="informes_leyenda_inline">
                        <span><span class="informes_celda informes_celda--p"></span>Pagó</span>
                        <span><span class="informes_celda informes_celda--d"></span>Debe</span>
                        <span><span class="informes_celda informes_celda--n"></span>Sin cuota</span>
                        <span><span class="informes_celda informes_celda--f"></span>Todavía no corresponde</span>
                    </div>`,
                    'informes_bloque--ancho')}

                <div class="informes_columna informes_bloque--angosto">
                    ${bloque(`Deudas de ${esc(rama.nombre)}`, `<div class="informes_caja informes_caja--lista">${deudaPorTipo(miembros)}</div>`, monto(money(deuda), 'deuda'))}
                    ${bloque('Campamentos y eventos de la rama', renderActividades(ramaId))}
                </div>
            </div>`;
    };

    const render = () => {
        ocultarTip();
        if(vista === 'grupo'){
            renderGrupo();
        }else{
            renderRama(vista);
        }
    };

    const activarEn = (selector, boton) => {
        document.querySelectorAll(selector).forEach((b) => {
            b.classList.toggle('activado', b === boton);
            b.setAttribute('aria-pressed', b === boton ? 'true' : 'false');
        });
    };

    enableHorizontalGrabScroll(document.querySelector('.informes_selector_pista'), { arrastrarDesdeBotones: true });

    document.querySelectorAll('.informes_selector_btn').forEach((boton) => {
        boton.addEventListener('click', () => {
            activarEn('.informes_selector_btn', boton);
            vista = boton.dataset.informesVista;
            render();
        });
    });

    document.querySelectorAll('.informes_rango_btn').forEach((boton) => {
        boton.addEventListener('click', () => {
            activarEn('.informes_rango_btn', boton);
            rango = boton.dataset.informesRango;
            render();
        });
    });

    // Botones Ingresos / Egresos (solo en la vista del grupo): muestran una sección y ocultan la otra
    contenido.addEventListener('click', (event) => {
        const boton = event.target.closest('[data-informes-seccion]');
        if(!boton) return;
        seccion = boton.dataset.informesSeccion;
        activarEn('[data-informes-seccion]', boton);
        contenido.querySelectorAll('[data-informes-panel]').forEach((panel) => {
            panel.classList.toggle('oculto', panel.dataset.informesPanel !== seccion);
        });
    });

    // Gasto por categoría: plazos, búsqueda personalizada y filas de categoría clickeables
    contenido.addEventListener('click', (event) => {
        const plazo = event.target.closest('[data-informes-cat-plazo]');
        if(plazo){
            categoria.plazo = plazo.dataset.informesCatPlazo;
            if(categoria.plazo === 'personalizado'){
                if(!categoria.desde) categoria.desde = `${data.period}-01-01`;
                if(!categoria.hasta) categoria.hasta = hoyIso();
                categoria.resultado = null;
                categoria.error = '';
                pintarCategoria(); // espera a que se toque "Ver"
            }else{
                pintarCategoria();
                buscarCategoria();
            }
            return;
        }
        if(event.target.closest('[data-informes-cat-buscar]')){
            buscarCategoria();
            return;
        }
        const fila = event.target.closest('[data-informes-cat-ir]');
        if(fila) abrirCategoria(fila.dataset.informesCatIr);
    });

    // Cartel flotante con el monto de cada barra de los gráficos por mes.
    // Va en el body (position: fixed) para que no lo recorte el scroll horizontal del gráfico.
    const tip = document.createElement('div');
    tip.className = 'informes_tip';
    tip.setAttribute('role', 'tooltip');
    document.body.appendChild(tip);
    let tipColumna = null;

    const ocultarTip = () => {
        tip.classList.remove('informes_tip--visible');
        if(tipColumna) tipColumna.classList.remove('informes_barras_mes--hover');
        tipColumna = null;
    };

    const mostrarTip = (columna) => {
        if(tipColumna && tipColumna !== columna) tipColumna.classList.remove('informes_barras_mes--hover');
        tipColumna = columna;
        columna.classList.add('informes_barras_mes--hover');
        const { informesTipTitulo, informesTipValor } = columna.dataset;
        const titulo = informesTipTitulo.charAt(0).toUpperCase() + informesTipTitulo.slice(1);
        tip.innerHTML = `${esc(titulo)}: ${informesTipValor}`;

        // Arriba de la barra (o de la base si está vacía); si no entra, abajo
        tip.classList.remove('informes_tip--visible', 'informes_tip--abajo');
        const barra = columna.querySelector('.informes_barra').getBoundingClientRect();
        const columnaRect = columna.getBoundingClientRect();
        const centro = columnaRect.left + columnaRect.width / 2;
        const arriba = barra.height > 0 ? barra.top : columnaRect.bottom;
        const { width, height } = tip.getBoundingClientRect();
        const left = Math.min(Math.max(8, centro - width / 2), window.innerWidth - width - 8);
        const entraArriba = arriba - height - 11 >= 8;
        tip.classList.toggle('informes_tip--abajo', !entraArriba);
        tip.style.left = `${left}px`;
        tip.style.top = `${entraArriba ? arriba - height - 11 : arriba + 11}px`;
        tip.style.setProperty('--flecha', `${centro - left}px`);
        void tip.offsetWidth; // fuerza el reflow para reiniciar la transición
        tip.classList.add('informes_tip--visible');
    };

    contenido.addEventListener('mouseover', (event) => {
        const columna = event.target.closest('[data-informes-tip-valor]');
        if(columna){
            if(columna !== tipColumna) mostrarTip(columna);
        }else if(tipColumna){
            ocultarTip();
        }
    });
    contenido.addEventListener('mouseleave', ocultarTip);
    // En celular no hay hover: el toque muestra el cartel y el scroll lo esconde
    contenido.addEventListener('click', (event) => {
        const columna = event.target.closest('[data-informes-tip-valor]');
        if(columna) mostrarTip(columna);
    });
    window.addEventListener('scroll', ocultarTip, { passive: true, capture: true });

    contenido.addEventListener('keydown', (event) => {
        const fila = event.target.closest('[data-informes-cat-ir]');
        if(fila && (event.key === 'Enter' || event.key === ' ')){
            event.preventDefault();
            abrirCategoria(fila.dataset.informesCatIr);
        }
    });

    contenido.addEventListener('change', (event) => {
        if(event.target.matches('[data-informes-cat-select]')){
            categoria.id = event.target.value;
            categoria.resultado = null;
            categoria.error = '';
            if(categoria.id && categoria.plazo !== 'personalizado'){
                buscarCategoria();
            }else{
                pintarCategoria();
            }
        }else if(event.target.matches('[data-informes-cat-fecha]')){
            categoria[event.target.dataset.informesCatFecha] = event.target.value;
        }
    });

    render();
}

function darkMode(){

    const botonDarkMode = document.querySelectorAll('.dark_mode_boton');
    if(botonDarkMode.length > 0){

        
        const prefiereDark = window.matchMedia('(prefers-color-scheme:dark)');

        prefiereDark.addEventListener('change',function(){
            
        if(prefiereDark.matches){

            document.body.classList.add('dark_mode');
            localStorage.setItem('modo-oscuro','true');
        }
        else{
            document.body.classList.remove('dark_mode');
            localStorage.setItem('modo-oscuro','false');
        }
    })
    
    botonDarkMode.forEach(boton =>{

        boton.addEventListener('click', function(){
    
            document.body.classList.add('dark');
            
            if (document.body.classList.contains('dark_mode')) {
                document.body.classList.remove('dark_mode');
                
            } else {
                document.body.classList.add('dark_mode'); 
            }
            
            setTimeout(() =>{
                document.body.classList.remove('dark');
            },1000)
            
            //Para que el modo elegido se quede guardado en local-storage
            if (document.body.classList.contains('dark_mode')) {
                
                localStorage.setItem('modo-oscuro','true');
            } else {
                
                localStorage.setItem('modo-oscuro','false');
            }
        });
    })
    
    
    //Obtenemos el modo del color actual
    if (localStorage.getItem('modo-oscuro') === 'true') {
        
        document.body.classList.add('dark_mode');
    } else {

        document.body.classList.remove('dark_mode');
    }
}
}

function generatePanelsButtom() {
    const panelActivo = localStorage.getItem('panelActivo') || 'cajadiaria';

    const botones = [
        { id: 'cobros', icono: 'fa-hand-holding-dollar', texto: 'Cobrar' },
        { id: 'pagos', icono: 'fa-money-bill-transfer', texto: 'Pagar' },
        { id: 'cajadiaria', icono: 'fa-chart-pie', texto: 'Caja' },
        { id: 'informes', icono: 'fa-chart-line', texto: 'Informes' },
        { id: 'quienes', icono: 'fa-people-group', texto: 'Quienes Somos?' },
        { id: 'config', icono: 'fa-gears', texto: 'Ajustes' }
    ];

    const contenedor = document.querySelector('.botones_selec');
    if(contenedor){

        contenedor.innerHTML = ''; // Limpiar por si ya había algo
    
        botones.forEach(boton => {
            const div = document.createElement('div');
            div.id = boton.id;
            div.className = `btn btn_select${boton.id === panelActivo ? ' activado' : ''}`;
    
            div.innerHTML = `
                <i class="fa-solid ${boton.icono}" style="color:#4d4d4d;"></i>
                <p>${boton.texto}</p>
            `;
    
            contenedor.appendChild(div);
        });
    }
}

function generateSubPanelsConfig() {
    const subPanelActivo = localStorage.getItem('PanelConfigActivo') || 'general';

    const botones = [
        { id: 'general', icono: 'fa-address-card', texto: 'General' },
        { id: 'miembros', icono: 'fa-user-group', texto: 'Miembros' },
        { id: 'campamentos', icono: 'fa-tent', texto: 'Campamentos' },
        { id: 'eventos', icono: 'fa-calendar-days', texto: 'Eventos' },
        { id: 'recibos', icono: 'fa-file-invoice-dollar', texto: 'Comprobantes' },
        { id: 'cierres', icono: 'fa-chart-pie', texto: 'Cierres' }
    ];

    const contenedor = document.querySelector('.opciones_config');
    if (contenedor) {
        contenedor.innerHTML = ''; // Limpiar por si ya había algo

        botones.forEach(boton => {
            const div = document.createElement('div');
            div.id = boton.id;
            div.className = `opciones${boton.id === subPanelActivo ? ' activado' : ''}`;

            div.innerHTML = `
                <i class="fa-solid ${boton.icono}" style="color:#4d4d4d;"></i>
                <p>${boton.texto}</p>
            `;

            contenedor.appendChild(div);
        });
    }
}

function switchPanels() {
    const cont_botones = document.querySelector('.cont_botones');
    const cont_paneles = document.querySelector('.paneles');

    if (cont_botones) {
        const botonPanels = cont_botones.querySelectorAll('.btn');

        botonPanels.forEach(boton => {
            boton.addEventListener('click', function () {
                const panelName = boton.id;
                const panel = cont_paneles.querySelector("#" + panelName);

                makePanelsInvisible();
                activeButtom();

                if (panel){
                    panel.style.display = 'block';
                } 
                    
                boton.classList.add('activado');

                // Guardar el panel activo
                localStorage.setItem('panelActivo', panelName);
            });
        });

        function makePanelsInvisible() {
            const paneles = cont_paneles.querySelectorAll(".panel");
            paneles.forEach(panel => {
                panel.style.display = 'none';
            });
        }

        function activeButtom() {
            botonPanels.forEach(boton => {
                boton.classList.remove('activado');
            });
        }
    }
}

function initCobrosPanelSkeleton(){
    if(sessionStorage.getItem('showCobrosSkeletonOnLogin') !== 'true'){
        return;
    }

    sessionStorage.removeItem('showCobrosSkeletonOnLogin');
    showCobrosPanelSkeleton();
}

function showCobrosPanelSkeleton(){
    const panelCobros = document.querySelector('section.panel_cobros');
    if(!panelCobros){
        return;
    }

    const contenidoCobros = panelCobros.querySelector('.contenido_cobros');
    if(!contenidoCobros){
        return;
    }

    window.clearTimeout(contenidoCobros.cobrosSkeletonTimer);
    contenidoCobros.classList.add('skeleton-loading');
    contenidoCobros.cobrosSkeletonTimer = window.setTimeout(() => {
        contenidoCobros.classList.remove('skeleton-loading');
    }, 3000);
}

function switchPanelsConfig() {
    const cont_opciones = document.querySelector('.opciones_config');
    const cont_paneles = document.querySelector('.paneles_config');

    if (cont_opciones && cont_paneles) {
        const opcionesConfig = cont_opciones.querySelectorAll('.opciones');

        opcionesConfig.forEach(opcion => {
            opcion.addEventListener('click', function () {
                const panelName = opcion.id;
                const panel = cont_paneles.querySelector("#" + panelName);

                resetConfigTransientModals();
                makePanelsInvisible();
                activeButtom();

                if (panel){
                    panel.style.display = 'block';
                    syncConfigNameOverflowMarquees(panel);
                }
                opcion.classList.add('activado');

                // Guardar el subpanel activo
                localStorage.setItem('PanelConfigActivo', panelName);
            });
        });

        function resetConfigTransientModals() {
            const layout = document.querySelector('.layout');
            const modals = cont_paneles.querySelectorAll('.form_import_miembros');

            modals.forEach(modal => {
                modal.classList.remove('mostrar');
                modal.classList.remove('ocultar');
            });

            if (layout) {
                layout.classList.remove('mostrar');
            }
        }

        function makePanelsInvisible() {
            const paneles = cont_paneles.querySelectorAll(".panel_config");
            paneles.forEach(panel => {
                panel.style.display = 'none';
            });
        }

        function activeButtom() {
            opcionesConfig.forEach(opcion => {
                opcion.classList.remove('activado');
            });
        }

        // // Mostrar subpanel guardado si existe
        // const subPanelGuardado = localStorage.getItem('PanelConfigActivo');
        // if (subPanelGuardado) {
        //     const opcionGuardada = cont_opciones.querySelector(`#${subPanelGuardado}`);
        //     if (opcionGuardada) opcionGuardada.click();
        // } else {
        //     // Si no hay nada guardado, mostrar el primero por defecto
        //     const primerPanel = opcionesConfig[0];
        //     if (primerPanel) primerPanel.click();
        // }
    }
}

function switchPanelCuota(){
    const panel_cuotas = document.querySelector('.panel_cobros.panel_cuotas');

    if (panel_cuotas) {
        const flechaPrev = panel_cuotas.querySelector('.flecha_prev');
        const periodo = panel_cuotas.querySelector('.periodo');
        const periodoPrev = panel_cuotas.querySelector('.periodo.prev');
        const flechaPost = panel_cuotas.querySelector('.flecha_post');
        const importesActual = panel_cuotas.querySelector('.importes_cuotas.actual')
        const importesPrevio = panel_cuotas.querySelector('.importes_cuotas.previo')

        flechaPrev.addEventListener('click',() => {
            flechaPrev.style.visibility = 'hidden';
            periodo.style.display = 'none';
            importesActual.style.display = 'none';

            flechaPost.style.visibility = 'visible';
            periodoPrev.style.display = 'block';
            importesPrevio.style.display = 'grid';
        })

        flechaPost.addEventListener('click',() => {
            flechaPost.style.visibility = 'hidden';
            periodoPrev.style.display = 'none';
            importesPrevio.style.display = 'none';

            flechaPrev.style.visibility = 'visible';
            periodo.style.display = 'block';
            importesActual.style.display = 'grid';
        })
    }
}

function listenImportMembersButtomLegacy(){
    const formMiembros = document.querySelector('.form_miembros');
    if(formMiembros){
        
        const inputFile = formMiembros.querySelector('.inputExcel');
        const botonImport = formMiembros.querySelector('.import_members');
        const importForm = formMiembros.matches('form') ? formMiembros : formMiembros.querySelector('form');
        const importModal = formMiembros.querySelector('.form_import_miembros');
        const dropContainer = importModal ? importModal.querySelector('.drop-container') : null;
        const layout = document.querySelector('.layout');

        if(inputFile && botonImport && importForm && importModal && dropContainer){
            const closeModal = () => {
                importModal.classList.remove('mostrar');
                importModal.classList.add('ocultar');
                if(layout){
                    layout.classList.remove('mostrar');
                }
                dropContainer.classList.remove('dragover');
            };

            importModal.addEventListener('animationend', () => {
                if(importModal.classList.contains('ocultar')){
                    importModal.classList.remove('ocultar');
                }
            });

            const openModal = () => {
                importModal.classList.add('mostrar');
                importModal.classList.remove('ocultar');
                if(layout){
                    layout.classList.add('mostrar');
                }
            };

            const syncSelectedExcel = () => {
                if (inputFile.files.length > 0) {
                    const fileName = inputFile.files[0].name;
                    if (!fileName.endsWith('.xls') && !fileName.endsWith('.xlsx')) {
                        showAlert('error','Selecciona un archivo Excel (.xls o .xlsx)');
                        inputFile.value = '';
                        return false;
                    }

                    return true;
                }

                return false;
            };

            const submitImportForm = () => {
                if(!importForm){
                    return;
                }

                if(typeof importForm.requestSubmit === 'function'){
                    importForm.requestSubmit(botonImport);
                    return;
                }

                importForm.submit();
            };

            if(botonImport){
                botonImport.addEventListener('click', function (event) {
                    const hasValidExcel = syncSelectedExcel();
                    if(!hasValidExcel){
                        event.preventDefault();
                        openModal();
                    }
                });
            }

            if(layout){
                layout.addEventListener('click', function () {
                    if(importModal.classList.contains('mostrar')){
                        closeModal();
                    }
                });
            }

            inputFile.addEventListener('change', function () {
                const isValidExcel = syncSelectedExcel();
                if(isValidExcel){
                    closeModal();
                    submitImportForm();
                }
            });

            dropContainer.addEventListener('dragover', function (event) {
                event.preventDefault();
                dropContainer.classList.add('dragover');
            });

            dropContainer.addEventListener('dragleave', function (event) {
                event.preventDefault();
                dropContainer.classList.remove('dragover');
            });

            dropContainer.addEventListener('drop', function (event) {
                event.preventDefault();
                dropContainer.classList.remove('dragover');
                const files = event.dataTransfer.files;
                if (files.length > 0) {
                    inputFile.files = files;
                    inputFile.dispatchEvent(new Event('change'));
                }
            });

            return;
        }
        return;
    
        botonFile.addEventListener('click', function () {
            inputFile.click();
        });
    
        botonFile.addEventListener('drop', function (event) {
            event.preventDefault();
            handleDrop(event);
            botonFile.classList.remove('hover');
        });
    
        botonFile.addEventListener('dragover', function (event) {
            event.preventDefault();
            botonFile.classList.add('hover');
        });
        
        botonFile.addEventListener('dragleave', function (event) {
            event.preventDefault();
            botonFile.classList.remove('hover');
        });
    
        inputFile.addEventListener('change', function () {
            if (this.files.length > 0) {
                const fileName = this.files[0]['name'];
                if (!fileName.endsWith('.xls') && !fileName.endsWith('.xlsx')) {
                    showAlert('error','Selecciona un archivo Excel (.xls o .xlsx)')
                    this.value = ''; // Resetea el input
                    textoBotonFile.innerHTML = 'Seleccione una Nómina';
                    return;
                }
                textoBotonFile.innerHTML = fileName;
            }else{
                textoBotonFile.innerHTML = 'Seleccione una Nomina'; 
            }
    
        });
        function handleDrop(event) {
            var files = event.dataTransfer.files;
            if (files.length > 0) {
                inputFile.files = files;
                inputFile.dispatchEvent(new Event('change'));
            }
        }
    }

}

function listenImportMembersButtom(){
    const formMiembros = document.querySelector('.form_miembros');
    if(!formMiembros){
        return;
    }

    const inputFile = formMiembros.querySelector('.inputExcel');
    const botonImport = formMiembros.querySelector('.import_members');
    const importForm = formMiembros.matches('form') ? formMiembros : formMiembros.querySelector('form');
    const importModal = formMiembros.querySelector('.form_import_miembros');
    const dropContainer = importModal ? importModal.querySelector('.drop-container') : null;
    const layout = document.querySelector('.layout');

    if(!inputFile || !botonImport || !importForm || !importModal || !dropContainer){
        return;
    }

    const closeModal = () => {
        importModal.classList.remove('mostrar');
        importModal.classList.add('ocultar');
        if(layout){
            layout.classList.remove('mostrar');
        }
        dropContainer.classList.remove('dragover');
    };

    const openModal = () => {
        importModal.classList.add('mostrar');
        importModal.classList.remove('ocultar');
        if(layout){
            layout.classList.add('mostrar');
        }
    };

    const validExcelSelected = () => {
        if(inputFile.files.length === 0){
            return false;
        }

        const fileName = inputFile.files[0].name;
        if(!fileName.endsWith('.xls') && !fileName.endsWith('.xlsx')){
            showAlert('error','Selecciona un archivo Excel (.xls o .xlsx)');
            inputFile.value = '';
            return false;
        }

        return true;
    };

    const submitImportForm = () => {
        if(typeof importForm.requestSubmit === 'function'){
            importForm.requestSubmit(botonImport);
            return;
        }

        importForm.submit();
    };

    importModal.addEventListener('animationend', () => {
        if(importModal.classList.contains('ocultar')){
            importModal.classList.remove('ocultar');
        }
    });

    botonImport.addEventListener('click', function (event) {
        if(!validExcelSelected()){
            event.preventDefault();
            openModal();
        }
    });

    if(layout){
        layout.addEventListener('click', function () {
            if(importModal.classList.contains('mostrar')){
                closeModal();
            }
        });
    }

    inputFile.addEventListener('change', function () {
        if(validExcelSelected()){
            closeModal();
            submitImportForm();
        }
    });

    dropContainer.addEventListener('dragover', function (event) {
        event.preventDefault();
        dropContainer.classList.add('dragover');
    });

    dropContainer.addEventListener('dragleave', function (event) {
        event.preventDefault();
        dropContainer.classList.remove('dragover');
    });

    dropContainer.addEventListener('drop', function (event) {
        event.preventDefault();
        dropContainer.classList.remove('dragover');
        const files = event.dataTransfer.files;
        if(files.length > 0){
            inputFile.files = files;
            inputFile.dispatchEvent(new Event('change'));
        }
    });
}

function showMemberForms(){
    const rowsMiembros = document.querySelectorAll('.row_miembro:not(.header_miembro)');
    const formMiembros = document.querySelector('.form_miembro_indv');
    
    if(formMiembros){
        showCreateMemberForm();
        showEditMemberForm();
        showDeleteMemberForm();
    }
}

function showCreateMemberForm(){
    const formMiembros = document.querySelector('.form_miembro_indv.create');
    const btn_indv = document.querySelector('.cont_individual');
    const btn_x = formMiembros.querySelector('.btn_x');
    const doc_input = formMiembros.querySelector('.campo.documento input');
    const tel_input = formMiembros.querySelector('.campo.telefono input');
    const layout = document.querySelector('.layout');

    btn_indv.addEventListener("click",()=>{
        if(formMiembros.classList.contains('mostrar')){
            formMiembros.classList.remove('mostrar');
            formMiembros.classList.add('ocultar');
            layout.classList.remove('mostrar');
            raiseMemberFields();
        }else{
            formMiembros.classList.add('mostrar');
            formMiembros.classList.remove('ocultar'); 
            layout.classList.add('mostrar');
        }
    })

    if(btn_x){
        btn_x.addEventListener("click",()=>{
            if(formMiembros.classList.contains('mostrar')){
                formMiembros.classList.remove('mostrar');
                formMiembros.classList.add('ocultar');
                layout.classList.remove('mostrar');
                raiseMemberFields();
            }
        })
    }
    layout.addEventListener("click",()=>{
        if(formMiembros.classList.contains('mostrar')){
            formMiembros.classList.remove('mostrar');
            formMiembros.classList.add('ocultar');
            layout.classList.remove('mostrar');
            raiseMemberFields();
        }
    })

    document.addEventListener("click",(event)=>{
        if(
            formMiembros.classList.contains('mostrar') &&
            !formMiembros.contains(event.target) &&
            !btn_indv.contains(event.target)
        ){
            formMiembros.classList.remove('mostrar');
            formMiembros.classList.add('ocultar');
            layout.classList.remove('mostrar');
            raiseMemberFields();
        }
    })

    doc_input.addEventListener("input", () => {
        doc_input.value = doc_input.value.replace(/\D/g, ""); // Reemplaza todo lo que no sea número
    });
    tel_input.addEventListener("input", () => {
        tel_input.value = tel_input.value.replace(/\D/g, ""); // Reemplaza todo lo que no sea número
    });

    function raiseMemberFields(){
        const inputNombre = formMiembros.querySelector("#nombre_create");
        const inputDoc = formMiembros.querySelector("#documento_create");
        const inputRama = formMiembros.querySelector("#rama_create");
        const inputTelefono = formMiembros.querySelector("#telefono_create");
        
        inputNombre.value = '';
        inputDoc.value = '';
        inputTelefono.value = '';
        inputRama.value = 0;
        syncAppCustomSelect(inputRama);

    }
}

function showEditMemberForm(newRow = false){
    const formMiembros = document.querySelector('.form_miembro_indv.edit');
    const btn_x = formMiembros.querySelector('.btn_x');
    const tel_input = formMiembros.querySelector('.campo.telefono input');
    const layout = document.querySelector('.layout');

    let rowsMiembros = [];
    if(newRow){
        rowsMiembros = document.querySelectorAll('.row_miembro:not(.header_miembro).no_revisar.new');
    }else{
        rowsMiembros = document.querySelectorAll('.row_miembro:not(.header_miembro).no_revisar');
    }

    rowsMiembros.forEach((row) => {
        const btn_edit = row.querySelector(".editar_miembro");
        row.classList.remove('new');
        btn_edit.addEventListener("click",()=>{
            if(formMiembros.classList.contains('mostrar')){
                formMiembros.classList.remove('mostrar');
                formMiembros.classList.add('ocultar');
                layout.classList.remove('mostrar');
                row.classList.remove('selected');
                raiseMemberFields(row);
            }else{
                formMiembros.classList.add('mostrar');
                formMiembros.classList.remove('ocultar'); 
                layout.classList.add('mostrar');
                row.classList.add('selected');
                completeMemberFields(row);
            }
        })
    })

    if(!newRow){
        btn_x.addEventListener("click",()=>{
            if(formMiembros.classList.contains('mostrar')){
                formMiembros.classList.remove('mostrar');
                formMiembros.classList.add('ocultar');
                layout.classList.remove('mostrar');
                rowsMiembros.forEach((row) => {row.classList.remove('selected');})
                raiseMemberFields();
            }
        })
        layout.addEventListener("click",()=>{
            if(formMiembros.classList.contains('mostrar')){
                formMiembros.classList.remove('mostrar');
                formMiembros.classList.add('ocultar');
                layout.classList.remove('mostrar');
                rowsMiembros.forEach((row) => {row.classList.remove('selected');})
                raiseMemberFields();
            }
        })
    
        tel_input.addEventListener("input", () => {
            tel_input.value = tel_input.value.replace(/\D/g, ""); // Reemplaza todo lo que no sea número
        });
    }

    function completeMemberFields(row){
        const activo = row.querySelector(".campo_activo div");
        const nombre = row.querySelector(".campo_nombre p");
        const rama = row.querySelector(".campo_codrama p");
        const telefono = row.querySelector(".campo_telefono p");

        const inputActivo = formMiembros.querySelector("#activo");
        const inputNombre = formMiembros.querySelector("#nombre_edit");
        const inputRama = formMiembros.querySelector("#rama_edit");
        const inputTelefono = formMiembros.querySelector("#telefono_edit");
        
        inputNombre.value = nombre.innerHTML;
        inputTelefono.value = telefono.innerHTML;
        inputRama.value = rama.innerHTML;
        syncAppCustomSelect(inputRama);

        if(activo.classList.contains('activo')){
            inputActivo.checked = true;
        }else{
            inputActivo.checked = false;
        }

    }

    function raiseMemberFields(row){
        const inputActivo = formMiembros.querySelector("#activo");
        const inputNombre = formMiembros.querySelector("#nombre_edit");
        const inputRama = formMiembros.querySelector("#rama_edit");
        const inputTelefono = formMiembros.querySelector("#telefono_edit");
        
        inputNombre.value = '';
        inputTelefono.value = '';
        inputRama.value = 0;
        inputActivo.checked = false;
        syncAppCustomSelect(inputRama);

    }

}

function showDeleteMemberForm(){
    const formMiembros = document.querySelector('.form_miembro_indv.delete');
    const rowsMiembros = document.querySelectorAll('.row_miembro:not(.header_miembro)');
    const btn_x = formMiembros.querySelector('.btn_x');
    const layout = document.querySelector('.layout');

    rowsMiembros.forEach((row) => {
        const btn_delete = row.querySelector(".eliminar_miembro");

        btn_delete.addEventListener("click",()=>{
            if(formMiembros.classList.contains('mostrar')){
                formMiembros.classList.remove('mostrar');
                formMiembros.classList.add('ocultar');
                layout.classList.remove('mostrar');
                row.classList.remove('selected');
                raiseMemberFields();
            }else{
                formMiembros.classList.add('mostrar');
                formMiembros.classList.remove('ocultar'); 
                layout.classList.add('mostrar');
                row.classList.add('selected');
                completeMemberFields(row);
            }
        })
    })

    btn_x.addEventListener("click",()=>{
        if(formMiembros.classList.contains('mostrar')){
            formMiembros.classList.remove('mostrar');
            formMiembros.classList.add('ocultar');
            layout.classList.remove('mostrar');
            rowsMiembros.forEach((row) => {row.classList.remove('selected');})
            raiseMemberFields();
        }
    })
    layout.addEventListener("click",()=>{
        if(formMiembros.classList.contains('mostrar')){
            formMiembros.classList.remove('mostrar');
            formMiembros.classList.add('ocultar');
            layout.classList.remove('mostrar');
            rowsMiembros.forEach((row) => {row.classList.remove('selected');})
            raiseMemberFields();
        }
    })
    function completeMemberFields(row){
        const doc = row.querySelector(".campo_doc p");
        const legend = formMiembros.querySelector(".eliminar_miembro legend");
        
        legend.innerHTML += doc.innerHTML + '?';

    }

    function raiseMemberFields(row){

        const legend = formMiembros.querySelector(".eliminar_miembro legend");
        
        legend.innerHTML = '¿Eliminar Miembro DNI: ';
    }
}

function showCampaForms(){
    const createFormCampa = document.querySelector('.form_campa_indv.create');
    const rowsCampa = document.querySelectorAll('.row_campa:not(.header_campa)');

    if(createFormCampa){
        activeCampRamaOptions(createFormCampa);
        showCreateCampaForm();
    }

    if(rowsCampa.length > 0){
        const formCampa = document.querySelector('.form_campa_indv.edit');
        activeCampRamaOptions(formCampa);
        showEditCampaForm();
        showDeleteCampaForm();
    }
}

function getCampAttendanceStatus(miembro, campId){
    const attendance = JSON.parse(miembro.dataset.campAttendance || '{}');
    return ['pendiente', 'confirmado', 'no_asiste'][Number(attendance[campId] || 0)] || 'pendiente';
}

function updateCampAttendanceState(doc, campId, status){
    document.querySelectorAll('.verificacion_miembro').forEach(miembro => {
        if(miembro.dataset.doc !== String(doc)){ return; }
        const attendance = Object.assign({}, JSON.parse(miembro.dataset.campAttendance || '{}'));
        attendance[campId] = status;
        miembro.dataset.campAttendance = JSON.stringify(attendance);
    });
    document.dispatchEvent(new CustomEvent('camp-attendance-updated', {detail: {campId: String(campId)}}));
}

function initCampVerificationPanel(){
    const panelCampas = document.querySelector('.panel_config.config_campas');
    if(!panelCampas || panelCampas.dataset.verificacionReady === 'true'){
        return;
    }
    panelCampas.dataset.verificacionReady = 'true';

    const modal = panelCampas.querySelector('.verificacion_campa_modal');
    if(!modal){
        return;
    }

    const title = modal.querySelector('#verificacion_campa_titulo');
    const closeBtn = modal.querySelector('.verificacion_campa_close');
    const searchInput = modal.querySelector('.verificacion_campa_search');
    const filterBtns = modal.querySelectorAll('.verificacion_filtro_btn');
    const groups = modal.querySelectorAll('.rama_group');
    const miembros = modal.querySelectorAll('.verificacion_miembro');
    const empty = modal.querySelector('.verificacion_empty');
    const counters = modal.querySelectorAll('[data-status-count]');
    let currentCampId = '';
    let statusFilter = 'todos';

    panelCampas.addEventListener('click',(event)=>{
        const btn = event.target.closest('.verificar_campa');
        if(!btn || !panelCampas.contains(btn)){
            return;
        }

        const row = btn.closest('.row_campa');
        if(row){
            openVerification(row);
        }
    })

    closeBtn.addEventListener('click', closeVerification);
    modal.addEventListener('click',(event)=>{
        if(event.target === modal){
            closeVerification();
        }
    })

    document.addEventListener('keydown',(event)=>{
        if(event.key === 'Escape' && modal.classList.contains('mostrar')){
            closeVerification();
        }
    })

    searchInput.addEventListener('input', applyFilters);

    filterBtns.forEach((btn)=>{
        btn.addEventListener('click',()=>{
            statusFilter = btn.dataset.filter;
            filterBtns.forEach((b)=>{ b.classList.toggle('active', b === btn); });
            applyFilters();
        })
    })

    groups.forEach((group)=>{
        const header = group.querySelector('.rama_header');
        header.addEventListener('click',()=>{
            group.classList.toggle('collapsed');
        })
    })

    miembros.forEach((miembro)=>{
        const buttons = miembro.querySelectorAll('.estado_btn');
        buttons.forEach((button)=>{
            button.addEventListener('click',async ()=>{
                if(!currentCampId || miembro.dataset.saving === 'true'){ return; }
                const campId = currentCampId;
                const status = ['pendiente', 'confirmado', 'no_asiste'].indexOf(button.dataset.status);
                miembro.dataset.saving = 'true';
                buttons.forEach(btn => { btn.disabled = true; });
                try {
                    const response = await fetch('/api/ChangeCampAssistentStatus.php', {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({Documento: miembro.dataset.doc, IdCampamento: campId, Asistencia: status})
                    });
                    const result = await response.json();
                    if(!response.ok || result.response !== 200){
                        throw new Error(result.error || 'No se pudo guardar la asistencia');
                    }
                    updateCampAttendanceState(miembro.dataset.doc, campId, status);
                }catch(error){
                    showAlert('error', error.message || 'No se pudo guardar la asistencia');
                }finally{
                    miembro.dataset.saving = 'false';
                    buttons.forEach(btn => { btn.disabled = false; });
                }
            })
        })
    })

    document.addEventListener('camp-attendance-updated', event => {
        if(event.detail.campId !== currentCampId){ return; }
        miembros.forEach(miembro => setMemberStatus(miembro, getCampAttendanceStatus(miembro, currentCampId)));
        updateCounters();
        applyFilters();
    });

    function openVerification(row){
        currentCampId = row.querySelector('.campo_internal p').textContent.trim();
        const campName = row.querySelector('.campo_nombre p').textContent.trim();
        const campRamas = getCampRamas(row);

        title.textContent = campName;
        searchInput.value = '';
        statusFilter = 'todos';
        filterBtns.forEach((b)=>{ b.classList.toggle('active', b.dataset.filter === 'todos'); });

        groups.forEach((group)=>{
            const familia = group.dataset.ramaFamilia;
            const eligible = campRamas.includes('ALL') || campRamas.includes(familia);
            group.classList.toggle('rama_oculta', !eligible);
            group.classList.remove('collapsed');
        })

        miembros.forEach((miembro)=>{
            miembro.classList.remove('search_oculta','status_oculta');
            const savedStatus = getCampAttendanceStatus(miembro, currentCampId);
            setMemberStatus(miembro, savedStatus);
        })

        updateCounters();
        applyFilters();
        modal.classList.add('mostrar');
        modal.classList.remove('ocultar');
        modal.setAttribute('aria-hidden','false');
    }

    function closeVerification(){
        modal.classList.remove('mostrar');
        modal.classList.add('ocultar');
        modal.setAttribute('aria-hidden','true');
        currentCampId = '';
    }

    function getCampRamas(row){
        const codRamaNode = row.querySelector('.campo_codrama p');
        const rawRamas = row.dataset.ramas || (codRamaNode ? codRamaNode.textContent : '') || 'ALL';
        return rawRamas.split(',').map(rama => rama.trim()).filter(Boolean);
    }

    function setMemberStatus(miembro,status){
        const nextStatus = status || 'pendiente';
        miembro.dataset.status = nextStatus;
        miembro.querySelectorAll('.estado_btn').forEach((button)=>{
            button.classList.toggle('active', button.dataset.status === nextStatus);
        })
    }

    // Busqueda por nombre + filtro por estado, combinados; se aplican por miembro y despues
    // se recalcula si cada grupo de rama tiene algun miembro visible (para ocultar el grupo
    // entero cuando el filtro/busqueda no deja nada de esa rama).
    function applyFilters(){
        const term = quitarAcentos(searchInput.value.toLowerCase());

        miembros.forEach((miembro)=>{
            const nombreEl = miembro.querySelector('.verificacion_miembro_nombre');
            const name = quitarAcentos((nombreEl ? nombreEl.textContent : '').toLowerCase());
            const matchesSearch = !term || name.includes(term);
            const matchesStatus = statusFilter === 'todos' || miembro.dataset.status === statusFilter;
            miembro.classList.toggle('search_oculta', !matchesSearch);
            miembro.classList.toggle('status_oculta', !matchesStatus);
        })

        groups.forEach((group)=>{
            const visibleInGroup = group.querySelectorAll('.verificacion_miembro:not(.search_oculta):not(.status_oculta)').length;
            const visibleSpan = group.querySelector('.rama_count_visible');
            if(visibleSpan){
                visibleSpan.textContent = visibleInGroup;
            }
            const eligible = !group.classList.contains('rama_oculta');
            group.classList.toggle('empty_oculta', eligible && visibleInGroup === 0);
        })

        updateEmptyState();
    }

    function getVisibleMembers(){
        return Array.from(miembros).filter((miembro)=>{
            const group = miembro.closest('.rama_group');
            const groupVisible = group && !group.classList.contains('rama_oculta');
            return groupVisible && !miembro.classList.contains('search_oculta') && !miembro.classList.contains('status_oculta');
        });
    }

    function updateCounters(){
        const eligibleMembers = Array.from(miembros).filter((miembro)=>{
            const group = miembro.closest('.rama_group');
            return group && !group.classList.contains('rama_oculta');
        });
        counters.forEach((counter)=>{
            const status = counter.dataset.statusCount;
            counter.textContent = eligibleMembers.filter(miembro => miembro.dataset.status === status).length;
        })
    }

    function updateEmptyState(){
        empty.style.display = getVisibleMembers().length ? 'none' : 'block';
    }
}

function getCampValueTypePlaceholder(rowIndex){
    if(rowIndex === 0){
        return 'S/Hnos';
    }
    return rowIndex === 1 ? '1 Hno' : `${rowIndex} Hnos`;
}

function updateCampValueTypePlaceholders(formCampa){
    formCampa.querySelectorAll('.valor_campa_row').forEach((row,index)=>{
        const tipoInput = row.querySelector('.tipo_valor_campa');
        if(tipoInput){
            tipoInput.placeholder = getCampValueTypePlaceholder(index);
        }
    });
}

function hasCampValueAmount(valorInput){
    if(!valorInput){
        return false;
    }

    const value = valorInput.value.trim();
    if(value === '' || value === '$ 0'){
        return false;
    }

    return !Number.isNaN(formatCurrencyToFloat(value));
}

function getCampValueTypeText(tipoInput, valorInput = null){
    if(!tipoInput){
        return '';
    }
    const typedValue = tipoInput.value.trim();
    if(typedValue !== ''){
        return typedValue;
    }

    return hasCampValueAmount(valorInput) ? tipoInput.placeholder.trim() : '';
}

function cloneCampCurrencyValues(values){
    try{
        return JSON.parse(JSON.stringify(values || {}));
    }catch(error){
        return {};
    }
}

function formatShortDate(dateValue){
    if(!dateValue){
        return '';
    }
    const datePart = String(dateValue).split('T')[0].split(' ')[0];
    const parts = datePart.split('-');
    if(parts.length === 3){
        const [year,month,day] = parts;
        return `${day.padStart(2,'0')}/${month.padStart(2,'0')}/${year.slice(-2)}`;
    }
    const date = new Date(dateValue);
    if(Number.isNaN(date.getTime())){
        return '';
    }
    const day = String(date.getDate()).padStart(2,'0');
    const month = String(date.getMonth() + 1).padStart(2,'0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
}

function getDateSortValue(dateValue){
    if(!dateValue){
        return 0;
    }

    const normalizedValue = String(dateValue).trim();
    const match = normalizedValue.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2}))?/);

    if(match){
        const [, year, month, day, hour = '0', minute = '0', second = '0'] = match;
        return new Date(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)).getTime();
    }

    return Date.parse(normalizedValue) || 0;
}

function getCampAmount(value){
    if(typeof value === 'number'){ return value; }
    const text = String(value == null ? '' : value).trim();
    if(!text){ return NaN; }
    if(/^-?\d+(?:\.\d{2})?$/.test(text)){ return Number(text); }
    return formatCurrencyToFloat(text);
}

function getConfiguredCampCurrencies(currencies){
    const configured = {};
    Object.entries(currencies || {}).forEach(([code, currency]) => {
        const values = (currency.Valores || []).filter(row =>
            String(row.Tipo || '').trim() && Number.isFinite(getCampAmount(row.Valor)) && getCampAmount(row.Valor) > 0
        );
        if(values.length){
            configured[code] = Object.assign({}, currency, {
                Valores: values.map(row => ({Tipo: row.Tipo, Valor: getCampAmount(row.Valor)}))
            });
        }
    });
    return configured;
}

function updateCampCurrencyIndicators(form, currencies){
    const configured = getConfiguredCampCurrencies(currencies);
    form.querySelectorAll('.opcion_moneda_campa').forEach(option => {
        const enabled = !!configured[option.dataset.code];
        option.classList.toggle('has_values', enabled);
        option.title = enabled ? 'Moneda habilitada: tiene importes cargados' : 'Sin importes: no aparece al cobrar';
    });
}

function getCampCurrencyCodes(campa, userCodes){
    if(!campa){ return []; }
    let values = {};
    try{ values = JSON.parse(campa.dataset.valoresMoneda || '{}'); }catch(error){}
    // Older camps only have a single legacy price, without per-currency rows.
    if(!Object.keys(values).length){ return userCodes.slice(0, 1); }
    const configured = getConfiguredCampCurrencies(values);
    return userCodes.filter(code => !!configured[code]);
}

// Precio de la columna de la lista de campamentos, con el signo de su moneda (ej. "US$20,00").
function formatCampListPrice(valor, signo = '$'){
    const sign = signo || '$';
    return formatCurrencyWithSigne(String(Number(valor).toFixed(2)), sign, false, false).replace(sign + ' ', sign);
}

function getCampFormFields(form){
    const name = form.querySelector('.campo.nombre input');
    const selected = form.querySelector('.opcion_moneda_campa.active');
    let currencies = {};
    try{ currencies = JSON.parse(form.dataset.valoresMoneda || '{}'); }catch(error){}
    if(selected){
        currencies[selected.dataset.code] = {
            Moneda: selected.dataset.code, Nombre: selected.dataset.name, Signo: selected.dataset.sign,
            Valores: Array.from(form.querySelectorAll('.valor_campa_row')).map(row => ({
                Tipo: getCampValueTypeText(row.querySelector('.tipo_valor_campa'), row.querySelector('.importe_valor_campa')),
                Valor: row.querySelector('.importe_valor_campa').value
            }))
        };
    }
    const configured = getConfiguredCampCurrencies(currencies);
    const codes = Object.keys(configured);
    const ramas = Array.from(form.querySelectorAll('.select_rama .opciones_rama.active')).map(option => option.id);
    const errors = [];
    if(!name.value.trim()){ errors.push('Nombre'); name.classList.add('input_error'); }
    if(!ramas.length){ errors.push('Unidad'); }
    if(!codes.length){ errors.push('al menos un importe mayor a cero en una moneda'); }
    Object.values(currencies).forEach(currency => {
        const enabled = (currency.Valores || []).some(row => getCampAmount(row.Valor) > 0);
        (currency.Valores || []).forEach(row => {
            const raw = String(row.Valor == null ? '' : row.Valor).trim();
            if(raw && (!Number.isFinite(getCampAmount(raw)) || getCampAmount(raw) < 0)){
                errors.push('un importe valido en ' + currency.Nombre);
            }else if(enabled && !(getCampAmount(raw) > 0)){
                errors.push('el importe de ' + (row.Tipo || 'cada tipo de valor') + ' en ' + currency.Nombre);
            }
        });
    });
    if(errors.length){ showAlert('error', 'Falta completar ' + errors.join(', ')); return false; }
    // La moneda principal (Precio de la lista) es la primera con importes segun el orden de
    // Ajustes, no la que quedo marcada al guardar.
    const orderedCodes = Array.from(form.querySelectorAll('.opcion_moneda_campa'))
        .map(option => option.dataset.code)
        .filter(code => configured[code]);
    const primary = configured[orderedCodes[0] || codes[0]];
    return {
        Nombre: name.value.trim(), Ramas: ramas.join(','),
        Valor: primary.Valores[0].Valor, TipoValor: primary.Valores[0].Tipo,
        Valores: primary.Valores, ValoresPorMoneda: configured,
        Moneda: primary.Moneda, MonedaName: primary.Nombre, MonedaSigno: primary.Signo
    };
}

function showCreateCampaForm(){
    const formCampa = document.querySelector('.form_campa_indv.create');
    const btn_indv = document.querySelector('.panel_config.config_campas .cont_individual');
    const btnAddValor = formCampa.querySelector('.agregar_valor_campa');
    const monedaOptions = formCampa.querySelectorAll('.opcion_moneda_campa');
    const layout = document.querySelector('.layout');
    let currentCurrencyCode = getActiveCurrencyCode();
    let currencyValues = {};

    formCampa.resetCampCurrencies = raiseCampaFields;
    initCreateCampValueRows();
    saveCurrentCurrencyValues();

    monedaOptions.forEach((option)=>{
        option.addEventListener('click',()=>{
            if(option.classList.contains('active')){
                return;
            }
            saveCurrentCurrencyValues();
            monedaOptions.forEach((opt)=>{
                opt.classList.remove('active');
                opt.setAttribute('aria-pressed','false');
            })
            option.classList.add('active');
            option.setAttribute('aria-pressed','true');
            currentCurrencyCode = option.dataset.code;
            loadCurrencyValues(currentCurrencyCode);
        })
    })

    btn_indv.addEventListener("click",()=>{
        if(formCampa.classList.contains('mostrar')){
            formCampa.classList.remove('mostrar');
            formCampa.classList.add('ocultar');
            layout.classList.remove('mostrar');
            raiseCampaFields();
        }else{
            formCampa.classList.add('mostrar');
            formCampa.classList.remove('ocultar');
            layout.classList.add('mostrar');
        }
    })

    layout.addEventListener("click",()=>{
        if(formCampa.classList.contains('mostrar')){
            formCampa.classList.remove('mostrar');
            formCampa.classList.add('ocultar');
            layout.classList.remove('mostrar');
            raiseCampaFields();
        }
    })

    document.addEventListener("click",(event)=>{
        if(
            formCampa.classList.contains('mostrar') &&
            !formCampa.contains(event.target) &&
            !btn_indv.contains(event.target)
        ){
            formCampa.classList.remove('mostrar');
            formCampa.classList.add('ocultar');
            layout.classList.remove('mostrar');
            raiseCampaFields();
        }
    })

    if(btnAddValor){
        btnAddValor.addEventListener('click',()=>{
            saveCurrentCurrencyValues();
            addCreateCampValueRow();
            syncCurrencyRowsFromDom();
        })
    }

    const inputNombreCreate = formCampa.querySelector("#nombre_campaCreate");
    if(inputNombreCreate){
        inputNombreCreate.addEventListener('input',()=>{
            inputNombreCreate.classList.remove('input_error');
        })
    }

    function initCreateCampValueRows(){
        const rows = formCampa.querySelectorAll('.valor_campa_row');

        updateCampValueTypePlaceholders(formCampa);
        rows.forEach((row)=>bindCreateCampValueRow(row));
    }

    function bindCreateCampValueRow(row){
        const tipoInput = row.querySelector('.tipo_valor_campa');
        const importeInput = row.querySelector('.importe_valor_campa');
        const deleteBtn = row.querySelector('.eliminar_valor_campa');

        tipoInput.addEventListener('input',()=>{
            tipoInput.value = tipoInput.value.slice(0,6);
            row.classList.remove('needs_edit');
            tipoInput.classList.remove('input_error');
            syncCurrencyRowsFromDom();
        })
        importeInput.addEventListener('input',()=>{
            importeInput.value = formatCurrencyInteger(importeInput.value);
            row.classList.remove('needs_edit');
            importeInput.classList.remove('input_error');
            saveCurrentCurrencyValues();
        })
        if(deleteBtn){
            deleteBtn.addEventListener('click',(event)=>{
                event.preventDefault();
                event.stopPropagation();
                const rowIndex = Array.from(formCampa.querySelectorAll('.valor_campa_row')).indexOf(row);
                if(row.classList.contains('extra')){
                    row.remove();
                    updateCampValueTypePlaceholders(formCampa);
                    removeCurrencyValueRow(rowIndex);
                    return;
                }
                tipoInput.value = '';
                importeInput.value = '';
                tipoInput.classList.remove('input_error');
                importeInput.classList.remove('input_error');
                syncCurrencyRowsFromDom();
            })
        }
    }

    function addCreateCampValueRow(){
        const contValores = formCampa.querySelector('.valores_campa_create');
        if(!contValores || !btnAddValor){
            return;
        }

        const row = document.createElement('div');
        row.className = 'valor_campa_row extra needs_edit';
        const rowIndex = formCampa.querySelectorAll('.valor_campa_row').length;
        row.innerHTML = `
            <input type="text" class="tipo_valor_campa" placeholder="${getCampValueTypePlaceholder(rowIndex)}" value="" maxlength="6">
            <input type="text" class="importe_valor_campa" placeholder="$Valor" value="">
            <button type="button" class="eliminar_valor_campa" title="Eliminar valor" aria-label="Eliminar valor">x</button>
        `;

        bindCreateCampValueRow(row);

        contValores.insertBefore(row, btnAddValor);
        updateCampValueTypePlaceholders(formCampa);
    }

    function getActiveCurrencyCode(){
        const active = formCampa.querySelector('.opcion_moneda_campa.active');
        return active ? active.dataset.code : '';
    }

    function getCurrencyMeta(option){
        return {
            'Nombre': option.dataset.name || '',
            'Signo': option.dataset.sign || ''
        };
    }

    function getValueRowsData(){
        const rows = formCampa.querySelectorAll('.valor_campa_row');
        return Array.from(rows).map((row)=>{
            const tipo = row.querySelector('.tipo_valor_campa');
            const valor = row.querySelector('.importe_valor_campa');
            return {
                'Tipo': getCampValueTypeText(tipo, valor),
                'Valor': valor ? valor.value : ''
            };
        });
    }

    function ensureCurrencyState(code){
        if(!code){
            return;
        }
        if(!currencyValues[code]){
            currencyValues[code] = {
                'Moneda': code,
                'Nombre': '',
                'Signo': '',
                'Valores': []
            };
        }
        const option = Array.from(monedaOptions).find((opt)=>opt.dataset.code === code);
        if(option){
            const meta = getCurrencyMeta(option);
            currencyValues[code]['Nombre'] = meta.Nombre;
            currencyValues[code]['Signo'] = meta.Signo;
        }
    }

    function saveCurrentCurrencyValues(){
        const code = currentCurrencyCode || getActiveCurrencyCode();
        if(!code){
            updateCurrencyValuesDataset();
            return;
        }
        ensureCurrencyState(code);
        currencyValues[code]['Valores'] = getValueRowsData();
        syncCurrencyRowsFromDom(false);
        updateCurrencyValuesDataset();
    }

    function syncCurrencyRowsFromDom(updateDataset = true){
        const rowsData = getValueRowsData();
        monedaOptions.forEach((option)=>{
            const code = option.dataset.code;
            ensureCurrencyState(code);
            const oldValues = currencyValues[code]['Valores'] || [];
            currencyValues[code]['Valores'] = rowsData.map((row,index)=>({
                'Tipo': row.Tipo || (oldValues[index] ? oldValues[index].Tipo : '') || getCampValueTypePlaceholder(index),
                'Valor': code === getActiveCurrencyCode() ? row.Valor : (oldValues[index] ? oldValues[index]['Valor'] : '')
            }));
        })
        if(updateDataset){
            updateCurrencyValuesDataset();
        }
    }

    function loadCurrencyValues(code){
        ensureCurrencyState(code);
        const rows = formCampa.querySelectorAll('.valor_campa_row');
        const values = currencyValues[code]['Valores'] || [];
        rows.forEach((row,index)=>{
            const tipo = row.querySelector('.tipo_valor_campa');
            const valor = row.querySelector('.importe_valor_campa');
            const data = values[index] || {'Tipo':'','Valor':''};
            if(tipo){
                tipo.value = data.Tipo || '';
            }
            if(valor){
                valor.classList.remove('valor_currency_skeleton');
                valor.classList.add('valor_currency_skeleton');
                valor.value = data.Valor ? formatCurrencyInteger(data.Valor) : '';
                window.setTimeout(()=>{
                    valor.classList.remove('valor_currency_skeleton');
                },180);
            }
        })
        updateCurrencyValuesDataset();
    }

    function removeCurrencyValueRow(rowIndex){
        monedaOptions.forEach((option)=>{
            const code = option.dataset.code;
            ensureCurrencyState(code);
            currencyValues[code]['Valores'].splice(rowIndex,1);
        })
        syncCurrencyRowsFromDom();
    }

    function updateCurrencyValuesDataset(){
        formCampa.dataset.valoresMoneda = JSON.stringify(currencyValues);
        updateCampCurrencyIndicators(formCampa, currencyValues);
    }

    function raiseCampaFields(){
        const inputNombre = formCampa.querySelector("#nombre_campaCreate");
        const inputPrecio = formCampa.querySelector("#valor_campaCreate");
        const inputTipo = formCampa.querySelector("#tipo_valor_campaCreate");
        const extraValores = formCampa.querySelectorAll(".valor_campa_row.extra");
        const optionsRama = formCampa.querySelectorAll(".select_rama .opciones_rama");
        const monedaOptions = formCampa.querySelectorAll(".opcion_moneda_campa");

        inputNombre.value = '';
        inputPrecio.value = '';
        inputTipo.value = '';
        formCampa.querySelectorAll('.input_error').forEach((input)=>input.classList.remove('input_error'));
        extraValores.forEach((row)=>row.remove());
        optionsRama.forEach((option)=>{
            option.classList.remove('disable');
            option.classList.remove('active');
        })
        monedaOptions.forEach((option,i)=>{
            option.classList.toggle('active', i === 0);
            option.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
        })
        currentCurrencyCode = getActiveCurrencyCode();
        currencyValues = {};
        syncCurrencyRowsFromDom();
    }
}

function showEditCampaForm(newRow = false){
    const formCampa = document.querySelector('.form_campa_indv.edit');
    const btn_x = formCampa.querySelector('.btn_x');
    const btnAddValor = formCampa.querySelector('.agregar_valor_campa');
    const monedaOptions = formCampa.querySelectorAll('.opcion_moneda_campa');
    const layout = document.querySelector('.layout');
    let currentCurrencyCode = getActiveCurrencyCode();
    let currencyValues = {};
    // activeCampRamaOptions(formCampa);

    if(formCampa.dataset.editValueControlsReady !== 'true'){
        formCampa.dataset.editValueControlsReady = 'true';
        initEditCampValueRows();
        formCampa.loadStoredCampCurrencies = loadStoredCurrencyValues;
        formCampa.resetCampCurrencies = resetCurrencyState;

        const inputNombreEdit = formCampa.querySelector("#nombre_campaEdit");
        if(inputNombreEdit){
            inputNombreEdit.addEventListener('input',()=>{
                inputNombreEdit.classList.remove('input_error');
            })
        }

        monedaOptions.forEach((option)=>{
            option.addEventListener('click',()=>{
                if(option.classList.contains('active')){
                    return;
                }
                saveCurrentCurrencyValues();
                monedaOptions.forEach((opt)=>{
                    opt.classList.remove('active');
                    opt.setAttribute('aria-pressed','false');
                })
                option.classList.add('active');
                option.setAttribute('aria-pressed','true');
                currentCurrencyCode = option.dataset.code;
                loadCurrencyValues(currentCurrencyCode);
            })
        })

        if(btnAddValor){
            btnAddValor.addEventListener('click',()=>{
                saveCurrentCurrencyValues();
                addEditCampValueRow();
                syncCurrencyRowsFromDom();
            })
        }
    }
    
    let rowsCampas = [];
    if(newRow){
        rowsCampas = document.querySelectorAll('.row_campa.new:not(.header_campa)');
    }else{
        rowsCampas = document.querySelectorAll('.row_campa:not(.header_campa)');
    }

    rowsCampas.forEach((row) => {
        const btn_edit = row.querySelector(".editar_campa");
        
        btn_edit.addEventListener("click",()=>{
            if(formCampa.classList.contains('mostrar')){
                formCampa.classList.remove('mostrar');
                formCampa.classList.add('ocultar');
                layout.classList.remove('mostrar');
                row.classList.remove('selected');
                raiseCampaFields(row);
            }else{
                formCampa.classList.add('mostrar');
                formCampa.classList.remove('ocultar'); 
                layout.classList.add('mostrar');
                row.classList.add('selected');
                completeCampaFields(row);
            }
        })
    })
    btn_x.addEventListener("click",()=>{
        if(formCampa.classList.contains('mostrar')){
            formCampa.classList.remove('mostrar');
            formCampa.classList.add('ocultar');
            layout.classList.remove('mostrar');
            rowsCampas.forEach((row) => {row.classList.remove('selected');})
            raiseCampaFields();
        }
    })
    layout.addEventListener("click",()=>{
        if(formCampa.classList.contains('mostrar')){
            formCampa.classList.remove('mostrar');
            formCampa.classList.add('ocultar');
            layout.classList.remove('mostrar');
            rowsCampas.forEach((row) => {row.classList.remove('selected');})
            raiseCampaFields();
        }
    })

    function completeCampaFields(row){
        const activo = row.querySelector(".campo_activo div");
        const nombre = row.querySelector(".campo_nombre p");
        const precio = row.querySelector(".campo_precio p");
        const ramas = row.querySelectorAll(".campo_rama p");
        let valoresMoneda = {};

        const inputActivo = formCampa.querySelector("#activo_campa");
        const inputNombre = formCampa.querySelector("#nombre_campaEdit");
        const inputPrecio = formCampa.querySelector("#valor_campaEdit");
        const inputTipo = formCampa.querySelector("#tipo_valor_campaEdit");
        const optionsRama = formCampa.querySelectorAll("#rama .opciones_rama");
        
        inputNombre.value = nombre.innerHTML;
        inputPrecio.value = formatCurrencyInteger(precio.innerHTML.replace('$','$ '));
        inputTipo.value = 'x1';
        formCampa.resetCampCurrencies();
        try{
            valoresMoneda = JSON.parse(row.dataset.valoresMoneda || '{}');
        }catch(error){
            valoresMoneda = {};
        }
        if(Object.keys(valoresMoneda).length > 0){
            formCampa.loadStoredCampCurrencies(valoresMoneda);
        }

        ramas.forEach((rama)=>{
            optionsRama.forEach((option)=>{
                if(rama.innerHTML == option.innerHTML){
                    if (rama.innerHTML == 'Todos'){
                        optionsRama.forEach((opt)=>{
                            opt.classList.add('disable');
                            opt.classList.remove('active');
                        })
                        option.classList.remove('disable');
                        option.classList.add('active');
                    }else{
                        option.classList.add('active');
                    }
                }
            })

        })

        if(activo.classList.contains('activo')){
            inputActivo.checked = true;
        }else{
            inputActivo.checked = false;
        }

    }

    function raiseCampaFields(row){
        const inputActivo = formCampa.querySelector("#activo_campa");
        const inputNombre = formCampa.querySelector("#nombre_campaEdit");
        const inputPrecio = formCampa.querySelector("#valor_campaEdit");
        const inputTipo = formCampa.querySelector("#tipo_valor_campaEdit");
        const extraValores = formCampa.querySelectorAll(".valor_campa_row.extra");
        const optionsRama = formCampa.querySelectorAll("#rama .opciones_rama");
        
        inputNombre.value = '';
        inputPrecio.value = '';
        inputTipo.value = '';
        formCampa.querySelectorAll('.input_error').forEach((input)=>input.classList.remove('input_error'));
        extraValores.forEach((row)=>row.remove());
        inputActivo.checked = false;
        optionsRama.forEach((option)=>{
            option.classList.remove('disable');
            option.classList.remove('active');
        })
        monedaOptions.forEach((option,i)=>{
            option.classList.toggle('active', i === 0);
            option.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
        })
        formCampa.resetCampCurrencies();
    }

    function initEditCampValueRows(){
        const rows = formCampa.querySelectorAll('.valor_campa_row');

        updateCampValueTypePlaceholders(formCampa);
        rows.forEach((row)=>bindEditCampValueRow(row));
    }

    function bindEditCampValueRow(row){
        const tipoInput = row.querySelector('.tipo_valor_campa');
        const importeInput = row.querySelector('.importe_valor_campa');
        const deleteBtn = row.querySelector('.eliminar_valor_campa');

        tipoInput.addEventListener('input',()=>{
            tipoInput.value = tipoInput.value.slice(0,6);
            row.classList.remove('needs_edit');
            tipoInput.classList.remove('input_error');
            syncCurrencyRowsFromDom();
        })
        importeInput.addEventListener('input',()=>{
            importeInput.value = formatCurrencyInteger(importeInput.value);
            row.classList.remove('needs_edit');
            importeInput.classList.remove('input_error');
            saveCurrentCurrencyValues();
        })
        if(deleteBtn){
            deleteBtn.addEventListener('click',(event)=>{
                event.preventDefault();
                event.stopPropagation();
                const rowIndex = Array.from(formCampa.querySelectorAll('.valor_campa_row')).indexOf(row);
                if(row.classList.contains('extra')){
                    row.remove();
                    updateCampValueTypePlaceholders(formCampa);
                    removeCurrencyValueRow(rowIndex);
                    return;
                }
                tipoInput.value = '';
                importeInput.value = '';
                tipoInput.classList.remove('input_error');
                importeInput.classList.remove('input_error');
                syncCurrencyRowsFromDom();
            })
        }
    }

    function addEditCampValueRow(){
        const contValores = formCampa.querySelector('.valores_campa_create');
        if(!contValores || !btnAddValor){
            return;
        }

        const row = document.createElement('div');
        row.className = 'valor_campa_row extra needs_edit';
        const rowIndex = formCampa.querySelectorAll('.valor_campa_row').length;
        row.innerHTML = `
            <input type="text" class="tipo_valor_campa" placeholder="${getCampValueTypePlaceholder(rowIndex)}" value="" maxlength="6">
            <input type="text" class="importe_valor_campa" placeholder="$Valor" value="">
            <button type="button" class="eliminar_valor_campa" title="Eliminar valor" aria-label="Eliminar valor">x</button>
        `;

        bindEditCampValueRow(row);
        contValores.insertBefore(row, btnAddValor);
        updateCampValueTypePlaceholders(formCampa);
    }

    function getActiveCurrencyCode(){
        const active = formCampa.querySelector('.opcion_moneda_campa.active');
        return active ? active.dataset.code : '';
    }

    function ensureCurrencyState(code){
        if(!code){
            return;
        }
        if(!currencyValues[code]){
            currencyValues[code] = {'Moneda': code,'Nombre': '','Signo': '','Valores': []};
        }
        const option = Array.from(monedaOptions).find((opt)=>opt.dataset.code === code);
        if(option){
            currencyValues[code]['Nombre'] = option.dataset.name || '';
            currencyValues[code]['Signo'] = option.dataset.sign || '';
        }
    }

    function getValueRowsData(){
        return Array.from(formCampa.querySelectorAll('.valor_campa_row')).map((row)=>{
            const tipo = row.querySelector('.tipo_valor_campa');
            const valor = row.querySelector('.importe_valor_campa');
            return {
                'Tipo': getCampValueTypeText(tipo, valor),
                'Valor': valor ? valor.value : ''
            };
        });
    }

    function saveCurrentCurrencyValues(){
        const code = currentCurrencyCode || getActiveCurrencyCode();
        if(!code){
            updateCurrencyValuesDataset();
            return;
        }
        ensureCurrencyState(code);
        currencyValues[code]['Valores'] = getValueRowsData();
        syncCurrencyRowsFromDom(false);
        updateCurrencyValuesDataset();
    }

    function syncCurrencyRowsFromDom(updateDataset = true){
        const rowsData = getValueRowsData();
        monedaOptions.forEach((option)=>{
            const code = option.dataset.code;
            ensureCurrencyState(code);
            const oldValues = currencyValues[code]['Valores'] || [];
            currencyValues[code]['Valores'] = rowsData.map((row,index)=>({
                'Tipo': row.Tipo || (oldValues[index] ? oldValues[index].Tipo : '') || getCampValueTypePlaceholder(index),
                'Valor': code === getActiveCurrencyCode() ? row.Valor : (oldValues[index] ? oldValues[index]['Valor'] : '')
            }));
        })
        if(updateDataset){
            updateCurrencyValuesDataset();
        }
    }

    function loadCurrencyValues(code){
        ensureCurrencyState(code);
        const rows = formCampa.querySelectorAll('.valor_campa_row');
        const values = currencyValues[code]['Valores'] || [];
        rows.forEach((row,index)=>{
            const data = values[index] || {'Tipo':'','Valor':''};
            const tipo = row.querySelector('.tipo_valor_campa');
            const valor = row.querySelector('.importe_valor_campa');
            tipo.value = data.Tipo || '';
            valor.classList.remove('valor_currency_skeleton');
            valor.classList.add('valor_currency_skeleton');
            valor.value = data.Valor ? formatCurrencyInteger(data.Valor) : '';
            window.setTimeout(()=>{
                valor.classList.remove('valor_currency_skeleton');
            },180);
        })
        updateCurrencyValuesDataset();
    }

    function removeCurrencyValueRow(rowIndex){
        monedaOptions.forEach((option)=>{
            const code = option.dataset.code;
            ensureCurrencyState(code);
            currencyValues[code]['Valores'].splice(rowIndex,1);
        })
        syncCurrencyRowsFromDom();
    }

    function updateCurrencyValuesDataset(){
        formCampa.dataset.valoresMoneda = JSON.stringify(currencyValues);
        updateCampCurrencyIndicators(formCampa, currencyValues);
    }

    function loadStoredCurrencyValues(storedValues){
        const configured = getConfiguredCampCurrencies(storedValues);
        const activeCode = Object.keys(configured)[0] || getActiveCurrencyCode();
        currentCurrencyCode = activeCode;
        monedaOptions.forEach(option => {
            option.classList.toggle('active', option.dataset.code === activeCode);
            option.setAttribute('aria-pressed', option.dataset.code === activeCode ? 'true' : 'false');
        });
        const maxRows = Object.values(storedValues).reduce((total, currency)=>{
            const values = currency && currency['Valores'] ? currency['Valores'].length : 0;
            return values > total ? values : total;
        },0);

        rebuildValueRows(maxRows || 1);
        currencyValues = cloneCampCurrencyValues(storedValues);
        loadCurrencyValues(activeCode);
    }

    function rebuildValueRows(totalRows){
        const contValores = formCampa.querySelector('.valores_campa_create');
        formCampa.querySelectorAll('.valor_campa_row.extra').forEach((row)=>row.remove());

        for(let i = 1; i < totalRows; i++){
            const row = document.createElement('div');
            row.className = 'valor_campa_row extra';
            row.innerHTML = `
                <input type="text" class="tipo_valor_campa" placeholder="${getCampValueTypePlaceholder(i)}" value="" maxlength="6">
                <input type="text" class="importe_valor_campa" placeholder="$Valor" value="">
                <button type="button" class="eliminar_valor_campa" title="Eliminar valor" aria-label="Eliminar valor">x</button>
            `;
            bindEditCampValueRow(row);
            contValores.insertBefore(row, btnAddValor);
        }
        updateCampValueTypePlaceholders(formCampa);
    }

    function resetCurrencyState(){
        currentCurrencyCode = getActiveCurrencyCode();
        currencyValues = {};
        syncCurrencyRowsFromDom();
    }
}

function showDeleteCampaForm(newRow = false){
    const formCampas = document.querySelector('.form_campa_indv.delete');
    const btn_x = formCampas.querySelector('.btn_x');
    const layout = document.querySelector('.layout');

    let rowsCampas = [];
    if(newRow){
        rowsCampas = document.querySelectorAll('.row_campa.new:not(.header_campa)');
    }else{
        rowsCampas = document.querySelectorAll('.row_campa:not(.header_campa)');
    }

    rowsCampas.forEach((row) => {
        const btn_delete = row.querySelector(".eliminar_campa");

        row.classList.remove('new');
        btn_delete.addEventListener("click",()=>{
            if(formCampas.classList.contains('mostrar')){
                formCampas.classList.remove('mostrar');
                formCampas.classList.add('ocultar');
                layout.classList.remove('mostrar');
                row.classList.remove('selected');
                raiseCampaFields();
            }else{
                formCampas.classList.add('mostrar');
                formCampas.classList.remove('ocultar'); 
                layout.classList.add('mostrar');
                row.classList.add('selected');
                completeCampaFields(row);
            }
        })
    })

    btn_x.addEventListener("click",()=>{
        if(formCampas.classList.contains('mostrar')){
            formCampas.classList.remove('mostrar');
            formCampas.classList.add('ocultar');
            layout.classList.remove('mostrar');
            rowsCampas.forEach((row) => {row.classList.remove('selected');})
            raiseCampaFields();
        }
    })
    layout.addEventListener("click",()=>{
        if(formCampas.classList.contains('mostrar')){
            formCampas.classList.remove('mostrar');
            formCampas.classList.add('ocultar');
            layout.classList.remove('mostrar');
            rowsCampas.forEach((row) => {row.classList.remove('selected');})
            raiseCampaFields();
        }
    })
    function completeCampaFields(row){
        const nombre = row.querySelector(".campo_nombre p");
        const legend = formCampas.querySelector(".eliminar_campa legend");
        
        legend.innerHTML += nombre.innerHTML + '?';

    }

    function raiseCampaFields(){

        const legend = formCampas.querySelector(".eliminar_campa legend");
        
        legend.innerHTML = '¿Eliminar Campamento: ';
    }
}

function showEventsForms(){
    const createFormEvento = document.querySelector('.form_evento_indv.create');
    const rowsEvent = document.querySelectorAll('.row_evento:not(.header_evento)');

    if(createFormEvento){
        activeEventRamaOptions(createFormEvento);
        showCreateEventoForm();
    }

    if(rowsEvent.length > 0){
        const formEvento = document.querySelector('.form_evento_indv.edit');
        activeEventRamaOptions(formEvento);
        showEditEventoForm();
        showDeleteEventoForm();
    }
}

function showCreateEventoForm(){
    const formEvento = document.querySelector('.form_evento_indv.create');
    const btn_indv = document.querySelector('.panel_config.config_eventos .cont_individual');
    const valor_input = formEvento.querySelector('.campo.valor input');
    const layout = document.querySelector('.layout');

    btn_indv.addEventListener("click",()=>{
        if(formEvento.classList.contains('mostrar')){
            formEvento.classList.remove('mostrar');
            formEvento.classList.add('ocultar');
            layout.classList.remove('mostrar');
            raiseEventFields();
        }else{
            formEvento.classList.add('mostrar');
            formEvento.classList.remove('ocultar');
            layout.classList.add('mostrar');
        }
    })

    layout.addEventListener("click",()=>{
        if(formEvento.classList.contains('mostrar')){
            formEvento.classList.remove('mostrar');
            formEvento.classList.add('ocultar');
            layout.classList.remove('mostrar');
            raiseEventFields();
        }
    })

    document.addEventListener("click",(event)=>{
        if(
            formEvento.classList.contains('mostrar') &&
            !formEvento.contains(event.target) &&
            !btn_indv.contains(event.target)
        ){
            formEvento.classList.remove('mostrar');
            formEvento.classList.add('ocultar');
            layout.classList.remove('mostrar');
            raiseEventFields();
        }
    })

    valor_input.addEventListener('input',() => {
        valor_input.value = formatCurrency(valor_input.value);
    })

    function raiseEventFields(){
        const inputNombre = formEvento.querySelector("#nombre_createEvent");
        const inputPrecio = formEvento.querySelector("#valor_createEvent");
        const optionsRama = formEvento.querySelectorAll(".select_rama .opciones_rama");

        inputNombre.value = '';
        inputPrecio.value = '';
        optionsRama.forEach((option)=>{
            option.classList.remove('disable');
            option.classList.remove('active');
        })
    }
}

function showEditEventoForm(newRow = false){
    const formEvento = document.querySelector('.form_evento_indv.edit');
    const btn_x = formEvento.querySelector('.btn_x');
    const valor_input = formEvento.querySelector('.campo.valor input');
    const layout = document.querySelector('.layout');
    // activeEventRamaOptions(formEvento);

    let rowsEventos = [];
    if(newRow){
        rowsEventos = document.querySelectorAll('.row_evento.new:not(.header_evento)');
    }else{
        rowsEventos = document.querySelectorAll('.row_evento:not(.header_evento)');
    }

    rowsEventos.forEach((row) => {
        const btn_edit = row.querySelector(".editar_evento");
        
        btn_edit.addEventListener("click",()=>{
            if(formEvento.classList.contains('mostrar')){
                formEvento.classList.remove('mostrar');
                formEvento.classList.add('ocultar');
                layout.classList.remove('mostrar');
                row.classList.remove('selected');
                raiseEventFields(row);
            }else{
                formEvento.classList.add('mostrar');
                formEvento.classList.remove('ocultar'); 
                layout.classList.add('mostrar');
                row.classList.add('selected');
                completeEventFields(row);
            }
        })
    })
    btn_x.addEventListener("click",()=>{
        if(formEvento.classList.contains('mostrar')){
            formEvento.classList.remove('mostrar');
            formEvento.classList.add('ocultar');
            layout.classList.remove('mostrar');
            rowsEventos.forEach((row) => {row.classList.remove('selected');})
            raiseEventFields();
        }
    })
    layout.addEventListener("click",()=>{
        if(formEvento.classList.contains('mostrar')){
            formEvento.classList.remove('mostrar');
            formEvento.classList.add('ocultar');
            layout.classList.remove('mostrar');
            rowsEventos.forEach((row) => {row.classList.remove('selected');})
            raiseEventFields();
        }
    })

    function completeEventFields(row){
        const activo = row.querySelector(".campo_activo div");
        const nombre = row.querySelector(".campo_nombre p");
        const precio = row.querySelector(".campo_precio p");
        const ramas = row.querySelectorAll(".campo_rama p");

        const inputActivo = formEvento.querySelector("#activo_evento");
        const inputNombre = formEvento.querySelector("#nombre_editEvent");
        const inputPrecio = formEvento.querySelector("#valor_editEvent");
        const optionsRama = formEvento.querySelectorAll("#rama .opciones_rama");
        
        inputNombre.value = nombre.innerHTML;
        inputPrecio.value = precio.innerHTML.replace('$','$ ');

        ramas.forEach((rama)=>{
            optionsRama.forEach((option)=>{
                if(rama.innerHTML == option.innerHTML){
                    if (rama.innerHTML == 'Todos'){
                        optionsRama.forEach((opt)=>{
                            opt.classList.add('disable');
                            opt.classList.remove('active');
                        })
                        option.classList.remove('disable');
                        option.classList.add('active');
                    }else{
                        option.classList.add('active');
                    }
                }
            })

        })

        if(activo.classList.contains('activo')){
            inputActivo.checked = true;
        }else{
            inputActivo.checked = false;
        }

    }

    function raiseEventFields(row){
        const inputActivo = formEvento.querySelector("#activo_evento");
        const inputNombre = formEvento.querySelector("#nombre_editEvent");
        const inputPrecio = formEvento.querySelector("#valor_editEvent");
        const optionsRama = formEvento.querySelectorAll("#rama .opciones_rama");
        
        inputNombre.value = '';
        inputPrecio.value = '';
        inputActivo.checked = false;
        optionsRama.forEach((option)=>{
            option.classList.remove('disable');
            option.classList.remove('active');
        })
    }
}

function showDeleteEventoForm(newRow = false){
    const formEventos = document.querySelector('.form_evento_indv.delete');
    const btn_x = formEventos.querySelector('.btn_x');
    const layout = document.querySelector('.layout');

    let rowsEventos = [];
    if(newRow){
        rowsEventos = document.querySelectorAll('.row_evento.new:not(.header_evento)');
    }else{
        rowsEventos = document.querySelectorAll('.row_evento:not(.header_evento)');
    }

    rowsEventos.forEach((row) => {
        const btn_delete = row.querySelector(".eliminar_evento");
        row.classList.remove('new');
        btn_delete.addEventListener("click",()=>{
            if(formEventos.classList.contains('mostrar')){
                formEventos.classList.remove('mostrar');
                formEventos.classList.add('ocultar');
                layout.classList.remove('mostrar');
                row.classList.remove('selected');
                raiseCampaFields();
            }else{
                rowsEventos.forEach((eventRow) => {
                    eventRow.classList.remove('selected');
                })
                formEventos.classList.add('mostrar');
                formEventos.classList.remove('ocultar'); 
                layout.classList.add('mostrar');
                row.classList.add('selected');
                completeCampaFields(row);
            }
        })
    })

    btn_x.addEventListener("click",()=>{
        if(formEventos.classList.contains('mostrar')){
            formEventos.classList.remove('mostrar');
            formEventos.classList.add('ocultar');
            layout.classList.remove('mostrar');
            rowsEventos.forEach((row) => {row.classList.remove('selected');})
            raiseCampaFields();
        }
    })
    layout.addEventListener("click",()=>{
        if(formEventos.classList.contains('mostrar')){
            formEventos.classList.remove('mostrar');
            formEventos.classList.add('ocultar');
            layout.classList.remove('mostrar');
            rowsEventos.forEach((row) => {row.classList.remove('selected');})
            raiseCampaFields();
        }
    })
    function completeCampaFields(row){
        const nombre = row.querySelector(".campo_nombre p");
        const legend = formEventos.querySelector(".eliminar_evento legend");
        
        legend.innerHTML += nombre.innerHTML + '?';

    }

    function raiseCampaFields(){

        const legend = formEventos.querySelector(".eliminar_evento legend");
        
        legend.innerHTML = '¿Eliminar Evento: ';
    }
}

function tableSearchMembers(){
    const searchBox = document.querySelector('.buscador_miembros input');
    if(searchBox){
        
        searchBox.addEventListener('input',searchOnTable);
        
        function searchOnTable(){
            const tableRows = document.querySelectorAll(".lista_miembros .row_miembro:not(.header_miembro)");

            const searchData = quitarAcentos(searchBox.value.toLowerCase());
            const buscarVacio = searchData === '';

            tableRows.forEach(row => {
                const nombre = row.querySelector('.campo_nombre p').textContent || '';
                const doc    = row.querySelector('.campo_doc p').textContent    || '';

                let rama = '';
                const pRama = row.querySelector('.campo_rama p');
                if (pRama) {
                    rama = pRama.textContent;
                }else {
                    const selectRama = row.querySelector('.campo_rama select');
                    if (selectRama) {
                        rama = selectRama.options[selectRama.selectedIndex].textContent;
                    }
                }

                const tableData = quitarAcentos((nombre + ' ' + doc + ' ' + rama).toLowerCase());
                
                // toggle ocultar si no coincide (o mostrar todo si input vacío)
                const noCoincide = tableData.indexOf(searchData) < 0;
                row.classList.toggle('oculta', !buscarVacio && noCoincide);
            })
        }
    }

}

function tableSearchCamps(){
    const searchBox = document.querySelector('.buscador_campas input');
    if(searchBox){
        
        searchBox.addEventListener('input',searchOnTable);
        
        function searchOnTable(){
            const tableRows = document.querySelectorAll(".lista_campas .row_campa:not(.header_campa)");
            tableRows.forEach((row,i) =>{
                let tableData = quitarAcentos(row.textContent.toLowerCase()),
                searchData = quitarAcentos(searchBox.value.toLowerCase());

                row.classList.toggle('oculta',tableData.indexOf(searchData) < 0);
            })
        }

    }
}

function tableSearchEvents(){
    const searchBox = document.querySelector('.buscador_eventos input');
    if(searchBox){
        
        searchBox.addEventListener('input',searchOnTable);
        
        function searchOnTable(){
            const tableRows = document.querySelectorAll(".lista_eventos .row_evento:not(.header_evento)");
            tableRows.forEach((row,i) =>{
                let tableData = quitarAcentos(row.textContent.toLowerCase()),
                searchData = quitarAcentos(searchBox.value.toLowerCase());

                row.classList.toggle('oculta',tableData.indexOf(searchData) < 0);
            })
        }

    }
}

function tableSearchReceipts(){
    const searchBox = document.querySelector('.buscador_recibos input');
    if(searchBox){
        
        searchBox.addEventListener('input',searchOnTable);
        
        function searchOnTable(){
            const tableRows = document.querySelectorAll(".lista_recibos .row_recibo:not(.header_recibo)");
            tableRows.forEach((row,i) =>{
                let tableData = quitarAcentos(row.textContent.toLowerCase()),
                searchData = quitarAcentos(searchBox.value.toLowerCase());

                row.classList.toggle('oculta',tableData.indexOf(searchData) < 0);
            })
        }

    }
}

function tableSearchZClosure(){
    const searchBox = document.querySelector('.buscador_cierres input');
    if(searchBox){
        
        searchBox.addEventListener('input',searchOnTable);
        
        function searchOnTable(){
            const tableRows = document.querySelectorAll(".lista_cierres .row_cierre:not(.header_cierre)");
            tableRows.forEach((row,i) =>{
                let tableData = quitarAcentos(row.textContent.toLowerCase()),
                searchData = quitarAcentos(searchBox.value.toLowerCase());

                row.classList.toggle('oculta',tableData.indexOf(searchData) < 0);
            })
        }

    }
}

const TABLE_RAMA_ORDER = ['CAS','MAN','UNI','CAM','ROV','EDU','SRAM'];

function getTableRamaSortValue(rawRamas, originalIndex = 0){
    const stableIndex = originalIndex >= 0 ? originalIndex : 0;
    const ramas = String(rawRamas || '')
        .split(',')
        .map(rama => rama.trim())
        .filter(Boolean);

    const values = ramas.map(rama => {
        const baseMatch = rama.match(/[A-Za-z]+/);
        const numMatch = rama.match(/\d+/);
        const base = baseMatch ? baseMatch[0].toUpperCase() : '';
        const num = numMatch ? parseInt(numMatch[0], 10) : 0;
        let index = TABLE_RAMA_ORDER.indexOf(base);

        if(base === 'ALL'){
            index = TABLE_RAMA_ORDER.length;
        }else if(index === -1){
            index = TABLE_RAMA_ORDER.length + 1 + stableIndex;
        }

        return { index, num };
    });

    if(values.length === 0){
        return { index: TABLE_RAMA_ORDER.length + 1 + stableIndex, num: 0 };
    }

    values.sort((a, b) => (a.index - b.index) || (a.num - b.num));
    return values[0];
}

function parseTableDateTimeValue(rawDate){
    const raw = String(rawDate || '').trim();
    const localParts = raw.match(/(\d{1,2})[\/-](\d{1,2})[\/-](\d{2,4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/);

    if(localParts){
        const year = localParts[3].length === 2 ? `20${localParts[3]}` : localParts[3];
        return new Date(
            Number(year),
            Number(localParts[2]) - 1,
            Number(localParts[1]),
            Number(localParts[4] || 0),
            Number(localParts[5] || 0),
            Number(localParts[6] || 0)
        ).getTime();
    }

    const isoParts = raw.match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?/);

    if(isoParts){
        return new Date(
            Number(isoParts[1]),
            Number(isoParts[2]) - 1,
            Number(isoParts[3]),
            Number(isoParts[4] || 0),
            Number(isoParts[5] || 0),
            Number(isoParts[6] || 0)
        ).getTime();
    }

    const parsed = Date.parse(raw);
    return Number.isNaN(parsed) ? 0 : parsed;
}


function sortMembersList(){
    const lista_miembros = document.querySelector('.lista_miembros');
    if(lista_miembros){
        const row_miembros = lista_miembros.querySelectorAll('.row_miembro:not(.header_miembro)');
        const bodyMembers = lista_miembros.querySelector(".body_miembro");
        if(row_miembros.length > 0){
            const sort_estado = lista_miembros.querySelector('.btn_sort_miembro.sort_estado');
            const sort_name = lista_miembros.querySelector('.btn_sort_miembro.sort_name');
            const sort_doc = lista_miembros.querySelector('.btn_sort_miembro.sort_doc');
            const sort_rama = lista_miembros.querySelector('.btn_sort_miembro.sort_rama');
            const sortButtons = [sort_name, sort_doc, sort_rama].filter(Boolean);
            const originalOrder = Array.from(row_miembros);

            applyMemberSort('name', 'asc', sort_name);

            // Ordenamiento por estado desactivado por ahora.
            // if(sort_estado){
            //     sort_estado.addEventListener('click',()=>{
            //         const direction = sort_estado.classList.contains('asc') ? 'desc' : 'asc';
            //         applyMemberSort('estado', direction, sort_estado);
            //     })
            // }

            if(sort_name){
                sort_name.addEventListener('click',()=>{
                    const direction = sort_name.classList.contains('asc') ? 'desc' : 'asc';
                    applyMemberSort('name', direction, sort_name);
                })
            }

            if(sort_doc){
                sort_doc.addEventListener('click',()=>{
                    const direction = sort_doc.classList.contains('desc') ? 'asc' : 'desc';
                    applyMemberSort('doc', direction, sort_doc);
                })
            }

            if(sort_rama){
                sort_rama.addEventListener('click',()=>{
                    const direction = sort_rama.classList.contains('asc') ? 'desc' : 'asc';
                    applyMemberSort('rama', direction, sort_rama);
                })
            }

            function applyMemberSort(type, direction, activeButton){
                const miembros = Array.from(lista_miembros.querySelectorAll(".row_miembro:not(.header_miembro)"));
                const headerRow = lista_miembros.querySelector(".row_miembro.header_miembro");

                bodyMembers.innerHTML = "";
                bodyMembers.appendChild(headerRow);
                updateSortButtons(activeButton, direction);

                miembros.sort((a, b) => compareMembers(a, b, type, direction));
                miembros.forEach(miembro => bodyMembers.appendChild(miembro));
            }

            function updateSortButtons(activeButton, direction){
                sortButtons.forEach(button => {
                    button.classList.remove('active', 'asc', 'desc');
                });

                if(activeButton){
                    activeButton.classList.add('active', direction);
                    updateSortIcon(activeButton, direction);
                }

                sortButtons.filter(button => button !== activeButton).forEach(button => {
                    updateSortIcon(button, button.classList.contains('sort_doc') ? 'desc' : 'asc');
                });
            }

            function updateSortIcon(button, direction){
                const icon = button.querySelector('i');
                if(!icon){
                    return;
                }

                if(button.classList.contains('sort_name')){
                    icon.className = direction === 'asc' ? 'fa-solid fa-arrow-down-a-z' : 'fa-solid fa-arrow-down-z-a';
                }else if(button.classList.contains('sort_doc')){
                    icon.className = direction === 'desc' ? 'fa-solid fa-arrow-down-9-1' : 'fa-solid fa-arrow-down-1-9';
                }else{
                    icon.className = direction === 'asc' ? 'fa-solid fa-arrow-down-short-wide' : 'fa-solid fa-arrow-down-wide-short';
                }
            }

            function compareMembers(a, b, type, direction){
                const estadoCompare = getEstadoOrder(a) - getEstadoOrder(b);
                if(estadoCompare !== 0){
                    return estadoCompare;
                }

                if(type === 'doc'){
                    return compareByDoc(a, b, direction) || compareByName(a, b, 'asc');
                }

                if(type === 'rama'){
                    return compareByRama(a, b, direction) || compareByName(a, b, 'asc');
                }

                return compareByName(a, b, direction);
            }

            function getEstadoOrder(row){
                return row.classList.contains('inactivo') ? 1 : 0;
            }

            // function compareEstado(a, b, direction){
            //     const result = getEstadoOrder(a) - getEstadoOrder(b);
            //     return direction === 'asc' ? result : result * -1;
            // }

            function compareByName(a, b, direction){
                const nombreAEl = a.querySelector(".campo_nombre p");
                const nombreBEl = b.querySelector(".campo_nombre p");
                const nombreA = quitarAcentos(((nombreAEl && nombreAEl.textContent) || '').toLowerCase());
                const nombreB = quitarAcentos(((nombreBEl && nombreBEl.textContent) || '').toLowerCase());
                const result = nombreA.localeCompare(nombreB, 'es', { sensitivity: 'base' });
                return direction === 'asc' ? result : result * -1;
            }

            function compareByDoc(a, b, direction){
                const docAEl = a.querySelector(".campo_doc p");
                const docBEl = b.querySelector(".campo_doc p");
                const docA = parseInt(((docAEl && docAEl.textContent) || '').replace(/\D/g, ''), 10) || 0;
                const docB = parseInt(((docBEl && docBEl.textContent) || '').replace(/\D/g, ''), 10) || 0;
                const result = docA - docB;
                return direction === 'asc' ? result : result * -1;
            }

            function compareByRama(a, b, direction){
                const ramaA = parseRama(a);
                const ramaB = parseRama(b);
                const resultBase = ramaA.index - ramaB.index;
                let result = resultBase;

                if(result === 0){
                    result = ramaA.num - ramaB.num;
                }

                return direction === 'asc' ? result : result * -1;
            }

            function parseRama(row){
                const ramaEl = row.querySelector(".campo_codrama p");
                const rama = (ramaEl && ramaEl.textContent) || '';
                const originalIndex = originalOrder.indexOf(row);
                return getTableRamaSortValue(rama, originalIndex);
            }
        }
    }
}

function sortCampsList(){
    const lista_campas = document.querySelector('.lista_campas');
    if(lista_campas){
        const row_campas = lista_campas.querySelectorAll('.row_campa:not(.header_campa)');
        const bodyCamps = lista_campas.querySelector(".body_campa");
        if(row_campas.length > 0){
            const sort_estado = lista_campas.querySelector('.btn_sort_campa.sort_estado');
            const sort_fecha = lista_campas.querySelector('.btn_sort_campa.sort_fecha');
            const sort_name = lista_campas.querySelector('.btn_sort_campa.sort_name');
            const sort_precio = lista_campas.querySelector('.btn_sort_campa.sort_precio');
            const sort_rama = lista_campas.querySelector('.btn_sort_campa.sort_rama');
            const sortButtons = [sort_fecha, sort_name, sort_precio].filter(Boolean);
            const originalOrder = Array.from(row_campas);

            applyCampSort('fecha', 'desc', sort_fecha);

            // Ordenamiento por estado desactivado por ahora.
            // if(sort_estado){
            //     sort_estado.addEventListener('click',()=>{
            //         const direction = sort_estado.classList.contains('asc') ? 'desc' : 'asc';
            //         applyCampSort('estado', direction, sort_estado);
            //     })
            // }

            if(sort_name){
                sort_name.addEventListener('click',()=>{
                    const direction = sort_name.classList.contains('asc') ? 'desc' : 'asc';
                    applyCampSort('name', direction, sort_name);
                })
            }

            if(sort_fecha){
                sort_fecha.addEventListener('click',()=>{
                    const direction = sort_fecha.classList.contains('desc') ? 'asc' : 'desc';
                    applyCampSort('fecha', direction, sort_fecha);
                })
            }

            if(sort_precio){
                sort_precio.addEventListener('click',()=>{
                    const direction = sort_precio.classList.contains('desc') ? 'asc' : 'desc';
                    applyCampSort('precio', direction, sort_precio);
                })
            }

            // Ordenamiento por rama desactivado por ahora.
            // if(sort_rama){
            //     sort_rama.addEventListener('click',()=>{
            //         const direction = sort_rama.classList.contains('asc') ? 'desc' : 'asc';
            //         applyCampSort('rama', direction, sort_rama);
            //     })
            // }

            function applyCampSort(type, direction, activeButton){
                const campas = Array.from(lista_campas.querySelectorAll(".row_campa:not(.header_campa)"));
                const headerRow = lista_campas.querySelector(".row_campa.header_campa");

                bodyCamps.innerHTML = "";
                bodyCamps.appendChild(headerRow);
                updateSortButtons(activeButton, direction);

                campas.sort((a, b) => compareCamps(a, b, type, direction));
                campas.forEach(campa => bodyCamps.appendChild(campa));
            }

            function updateSortButtons(activeButton, direction){
                sortButtons.forEach(button => {
                    button.classList.remove('active', 'asc', 'desc');
                });

                if(activeButton){
                    activeButton.classList.add('active', direction);
                    updateSortIcon(activeButton, direction);
                }

                sortButtons.filter(button => button !== activeButton).forEach(button => {
                    updateSortIcon(button, (button.classList.contains('sort_fecha') || button.classList.contains('sort_precio')) ? 'desc' : 'asc');
                });
            }

            function updateSortIcon(button, direction){
                const icon = button.querySelector('i');
                if(!icon){
                    return;
                }

                if(button.classList.contains('sort_name')){
                    icon.className = direction === 'asc' ? 'fa-solid fa-arrow-down-a-z' : 'fa-solid fa-arrow-down-z-a';
                }else if(button.classList.contains('sort_fecha') || button.classList.contains('sort_precio')){
                    icon.className = direction === 'desc' ? 'fa-solid fa-arrow-down-9-1' : 'fa-solid fa-arrow-down-1-9';
                }else{
                    icon.className = direction === 'asc' ? 'fa-solid fa-arrow-down-short-wide' : 'fa-solid fa-arrow-down-wide-short';
                }
            }

            function compareCamps(a, b, type, direction){
                if(type === 'estado'){
                    return compareEstado(a, b, direction) || compareByName(a, b, 'asc');
                }

                if(type === 'precio'){
                    return compareByPrice(a, b, direction) || compareByName(a, b, 'asc');
                }

                if(type === 'fecha'){
                    return compareByDate(a, b, direction) || compareByName(a, b, 'asc');
                }

                if(type === 'rama'){
                    return compareByRama(a, b, direction) || compareByName(a, b, 'asc');
                }

                return compareByName(a, b, direction);
            }

            function getEstadoOrder(row){
                return row.classList.contains('inactivo') ? 1 : 0;
            }

            function compareEstado(a, b, direction){
                const result = getEstadoOrder(a) - getEstadoOrder(b);
                return direction === 'asc' ? result : result * -1;
            }

            function compareByName(a, b, direction){
                const nombreAEl = a.querySelector(".campo_nombre p");
                const nombreBEl = b.querySelector(".campo_nombre p");
                const nombreA = quitarAcentos(((nombreAEl && nombreAEl.textContent) || '').toLowerCase());
                const nombreB = quitarAcentos(((nombreBEl && nombreBEl.textContent) || '').toLowerCase());
                const result = nombreA.localeCompare(nombreB, 'es', { sensitivity: 'base' });
                return direction === 'asc' ? result : result * -1;
            }

            function compareByPrice(a, b, direction){
                const priceA = getPriceValue(a);
                const priceB = getPriceValue(b);
                const result = priceA - priceB;
                return direction === 'asc' ? result : result * -1;
            }

            function compareByDate(a, b, direction){
                const dateA = getDateSortValue(a.dataset.fechaAlta || '');
                const dateB = getDateSortValue(b.dataset.fechaAlta || '');
                const result = dateA - dateB;
                return direction === 'asc' ? result : result * -1;
            }

            function getPriceValue(row){
                const priceEl = row.querySelector(".campo_precio p");
                const priceText = ((priceEl && priceEl.textContent) || '').replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
                return parseFloat(priceText) || 0;
            }

            function compareByRama(a, b, direction){
                const ramaA = parseRama(a);
                const ramaB = parseRama(b);
                const resultBase = ramaA.index - ramaB.index;
                let result = resultBase;

                if(result === 0){
                    result = ramaA.num - ramaB.num;
                }

                return direction === 'asc' ? result : result * -1;
            }

            function parseRama(row){
                const ramaEl = row.querySelector(".campo_codrama p");
                const rama = (ramaEl && ramaEl.textContent) || '';
                const originalIndex = originalOrder.indexOf(row);
                return getTableRamaSortValue(rama, originalIndex);
            }
        }
    }
}

function sortEventList(){
    const lista_eventos = document.querySelector('.lista_eventos');
    if(lista_eventos){
        const row_eventos = lista_eventos.querySelectorAll('.row_evento:not(.header_evento)');
        const bodyEvents = lista_eventos.querySelector(".body_evento");
        if(row_eventos.length > 0){
            const sort_estado = lista_eventos.querySelector('.btn_sort_evento.sort_estado');
            const sort_name = lista_eventos.querySelector('.btn_sort_evento.sort_name');
            const sort_precio = lista_eventos.querySelector('.btn_sort_evento.sort_precio');
            const sort_rama = lista_eventos.querySelector('.btn_sort_evento.sort_rama');
            const sortButtons = [sort_name, sort_precio].filter(Boolean);
            const originalOrder = Array.from(row_eventos);

            applyEventSort('name', 'asc', sort_name);

            // Ordenamiento por estado desactivado por ahora.
            // if(sort_estado){
            //     sort_estado.addEventListener('click',()=>{
            //         const direction = sort_estado.classList.contains('asc') ? 'desc' : 'asc';
            //         applyEventSort('estado', direction, sort_estado);
            //     })
            // }

            if(sort_name){
                sort_name.addEventListener('click',()=>{
                    const direction = sort_name.classList.contains('asc') ? 'desc' : 'asc';
                    applyEventSort('name', direction, sort_name);
                })
            }

            if(sort_precio){
                sort_precio.addEventListener('click',()=>{
                    const direction = sort_precio.classList.contains('desc') ? 'asc' : 'desc';
                    applyEventSort('precio', direction, sort_precio);
                })
            }

            // Ordenamiento por rama desactivado por ahora.
            // if(sort_rama){
            //     sort_rama.addEventListener('click',()=>{
            //         const direction = sort_rama.classList.contains('asc') ? 'desc' : 'asc';
            //         applyEventSort('rama', direction, sort_rama);
            //     })
            // }

            function applyEventSort(type, direction, activeButton){
                const eventos = Array.from(lista_eventos.querySelectorAll(".row_evento:not(.header_evento)"));
                const headerRow = lista_eventos.querySelector(".row_evento.header_evento");

                bodyEvents.innerHTML = "";
                bodyEvents.appendChild(headerRow);
                updateSortButtons(activeButton, direction);

                eventos.sort((a, b) => compareEvents(a, b, type, direction));
                eventos.forEach(evento => bodyEvents.appendChild(evento));
            }

            function updateSortButtons(activeButton, direction){
                sortButtons.forEach(button => {
                    button.classList.remove('active', 'asc', 'desc');
                });

                if(activeButton){
                    activeButton.classList.add('active', direction);
                    updateSortIcon(activeButton, direction);
                }

                sortButtons.filter(button => button !== activeButton).forEach(button => {
                    updateSortIcon(button, button.classList.contains('sort_precio') ? 'desc' : 'asc');
                });
            }

            function updateSortIcon(button, direction){
                const icon = button.querySelector('i');
                if(!icon){
                    return;
                }

                if(button.classList.contains('sort_name')){
                    icon.className = direction === 'asc' ? 'fa-solid fa-arrow-down-a-z' : 'fa-solid fa-arrow-down-z-a';
                }else if(button.classList.contains('sort_precio')){
                    icon.className = direction === 'desc' ? 'fa-solid fa-arrow-down-9-1' : 'fa-solid fa-arrow-down-1-9';
                }else{
                    icon.className = direction === 'asc' ? 'fa-solid fa-arrow-down-short-wide' : 'fa-solid fa-arrow-down-wide-short';
                }
            }

            function compareEvents(a, b, type, direction){
                if(type === 'estado'){
                    return compareEstado(a, b, direction) || compareByName(a, b, 'asc');
                }

                if(type === 'precio'){
                    return compareByPrice(a, b, direction) || compareByName(a, b, 'asc');
                }

                if(type === 'rama'){
                    return compareByRama(a, b, direction) || compareByName(a, b, 'asc');
                }

                return compareByName(a, b, direction);
            }

            function getEstadoOrder(row){
                return row.classList.contains('inactivo') ? 1 : 0;
            }

            function compareEstado(a, b, direction){
                const result = getEstadoOrder(a) - getEstadoOrder(b);
                return direction === 'asc' ? result : result * -1;
            }

            function compareByName(a, b, direction){
                const nombreAEl = a.querySelector(".campo_nombre p");
                const nombreBEl = b.querySelector(".campo_nombre p");
                const nombreA = quitarAcentos(((nombreAEl && nombreAEl.textContent) || '').toLowerCase());
                const nombreB = quitarAcentos(((nombreBEl && nombreBEl.textContent) || '').toLowerCase());
                const result = nombreA.localeCompare(nombreB, 'es', { sensitivity: 'base' });
                return direction === 'asc' ? result : result * -1;
            }

            function compareByPrice(a, b, direction){
                const priceA = getPriceValue(a);
                const priceB = getPriceValue(b);
                const result = priceA - priceB;
                return direction === 'asc' ? result : result * -1;
            }

            function getPriceValue(row){
                const priceEl = row.querySelector(".campo_precio p");
                const priceText = ((priceEl && priceEl.textContent) || '').replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
                return parseFloat(priceText) || 0;
            }

            function compareByRama(a, b, direction){
                const ramaA = parseRama(a);
                const ramaB = parseRama(b);
                const resultBase = ramaA.index - ramaB.index;
                let result = resultBase;

                if(result === 0){
                    result = ramaA.num - ramaB.num;
                }

                return direction === 'asc' ? result : result * -1;
            }

            function parseRama(row){
                const ramaEl = row.querySelector(".campo_codrama p");
                const rama = (ramaEl && ramaEl.textContent) || '';
                const originalIndex = originalOrder.indexOf(row);
                return getTableRamaSortValue(rama, originalIndex);
            }
        }
    }
}

function sortReceiptList(){
    const lista_recibos = document.querySelector('.lista_recibos');
    if(lista_recibos){
        const rowsRecibos = lista_recibos.querySelectorAll('.row_recibo:not(.header_recibo)');
        const bodyReceipt = lista_recibos.querySelector(".body_recibo");
        if(bodyReceipt){
            const sort_estado = lista_recibos.querySelector('.btn_sort_recibo.sort_estado');
            const sort_name = lista_recibos.querySelector('.btn_sort_recibo.sort_name');
            const sort_fecha = lista_recibos.querySelector('.btn_sort_recibo.sort_fecha');
            const sort_total = lista_recibos.querySelector('.btn_sort_recibo.sort_total');
            const sort_detalle = lista_recibos.querySelector('.btn_sort_recibo.sort_detalle');
            const sortButtons = [sort_name, sort_fecha, sort_total, sort_detalle].filter(Boolean);

            applyReceiptSort('fecha', 'desc', sort_fecha);

            // Ordenamiento por estado desactivado por ahora.
            // if(sort_estado){
            //     sort_estado.addEventListener('click',()=>{
            //         const direction = sort_estado.classList.contains('asc') ? 'desc' : 'asc';
            //         applyReceiptSort('estado', direction, sort_estado);
            //     })
            // }

            if(sort_name){
                sort_name.addEventListener('click',()=>{
                    const direction = sort_name.classList.contains('asc') ? 'desc' : 'asc';
                    applyReceiptSort('name', direction, sort_name);
                })
            }

            if(sort_fecha){
                sort_fecha.addEventListener('click',()=>{
                    const direction = sort_fecha.classList.contains('desc') ? 'asc' : 'desc';
                    applyReceiptSort('fecha', direction, sort_fecha);
                })
            }

            if(sort_total){
                sort_total.addEventListener('click',()=>{
                    const direction = sort_total.classList.contains('desc') ? 'asc' : 'desc';
                    applyReceiptSort('total', direction, sort_total);
                })
            }

            if(sort_detalle){
                sort_detalle.addEventListener('click',()=>{
                    const direction = sort_detalle.classList.contains('asc') ? 'desc' : 'asc';
                    applyReceiptSort('detalle', direction, sort_detalle);
                })
            }

            function applyReceiptSort(type, direction, activeButton){
                const recibos = Array.from(lista_recibos.querySelectorAll(".row_recibo:not(.header_recibo)"));
                const headerRow = lista_recibos.querySelector(".row_recibo.header_recibo");

                bodyReceipt.innerHTML = "";
                bodyReceipt.appendChild(headerRow);
                updateSortButtons(activeButton, direction);

                recibos.sort((a, b) => compareReceipts(a, b, type, direction));
                recibos.forEach(recibo => bodyReceipt.appendChild(recibo));
            }

            function updateSortButtons(activeButton, direction){
                sortButtons.forEach(button => {
                    button.classList.remove('active', 'asc', 'desc');
                });

                if(activeButton){
                    activeButton.classList.add('active', direction);
                    updateSortIcon(activeButton, direction);
                }

                sortButtons.filter(button => button !== activeButton).forEach(button => {
                    updateSortIcon(button, (button.classList.contains('sort_fecha') || button.classList.contains('sort_total')) ? 'desc' : 'asc');
                });
            }

            function updateSortIcon(button, direction){
                const icon = button.querySelector('i');
                if(!icon){
                    return;
                }

                if(button.classList.contains('sort_name') || button.classList.contains('sort_detalle')){
                    icon.className = direction === 'asc' ? 'fa-solid fa-arrow-down-a-z' : 'fa-solid fa-arrow-down-z-a';
                }else if(button.classList.contains('sort_fecha') || button.classList.contains('sort_total')){
                    icon.className = direction === 'desc' ? 'fa-solid fa-arrow-down-9-1' : 'fa-solid fa-arrow-down-1-9';
                }else{
                    icon.className = direction === 'asc' ? 'fa-solid fa-arrow-down-short-wide' : 'fa-solid fa-arrow-down-wide-short';
                }
            }

            function compareReceipts(a, b, type, direction){
                if(type === 'estado'){
                    return compareEstado(a, b, direction) || compareByDate(a, b, 'desc');
                }

                if(type === 'name'){
                    return compareByName(a, b, direction) || compareByDate(a, b, 'desc');
                }

                if(type === 'total'){
                    return compareByTotal(a, b, direction) || compareByDate(a, b, 'desc');
                }

                if(type === 'detalle'){
                    return compareByDetalle(a, b, direction) || compareByDate(a, b, 'desc');
                }

                return compareByDate(a, b, direction);
            }

            function compareEstado(a, b, direction){
                const result = getEstadoOrder(a) - getEstadoOrder(b);
                return direction === 'asc' ? result : result * -1;
            }

            function getEstadoOrder(row){
                if(row.classList.contains('anulado')){
                    return 2;
                }

                const cierre = row.querySelector('.circulo_cierre');
                return cierre && cierre.classList.contains('cerrado') ? 1 : 0;
            }

            function compareByName(a, b, direction){
                const nameA = quitarAcentos((getCellText(a, '.campo_nombre p') || '').toLowerCase());
                const nameB = quitarAcentos((getCellText(b, '.campo_nombre p') || '').toLowerCase());
                const result = nameA.localeCompare(nameB, 'es', { sensitivity: 'base' });
                return direction === 'asc' ? result : result * -1;
            }

            function compareByDate(a, b, direction){
                const result = getDateValue(a) - getDateValue(b);
                return direction === 'asc' ? result : result * -1;
            }

            function getDateValue(row){
                const fechaEl = row.querySelector('.campo_fecha');
                const rawDate = fechaEl ? `${fechaEl.textContent || ''} ${fechaEl.getAttribute('title') || ''}` : '';
                return parseTableDateTimeValue(rawDate);
            }

            function compareByTotal(a, b, direction){
                const result = getMoneyValue(a, '.campo_total p') - getMoneyValue(b, '.campo_total p');
                return direction === 'asc' ? result : result * -1;
            }

            function compareByDetalle(a, b, direction){
                const detailA = quitarAcentos((getCellText(a, '.campo_rama p') || '').toLowerCase());
                const detailB = quitarAcentos((getCellText(b, '.campo_rama p') || '').toLowerCase());
                const result = detailA.localeCompare(detailB, 'es', { sensitivity: 'base' });
                return direction === 'asc' ? result : result * -1;
            }

            function getCellText(row, selector){
                const cell = row.querySelector(selector);
                return cell ? cell.textContent : '';
            }

            function getMoneyValue(row, selector){
                const amount = getCellText(row, selector).replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
                return parseFloat(amount) || 0;
            }
        }
    }
}

function sortZClosureList(){
    const lista_cierres = document.querySelector('.lista_cierres');
    if(lista_cierres){
        const bodyClose = lista_cierres.querySelector(".body_cierre");
        const sortButtons = Array.from(lista_cierres.querySelectorAll('.btn_sort_cierre'));
        const sort_name = lista_cierres.querySelector('.btn_sort_cierre.sort_name');
        const sort_fecha = lista_cierres.querySelector('.btn_sort_cierre.sort_fecha');
        const sort_ingreso = lista_cierres.querySelector('.btn_sort_cierre.sort_ingreso');
        const sort_egreso = lista_cierres.querySelector('.btn_sort_cierre.sort_egreso');
        const sort_cierre = lista_cierres.querySelector('.btn_sort_cierre.sort_cierre');
        const sort_firma = lista_cierres.querySelector('.btn_sort_cierre.sort_firma');

        if(bodyClose && sortButtons.length > 0){
            if(sort_name) sort_name.addEventListener('click', () => applyClosureSort('name', toggleDirection(sort_name, 'asc'), sort_name));
            if(sort_fecha) sort_fecha.addEventListener('click', () => applyClosureSort('fecha', toggleDirection(sort_fecha, 'desc'), sort_fecha));
            if(sort_ingreso) sort_ingreso.addEventListener('click', () => applyClosureSort('ingreso', toggleDirection(sort_ingreso, 'desc'), sort_ingreso));
            if(sort_egreso) sort_egreso.addEventListener('click', () => applyClosureSort('egreso', toggleDirection(sort_egreso, 'desc'), sort_egreso));
            if(sort_cierre) sort_cierre.addEventListener('click', () => applyClosureSort('cierre', toggleDirection(sort_cierre, 'desc'), sort_cierre));
            if(sort_firma) sort_firma.addEventListener('click', () => applyClosureSort('firma', toggleDirection(sort_firma, 'asc'), sort_firma));

            applyClosureSort('fecha', 'desc', sort_fecha);

            function applyClosureSort(sortType, direction, activeButton){
                const cierres = Array.from(bodyClose.querySelectorAll(".row_cierre:not(.header_cierre)"));

                setActiveSortButton(activeButton, direction);

                if(cierres.length === 0){
                    return;
                }

                cierres.sort((a, b) => {
                    let result = 0;

                    if(sortType === 'name'){
                        result = compareText(getCellText(a, '.campo_nombre p'), getCellText(b, '.campo_nombre p'));
                    }else if(sortType === 'fecha'){
                        result = getDateValue(a, '.campo_fecha').getTime() - getDateValue(b, '.campo_fecha').getTime();
                    }else if(sortType === 'ingreso'){
                        result = getMoneyValue(a, '.campo_monto.ingreso p') - getMoneyValue(b, '.campo_monto.ingreso p');
                    }else if(sortType === 'egreso'){
                        result = getMoneyValue(a, '.campo_monto.egreso p') - getMoneyValue(b, '.campo_monto.egreso p');
                    }else if(sortType === 'cierre'){
                        result = getMoneyValue(a, '.campo_monto.cierre p') - getMoneyValue(b, '.campo_monto.cierre p');
                    }else if(sortType === 'firma'){
                        result = compareText(getCellText(a, '.campo_firmante p'), getCellText(b, '.campo_firmante p'));
                    }

                    if(result === 0 && sortType !== 'fecha'){
                        return getDateValue(b, '.campo_fecha').getTime() - getDateValue(a, '.campo_fecha').getTime();
                    }

                    return direction === 'asc' ? result : result * -1;
                });

                cierres.forEach(cierre => bodyClose.appendChild(cierre));
            }

            function toggleDirection(button, defaultDirection){
                if(!button.classList.contains('active')){
                    return defaultDirection;
                }

                return button.classList.contains('asc') ? 'desc' : 'asc';
            }

            function setActiveSortButton(activeButton, direction){
                sortButtons.forEach(button => {
                    button.classList.remove('active', 'asc', 'desc');
                    updateSortIcon(button, button.classList.contains('sort_name') || button.classList.contains('sort_firma') ? 'asc' : 'desc');
                });

                if(activeButton){
                    activeButton.classList.add('active', direction);
                    updateSortIcon(activeButton, direction);
                }
            }

            function updateSortIcon(button, direction){
                const icon = button.querySelector('i');
                if(!icon){
                    return;
                }

                icon.className = '';
                icon.classList.add('fa-solid');

                if(button.classList.contains('sort_name') || button.classList.contains('sort_firma')){
                    icon.classList.add(direction === 'asc' ? 'fa-arrow-down-a-z' : 'fa-arrow-down-z-a');
                }else{
                    icon.classList.add(direction === 'asc' ? 'fa-arrow-down-1-9' : 'fa-arrow-down-9-1');
                }
            }

            function compareText(textA, textB){
                return quitarAcentos((textA || '').toLowerCase()).localeCompare(quitarAcentos((textB || '').toLowerCase()), 'es', { sensitivity: 'base' });
            }

            function getCellText(row, selector){
                const cell = row.querySelector(selector);
                return cell ? cell.textContent.trim() : '';
            }

            function getDateValue(row, selector){
                const cell = row.querySelector(selector);
                const rawDate = cell ? `${cell.textContent || ''} ${cell.getAttribute('title') || ''}` : '';
                return new Date(parseTableDateTimeValue(rawDate));
            }

            function getMoneyValue(row, selector){
                const amount = getCellText(row, selector).replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
                return parseFloat(amount) || 0;
            }
        } 
    }
}

function loaderMembersForm(){
    const loaderMember = document.querySelector('.cont_loader_miembro');
    if(loaderMember){
        const formMiembrosWrap = document.querySelector('.form_miembros');
        const formMiembros = formMiembrosWrap && formMiembrosWrap.matches('form') ? formMiembrosWrap : document.querySelector('.form_miembros form');
        const inputExcel = formMiembros ? formMiembros.querySelector('.inputExcel') : null;

        if(formMiembros && inputExcel){
            formMiembros.addEventListener('submit', (event) => {
                if(inputExcel.files.length === 0){
                    event.preventDefault();
                    return;
                }

                loaderMember.classList.add('loading');
            });
        }

    }
}

function createMemberByForm(){
    const form_create = document.querySelector('.form_miembro_indv.create');

    if(form_create){
        const btn_submit = form_create.querySelector('.btn_submit.agregar');
        const loader = document.querySelector('.panel_config.config_miembros .cont_loader_miembro');

        btn_submit.addEventListener('click',()=>{

            if(form_create.classList.contains('mostrar')){
                const campos = getCreateFormFields();
                if(campos){
                    loader.classList.add('loading');
                    fetch('/api/createMemberByForm.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(campos)
                      })
                      .then(response => response.json())  // Parsear la respuesta JSON
                      .then(data => {
                          //console.log(data);  // Hacer algo con la respuesta
                          if(data['response'] == 200){
                            insertSuccessful(campos,data['internalId']);
                            loader.classList.remove('loading');
                          }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al Crear Miembro');
                            }else{
                                showAlert('error',data['error']);
                            }
                            loader.classList.remove('loading');
                          }
                      })
                      .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Crear Miembro');
                        loader.classList.remove('loading');
                      });
                }
            }
        })

        function insertSuccessful(campos,intId){
            showAlert('success','Miembro Creado Correctamente');
            createNewMemberRow(campos,intId);
            sortNewMembersList();
            raiseMemberFields();

            refreshAllMembers();
        }

        function createNewMemberRow(member,intId) {
            const lista_miembros = document.querySelector(".lista_miembros");
            const bodyMembers = lista_miembros.querySelector(".body_miembro");
            const emptyMessage = lista_miembros.querySelector(".emptyMessage");
            const row = document.createElement("div");
            row.classList.add("row_miembro","activo","no_revisar");
        
            row.innerHTML = `
                <div class="campo campo_internal" style="display: none;">
                    <p>${intId}</p>
                </div>
                <div class="campo campo_activo">
                    <div class="circulo_actividad activo"></div>
                </div>
                <div class="campo campo_nombre">
                    <p>${member.Nombre}</p>
                </div>
                <div class="campo campo_doc">
                    <p>${member.Doc}</p>
                </div>
                <div class="campo campo_rama ${member.Rama.replace(/\d/g, '').toLowerCase()}" title="${member.NombreRama}">
                    <p>${member.NombreRama}</p>
                </div>
                <div class="campo editar_miembro" title="Editar Miembro" >
                    <i class="fa-solid fa-square-pen fa-xl" style="color: #0071bc;"></i>
                </div>
                <div class="campo eliminar_miembro" title="Eliminar Miembro" >
                    <i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i>
                </div>
                <div class="campo campo_telefono" style="display: none;">
                    <p>${member.Tel}</p>
                </div>
                <div class="campo campo_codrama" style="display: none;">
                    <p>${member.Rama}</p>
                </div>
            `;
            
            if(emptyMessage){
                emptyMessage.style.display = 'none';
            }
            bodyMembers.appendChild(row);
            addEventsButtoms(row);

        }

        function sortNewMembersList(){
            const sort_name = document.querySelector('.btn_sort_miembro.sort_name');

            if(sort_name){
                sort_name.classList.remove('asc');
                sort_name.click();
            }
        }

        function getCreateFormFields(){
            const campo_doc = form_create.querySelector('.campo.documento input');
            const campo_nombre = form_create.querySelector('.campo.nombre input');
            const campo_rama = form_create.querySelector('.campo.rama select');
            const nombre_rama = campo_rama.options[campo_rama.selectedIndex].text;
            const campo_tel = form_create.querySelector('.campo.telefono input');

            let errorMsg = "Falto completar ";
            let error = false;
            if(campo_doc.value == ''){
                errorMsg = errorMsg + 'DNI. ';
                error = true
            }
            if(campo_nombre.value == ''){
                errorMsg = errorMsg + 'Nombre. ';
                error = true
            }
            if(campo_rama.value == 0){
                errorMsg = errorMsg + 'Unidad. ';
                error = true
            }
            if(error){
                showAlert('error',errorMsg);
                return false;
            }
    
            dic = {'Doc':campo_doc.value,'Nombre':campo_nombre.value,
                'Rama':campo_rama.value,'NombreRama':nombre_rama,'Tel':campo_tel.value};
    
            return dic;
        }

        function raiseMemberFields(){
            const inputNombre = form_create.querySelector("#nombre_create");
            const inputDoc = form_create.querySelector("#documento_create");
            const inputRama = form_create.querySelector("#rama_create");
            const inputTelefono = form_create.querySelector("#telefono_create");
            const layout = document.querySelector('.layout');
            
            layout.classList.remove('mostrar');
            form_create.classList.remove('mostrar');
            inputNombre.value = '';
            inputDoc.value = '';
            inputTelefono.value = '';
            inputRama.value = 0;
    
        }

        function addEventsButtoms(row){
            const btn_edit = row.querySelector(".editar_miembro");
            const btn_delete = row.querySelector(".eliminar_miembro");
            const formEdit = document.querySelector('.form_miembro_indv.edit');
            const layout = document.querySelector('.layout');
            const formDelete = document.querySelector('.form_miembro_indv.delete');

            btn_edit.addEventListener("click",()=>{
                if(formEdit.classList.contains('mostrar')){
                    formEdit.classList.remove('mostrar');
                    formEdit.classList.add('ocultar');
                    layout.classList.remove('mostrar');
                    row.classList.remove('selected');
                    raiseEditFields();
                }else{
                    formEdit.classList.add('mostrar');
                    formEdit.classList.remove('ocultar'); 
                    layout.classList.add('mostrar');
                    row.classList.add('selected');
                    completeEditFields(row);
                }
            })

            btn_delete.addEventListener("click",()=>{
                if(formDelete.classList.contains('mostrar')){
                    formDelete.classList.remove('mostrar');
                    formDelete.classList.add('ocultar');
                    layout.classList.remove('mostrar');
                    row.classList.remove('selected');
                    raiseDeleteFields();
                }else{
                    formDelete.classList.add('mostrar');
                    formDelete.classList.remove('ocultar'); 
                    layout.classList.add('mostrar');
                    row.classList.add('selected');
                    completeDeleteFields(row);
                }
            })

            function completeEditFields(row){
                const activo = row.querySelector(".campo_activo div");
                const nombre = row.querySelector(".campo_nombre p");
                const doc = row.querySelector(".campo_doc p");
                const rama = row.querySelector(".campo_codrama p");
                const telefono = row.querySelector(".campo_telefono p");
        
                const inputActivo = formEdit.querySelector("#activo");
                const inputNombre = formEdit.querySelector("#nombre_edit");
                // const inputDoc = formEdit.querySelector("#documento_edit");
                const inputRama = formEdit.querySelector("#rama_edit");
                const inputTelefono = formEdit.querySelector("#telefono_edit");
                
                inputNombre.value = nombre.innerHTML;
                // inputDoc.value = doc.innerHTML;
                inputTelefono.value = telefono.innerHTML;
                inputRama.value = rama.innerHTML;
        
                if(activo.classList.contains('activo')){
                    inputActivo.checked = true;
                }else{
                    inputActivo.checked = false;
                }
        
            }
        
            function raiseEditFields(){
                const inputActivo = formEdit.querySelector("#activo");
                const inputNombre = formEdit.querySelector("#nombre_edit");
                // const inputDoc = formEdit.querySelector("#documento_edit");
                const inputRama = formEdit.querySelector("#rama_edit");
                const inputTelefono = formEdit.querySelector("#telefono_edit");
                
                inputNombre.value = '';
                // inputDoc.value = '';
                inputTelefono.value = '';
                inputRama.value = 0;
                inputActivo.checked = false;
        
            }

            function completeDeleteFields(row){
                const doc = row.querySelector(".campo_doc p");
                const legend = formDelete.querySelector(".eliminar_miembro legend");
  
                legend.innerHTML += doc.innerHTML + '?';
            }
        
            function raiseDeleteFields(){
                const legend = formDelete.querySelector(".eliminar_miembro legend");
                legend.innerHTML = '¿Eliminar Miembro DNI: ';
            }
        }
    }

}

function editMemberByForm(){
    const form_edit = document.querySelector('.form_miembro_indv.edit');

    if(form_edit){
        const btn_submit = form_edit.querySelector('.btn_submit.editar');
        const loader = document.querySelector('.panel_config.config_miembros .cont_loader_miembro');
        
        btn_submit.addEventListener('click',()=>{

            if(form_edit.classList.contains('mostrar')){
                const campos = getEditFormFields();
                if(campos){
                    loader.classList.add('loading');
                    //console.log(campos);
                    fetch('/api/editMemberByForm.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(campos)
                      })
                      .then(response => response.json())  //Parsear la respuesta JSON
                      .then(data => {
                        //console.log(data);  //Hacer algo con la respuesta
                        if(data['response'] == 200){
                            updateSuccessful(campos);
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al Actualizar Miembro');
                            }else{
                                showAlert('error',data['error']);
                            }
                        }
                        loader.classList.remove('loading');
                      })
                      .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Actualizar Miembro');
                        loader.classList.remove('loading');
                      });
                }
            }
        })

        function updateSuccessful(campos){
            showAlert('success','Miembro Actualizado Correctamente');
            editMemberRow(campos);
            sortNewMembersList();
            raiseMemberFields();

            refreshAllMembers();
        }

        function editMemberRow(member) {
            const lista_miembros = document.querySelector(".lista_miembros");
            const row = lista_miembros.querySelector(".row_miembro:not(.header_miembro).selected")
        
            const activo = row.querySelector(".campo_activo div");
            const nombre = row.querySelector(".campo_nombre p");
            const rama = row.querySelector(".campo_codrama p");
            const divRamaNombre = row.querySelector(".campo_rama");
            const ramaNombre = row.querySelector(".campo_rama p");
            const telefono = row.querySelector(".campo_telefono p");
            
            nombre.innerHTML = member.Nombre;
            telefono.innerHTML = member.Tel;
            rama.innerHTML = member.Rama;
            ramaNombre.innerHTML = member.NombreRama;
            nombre.title = member.Nombre;

            divRamaNombre.className = '';
            divRamaNombre.classList.add('campo','campo_rama');
            divRamaNombre.classList.add(member.Rama.replace(/\d/g, '').toLowerCase());
            divRamaNombre.title = member.NombreRama;
    
            if(member.Active == true){
                activo.classList.remove('inactivo');
                activo.classList.add('activo');
                row.classList.remove('inactivo');
                row.classList.add('activo');
            }else{
                activo.classList.remove('activo');
                activo.classList.add('inactivo');
                row.classList.remove('activo');
                row.classList.add('inactivo');
            }
        }

        function sortNewMembersList(){
            const sort_name = document.querySelector('.btn_sort_miembro.sort_name');

            if(sort_name){
                sort_name.classList.remove('asc');
                sort_name.click();
            }
        }

        function getEditFormFields(){
            const lista_miembros = document.querySelector(".lista_miembros");
            const row = lista_miembros.querySelector(".row_miembro:not(.header_miembro).selected")
            const intId = row.querySelector(".campo_internal p").innerHTML;
            const campo_nombre = form_edit.querySelector('.campo.nombre input');
            const campo_rama = form_edit.querySelector('.campo.rama select');
            const nombre_rama = campo_rama.options[campo_rama.selectedIndex].text;
            const campo_tel = form_edit.querySelector('.campo.telefono input');
            const campo_active = form_edit.querySelector('.campo.activo input');

            let errorMsg = "Falto completar ";
            let error = false;
            if(campo_nombre.value == ''){
                errorMsg = errorMsg + 'Nombre. ';
                error = true
            }
            if(campo_rama.value == 0){
                errorMsg = errorMsg + 'Unidad. ';
                error = true
            }
            if(error){
                showAlert('error',errorMsg);
                return false;
            }
    
            dic = {'Nombre':campo_nombre.value,
                'Rama':campo_rama.value,'NombreRama':nombre_rama,
                'Tel':campo_tel.value,'Active':campo_active.checked,
                'InternalId':intId};
    
            return dic;
        }

        function raiseMemberFields(){
            const lista_miembros = document.querySelector(".lista_miembros");
            const row = lista_miembros.querySelector(".row_miembro:not(.header_miembro).selected")
            const inputNombre = form_edit.querySelector("#nombre_edit");
            const inputRama = form_edit.querySelector("#rama_edit");
            const inputTelefono = form_edit.querySelector("#telefono_edit");
            const layout = document.querySelector('.layout');
            
            layout.classList.remove('mostrar');
            form_edit.classList.remove('mostrar');
            row.classList.remove('selected');
            inputNombre.value = '';
            inputTelefono.value = '';
            inputRama.value = 0;
    
        }
    }
}

function confirmMemberByForm(){

    const lista_miembros = document.querySelector('.lista_miembros');
    if(lista_miembros){
        const row_miembros = lista_miembros.querySelectorAll('.row_miembro:not(.header_miembro).revisar');
        if(row_miembros.length > 0){
            row_miembros.forEach((miembro) =>{
                const btn_confirm = miembro.querySelector('.campo.confirmar_miembro');
                const campo_rama = miembro.querySelector('.campo_rama');
                const select_rama = campo_rama.querySelector('select');

                btn_confirm.addEventListener('click',()=>{

                    const campos = getConfirmFormFields(miembro);
                    const loader = document.querySelector('.panel_config.config_miembros .cont_loader_miembro');
                    if(campos){
                        loader.classList.add('loading');
                        //console.log(campos);
                        fetch('/api/confirmMemberByForm.php', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(campos)
                            })
                            .then(response => response.json())  //Parsear la respuesta JSON
                            .then(data => {
                                //console.log(data);  //Hacer algo con la respuesta
                                if(data['response'] == 200){
                                confirmSuccessful(miembro);
                                }else{
                                console.error('Error en la solicitud:', data['error']);
                                if(Object.keys(data['error']).length === 0){
                                    showAlert('error','Error al Confirmar Miembro');
                                }else{
                                    showAlert('error',data['error']);
                                }
                                //raiseMemberFields();
                                }
                                loader.classList.remove('loading');
                            })
                            .catch(error => {
                                console.error('Error en la solicitud:', error);
                                showAlert('error','Error al Actualizar Miembro');
                                loader.classList.remove('loading');
                            });
                    }
                })

                select_rama.addEventListener('change',()=>{
                    let clase_rama = select_rama.value.replace(/\d/g, '').toLowerCase();
                    campo_rama.className = '';
                    campo_rama.classList.add('campo','campo_rama',clase_rama);
                    campo_rama.title = select_rama.options[select_rama.selectedIndex].text;
                })
            })
    
            function confirmSuccessful(member){
                showAlert('success','Miembro Confirmado Correctamente');
                changeRowClass(member);
                sortNewMembersList();

                refreshAllMembers();
            }
    
            function sortNewMembersList(){
                const sort_name = document.querySelector('.btn_sort_miembro.sort_name');
    
                if(sort_name){
                    sort_name.classList.remove('asc');
                    sort_name.click();
                }
            }
    
            function getConfirmFormFields(row){
                const intId = row.querySelector(".campo_internal p").innerHTML
                const codRama = row.querySelector(".campo_rama select").value
        
                dic = {'Rama':codRama,'InternalId':intId};
        
                return dic;
            }
    
            function changeRowClass(member){
                const campoRama = member.querySelector('.campo_rama');
                const ramaSelect = campoRama.querySelector('select');
                const btn_confirm = member.querySelector('.confirmar_miembro');
                const pRama = document.createElement('p');
                const btn_edit = document.createElement('div');
                const rama = ramaSelect.options[ramaSelect.selectedIndex].text;

                member.classList.remove('revisar');
                member.classList.add('no_revisar','new');

                ramaSelect.remove();
                pRama.textContent = rama;
                campoRama.appendChild(pRama);

                btn_edit.className = 'campo editar_miembro';
                btn_edit.setAttribute('title', 'Editar Miembro');
                btn_edit.innerHTML = '<i class="fa-solid fa-square-pen fa-xl" style="color: #0071bc;"></i>';
                
                btn_confirm.replaceWith(btn_edit);

                showEditMemberForm(true);

            }

        }
    }

}

function deleteMemberByForm(){
    const form_delete = document.querySelector('.form_miembro_indv.delete');

    if(form_delete){
        const btn_submit = form_delete.querySelector('.btn_submit.eliminar');

        btn_submit.addEventListener('click',()=>{
            
            const loader = document.querySelector('.panel_config.config_miembros .cont_loader_miembro');
            if(form_delete.classList.contains('mostrar')){
                const campos = getDeleteFormFields();
                if(campos){
                    loader.classList.add('loading');
                    //console.log(campos);
                    fetch('/api/deleteMemberByForm.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(campos)
                      })
                      .then(response => response.json())  //Parsear la respuesta JSON
                      .then(data => {
                          //console.log(data);  //Hacer algo con la respuesta
                          if(data['response'] == 200){
                            deleteSuccessful(campos);
                          }else{
                            console.error('Error en la solicitud:', data['error']);
                            showAlert('error','Error al Eliminar Miembro');
                            raiseMemberFields();
                          }
                          loader.classList.remove('loading');
                      })
                      .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Eliminar Miembro');
                        raiseMemberFields();
                        loader.classList.remove('loading');
                      });
                }
            }
        })

        function deleteSuccessful(campos){
            showAlert('success','Miembro Eliminado Correctamente');
            deleteMemberRow(campos);
            raiseMemberFields();

            refreshAllMembers();
        }

        function deleteMemberRow(member) {
            const lista_miembros = document.querySelector(".lista_miembros");
            const row = lista_miembros.querySelector(".row_miembro:not(.header_miembro).selected")
            const emptyMessage = lista_miembros.querySelector(".emptyMessage");

            row.remove();

            const rows = lista_miembros.querySelectorAll(".row_miembro:not(.header_miembro)");
            if(rows.length == 0){emptyMessage.style.display = 'block';}
        }

        function getDeleteFormFields(){
            const lista_miembros = document.querySelector(".lista_miembros");
            const row = lista_miembros.querySelector(".row_miembro:not(.header_miembro).selected")
            const intId = row.querySelector(".campo_internal p").innerHTML
    
            dic = {'InternalId':intId};
    
            return dic;
        }

        function raiseMemberFields(){
            const legend = form_delete.querySelector(".legend_delete");
            const layout = document.querySelector('.layout');
            
            layout.classList.remove('mostrar');
            form_delete.classList.remove('mostrar');
            legend.textContent = legend.textContent.split(":")[0] + ":"; 
        }
    }


}

function createCampByForm(){
    const form_create = document.querySelector('.form_campa_indv.create');

    if(form_create){
        const btn_submit = form_create.querySelector('.btn_submit.agregar');

        btn_submit.addEventListener('click',()=>{
            const loader = document.querySelector('.panel_config.config_campas .cont_loader');
            const campos = getCreateFormFields();
            // console.log(campos);
            if(campos){
                loader.classList.add('loading');
                fetch('/api/createCampByForm.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(campos)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        if(data['response'] == 200){
                            insertSuccessful(campos,data['internalId']);
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al Crear Campamento');
                            }else{
                                showAlert('error',data['error']);
                            }
                        //raiseMemberFields();
                        }
                        loader.classList.remove('loading');
                    })
                    .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Crear Campamento');
                        loader.classList.remove('loading');
                    });
            }
        })

        function insertSuccessful(campos,intId){
            showAlert('success','Campamento Creado Correctamente');
            createNewCampRow(campos,intId);
            sortNewCampsList();
            raiseCampaFields();

            refreshCamps();
        }

        function createNewCampRow(camp,intId) {
            const lista_campas = document.querySelector(".lista_campas");
            const bodyCamps = lista_campas.querySelector(".body_campa");
            const emptyMessage = lista_campas.querySelector(".emptyMessage");
            const row = document.createElement("div");
            row.classList.add("row_campa","activo","new");
            // Fecha local (toISOString devuelve UTC y despues de las 21 hs da el dia siguiente).
            const hoy = new Date();
            const fechaAlta = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2,'0')}-${String(hoy.getDate()).padStart(2,'0')}`;
            row.dataset.ramas = camp.Ramas;
            row.dataset.fechaAlta = fechaAlta;
            row.dataset.valoresMoneda = JSON.stringify(camp.ValoresPorMoneda || {});

            const valor = formatCampListPrice(camp.Valor, camp.MonedaSigno);
        
            row.innerHTML = `
            <div class="campo campo_internal" style="display: none;">
                    <p>${intId}</p>
                </div>
                <div class="campo campo_activo">
                    <div class="circulo_actividad activo"></div>
                </div>
                <div class="campo campo_fecha" title="${fechaAlta}">
                    <p>${formatShortDate(fechaAlta)}</p>
                </div>
                <div class="campo campo_nombre" title="${camp.Nombre}">
                    <p>${camp.Nombre}</p>
                </div>
                <div class="campo campo_precio">
                    <p>${valor}</p>
                </div>
                <div class="campo campo_rama">
                </div>
                <div class="campo editar_campa" title="Editar Campa" >
                    <i class="fa-solid fa-square-pen fa-xl" style="color: #0071bc;"></i>
                </div>
                <div class="campo verificar_campa" title="Verificar campamento" >
                    <span class="campa_action_icon verificar"><i class="fa-solid fa-list"></i></span>
                </div>
                <div class="campo eliminar_campa" title="Eliminar Campa" >
                    <i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i>
                </div>
                <div class="campo campo_codrama" style="display: none;">
                    <p>${camp.Ramas}</p>
                </div>
            `;
        
            const ramasDic = getRamaDic();
            //Agregar ramas dentro del campo_rama
            const campoRama = row.querySelector(".campo_rama");

            camp.Ramas.split(",").forEach(codR => {
                const rama = ramasDic[`${codR.trim()}`];
                if (rama) {
                    const pRama = document.createElement("p");
                    if(rama.Nombre == 'Todos'){
                        pRama.className = 'all';
                    }else{
                        pRama.className = rama.Cod.replace(/[\d-]/g, '').toLowerCase();
                    }
                    pRama.textContent = rama.Nombre;
                    pRama.title = rama.Nombre;
                    
                    campoRama.appendChild(pRama);
                }
            });
            
            if(emptyMessage){
                emptyMessage.style.display = 'none';
            }
            bodyCamps.appendChild(row);
            // addEventsButtoms(row);
            showEditCampaForm(true);
            showDeleteCampaForm(true);

        }

        function sortNewCampsList(){
            const sort_fecha = document.querySelector('.btn_sort_campa.sort_fecha');

            if(sort_fecha){
                sort_fecha.classList.remove('desc');
                sort_fecha.click();
            }
        }

        function getCreateFormFields(){
            return getCampFormFields(form_create);
        }

        function raiseCampaFields(){
            const inputNombre = form_create.querySelector("#nombre_campaCreate");
            const inputPrecio = form_create.querySelector("#valor_campaCreate");
            const inputTipo = form_create.querySelector("#tipo_valor_campaCreate");
            const extraValores = form_create.querySelectorAll(".valor_campa_row.extra");
            const optionsRama = form_create.querySelectorAll(".select_rama .opciones_rama");
            const monedaOptions = form_create.querySelectorAll(".opcion_moneda_campa");
            const layout = document.querySelector('.layout');
            
            inputNombre.value = '';
            inputPrecio.value = '';
            inputTipo.value = '';
            form_create.querySelectorAll('.input_error').forEach((input)=>input.classList.remove('input_error'));
            extraValores.forEach((row)=>row.remove());
            optionsRama.forEach((option)=>{
                option.classList.remove('disable');
                option.classList.remove('active');
            })
            monedaOptions.forEach((option,i)=>{
                option.classList.toggle('active', i === 0);
                option.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
            })
            form_create.classList.remove('mostrar');
            form_create.classList.add('ocultar');
            layout.classList.remove('mostrar');
            form_create.resetCampCurrencies();
    
        }

        function getRamaDic(){
            const select_rama = form_create.querySelector('.select_rama');
            const option_rama = select_rama.querySelectorAll('.opciones_rama');
            let rama_dic = {};
            option_rama.forEach((option)=>{
                rama_dic[option.id] = {'Nombre':option.innerHTML,'Cod':option.id}
              })

            return rama_dic
        }
    }

}

function editCampByForm(){
    const form_edit = document.querySelector('.form_campa_indv.edit');

    if(form_edit){
        const btn_submit = form_edit.querySelector('.cont_submit');
        const campo_valor = form_edit.querySelector('#valor_campaEdit');

        campo_valor.addEventListener('input',() => {
            campo_valor.value = formatCurrencyInteger(campo_valor.value);
        })
        
        btn_submit.addEventListener('click',()=>{
            const loader = document.querySelector('.panel_config.config_campas .cont_loader');
            const campos = getUpdateFormFields();
            // console.log(campos);
            if(campos){
                loader.classList.add('loading');
                fetch('/api/editCampByForm.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(campos)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        if(data['response'] == 200){
                        updateSuccessful(campos);
                        }else{
                        console.error('Error en la solicitud:', data['error']);
                        if(Object.keys(data['error']).length === 0){
                            showAlert('error','Error al Actualizar Campamento');
                        }else{
                            showAlert('error',data['error']);
                        }
                        //raiseMemberFields();
                        }
                        loader.classList.remove('loading');
                    })
                    .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Actualizar Campamento');
                        loader.classList.remove('loading');
                    });
            }
        })

        function updateSuccessful(campos){
            showAlert('success','Campamento Actualizado Correctamente');
            editCampaRow(campos);
            sortNewCampaList();
            raiseCampaFields();

            refreshCamps();
        }

        function editCampaRow(campa) {
            const lista_campas = document.querySelector(".lista_campas");
            const row = lista_campas.querySelector(".row_campa:not(.header_campa).selected")
            const activo = row.querySelector(".campo_activo div");
            const nombre = row.querySelector(".campo_nombre p");
            const precio = row.querySelector(".campo_precio p");
            const ramas = row.querySelector(".campo_rama");
            const codRama = row.querySelector(".campo_codrama p");
            const ramasDic = getRamaDic();
            
            nombre.innerHTML = campa.Nombre;
            nombre.title = campa.Nombre;
            row.dataset.ramas = campa.Ramas;
            row.dataset.valoresMoneda = JSON.stringify(campa.ValoresPorMoneda || {});
            if(codRama){
                codRama.innerHTML = campa.Ramas;
            }
            
            precio.innerHTML = formatCampListPrice(campa.Valor, campa.MonedaSigno);

            ramas.innerHTML = '';
            campa.Ramas.split(",").forEach(codR => {
                const rama = ramasDic[`${codR.trim()}`];
                if (rama) {
                    const pRama = document.createElement("p");
                    if(rama.Nombre == 'Todos'){
                        pRama.className = 'all';
                    }else{
                        pRama.className = rama.Cod.replace(/[\d-]/g, '').toLowerCase();
                    }
                    pRama.textContent = rama.Nombre;
                    pRama.title = rama.Nombre;
                    ramas.appendChild(pRama);
                }
            });
    
            if(campa.Active == true){
                activo.classList.remove('inactivo');
                activo.classList.add('activo');
                row.classList.remove('inactivo');
                row.classList.add('activo');
            }else{
                activo.classList.remove('activo');
                activo.classList.add('inactivo');
                row.classList.remove('activo');
                row.classList.add('inactivo');
            }
        }

        function sortNewCampaList(){
            const sort_fecha = document.querySelector('.btn_sort_campa.sort_fecha');

            if(sort_fecha){
                sort_fecha.classList.remove('desc');
                sort_fecha.click();
            }
        }

        function getUpdateFormFields(){
            const fields = getCampFormFields(form_edit);
            if(!fields){ return false; }
            const row = document.querySelector('.lista_campas .row_campa:not(.header_campa).selected');
            fields.InternalId = row.querySelector('.campo_internal p').textContent;
            fields.Active = form_edit.querySelector('#activo_campa').checked;
            return fields;
        }

        function raiseCampaFields(){
            const lista_campas = document.querySelector(".lista_campas");
            const row = lista_campas.querySelector(".row_campa:not(.header_campa).selected")
            const layout = document.querySelector('.layout');
            const inputNombre = form_edit.querySelector("#nombre_campaEdit");
            const inputPrecio = form_edit.querySelector("#valor_campaEdit");
            const inputTipo = form_edit.querySelector("#tipo_valor_campaEdit");
            const extraValores = form_edit.querySelectorAll(".valor_campa_row.extra");
            const monedaOptions = form_edit.querySelectorAll(".opcion_moneda_campa");
            const optionsRama = form_edit.querySelectorAll("#rama .opciones_rama");
            
            inputNombre.value = '';
            inputPrecio.value = '';
            inputTipo.value = '';
            form_edit.querySelectorAll('.input_error').forEach((input)=>input.classList.remove('input_error'));
            extraValores.forEach((row)=>row.remove());
            optionsRama.forEach((option)=>{
                option.classList.remove('disable');
                option.classList.remove('active');
            })
            monedaOptions.forEach((option,i)=>{
                option.classList.toggle('active', i === 0);
                option.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
            })
            form_edit.dataset.valoresMoneda = '{}';
            layout.classList.remove('mostrar');
            form_edit.classList.remove('mostrar');
            row.classList.remove('selected');
    
        }

        function getRamaDic(){
            const select_rama = form_edit.querySelector('.select_rama');
            const option_rama = select_rama.querySelectorAll('.opciones_rama');
            let rama_dic = {};
            option_rama.forEach((option)=>{
                rama_dic[option.id] = {'Nombre':option.innerHTML,'Cod':option.id}
              })

            return rama_dic
        }
    }

}

function deleteCampByForm(){
    const form_delete = document.querySelector('.form_campa_indv.delete');

    if(form_delete){
        const btn_submit = form_delete.querySelector('.btn_submit.eliminar');

        btn_submit.addEventListener('click',()=>{
            const loader = document.querySelector('.panel_config.config_campas .cont_loader');

            if(form_delete.classList.contains('mostrar')){
                const campos = getDeleteFormFields();
                if(campos){
                    loader.classList.add('loading');
                    // console.log(campos);
                    fetch('/api/deleteCampByForm.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(campos)
                      })
                      .then(response => response.json())  //Parsear la respuesta JSON
                      .then(data => {
                        //   console.log(data);  //Hacer algo con la respuesta
                          if(data['response'] == 200){
                            deleteSuccessful(campos);
                          }else{
                            console.error('Error en la solicitud:', data['error']);
                            showAlert('error','Error al Eliminar Campamento');
                            raiseCampaFields();
                          }
                          loader.classList.remove('loading');
                      })
                      .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Eliminar Campamento');
                        raiseCampaFields();
                        loader.classList.remove('loading');
                      });
                }
            }
        })

        function deleteSuccessful(campos){
            showAlert('success','Campamento Eliminado Correctamente');
            deleteCampaRow();
            raiseCampaFields();

            refreshCamps();
        }

        function deleteCampaRow() {
            const lista_campas = document.querySelector(".lista_campas");
            const row = lista_campas.querySelector(".row_campa:not(.header_campa).selected")
            const emptyMessage = lista_campas.querySelector(".emptyMessage");

            row.remove();

            const rows = lista_campas.querySelectorAll(".row_campa:not(.header_campa)");
            if(rows.length == 0){emptyMessage.style.display = 'block';}
        }

        function getDeleteFormFields(){
            const lista_campas = document.querySelector(".lista_campas");

            const row = lista_campas.querySelector(".row_campa:not(.header_campa).selected")
            const intId = row.querySelector(".campo_internal p").innerHTML
    
            dic = {'InternalId':intId};
    
            return dic;
        }

        function raiseCampaFields(){
            const legend = form_delete.querySelector(".legend_delete");
            const layout = document.querySelector('.layout');
            
            layout.classList.remove('mostrar');
            form_delete.classList.remove('mostrar');
            legend.textContent = legend.textContent.split(":")[0] + ":"; 
        }
    }


}

function createEventByForm(){
    const form_create = document.querySelector('.form_evento_indv.create');

    if(form_create){
        const btn_submit = form_create.querySelector('.btn_submit.agregar');

        btn_submit.addEventListener('click',()=>{
            const loader = document.querySelector('.panel_config.config_eventos .cont_loader');
            const campos = getCreateFormFields();
            // console.log(campos);
            if(campos){
                loader.classList.add('loading');
                fetch('/api/createEventByForm.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(campos)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        if(data['response'] == 200){
                        insertSuccessful(campos,data['internalId']);
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al Crear Evento');
                            }else{
                                showAlert('error',data['error']);
                            }
                            //raiseMemberFields();
                        }
                        loader.classList.remove('loading');
                    })
                    .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Crear Evento');
                        loader.classList.remove('loading');
                    });
            }
        })

        function insertSuccessful(campos,intId){
            showAlert('success','Evento Creado Correctamente');
            createNewEventRow(campos,intId);
            sortNewEventsList();
            raiseEventsFields();

            refreshEvents();
        }

        function createNewEventRow(event,intId) {
            const lista_evento = document.querySelector(".lista_eventos");
            const bodyEvents = lista_evento.querySelector(".body_evento");
            const emptyMessage = lista_evento.querySelector(".emptyMessage");
            const row = document.createElement("div");
            row.classList.add("row_evento","activo","new");

            let valor = formatCurrency(String(event.Valor.toFixed(2)),false,false);
            valor = valor.replace('$ ','$');

            row.innerHTML = `
            <div class="campo campo_internal" style="display: none;">
                    <p>${intId}</p>
                </div>
                <div class="campo campo_activo">
                    <div class="circulo_actividad activo"></div>
                </div>
                <div class="campo campo_nombre" title="${event.Nombre}">
                    <p>${event.Nombre}</p>
                </div>
                <div class="campo campo_precio">
                    <p>${valor}</p>
                </div>
                <div class="campo campo_rama">
                </div>
                <div class="campo editar_evento" title="Editar Evento" >
                    <i class="fa-solid fa-square-pen fa-xl" style="color: #0071bc;"></i>
                </div>
                <div class="campo eliminar_evento" title="Eliminar Evento" >
                    <i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i>
                </div>
                <div class="campo campo_codrama" style="display: none;">
                    <p></p>
                </div>
            `;
        
            const ramasDic = getRamaDic();
            //Agregar ramas dentro del campo_rama
            const campoRama = row.querySelector(".campo_rama");
            event.Ramas.split(",").forEach(codR => {
                const rama = ramasDic[`${codR.trim()}`];
                if (rama) {
                    const pRama = document.createElement("p");
                    if(rama.Nombre == 'Todos'){
                        pRama.className = 'all';
                    }else{
                        pRama.className = rama.Cod.replace(/[\d-]/g, '').toLowerCase();
                    }
                    pRama.textContent = rama.Nombre;
                    pRama.title = rama.Nombre;
                    campoRama.appendChild(pRama);
                }
            });
            
            if(emptyMessage){
                emptyMessage.style.display = 'none';
            }
            bodyEvents.appendChild(row);
            // addEventsButtoms(row);
            showEditEventoForm(true);
            showDeleteEventoForm(true);

        }

        function sortNewEventsList(){
            const sort_name = document.querySelector('.btn_sort_evento.sort_name');

            if(sort_name){
                sort_name.classList.remove('asc');
                sort_name.click();
            }
        }

        function getCreateFormFields(){
            const campo_nombre = form_create.querySelector('.campo.nombre input');
            const campo_valor = form_create.querySelector('.campo.valor input');
            const select_rama = form_create.querySelector('.select_rama');
            const option_rama = select_rama.querySelectorAll('.opciones_rama');
            let rama_list = [];

            option_rama.forEach((option)=>{
              if(option.classList.contains('active')){
                rama_list.push(option.id);
              }  
            })

            let errorMsg = "Falto completar ";
            let error = false;
            if(campo_nombre.value == ''){
                errorMsg = errorMsg + 'Nombre. ';
                error = true
            }
            if(campo_valor.value == 0){
                errorMsg = errorMsg + 'Valor. ';
                error = true
            }
            if(rama_list.length == 0){
                errorMsg = errorMsg + 'Unidad. ';
                error = true
            }
            if(error){
                showAlert('error',errorMsg);
                return false;
            }
    
            dic = {'Valor':formatCurrencyToFloat(campo_valor.value),'Nombre':campo_nombre.value,'Ramas':rama_list.join(',')};
    
            return dic;
        }

        function raiseEventsFields(){
            const inputNombre = form_create.querySelector("#nombre_createEvent");
            const inputPrecio = form_create.querySelector("#valor_createEvent");
            const optionsRama = form_create.querySelectorAll(".select_rama .opciones_rama");
            const layout = document.querySelector('.layout');
            
            inputNombre.value = '';
            inputPrecio.value = '';
            optionsRama.forEach((option)=>{
                option.classList.remove('disable');
                option.classList.remove('active');
            })
            form_create.classList.remove('mostrar');
            form_create.classList.add('ocultar');
            layout.classList.remove('mostrar');
    
        }

        function getRamaDic(){
            const select_rama = form_create.querySelector('.select_rama');
            const option_rama = select_rama.querySelectorAll('.opciones_rama');
            let rama_dic = {};
            option_rama.forEach((option)=>{
                rama_dic[option.id] = {'Nombre':option.innerHTML,'Cod':option.id}
              })

            return rama_dic
        }
    }

}

function editEventByForm(){
    const form_edit = document.querySelector('.form_evento_indv.edit');

    if(form_edit){
        const btn_submit = form_edit.querySelector('.cont_submit');
        const campo_valor = form_edit.querySelector('.campo.valor input');

        campo_valor.addEventListener('input',() => {
            campo_valor.value = formatCurrency(campo_valor.value);
        })

        btn_submit.addEventListener('click',()=>{
            const loader = document.querySelector('.panel_config.config_eventos .cont_loader');
            const campos = getUpdateFormFields();
            // console.log(campos);
            if(campos){
                loader.classList.add('loading');
                fetch('/api/editEventByForm.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(campos)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        if(data['response'] == 200){
                            updateSuccessful(campos);
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al Actualizar Evento');
                            }else{
                                showAlert('error',data['error']);
                            }
                            //raiseMemberFields();
                        }
                        loader.classList.remove('loading');
                    })
                    .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Actualizar Evento');
                        loader.classList.remove('loading');
                    });
                }
        })

        function updateSuccessful(campos){
            showAlert('success','Evento Actualizado Correctamente');
            editEventRow(campos);
            sortNewEventoList();
            raiseEventoFields();

            refreshEvents();
        }

        function editEventRow(evento) {
            const lista_eventos = document.querySelector(".lista_eventos");
            const row = lista_eventos.querySelector(".row_evento:not(.header_evento).selected")
            const activo = row.querySelector(".campo_activo div");
            const nombre = row.querySelector(".campo_nombre p");
            const precio = row.querySelector(".campo_precio p");
            const ramas = row.querySelector(".campo_rama");
            const ramasDic = getRamaDic();
            
            nombre.innerHTML = evento.Nombre;
            nombre.title = evento.Nombre;

            precio.innerHTML = formatCurrency(String(evento.Valor.toFixed(2)),false,false);
            precio.innerHTML = precio.innerHTML.replace('$ ','$');
            
            ramas.innerHTML = '';
            evento.Ramas.split(",").forEach(codR => {
                const rama = ramasDic[`${codR.trim()}`];
                if (rama) {
                    const pRama = document.createElement("p");
                    if(rama.Nombre == 'Todos'){
                        pRama.className = 'all';
                    }else{
                        pRama.className = rama.Cod.replace(/[\d-]/g, '').toLowerCase();
                    }
                    pRama.textContent = rama.Nombre;
                    pRama.title = rama.Nombre;
                    ramas.appendChild(pRama);
                }
            });
    
            if(evento.Active == true){
                activo.classList.remove('inactivo');
                activo.classList.add('activo');
                row.classList.remove('inactivo');
                row.classList.add('activo');
            }else{
                activo.classList.remove('activo');
                activo.classList.add('inactivo');
                row.classList.remove('activo');
                row.classList.add('inactivo');
            }
        }

        function sortNewEventoList(){
            const sort_name = document.querySelector('.btn_sort_evento.sort_name');

            if(sort_name){
                sort_name.classList.remove('asc');
                sort_name.click();
            }
        }

        function getUpdateFormFields(){
            const lista_eventos = document.querySelector(".lista_eventos");
            const row = lista_eventos.querySelector(".row_evento:not(.header_evento).selected")
            const intId = row.querySelector(".campo_internal p").innerHTML
            const campo_nombre = form_edit.querySelector('.campo.nombre input');
            const campo_valor = form_edit.querySelector('.campo.valor input');
            const campo_active = form_edit.querySelector('.campo.activo input');
            const select_rama = form_edit.querySelector('.select_rama');
            const option_rama = select_rama.querySelectorAll('.opciones_rama');
            let rama_list = [];

            option_rama.forEach((option)=>{
              if(option.classList.contains('active')){
                rama_list.push(option.id);
              }  
            })

            let errorMsg = "Falto completar ";
            let error = false;
            if(campo_nombre.value == ''){
                errorMsg = errorMsg + 'Nombre. ';
                error = true
            }
            if(campo_valor.value == 0){
                errorMsg = errorMsg + 'Valor. ';
                error = true
            }
            if(rama_list.length == 0){
                errorMsg = errorMsg + 'Unidad. ';
                error = true
            }
            if(error){
                showAlert('error',errorMsg);
                return false;
            }
    
            dic = {'Valor':formatCurrencyToFloat(campo_valor.value),'Nombre':campo_nombre.value,
                'Ramas':rama_list.join(','),'Active':campo_active.checked,
                'InternalId':intId};

            return dic;
        }

        function raiseEventoFields(){
            const lista_eventos = document.querySelector(".lista_eventos");
            const row = lista_eventos.querySelector(".row_evento:not(.header_evento).selected")
            const layout = document.querySelector('.layout');
            const inputNombre = form_edit.querySelector("#nombre_editEvent");
            const inputPrecio = form_edit.querySelector("#valor_editEvent");
            const optionsRama = form_edit.querySelectorAll("#rama .opciones_rama");
            
            inputNombre.value = '';
            inputPrecio.value = '';
            optionsRama.forEach((option)=>{
                option.classList.remove('disable');
                option.classList.remove('active');
            })
            layout.classList.remove('mostrar');
            form_edit.classList.remove('mostrar');
            row.classList.remove('selected');
    
        }

        function getRamaDic(){
            const select_rama = form_edit.querySelector('.select_rama');
            const option_rama = select_rama.querySelectorAll('.opciones_rama');
            let rama_dic = {};
            option_rama.forEach((option)=>{
                rama_dic[option.id] = {'Nombre':option.innerHTML,'Cod':option.id}
              })

            return rama_dic
        }
    }

}

function deleteEventByForm(){
    const form_delete = document.querySelector('.form_evento_indv.delete');

    if(form_delete){
        const btn_submit = form_delete.querySelector('.btn_submit.eliminar');

        btn_submit.addEventListener('click',()=>{

            if(form_delete.classList.contains('mostrar')){
                const campos = getDeleteFormFields();
                const loader = document.querySelector('.panel_config.config_eventos .cont_loader');
                if(campos){
                    loader.classList.add('loading');
                    // console.log(campos);
                    fetch('/api/deleteEventByForm.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(campos)
                      })
                      .then(response => response.json())  //Parsear la respuesta JSON
                      .then(data => {
                        //   console.log(data);  //Hacer algo con la respuesta
                          if(data['response'] == 200){
                            deleteSuccessful(campos);
                          }else{
                            console.error('Error en la solicitud:', data['error']);
                            showAlert('error','Error al Eliminar Evento');
                            raiseEventoFields();
                          }
                          loader.classList.remove('loading');
                      })
                      .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Eliminar Evento');
                        raiseEventoFields();
                        loader.classList.remove('loading');
                      });
                }
            }
        })

        function deleteSuccessful(campos){
            showAlert('success','Evento Eliminado Correctamente');
            deleteEventoRow();
            raiseEventoFields();

            refreshEvents();
        }

        function deleteEventoRow() {
            const lista_eventos = document.querySelector(".lista_eventos");
            const row = lista_eventos.querySelector(".row_evento:not(.header_evento).selected")
            const emptyMessage = lista_eventos.querySelector(".emptyMessage");

            if(!row){
                return;
            }

            row.remove();

            const rows = lista_eventos.querySelectorAll(".row_evento:not(.header_evento)");
            if(rows.length == 0 && emptyMessage){emptyMessage.style.display = 'block';}
        }

        function getDeleteFormFields(){
            const lista_eventos = document.querySelector(".lista_eventos");
            const row = lista_eventos.querySelector(".row_evento:not(.header_evento).selected")

            if(!row){
                showAlert('error','Selecciona un Evento para Eliminar');
                return false;
            }

            const intId = row.querySelector(".campo_internal p").innerHTML
    
            dic = {'InternalId':intId};
    
            return dic;
        }

        function raiseEventoFields(){
            const legend = form_delete.querySelector(".legend_delete");
            const layout = document.querySelector('.layout');
            
            layout.classList.remove('mostrar');
            form_delete.classList.remove('mostrar');
            legend.textContent = legend.textContent.split(":")[0] + ":"; 
        }
    }

}

function clearActiveRamaSelection(scope = document){
    const cont_ramas = scope.querySelectorAll ? scope.querySelectorAll(".contenido_uni .cont_rama") : [];
    if(cont_ramas.length > 0){
        cont_ramas.forEach((cont) => {
            cont.querySelectorAll('.unidad.row.selected').forEach((unidad) => {
                unidad.classList.remove('selected');
            });
            const footerActions = cont.querySelector('.acciones_rama_card');
            if(footerActions){
                footerActions.classList.remove('has-selection');
            }
        });
    }
}

function closeRamaAddForms(scope = document){
    const cont_ramas = scope.querySelectorAll ? scope.querySelectorAll(".contenido_uni .cont_rama") : [];
    if(cont_ramas.length > 0){
        cont_ramas.forEach((cont) => {
            const footerActions = cont.querySelector('.acciones_rama_card');
            const form = cont.querySelector('.agregar_rama_form');
            if(footerActions){
                footerActions.classList.remove('adding');
            }
            if(form){
                const input = form.querySelector('input');
                if(input){
                    input.value = '';
                }
            }
        });
    }
}

function closeRamaEditForms(scope = document){
    const cont_ramas = scope.querySelectorAll ? scope.querySelectorAll(".contenido_uni .cont_rama") : [];
    if(cont_ramas.length > 0){
        cont_ramas.forEach((cont) => {
            const editingRow = cont.querySelector('.unidad.row.input_edit');
            const footerActions = cont.querySelector('.acciones_rama_card');

            if(footerActions){
                footerActions.classList.remove('editing');
            }

            if(editingRow){
                const originalText = editingRow.dataset.originalValue || '';
                const input = editingRow.querySelector('input.input_edit');
                const check = editingRow.querySelector('.editar_uni');
                const paragraph = document.createElement('p');
                paragraph.textContent = originalText;
                editingRow.classList.remove('input_edit');
                if(input){
                    input.replaceWith(paragraph);
                }
                if(check){
                    check.remove();
                }
                delete editingRow.dataset.originalValue;
            }
        });
    }
}

function openRamaAddForm(cont){
    if(!cont){
        return;
    }

    const footerActions = cont.querySelector('.acciones_rama_card');
    const addForm = cont.querySelector('.agregar_rama_form');
    const input = addForm ? addForm.querySelector('input') : null;

    clearActiveRamaSelection();
    closeRamaAddForms();
    closeRamaEditForms();

    if(footerActions){
        footerActions.classList.add('adding');
    }

    if(input){
        input.value = '';
        input.focus();
    }
}

function setActiveRamaSelection(cont, unidad = null){
    if(!cont){
        return;
    }

    cont.querySelectorAll('.unidad.row.selected').forEach((row) => {
        row.classList.remove('selected');
    });

    const footerActions = cont.querySelector('.acciones_rama_card');
    if(footerActions){
        footerActions.classList.remove('has-selection');
        footerActions.classList.remove('editing');
    }

    if(unidad){
        closeRamaAddForms(cont.parentElement || document);
        unidad.classList.add('selected');
        if(footerActions){
            footerActions.classList.add('has-selection');
        }
    }
}

function initRamaFooterActions(){
    const cont_ramas = document.querySelectorAll(".contenido_uni .cont_rama");
    if(cont_ramas.length > 0){
        cont_ramas.forEach((cont) => {
            if(cont.dataset.footerActionsReady === 'true'){
                return;
            }

            const footerActions = cont.querySelector('.acciones_rama_card');
            if(!footerActions){
                return;
            }

            const btnAdd = footerActions.querySelector('.agregar_rama_card');
            const btnEdit = footerActions.querySelector('.editar_rama_card');
            const btnDelete = footerActions.querySelector('.eliminar_rama_card');
            const btnConfirm = footerActions.querySelector('.confirmar_rama_card');
            const addForm = footerActions.querySelector('.agregar_rama_form');
            const addInput = addForm ? addForm.querySelector('input') : null;

            if(btnAdd && addForm && addInput){
                btnAdd.addEventListener('click', (event) => {
                    event.stopPropagation();
                    openRamaAddForm(cont);
                });
            }

            if(btnEdit){
                btnEdit.addEventListener('click', (event) => {
                    event.stopPropagation();
                    const activeRow = cont.querySelector('.unidad.row.selected');
                    if(!activeRow){
                        return;
                    }
                    const hiddenEdit = activeRow.querySelector('.acciones_unidad .edit');
                    if(hiddenEdit){
                        hiddenEdit.click();
                    }
                });
            }

            if(btnDelete){
                btnDelete.addEventListener('click', (event) => {
                    event.stopPropagation();
                    const activeRow = cont.querySelector('.unidad.row.selected');
                    if(!activeRow){
                        return;
                    }
                    const hiddenDelete = activeRow.querySelector('.acciones_unidad .delete');
                    if(hiddenDelete){
                        hiddenDelete.click();
                    }
                });
            }

            if(btnConfirm){
                btnConfirm.addEventListener('click', (event) => {
                    event.stopPropagation();
                    const editingRow = cont.querySelector('.unidad.row.input_edit');
                    if(!editingRow){
                        return;
                    }
                    const hiddenConfirm = editingRow.querySelector('.editar_uni');
                    if(hiddenConfirm){
                        hiddenConfirm.click();
                    }
                });
            }

            cont.dataset.footerActionsReady = 'true';
        });
    }
}

function createRamaInTable(){
    const cont_ramas = document.querySelectorAll(".contenido_uni .cont_rama");
    if(cont_ramas.length > 0){
        cont_ramas.forEach((cont)=>{
            const btn_create = cont.querySelector('.crear_uni');
            const addForm = cont.querySelector('.agregar_rama_form');
            const input = addForm ? addForm.querySelector('input') : null;
            const loader = document.querySelector('.panel_config .cont_unidades .cont_loader');

            if(!btn_create || !addForm || !input){
                return;
            }

            input.addEventListener('keydown', (event) => {
                if(event.key === 'Enter'){
                    event.preventDefault();
                    btn_create.click();
                }
            });

            btn_create.addEventListener('click',(event)=>{
                event.stopPropagation();
                const footerActions = cont.querySelector('.acciones_rama_card');
                if(footerActions && footerActions.classList.contains('adding')){
                    if(input.value.trim() != ''){
                        loader.classList.add('loading');
                        campos = {'Rama':btn_create.id,'Nombre':input.value}
                        // console.log(campos);
                        fetch('/api/createRama.php', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(campos)
                            })
                            .then(response => response.json())
                            .then(data => {
                                // console.log(data);
                                if(data['response'] == 200){
                                    createSuccess(campos,data['codRama'],cont);
                                }else{
                                    console.error('Error en la solicitud:', data['error']);
                                    if(Object.keys(data['error']).length === 0){
                                        showAlert('error','Error al Crear Unidad');
                                    }else{
                                        showAlert('error',data['error']);
                                    }
                                    //raiseMemberFields();
                                }
                                loader.classList.remove('loading');
                            })
                            .catch(error => {
                                console.error('Error en la solicitud:', error);
                                showAlert('error','Error al Crear Unidad');
                                //raiseMemberFields();
                                loader.classList.remove('loading');
                            });
                    }else{
                        showAlert('error','Debes Ponerle un nombre a la Unidad');
                        input.focus();
                    }
                }else{
                    openRamaAddForm(cont);
                }
            });
        })

        function createSuccess(campos,cod,cont){
            showAlert('success','Unidad Creada Correctamente');
            clearFields();
            createRamaRow(campos,cod,cont);

            refreshRamas();
        }

        function clearFields(){
            cont_ramas.forEach((cont)=>{
                const input = cont.querySelector('.agregar_rama_form input');
                input.value = '';
                cont.querySelector('.acciones_rama_card').classList.remove('adding');
            })
        }

        function createRamaRow(campos,cod,cont){
            const row = document.createElement("div");
            const lista_unidades = cont.querySelector(".lista_unidades");

            row.id = cod;
            row.classList.add("unidad","row","new");
            row.innerHTML = `
            <p>${campos.Nombre}</p>
            <div class="acciones_unidad">
                <i class="fa-solid fa-square-pen edit fa-xl" style="color: #0071bc;"></i>
                <i class="fa-solid fa-square-xmark delete fa-xl" style="color: #ad272d;"></i>
            </div>
            `;

            lista_unidades.appendChild(row);
            showRamasActions(true);
            editRamaInTable(true);
            deleteRamaInTable(true);
            syncRamaNameOverflowMarquee(cont);
        }

    }
}

function editRamaInTable(newRow = false){
    const cont_ramas = document.querySelectorAll(".contenido_uni .cont_rama");
    if(cont_ramas.length > 0){
        cont_ramas.forEach((cont)=>{

            let all_row_rama = [];
            if(newRow){
                all_row_rama = cont.querySelectorAll('.unidad.row.new');
            }else{
                all_row_rama = cont.querySelectorAll('.unidad.row');
            }

            all_row_rama.forEach((rowRama)=>{
                const btn_edit = rowRama.querySelector('.acciones_unidad .edit');
                const pRama = rowRama.querySelector('p');

                btn_edit.addEventListener('click',()=>{
                    convertirAInput(pRama,rowRama);
                    const checkEdit = rowRama.querySelector('i.editar_uni');
                    if (checkEdit){
                        const input = rowRama.querySelector('.input_edit');
                        input.addEventListener('keydown', (event) => {
                            if(event.key === 'Enter'){
                                event.preventDefault();
                                const footerConfirm = cont.querySelector('.confirmar_rama_card');
                                if(footerConfirm){
                                    footerConfirm.click();
                                }
                            }
                        });
                        const loader = document.querySelector('.panel_config .cont_unidades .cont_loader');
                        checkEdit.addEventListener('click',()=>{
                            if(input.value.trim() != ''){
                                loader.classList.add('loading');
                                campos = {'CodRama':rowRama.id,'Nombre':input.value}
                                // console.log(campos);
                                fetch('/api/editRama.php', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify(campos)
                                    })
                                    .then(response => response.json())
                                    .then(data => {
                                        // console.log(data);
                                        if(data['response'] == 200){
                                        editSuccess(campos,rowRama,pRama);
                                        }else{
                                            console.error('Error en la solicitud:', data['error']);
                                            if(Object.keys(data['error']).length === 0){
                                                showAlert('error','Error al Actualizar Unidad');
                                            }else{
                                                showAlert('error',data['error']);
                                            }
                                            //raiseMemberFields();
                                        }
                                        loader.classList.remove('loading');
                                    })
                                    .catch(error => {
                                        console.error('Error en la solicitud:', error);
                                        showAlert('error','Error al Actualizar Unidad');
                                        //raiseMemberFields();
                                        loader.classList.remove('loading');
                                    });
                            
                            }else{
                                showAlert('error','Debes Ponerle un nombre a la Unidad');
                            }
                        })
                    }
                })
            })
        })

        function convertirAInput(p,rowRama) {
            const actions = rowRama.querySelector(".acciones_unidad");
            const cont = rowRama.closest('.cont_rama');
            const footerActions = cont ? cont.querySelector('.acciones_rama_card') : null;
            let valorActual = p.innerText; // Guarda el texto actual
            let input = document.createElement("input");
            let check = document.createElement("i");

            closeRamaEditForms(cont ? cont.parentElement || document : document);
            rowRama.classList.add('input_edit');
            rowRama.dataset.originalValue = valorActual;
            actions.classList.remove('showActions');
            setActiveRamaSelection(cont, null);
            closeRamaAddForms(cont ? cont.parentElement || document : document);

            if(footerActions){
                footerActions.classList.add('editing');
            }

            input.type = "text";
            input.classList.add('input_edit');
            input.value = valorActual;
            //input.onblur = function() { revertirAParrafo(input,p,rowRama); };

            check.classList.add('fa-solid','fa-square-check','editar_uni')
            check.style.display = 'none';
             
            rowRama.appendChild(check);
            p.replaceWith(input);
            input.focus();

            document.addEventListener("click", (event) => {
                // Si el clic no es dentro de una fila ni dentro de .acciones_unidad
                if (!event.target.closest(".unidad.row") && !event.target.closest(".input_edit") && !event.target.closest(".acciones_rama_card")) {
                    revertirAParrafo(input,p,rowRama); // Cierra las acciones
                }
            });

            function revertirAParrafo(input,p,rowRama) {
                rowRama.classList.remove('input_edit');
                delete rowRama.dataset.originalValue;
                if(footerActions){
                    footerActions.classList.remove('editing');
                }
                showRamasActions();
                input.replaceWith(p);
                check.remove();
            }
        }

        function editSuccess(campos,rowRama,pRama){
            showAlert('success','Unidad Actualizada Correctamente');
            clearFields(rowRama,pRama);
            editRamaRow(campos,rowRama);

            refreshRamas();
        }

        function clearFields(rowRama,p){
            const check = rowRama.querySelector('i.editar_uni');
            const input = rowRama.querySelector('.input_edit');
            const footerActions = rowRama.closest('.cont_rama').querySelector('.acciones_rama_card');
            rowRama.classList.remove('input_edit');
            delete rowRama.dataset.originalValue;
            footerActions.classList.remove('editing');
            showRamasActions();
            input.replaceWith(p);
            check.remove();
        }

        function editRamaRow(campos,rowRama){
            const row = rowRama.querySelector("p");
            row.innerHTML = campos['Nombre'];
            syncRamaNameOverflowMarquee(rowRama.closest('.cont_rama'));
        }

    }
}

function deleteRamaInTable(newRow = false){
    const cont_ramas = document.querySelectorAll(".contenido_uni .cont_rama");
    if(cont_ramas.length > 0){
        cont_ramas.forEach((cont)=>{

            let all_row_rama = [];
            if(newRow){
                all_row_rama = cont.querySelectorAll('.unidad.row.new');
            }else{
                all_row_rama = cont.querySelectorAll('.unidad.row');
            }

            all_row_rama.forEach((rowRama)=>{
                const btn_delete = rowRama.querySelector('.acciones_unidad .delete');
                const loader = document.querySelector('.panel_config .cont_unidades .cont_loader');

                rowRama.classList.remove('new');
                btn_delete.addEventListener('click',()=>{
                    loader.classList.add('loading');
                    campos = {'CodRama':rowRama.id}
                    // console.log(campos);
                    fetch('/api/deleteRama.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(campos)
                        })
                        .then(response => response.json())
                        .then(data => {
                            // console.log(data);
                            if(data['response'] == 200){
                            deleteSuccess(rowRama);
                            }else{
                                console.error('Error en la solicitud:', data['error']);
                                if(Object.keys(data['error']).length === 0){
                                    showAlert('error','Error al Eliminar Unidad');
                                }else{
                                    showAlert('error',data['error']);
                                }
                            //raiseMemberFields();
                            }
                            loader.classList.remove('loading');
                        })
                            .catch(error => {
                            console.error('Error en la solicitud:', error);
                            showAlert('error','Error al Eliminar Unidad');
                            //raiseMemberFields();
                            loader.classList.remove('loading');
                        });
                })
            })
        })

        function deleteSuccess(rowRama){
            showAlert('success','Unidad Eliminada Correctamente');
            deleteRamaRow(rowRama);
        }

        function deleteRamaRow(rowRama){
            const listaUnidades = rowRama.parentElement;
            const cont = rowRama.closest('.cont_rama');
            rowRama.remove();
            setActiveRamaSelection(cont, null);
            refreshRamas();
        }

    }
}

function showRamasActions(newRow = false){
    const cont_ramas = document.querySelectorAll(".contenido_uni .cont_rama");
    if(cont_ramas.length > 0){
        initRamaFooterActions();

        cont_ramas.forEach((cont) => {
            let unidades = [];
            if(newRow){
                unidades = cont.querySelectorAll('.unidad.row.new');
            }else{
                unidades = cont.querySelectorAll('.unidad.row');
            }

            unidades.forEach((unidad)=>{
                unidad.addEventListener('click',(event)=>{
                    event.stopPropagation();
                    clearActiveRamaSelection();
                    if(!unidad.classList.contains('input_edit')){
                        setActiveRamaSelection(cont, unidad);
                    }
                })
            })
        })

        document.addEventListener("click", (event) => {
            // Si el clic no es dentro de una fila ni dentro de .acciones_unidad
            if (!event.target.closest(".unidad.row") && !event.target.closest(".acciones_rama_card")) {
                clearActiveRamaSelection(); // Cierra las acciones
                closeRamaAddForms();
            }
        });

        syncRamaNameOverflowMarquee();
    }
}

function syncRamaNameOverflowMarquee(scope = document){
    if(!scope || typeof scope.querySelectorAll !== 'function'){
        scope = document;
    }

    const ramaNames = scope.querySelectorAll(".lista_unidades .unidad.row p");
    if(ramaNames.length === 0){
        return;
    }

    requestAnimationFrame(() => {
        ramaNames.forEach((ramaName) => {
            ramaName.classList.remove('show-rama-scroll');
            ramaName.removeAttribute('data-text');

            const text = ramaName.textContent.trim();
            if(!text){
                return;
            }

            if(ramaName.scrollWidth > ramaName.clientWidth + 1){
                ramaName.classList.add('show-rama-scroll');
                ramaName.setAttribute('data-text', text);
            }
        });
    });
}

function syncConfigNameOverflowMarquees(scope = document){
    requestAnimationFrame(() => {
        syncRamaNameOverflowMarquee(scope);
        syncMontoNameOverflowMarquee(scope);
        syncCategoryNameOverflowMarquee(scope);
    });
}

function syncMontoNameOverflowMarquee(scope = document){
    if(!scope || typeof scope.querySelectorAll !== 'function'){
        scope = document;
    }

    const montoNames = scope.querySelectorAll(".nombre_monto input");
    if(montoNames.length === 0){
        return;
    }

    requestAnimationFrame(() => {
        montoNames.forEach((montoInput) => {
            const wrapper = montoInput.closest('.nombre_monto');
            const montoCard = montoInput.closest('.monto_general');
            if(!wrapper){
                return;
            }

            wrapper.classList.remove('show-name-scroll');
            wrapper.removeAttribute('data-text');
            if(montoCard){
                montoCard.classList.remove('has-name-overflow');
            }

            if(!montoInput.readOnly){
                return;
            }

            const text = montoInput.value.trim();
            if(!text){
                return;
            }

            const hasOverflow = isTextOverflowingElement(montoInput, text);
            if(hasOverflow){
                wrapper.classList.add('show-name-scroll');
                wrapper.setAttribute('data-text', text);
            }
            if(montoCard){
                montoCard.classList.toggle('has-name-overflow', hasOverflow);
            }
        });
    });
}

function syncCategoryNameOverflowMarquee(scope = document){
    if(!scope || typeof scope.querySelectorAll !== 'function'){
        scope = document;
    }

    const categoryNames = scope.querySelectorAll(".nombre_categ input");
    if(categoryNames.length === 0){
        return;
    }

    requestAnimationFrame(() => {
        categoryNames.forEach((categoryInput) => {
            const wrapper = categoryInput.closest('.nombre_categ');
            if(!wrapper){
                return;
            }

            wrapper.classList.remove('show-name-scroll');
            wrapper.removeAttribute('data-text');

            if(!categoryInput.readOnly){
                return;
            }

            const text = categoryInput.value.trim();
            if(!text){
                return;
            }

            if(isTextOverflowingElement(categoryInput, text)){
                wrapper.classList.add('show-name-scroll');
                wrapper.setAttribute('data-text', text);
            }
        });
    });
}

// El nombre de categoria ahora se ajusta a 2 lineas (ver .nombre en _panel_pagos.scss) en vez
// de truncarse en una sola linea, asi que ya no hace falta el marquee de scroll por overflow;
// esta funcion solo limpia rastros de esa marquesina si un navegador la tenia aplicada de antes.
function syncPagoCategoryNameOverflowMarquee(scope = document){
    if(!scope || typeof scope.querySelectorAll !== 'function'){
        scope = document;
    }

    const categoryNames = scope.querySelectorAll(".panel_categorias .categorias:not(.agregar):not(.new) .nombre");
    if(categoryNames.length === 0){
        return;
    }

    categoryNames.forEach((categoryName) => {
        categoryName.classList.remove('show-rama-scroll');
        categoryName.removeAttribute('data-text');
    });
}

// Paleta fija para diferenciar categorias de Pagos a simple vista (mismo icono, distinto color).
// Misma familia que los colores de rama ya usados en la app (castores, unidad, caminantes...):
// saturacion y luminosidad parejas, variando el matiz; se evita el violeta base de la tarjeta.
const CATEG_TILE_PALETTE = ['#e0692e','#3973c5','#339f41','#c99a2e','#d1477e','#2f9e93','#b8422f','#9b3fc9','#7a8f2e','#4a7fa8'];

// Iconos que se muestran de entrada al crear una categoria en Pagos (el resto, en "Ver todos")
const CATEG_QUICK_ICONS = ['tag-2','coin','tree','bus','shopping-bag','house','flash','drop','wifi','book','ticket','health','gift'];

// Color estable por categoria (hash del id): no depende del orden ni de cuantas categorias
// haya, asi que no se "reacomoda" si se borra o agrega una categoria en otro lado.
function categoryColorFor(catId){
    const str = String(catId || '');
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
    }
    return CATEG_TILE_PALETTE[hash % CATEG_TILE_PALETTE.length];
}

// Icono/color de categorias: registro compartido con PHP, embebido en header.php como JSON
// (ver getIconsaxIconsDic() en cobraTools.php) para no duplicar los paths de los icones.
let iconsaxIconsCache = null;
function getIconsaxIcons(){
    if(iconsaxIconsCache){
        return iconsaxIconsCache;
    }
    const el = document.getElementById('iconsax-icons-data');
    if(!el){
        return {};
    }
    try{
        iconsaxIconsCache = JSON.parse(el.textContent);
    }catch(e){
        iconsaxIconsCache = {};
    }
    return iconsaxIconsCache;
}

// Arma el markup <svg> (paths rellenos, blancos) de un icono de categoria por su slug
function buildIconsaxSvgMarkup(slug){
    const icons = getIconsaxIcons();
    const icon = icons[slug] || icons['tag-2'];
    if(!icon){
        return '';
    }
    const paths = icon.Paths.map((path) => {
        const opacityAttr = path.opacity ? ' fill-opacity="' + path.opacity + '"' : '';
        return '<path d="' + path.d + '" fill="#ffffff"' + opacityAttr + '></path>';
    }).join('');
    return '<svg viewBox="0 0 24 24" fill="none">' + paths + '</svg>';
}

// Sugiere un icono para una categoria nueva a partir de su nombre, comparando contra el
// Label y los Keywords (sinonimos) de cada icono. Devuelve el slug de la mejor coincidencia,
// o null si ninguna se parece lo suficiente (se usa "tag-2" como default en ese caso).
function findMatchingIcon(categoryName){
    const term = quitarAcentos(String(categoryName || '').trim().toLowerCase());
    if(!term){
        return null;
    }

    const icons = getIconsaxIcons();
    let bestSlug = null;
    let bestScore = 0;
    const termWords = term.split(/\s+/);

    Object.keys(icons).forEach((slug) => {
        if(slug === 'tag-2'){
            return;
        }
        const icon = icons[slug];
        const candidates = [icon.Label].concat(icon.Keywords || []);

        candidates.forEach((raw) => {
            const cand = quitarAcentos(String(raw || '').toLowerCase());
            if(!cand){
                return;
            }
            let score = 0;
            const candWords = cand.split(/\s+/);
            if(cand === term){
                score = 100;
            }else if(termWords.includes(cand) || candWords.includes(term)){
                score = 80;
            }else if(term.indexOf(cand) !== -1 || cand.indexOf(term) !== -1){
                score = 50;
            }
            if(score > bestScore){
                bestScore = score;
                bestSlug = slug;
            }
        });
    });

    return bestScore >= 50 ? bestSlug : null;
}

// Pinta el circulo de icono de una tarjeta de categoria con su color asignado
function applyCategoryTileColor(categoria){
    if(!categoria){
        return;
    }
    const tile = categoria.querySelector('.tile_icon');
    const catId = categoria.getAttribute('data-id');
    if(tile && catId){
        tile.style.backgroundColor = categoryColorFor(catId);
    }
}

// Marca visualmente si una categoria de Pagos ya tiene un monto cargado (punto verde en la tarjeta)
function syncCategoryValueState(categoria){
    if(!categoria){
        return;
    }
    const rawValue = parseFloat(categoria.getAttribute('data-value'));
    const tieneMonto = !isNaN(rawValue) && rawValue > 0;
    categoria.classList.toggle('with-value', tieneMonto);
}

// Actualiza el contador "X de N con monto cargado" del panel de Categorias en Pagos
function updateCategMeta(scope = document){
    const meta = scope.querySelector('.panel_categorias .categ_meta');
    if(!meta){
        return;
    }
    const categorias = scope.querySelectorAll('.panel_categorias .categorias:not(.agregar):not(.new)');
    const conMonto = scope.querySelectorAll('.panel_categorias .categorias.with-value:not(.agregar):not(.new)').length;
    meta.textContent = conMonto + ' de ' + categorias.length + ' con monto cargado';
}

// Combina el buscador y el filtro "Solo con monto" del panel de Categorias en Pagos
function applyCategoryFilters(scope = document){
    const searchInput = scope.querySelector('#search_categoria_pago');
    const soloConMontoBtn = scope.querySelector('#toggle_solo_con_monto');
    if(!searchInput && !soloConMontoBtn){
        return;
    }

    const categorias = scope.querySelectorAll('.panel_categorias .categorias:not(.agregar):not(.new)');
    const empty = scope.querySelector('.panel_categorias .categ_empty');
    const term = searchInput ? quitarAcentos(searchInput.value.trim().toLowerCase()) : '';
    const soloConMonto = soloConMontoBtn ? soloConMontoBtn.classList.contains('active') : false;
    let visibleCount = 0;

    categorias.forEach((categoria) => {
        const nombre = categoria.querySelector('.nombre');
        const texto = quitarAcentos((nombre ? nombre.textContent : '').toLowerCase());
        const coincideBusqueda = !term || texto.indexOf(term) !== -1;
        const tieneMonto = categoria.classList.contains('with-value');
        const visible = coincideBusqueda && (!soloConMonto || tieneMonto);
        categoria.classList.toggle('categ_oculta', !visible);
        if(visible){
            visibleCount += 1;
        }
    });

    if(empty){
        empty.style.display = visibleCount === 0 ? 'block' : 'none';
    }
}

function syncCobrosGeneralLegendOverflowMarquee(scope = document){
    if(!scope || typeof scope.querySelectorAll !== 'function'){
        scope = document;
    }

    const generalLegends = scope.querySelectorAll(".panel_generales .imp_gral .leyenda p");
    if(generalLegends.length === 0){
        return;
    }

    requestAnimationFrame(() => {
        generalLegends.forEach((legend) => {
            legend.classList.remove('show-rama-scroll');
            legend.removeAttribute('data-text');

            const text = legend.textContent.trim();
            if(!text){
                return;
            }

            if(isTextOverflowingElement(legend, text)){
                legend.classList.add('show-rama-scroll');
                legend.setAttribute('data-text', text);
            }
        });
    });
}

function syncCobrosEventLegendOverflowMarquee(scope = document){
    if(!scope || typeof scope.querySelectorAll !== 'function'){
        scope = document;
    }

    const eventLegends = scope.querySelectorAll(".panel_eventos .evento .leyenda p");
    if(eventLegends.length === 0){
        return;
    }

    requestAnimationFrame(() => {
        eventLegends.forEach((legend) => {
            legend.classList.remove('show-rama-scroll');
            legend.removeAttribute('data-text');

            const text = legend.textContent.trim();
            if(!text){
                return;
            }

            if(isTextOverflowingElement(legend, text)){
                legend.classList.add('show-rama-scroll');
                legend.setAttribute('data-text', text);
            }
        });
    });
}

function isTextOverflowingElement(element, text){
    if(!element || !text){
        return false;
    }

    const elementRect = element.getBoundingClientRect();
    if(element.getClientRects().length === 0 || elementRect.width <= 0){
        return false;
    }

    const styles = window.getComputedStyle(element);
    const availableWidth = element.clientWidth
        - parseFloat(styles.paddingLeft || 0)
        - parseFloat(styles.paddingRight || 0);

    if(availableWidth <= 0){
        return false;
    }

    const measure = document.createElement('span');
    measure.textContent = text;
    measure.style.position = 'absolute';
    measure.style.visibility = 'hidden';
    measure.style.whiteSpace = 'nowrap';
    measure.style.pointerEvents = 'none';
    measure.style.fontFamily = styles.fontFamily;
    measure.style.fontSize = styles.fontSize;
    measure.style.fontWeight = styles.fontWeight;
    measure.style.letterSpacing = styles.letterSpacing;
    document.body.appendChild(measure);

    const textWidth = measure.getBoundingClientRect().width;
    measure.remove();

    return textWidth > availableWidth + 1;
}

function addRamaSettingForm(){
    const cont_ramas = document.querySelectorAll(".contenido_uni .cont_rama");
    if(cont_ramas.length > 0){
        cont_ramas.forEach((cont) => {
            const footerActions = cont.querySelector('.acciones_rama_card');
            const addForm = cont.querySelector('.agregar_rama_form');
            const input = addForm.querySelector('input');

            addForm.addEventListener('click', (event) => {
                event.stopPropagation();
            });
        
            document.addEventListener('click', (event) => {
                if (!cont.contains(event.target)) {
                    footerActions.classList.remove('adding');
                    input.value = '';
                }
            });
        });
    }
}

function createMontoInTable(){
    const cont_montos = document.querySelector(".contenido_montos");
    if(cont_montos){
        enableHorizontalGrabScroll(cont_montos);
        const agregar_monto = cont_montos.querySelector(".agregar_monto");
        const montos_generales = cont_montos.querySelectorAll(".monto_general");
        let creation = false;
        syncMontoRows(cont_montos);

        montos_generales.forEach((monto) => {
            activeMontoAction(monto);
        })

        agregar_monto.addEventListener('click',() => {
            if(!creation){
                creation = true;
                newMonto = createNewMonto();
                cont_montos.insertBefore(newMonto, agregar_monto);
                syncMontoRows(cont_montos);
                const nombreMonto = newMonto.querySelector(".nombre_monto");
                const nombreInput = newMonto.querySelector(".nombre_monto input");
                const precioInput = newMonto.querySelector(".precio_monto input");
                const confirmMonto = newMonto.querySelector(".confirmar_monto");
                const anularCreacion = newMonto.querySelector(".anular_creacion");

                const syncMontoNamePlaceholder = () => {
                    nombreMonto.classList.toggle('show-placeholder-scroll', nombreInput.value.trim() === '');
                };

                syncMontoNamePlaceholder();
                nombreInput.addEventListener('input', syncMontoNamePlaceholder);

                const handleCreateMontoEnter = (event) => {
                    if(event.key === 'Enter'){
                        event.preventDefault();
                        event.stopPropagation();
                        confirmMonto.click();
                    }
                };

                nombreInput.addEventListener('keydown', handleCreateMontoEnter);
                precioInput.addEventListener('keydown', handleCreateMontoEnter);
                precioInput.addEventListener('input',() => {precioInput.value = formatCurrency(precioInput.value);})
                nombreInput.focus();

                const loader = document.querySelector('.panel_config .cont_montos .cont_loader');
                confirmMonto.addEventListener('click',() => {
                    if(nombreInput.value && precioInput.value){
                        
                        loader.classList.add('loading');
                        let raw = precioInput.value.replace('$ ', '').replace(/\./g, '').replace(',', '.');
                        let value = parseFloat(raw);
                        let price = value.toFixed(2); // Esto asegura que tenga siempre dos decimales
                        campos = {'Precio':price,'Nombre':nombreInput.value}
                        // console.log(campos);
                        fetch('/api/createGeneralMonto.php', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(campos)
                            })
                            .then(response => response.json())
                            .then(data => {
                                // console.log(data);
                                if(data['response'] == 200){
                                    successCreation(newMonto,data['intId']);
                                    showAlert('success',"Monto Creado Correctamente")
                                }else{
                                    console.error('Error en la solicitud:', data['error']);
                                    if(Object.keys(data['error']).length === 0){
                                        showAlert('error','Error al Crear Monto');
                                    }else{
                                        showAlert('error',data['error']);
                                    }
                                    //raiseMemberFields();
                                }
                                loader.classList.remove('loading');
                            })
                            .catch(error => {
                                console.error('Error en la solicitud:', error);
                                showAlert('error','Error al Crear Monto');
                                //raiseMemberFields();
                                loader.classList.remove('loading');
                            });
                    }else{
                        showAlert('error','Debes completar Nombre y Monto');
                    }
                })

                anularCreacion.addEventListener('click',() => {
                    newMonto.remove();
                    creation = false;
                    syncMontoRows(cont_montos);
                })

            }

        })

        function successCreation(monto,intId){
            const nombreInput = monto.querySelector(".nombre_monto input");
            const precioInput = monto.querySelector(".precio_monto input");
            const accionesMonto = monto.querySelector(".acciones_monto");
            const confirmMonto = monto.querySelector(".confirmar_monto");
            const anularCreacion = monto.querySelector(".anular_creacion");

            creation = false;
            monto.setAttribute('data-id', intId);

            let price = parseFloat(precioInput.value.replace('$', '').replace(/\./g, '').trim());
            let formatPrice = price.toLocaleString('es-AR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });

            precioInput.readOnly = true;
            precioInput.name = `monto_${intId}`;
            precioInput.id = `monto_${intId}`;
            precioInput.value = `$ ${formatPrice}`;;
            
            nombreInput.readOnly = true;
            nombreInput.name = `nombre_${intId}`;
            nombreInput.id = `nombre_${intId}`;
            nombreInput.removeAttribute('placeholder');
            nombreInput.parentElement.classList.remove('show-placeholder-scroll');
            delete nombreInput.parentElement.dataset.placeholder;

            confirmMonto.remove();
            anularCreacion.remove();

            const editar = document.createElement('div');
            editar.className = 'campo editar_monto';
            editar.title = 'Editar Monto';
            editar.innerHTML = '<i class="fa-solid fa-square-pen fa-xl" style="color: #0071bc;"></i>';

            const eliminar = document.createElement('div');
            eliminar.className = 'campo eliminar_monto';
            eliminar.title = 'Eliminar Monto';
            eliminar.innerHTML = '<i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i>';

            accionesMonto.appendChild(editar);
            accionesMonto.appendChild(eliminar);

            activeMontoAction(monto);
            syncMontoNameOverflowMarquee(monto);
            syncMontoRows(cont_montos);

            refreshGeneralAmounts();
        }

    }
}

function syncMontoRows(cont_montos = document.querySelector(".contenido_montos")) {
    if(!cont_montos){
        return;
    }

    const montoCount = cont_montos.querySelectorAll(".monto_general").length;
    cont_montos.classList.toggle("two-row-montos", montoCount > 10);
}

function createNewMonto() {
    const montoGeneral = document.createElement('div');
    montoGeneral.className = 'monto_general';

    const infoMonto = document.createElement('div');
    infoMonto.className = 'info_monto';

    const nombreMonto = document.createElement('div');
    nombreMonto.className = 'nombre_monto';
    nombreMonto.dataset.placeholder = 'Nombre del monto';
    nombreMonto.classList.add('show-placeholder-scroll');
    const inputNombre = document.createElement('input');
    inputNombre.type = 'text';
    inputNombre.name = `nombre_creado`;
    inputNombre.id = `nombre_creado`;
    nombreMonto.appendChild(inputNombre);

    const precioMonto = document.createElement('div');
    precioMonto.className = 'precio_monto';
    const inputPrecio = document.createElement('input');
    inputPrecio.type = 'text';
    inputPrecio.name = `monto_creado`;
    inputPrecio.id = `monto_creado`;
    inputPrecio.placeholder = '$ 0,00';
    precioMonto.appendChild(inputPrecio);

    const accionesMonto = document.createElement('div');
    accionesMonto.className = 'acciones_monto';

    const confirmar = document.createElement('div');
    confirmar.className = 'campo confirmar_monto';
    confirmar.title = 'Confirmar Monto';
    confirmar.innerHTML = '<i class="fa-solid fa-square-check fa-xl" style="color:rgb(21, 134, 59);"></i>';

    const anular = document.createElement('div');
    anular.className = 'campo anular_creacion';
    anular.title = 'Anular Creacion';
    anular.innerHTML = '<i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i>';

    accionesMonto.appendChild(confirmar);
    accionesMonto.appendChild(anular);

    infoMonto.appendChild(nombreMonto);
    infoMonto.appendChild(precioMonto);

    montoGeneral.appendChild(infoMonto);
    montoGeneral.appendChild(accionesMonto);

    return montoGeneral;
}

function activeMontoAction(monto) {

    const editar = monto.querySelector('.editar_monto');
    const eliminar = monto.querySelector('.eliminar_monto');

    if (editar) {
        editar.addEventListener('click', () => {
            editMontoGeneral(monto);
        });
    }

    if (eliminar) {
        eliminar.addEventListener('click', () => {
            deleteMontoGeneral(monto);
        });
    }
}

function editMontoGeneral(monto) {
    const nombreInput = monto.querySelector(".nombre_monto input");
    const precioInput = monto.querySelector(".precio_monto input");
    const nombreMonto = monto.querySelector(".nombre_monto");
    const editar = monto.querySelector('.editar_monto');
    const eliminar = monto.querySelector('.eliminar_monto');
    const accionesMonto = monto.querySelector(".acciones_monto");
    const isCuotaMonto = nombreInput.id === 'nombre_cuota';
    const isAffiliationMonto = nombreInput.id === 'nombre_afiliacion';
    const isFixedNameMonto = isCuotaMonto || isAffiliationMonto;
    let changeMake = false;

    const clearInputSelection = (input) => {
        if(!input){
            return;
        }

        const end = input.value.length;
        input.focus();
        input.setSelectionRange(end, end);
        input.blur();

        const selection = window.getSelection ? window.getSelection() : null;
        if(selection && typeof selection.removeAllRanges === 'function'){
            selection.removeAllRanges();
        }

        setTimeout(() => {
            try{
                input.setSelectionRange(end, end);
            }catch(error){
                return;
            }

            input.blur();

            const delayedSelection = window.getSelection ? window.getSelection() : null;
            if(delayedSelection && typeof delayedSelection.removeAllRanges === 'function'){
                delayedSelection.removeAllRanges();
            }
        }, 0);
    };

    const confirmar = document.createElement('div');
    confirmar.className = 'campo confirmar_monto';
    confirmar.title = 'Confirmar Monto';
    confirmar.innerHTML = '<i class="fa-solid fa-square-check fa-xl" style="color:rgb(21, 134, 59);"></i>';
    accionesMonto.appendChild(confirmar);

    if(!isFixedNameMonto){
        nombreInput.readOnly = false;
        if(eliminar){
            eliminar.style.display = 'none';
        }
        nombreMonto.classList.remove('show-name-scroll');
        nombreMonto.removeAttribute('data-text');
    }
    precioInput.readOnly = false;
    monto.classList.add('editing_monto');
    editar.style.display = 'none';

    const inputToFocus = !isFixedNameMonto ? nombreInput : precioInput;
    inputToFocus.focus();
    if (typeof inputToFocus.select === 'function') {
        inputToFocus.select();
    }
    setTimeout(() => {
        inputToFocus.focus();
        if (typeof inputToFocus.select === 'function') {
            inputToFocus.select();
        }
    }, 10);

    const handleEditMontoEnter = (event) => {
        if(event.key === 'Enter'){
            event.preventDefault();
            event.stopPropagation();
            submitEditMonto();
        }
    };

    [precioInput,nombreInput].forEach((input) => {
        input.addEventListener('input',() => {changeMake = true;})
        input.addEventListener('keydown', handleEditMontoEnter);
    })
    precioInput.addEventListener('input',() => {precioInput.value = formatCurrency(precioInput.value);})

    const loader = document.querySelector('.panel_config .cont_montos .cont_loader');
    confirmar.addEventListener('click', submitEditMonto);

    function submitEditMonto(){
        if(changeMake){
            if(!isFixedNameMonto){
                if(nombreInput.value && precioInput.value){
                    loader.classList.add('loading');
                    let raw = precioInput.value.replace('$ ', '').replace(/\./g, '').replace(',', '.');
                    let value = parseFloat(raw);
                    let price = value.toFixed(2); // Esto asegura que tenga siempre dos decimales
                    const intId = monto.getAttribute('data-id');

                    campos = {'Precio':price,'Nombre':nombreInput.value,'IntId':intId}
                    // console.log(campos);
                    fetch('/api/updateGeneralMonto.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(campos)
                        })
                        .then(response => response.json())
                        .then(data => {
                            // console.log(data);
                            if(data['response'] == 200){
                                successUpdate(monto,true,false);
                                showAlert('success',"Monto Actualizado Correctamente")
                            }else{
                                console.error('Error en la solicitud:', data['error']);
                                if(Object.keys(data['error']).length === 0){
                                    showAlert('error','Error al Actualizar Monto');
                                }else{
                                    showAlert('error',data['error']);
                                }
                                //raiseMemberFields();
                            }
                            loader.classList.remove('loading');
                        })
                        .catch(error => {
                            console.error('Error en la solicitud:', error);
                            showAlert('error','Error al Actualizar Monto');
                            //raiseMemberFields();
                            loader.classList.remove('loading');
                        });
                }else{
                    showAlert('error','Debes completar Nombre y Monto');
                }
            }else if(isCuotaMonto){
                if(precioInput.value){
                    loader.classList.add('loading');
                    let raw = precioInput.value.replace('$ ', '').replace(/\./g, '').replace(',', '.');
                    let value = parseFloat(raw);
                    let price = value.toFixed(2); // Esto asegura que tenga siempre dos decimales
                    campos = {'Precio':price}
                    // console.log(campos);
                    fetch('/api/updateCuotaMonto.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(campos)
                        })
                        .then(response => response.json())
                        .then(data => {
                            // console.log(data);
                            if(data['response'] == 200){
                                successUpdate(monto,true,price);
                                showAlert('success',"Monto Actualizado Correctamente")
                            }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al Actualizar Monto');
                            }else{
                                showAlert('error',data['error']);
                            }
                            //raiseMemberFields();
                            }
                            loader.classList.remove('loading');
                        })
                        .catch(error => {
                            console.error('Error en la solicitud:', error);
                            showAlert('error','Error al Actualizar Monto');
                            loader.classList.remove('loading');
                        });
                }else{
                    showAlert('error','Debes completar Monto');
                }
            }else if(isAffiliationMonto){
                if(precioInput.value){
                    loader.classList.add('loading');
                    let raw = precioInput.value.replace('$ ', '').replace(/\./g, '').replace(',', '.');
                    let value = parseFloat(raw);
                    let price = value.toFixed(2);
                    const intId = monto.getAttribute('data-id');
                    campos = {'Precio':price,'Nombre':nombreInput.value,'IntId':intId}

                    fetch('/api/updateGeneralMonto.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(campos)
                        })
                        .then(response => response.json())
                        .then(data => {
                            if(data['response'] == 200){
                                successUpdate(monto,true,false);
                                showAlert('success',"Monto Actualizado Correctamente")
                            }else{
                                console.error('Error en la solicitud:', data['error']);
                                if(Object.keys(data['error']).length === 0){
                                    showAlert('error','Error al Actualizar Monto');
                                }else{
                                    showAlert('error',data['error']);
                                }
                            }
                            loader.classList.remove('loading');
                        })
                        .catch(error => {
                            console.error('Error en la solicitud:', error);
                            showAlert('error','Error al Actualizar Monto');
                            loader.classList.remove('loading');
                        });
                }else{
                    showAlert('error','Debes completar Monto');
                }
            }
        }else{
            successUpdate(monto);
        }
    }

    function successUpdate(monto, refresh=false, cuota=null){
        const nombreInput = monto.querySelector(".nombre_monto input");
        const precioInput = monto.querySelector(".precio_monto input");
        const confirmMonto = monto.querySelector(".confirmar_monto");
        const editar = monto.querySelector('.editar_monto');
        const eliminar = monto.querySelector('.eliminar_monto');

        changeMake = false;

        let price = parseFloat(precioInput.value.replace('$', '').replace(/\./g, '').trim());
        let formatPrice = price.toLocaleString('es-AR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

        precioInput.readOnly = true;
        precioInput.value = `$ ${formatPrice}`;;
        clearInputSelection(precioInput);
        monto.classList.remove('editing_monto');
        
        if(!isFixedNameMonto){
            nombreInput.readOnly = true;
            clearInputSelection(nombreInput);
            nombreInput.removeEventListener('keydown', handleEditMontoEnter);
            if(eliminar){
                eliminar.style.display = 'flex';
            }
            syncMontoNameOverflowMarquee(monto);
        }
        precioInput.removeEventListener('keydown', handleEditMontoEnter);
        editar.style.display = 'flex';

        confirmMonto.remove();

        if (refresh){
            if(cuota){
                refreshCuotaAmount(cuota);
            }else{
                refreshGeneralAmounts();
            }
        }
    }

}

function deleteMontoGeneral(monto) {
    const intId = monto.getAttribute('data-id');
    campos = {'IntId':intId}
    // console.log(campos);
    const loader = document.querySelector('.panel_config .cont_montos .cont_loader');
    loader.classList.add('loading');
    fetch('/api/deleteGeneralMonto.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(campos)
        })
        .then(response => response.json())
        .then(data => {
            // console.log(data);
            if(data['response'] == 200){
                successDelete(monto);
                showAlert('success',"Monto Eliminado Correctamente")
            }else{
                console.error('Error en la solicitud:', data['error']);
                if(Object.keys(data['error']).length === 0){
                    showAlert('error','Error al Eliminar Monto');
                }else{
                    showAlert('error',data['error']);
                }
            }
            loader.classList.remove('loading');
        })
        .catch(error => {
        console.error('Error en la solicitud:', error);
        showAlert('error','Error al Eliminar Monto');
        loader.classList.remove('loading');
    });

    function successDelete(monto){
        monto.remove();
        syncMontoRows();
        refreshGeneralAmounts();
    }
}

function createCategoryInTable(){
    const cont_categ = document.querySelector(".contenido_categorias");
    if(cont_categ){
        enableHorizontalGrabScroll(cont_categ);
        const agregar_categ = cont_categ.querySelector(".agregar_categ");
        const categoties = cont_categ.querySelectorAll(".categ_general");
        syncCategoryRows(cont_categ);

        categoties.forEach((category) => {
            activeCategoryAction(category);
            applyCategoryTileColor(category);
        })

        dynamicCategoryIconPicker(cont_categ);

        // Alta de categoria: mismo popup que en Pagos (openCategoryComposer)
        agregar_categ.setAttribute('role','button');
        agregar_categ.setAttribute('tabindex','0');
        agregar_categ.setAttribute('aria-label','Agregar categoría');
        const abrirAlta = () => {
            openCategoryComposer({
                returnFocus: agregar_categ,
                onCreated: (intId, name, icon) => {
                    // refreshCatPagosInConfig arma la fila nueva en esta tabla (con editar/eliminar)
                    refreshCatPagosInConfig(name,intId,icon);
                    const newCateg = cont_categ.querySelector(`.categ_general[data-id="${intId}"]`);
                    if(newCateg){
                        newCateg.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
                    }
                    refreshCatPagosInPanel(name,intId,'create',icon);
                    refreshCatPagosListCaja(name,intId);
                }
            });
        };
        agregar_categ.addEventListener('click', abrirAlta);
        agregar_categ.addEventListener('keydown', (event) => {
            if(event.key === 'Enter' || event.key === ' '){
                event.preventDefault();
                abrirAlta();
            }
        });

    }
}

// Selector de icono por categoria: un popover con la grilla de iconos disponibles que se abre
// al tocar el circulo de icono de una categoria en Config, y guarda la eleccion.
function dynamicCategoryIconPicker(cont_categ){
    if(!cont_categ || cont_categ.dataset.iconPickerReady === 'true'){
        return;
    }
    cont_categ.dataset.iconPickerReady = 'true';

    let popover = null;
    let activeCateg = null;

    function closePopover(){
        if(popover){
            popover.remove();
            popover = null;
        }
        activeCateg = null;
    }

    function openPopoverFor(categ, anchor){
        closePopover();
        activeCateg = categ;

        const icons = getIconsaxIcons();
        const currentSlug = categ.getAttribute('data-icono') || 'tag-2';
        const slugs = Object.keys(icons);

        popover = document.createElement('div');
        popover.className = 'icono_categ_popover';
        popover.addEventListener('click', (event) => {
            event.stopPropagation();
        });

        const searchWrap = document.createElement('div');
        searchWrap.className = 'icono_categ_search';
        searchWrap.innerHTML = '<i class="fa-solid fa-magnifying-glass"></i>';
        const searchInput = document.createElement('input');
        searchInput.type = 'text';
        searchInput.placeholder = 'Buscar icono...';
        searchWrap.appendChild(searchInput);
        popover.appendChild(searchWrap);

        const grid = document.createElement('div');
        grid.className = 'icono_categ_grid';
        popover.appendChild(grid);

        const empty = document.createElement('div');
        empty.className = 'icono_categ_empty';
        empty.textContent = 'No hay iconos que coincidan';
        empty.style.display = 'none';
        popover.appendChild(empty);

        const options = slugs.map((slug) => {
            const option = document.createElement('button');
            option.type = 'button';
            option.className = 'icono_categ_option';
            option.classList.toggle('active', slug === currentSlug);
            option.title = icons[slug].Label;
            option.innerHTML = buildIconsaxSvgMarkup(slug);
            option.addEventListener('click', (event) => {
                event.stopPropagation();
                selectIcon(slug);
            });
            grid.appendChild(option);
            return { slug, label: quitarAcentos(icons[slug].Label.toLowerCase()), el: option };
        });

        searchInput.addEventListener('input', () => {
            const term = quitarAcentos(searchInput.value.trim().toLowerCase());
            let visibleCount = 0;
            options.forEach((opt) => {
                const visible = !term || opt.label.indexOf(term) !== -1 || opt.slug.indexOf(term) !== -1;
                opt.el.style.display = visible ? '' : 'none';
                if(visible){
                    visibleCount += 1;
                }
            });
            empty.style.display = visibleCount === 0 ? 'block' : 'none';
        });

        const rect = anchor.getBoundingClientRect();
        document.body.appendChild(popover);
        popover.style.top = (window.scrollY + rect.bottom + 8) + 'px';
        popover.style.left = (window.scrollX + rect.left) + 'px';
        // preventScroll: el popover ya quedo bien posicionado antes de este punto, pero por las
        // dudas evitamos que el foco dispare un scroll (algunos navegadores lo hacen igual si el
        // elemento no esta 100% visible todavia justo despues de moverlo).
        searchInput.focus({ preventScroll: true });
    }

    function selectIcon(slug){
        const categ = activeCateg;
        if(!categ){
            return;
        }
        const intId = categ.getAttribute('data-id');
        const tile = categ.querySelector('.tile_icon');
        const previousSlug = categ.getAttribute('data-icono') || 'tag-2';
        closePopover();

        if(!intId){
            return;
        }
        if(slug === previousSlug){
            return;
        }

        categ.setAttribute('data-icono', slug);
        if(tile){
            tile.innerHTML = buildIconsaxSvgMarkup(slug);
        }

        fetch('/api/updatePayCategory.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ IntId: intId, Icono: slug })
            })
            .then(response => response.json())
            .then(data => {
                if(data['response'] == 200){
                    syncCategoryIconInPagos(intId, slug);
                }else{
                    categ.setAttribute('data-icono', previousSlug);
                    if(tile){
                        tile.innerHTML = buildIconsaxSvgMarkup(previousSlug);
                    }
                    showAlert('error','Error al Actualizar el Icono');
                }
            })
            .catch(error => {
                console.error('Error en la solicitud:', error);
                categ.setAttribute('data-icono', previousSlug);
                if(tile){
                    tile.innerHTML = buildIconsaxSvgMarkup(previousSlug);
                }
                showAlert('error','Error al Actualizar el Icono');
            });
    }

    function syncCategoryIconInPagos(intId, slug){
        const categoria = document.querySelector('.panel_pagos .categorias[data-id="'+intId+'"]');
        if(categoria){
            const tile = categoria.querySelector('.tile_icon');
            if(tile){
                tile.innerHTML = buildIconsaxSvgMarkup(slug);
            }
        }
    }

    cont_categ.addEventListener('click', (event) => {
        const tile = event.target.closest('.tile_icon');
        if(!tile){
            return;
        }
        event.stopPropagation();
        const categ = tile.closest('.categ_general');
        if(!categ || !categ.getAttribute('data-id')){
            return;
        }
        if(activeCateg === categ){
            closePopover();
        }else{
            openPopoverFor(categ, tile);
        }
    });

    document.addEventListener('click', () => closePopover());
    document.addEventListener('keydown', (event) => {
        if(event.key === 'Escape'){
            closePopover();
        }
    });
}

function syncCategoryRows(cont_categ = document.querySelector(".contenido_categorias")) {
    if(!cont_categ){
        return;
    }

    const categoryCount = cont_categ.querySelectorAll(".categ_general").length;
    cont_categ.classList.toggle("two-row-categorias", categoryCount > 10);
}

function createNewCategory(refresh = false) {

    const category = document.createElement('div');
    category.className = 'categ_general';
    category.setAttribute('data-icono', 'tag-2');
    if(!refresh){
        category.classList.add('editing_categ')
    }

    const tileIcon = document.createElement('div');
    tileIcon.className = 'tile_icon';
    tileIcon.title = 'Cambiar ícono';
    tileIcon.innerHTML = buildIconsaxSvgMarkup('tag-2');
    category.appendChild(tileIcon);

    const infoCateg = document.createElement('div');
    infoCateg.className = 'info_categ';

    const nombreCateg = document.createElement('div');
    nombreCateg.className = 'nombre_categ';

    const inputNombre = document.createElement('input');
    inputNombre.type = 'text';
    inputNombre.name = `nombre_creado`;
    inputNombre.id = `nombre_creado`;

    nombreCateg.appendChild(inputNombre);

    const accionesCateg = document.createElement('div');
    accionesCateg.className = 'acciones_categ';

    const confirmar = document.createElement('div');
    confirmar.className = 'campo confirmar_categ';
    confirmar.title = 'Confirmar Categoria';
    confirmar.innerHTML = '<i class="fa-solid fa-square-check fa-xl" style="color:rgb(21, 134, 59);"></i>';

    const anular = document.createElement('div');
    anular.className = 'campo anular_creacion';
    anular.title = 'Anular Creacion';
    anular.innerHTML = '<i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i>';

    accionesCateg.appendChild(confirmar);
    accionesCateg.appendChild(anular);

    infoCateg.appendChild(nombreCateg);
    category.appendChild(infoCateg);
    category.appendChild(accionesCateg);

    return category;
}

function activeCategoryAction(categ) {

    const editar = categ.querySelector('.editar_categ');
    const eliminar = categ.querySelector('.eliminar_categ');

    if (editar) {
        editar.addEventListener('click', () => {
            editPayCategory(categ);
        });
    }

    if (eliminar) {
        eliminar.addEventListener('click', () => {
            deletePayCategory(categ);
        });
    }
}

function editPayCategory(categ) {
    const nombreInput = categ.querySelector(".nombre_categ input");
    const nombreCateg = categ.querySelector(".nombre_categ");
    const editar = categ.querySelector('.editar_categ');
    const eliminar = categ.querySelector('.eliminar_categ');
    const accionesMonto = categ.querySelector(".acciones_categ");
    let changeMake = false;

    const clearInputSelection = (input) => {
        if(!input){
            return;
        }

        const end = input.value.length;
        input.focus();
        input.setSelectionRange(end, end);
        input.blur();

        const selection = window.getSelection ? window.getSelection() : null;
        if(selection && typeof selection.removeAllRanges === 'function'){
            selection.removeAllRanges();
        }

        setTimeout(() => {
            try{
                input.setSelectionRange(end, end);
            }catch(error){
                return;
            }

            input.blur();

            const delayedSelection = window.getSelection ? window.getSelection() : null;
            if(delayedSelection && typeof delayedSelection.removeAllRanges === 'function'){
                delayedSelection.removeAllRanges();
            }
        }, 0);
    };

    const confirmar = document.createElement('div');
    confirmar.className = 'campo confirmar_categ';
    confirmar.title = 'Confirmar Categoria';
    confirmar.innerHTML = '<i class="fa-solid fa-square-check fa-xl" style="color:rgb(21, 134, 59);"></i>';
    accionesMonto.appendChild(confirmar);

    nombreInput.readOnly = false;
    eliminar.style.display = 'none';
    editar.style.display = 'none';
    categ.classList.add('editing_categ');
    nombreCateg.classList.remove('show-name-scroll');
    nombreCateg.removeAttribute('data-text');

    nombreInput.focus();
    if (typeof nombreInput.select === 'function') {
        nombreInput.select();
    }
    setTimeout(() => {
        nombreInput.focus();
        if (typeof nombreInput.select === 'function') {
            nombreInput.select();
        }
    }, 10);

    const handleEditCategoryEnter = (event) => {
        if(event.key === 'Enter'){
            event.preventDefault();
            event.stopPropagation();
            submitEditCategory();
        }
    };

    nombreInput.addEventListener('input',() => {changeMake = true;})
    nombreInput.addEventListener('keydown', handleEditCategoryEnter);
    nombreInput.addEventListener('change',() => {changeMake = true;})

    const loader = document.querySelector('.panel_config .cont_categorias .cont_loader');
    confirmar.addEventListener('click', submitEditCategory);

    function submitEditCategory() {
        if(changeMake){
            if(nombreInput.value){
                loader.classList.add('loading');
                const intId = categ.getAttribute('data-id');
                campos = {'Nombre':nombreInput.value,'IntId':intId}
                // console.log(campos);
                fetch('/api/updatePayCategory.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(campos)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        if(data['response'] == 200){
                            successUpdate(categ, nombreInput.value, intId);
                            showAlert('success',"Categoria Actualizada Correctamente")
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al Actualizar Categoria');
                            }else{
                                showAlert('error',data['error']);
                            }
                            //raiseMemberFields();
                        }
                        loader.classList.remove('loading');
                    })
                    .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Actualizar Categoria');
                        //raiseMemberFields();
                        loader.classList.remove('loading');
                    });
            }else{
                showAlert('error','Debes completar Nombre');
            }
        }else{
            successUpdate(categ);
        }
    }

    function successUpdate(categ,nombre=null,intId=null){
        const nombreInput = categ.querySelector(".nombre_categ input");
        const confirmCateg = categ.querySelector(".confirmar_categ");
        const editar = categ.querySelector('.editar_categ');
        const eliminar = categ.querySelector('.eliminar_categ');

        changeMake = false;
        
        nombreInput.readOnly = true;
        clearInputSelection(nombreInput);
        nombreInput.removeEventListener('keydown', handleEditCategoryEnter);
        eliminar.style.display = 'flex';
        editar.style.display = 'flex';
        categ.classList.remove('editing_categ');
        syncCategoryNameOverflowMarquee(categ);

        confirmCateg.remove();

        if(intId){
            refreshCatPagosInPanel(nombre,intId, 'update');
            refreshCatPagosListCaja(nombre,intId, 'update');
        }
    }

}

function deletePayCategory(categ) {
    const intId = categ.getAttribute('data-id');
    const loader = document.querySelector('.panel_config .cont_categorias .cont_loader');
    loader.classList.add('loading');
    campos = {'IntId':intId}
    // console.log(campos);
    fetch('/api/deletePayCategory.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(campos)
        })
        .then(response => response.json())
        .then(data => {
            // console.log(data);
            if(data['response'] == 200){
                successDelete(categ, intId);
                showAlert('success',"Categoria Eliminada Correctamente")
            }else{
                console.error('Error en la solicitud:', data['error']);
                if(Object.keys(data['error']).length === 0){
                    showAlert('error','Error al Eliminar Categoria');
                }else{
                    showAlert('error',data['error']);
                }
            }
            loader.classList.remove('loading');
        })
        .catch(error => {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al Eliminar Categoria');
            loader.classList.remove('loading');
        });

    function successDelete(categ, intId){
        categ.remove();
        syncCategoryRows();

        refreshCatPagosInPanel(categ,intId, 'delete');
        refreshCatPagosListCaja(categ,intId, 'delete');
    }
}

function createSignerInTable(){
    const cont_signer = document.querySelector(".contenido_firmas");
    if(cont_signer){
        const accionesFirmantes = cont_signer.querySelector(".acciones_firmantes");
        const agregar_signer = cont_signer.querySelector(".agregar_firma");
        const editarSigner = cont_signer.querySelector(".editar_firma");
        const eliminarSigner = cont_signer.querySelector(".acciones_firmantes > .acciones_firmantes_selected .eliminar_firma");
        const confirmarSigner = cont_signer.querySelector(".acciones_firmantes > .acciones_firmantes_editing .confirmar_signer");
        const anularCreacion = cont_signer.querySelector(".acciones_firmantes > .acciones_firmantes_editing .anular_creacion");
        const firmas = cont_signer.querySelectorAll(".firma_config");
        let creation = false;
        let editing = false;
        let selectedSigner = null;
        let currentSigner = null;
        let originalName = '';

        const syncSignerActions = () => {
            accionesFirmantes.classList.remove('has-selection','editing');

            if(editing || creation){
                accionesFirmantes.classList.add('editing');
                return;
            }

            if(selectedSigner){
                accionesFirmantes.classList.add('has-selection');
            }
        };

        const bindSignerSelection = (signer) => {
            if(signer.dataset.signerBound === 'true'){
                return;
            }

            signer.dataset.signerBound = 'true';
            signer.addEventListener('click', (event) => {
                event.stopPropagation();
                setSelectedSigner(signer);
            });
        };

        const clearSignerSelection = () => {
            cont_signer.querySelectorAll('.firma_config.selected').forEach((signer) => signer.classList.remove('selected'));
            selectedSigner = null;
            if(!editing && !creation){
                syncSignerActions();
            }
        };

        const setSelectedSigner = (signer) => {
            if(creation || editing){
                return;
            }

            if(selectedSigner === signer){
                clearSignerSelection();
                return;
            }

            cont_signer.querySelectorAll('.firma_config.selected').forEach((item) => item.classList.remove('selected'));
            signer.classList.add('selected');
            selectedSigner = signer;
            syncSignerActions();
        };

        firmas.forEach((signer) => {
            bindSignerSelection(signer);
        });

        document.addEventListener('click', (event) => {
            if(creation || editing){
                return;
            }

            if(!cont_signer.contains(event.target)){
                clearSignerSelection();
            }
        });

        agregar_signer.addEventListener('click',() => {
            if(!creation){
                creation = true;
                clearSignerSelection();
                newSigner = createNewSigner();
                cont_signer.insertBefore(newSigner, accionesFirmantes);
                const nombreInput = newSigner.querySelector(".firma_nombre input");
                currentSigner = newSigner;
                syncSignerActions();

                nombreInput.focus();
            }
        });

        editarSigner.addEventListener('click', () => {
            if(!selectedSigner || creation || editing){
                return;
            }

            const nombreNode = selectedSigner.querySelector('.firma_nombre p');
            if(!nombreNode){
                return;
            }

            originalName = nombreNode.textContent;
            editing = true;
            currentSigner = selectedSigner;

            const inputNombre = document.createElement('input');
            inputNombre.type = 'text';
            inputNombre.name = `nombre_${currentSigner.getAttribute('data-id')}`;
            inputNombre.id = `nombre_${currentSigner.getAttribute('data-id')}`;
            inputNombre.value = originalName;

            nombreNode.replaceWith(inputNombre);
            inputNombre.focus();
            inputNombre.select();
            syncSignerActions();
        });

        eliminarSigner.addEventListener('click', () => {
            if(selectedSigner && !creation && !editing){
                const signerToDelete = selectedSigner;
                deleteSigner(signerToDelete, () => {
                    if(selectedSigner === signerToDelete){
                        selectedSigner = null;
                    }
                    syncSignerActions();
                });
            }
        });

        confirmarSigner.addEventListener('click', () => {
            const loader = document.querySelector('.panel_config .cont_firmantes .cont_loader');
            const nombreInput = currentSigner ? currentSigner.querySelector(".firma_nombre input") : null;

            if(!currentSigner || !nombreInput){
                return;
            }

            if(!nombreInput.value){
                showAlert('error','Debes completar Nombre');
                return;
            }

            loader.classList.add('loading');

            if(creation){
                campos = {'Nombre':nombreInput.value}
                fetch('/api/createSignatory.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(campos)
                    })
                    .then(response => response.json())
                    .then(data => {
                        if(data['response'] == 200){
                            successCreateSigner(currentSigner,data['intId']);
                            showAlert('success',"Firmante Creado Correctamente")
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al Crear Firmante');
                            }else{
                                showAlert('error',data['error']);
                            }
                        }
                        loader.classList.remove('loading');
                    })
                    .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Crear Firmante');
                        loader.classList.remove('loading');
                    });
                return;
            }

            if(editing){
                const intId = currentSigner.getAttribute('data-id');
                campos = {'Nombre':nombreInput.value,'IntId':intId}
                fetch('/api/updateSignatory.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(campos)
                    })
                    .then(response => response.json())
                    .then(data => {
                        if(data['response'] == 200){
                            successUpdateSigner(currentSigner,nombreInput.value);
                            showAlert('success',"Firmante Actualizado Correctamente")
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al Actualizar Firmante');
                            }else{
                                showAlert('error',data['error']);
                            }
                        }
                        loader.classList.remove('loading');
                    })
                    .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Actualizar Firmante');
                        loader.classList.remove('loading');
                    });
            }
        });

        cont_signer.addEventListener('keydown', (event) => {
            if(event.key !== 'Enter'){
                return;
            }

            const nombreInput = currentSigner ? currentSigner.querySelector(".firma_nombre input") : null;
            if(!nombreInput || event.target !== nombreInput){
                return;
            }

            event.preventDefault();
            confirmarSigner.click();
        });

        anularCreacion.addEventListener('click', () => {
            if(creation && currentSigner){
                currentSigner.remove();
                currentSigner = null;
                creation = false;
                syncSignerActions();
                return;
            }

            if(editing && currentSigner){
                const nombreInput = currentSigner.querySelector('.firma_nombre input');
                const p = document.createElement('p');
                p.textContent = originalName;
                nombreInput.replaceWith(p);
                editing = false;
                currentSigner = null;
                syncSignerActions();
            }
        });

        function successCreateSigner(signer,intId){
            const nombreInput = signer.querySelector(".firma_nombre input");

            creation = false;
            currentSigner = null;
            signer.setAttribute('data-id', intId);

            const p = document.createElement('p');
            p.textContent = nombreInput.value;
            nombreInput.replaceWith(p);

            bindSignerSelection(signer);
            syncSignerActions();
            refreshSignatories();
        }

        function successUpdateSigner(signer,newName){
            const nombreInput = signer.querySelector(".firma_nombre input");
            const p = document.createElement('p');
            p.textContent = newName;
            nombreInput.replaceWith(p);

            signer.classList.remove('selected');
            editing = false;
            selectedSigner = null;
            currentSigner = null;
            originalName = '';
            syncSignerActions();
            refreshSignatories();
        }

        syncSignerActions();

    }
}

function createNewSigner() {

    const signer = document.createElement('div');
    signer.className = 'firma_config';

    const infoSigner = document.createElement('div');
    infoSigner.className = 'cont_firma';

    const nombreSigner = document.createElement('div');
    nombreSigner.className = 'firma_nombre';

    const inputNombre = document.createElement('input');
    inputNombre.type = 'text';
    inputNombre.name = `nombre_creado`;
    inputNombre.id = `nombre_creado`;

    nombreSigner.appendChild(inputNombre);

    infoSigner.appendChild(nombreSigner);

    signer.appendChild(infoSigner);

    return signer;
}

function deleteSigner(signer, onSuccess = null) {
    const loader = document.querySelector('.panel_config .cont_firmantes .cont_loader');
    loader.classList.add('loading');
    const intId = signer.getAttribute('data-id');
    campos = {'IntId':intId}
    // console.log(campos);
    fetch('/api/deleteSignatory.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(campos)
        })
        .then(response => response.json())
        .then(data => {
            // console.log(data);
            if(data['response'] == 200){
                successDelete(signer);
                showAlert('success',"Firmante Eliminado Correctamente")
            }else{
                console.error('Error en la solicitud:', data['error']);
                if(Object.keys(data['error']).length === 0){
                    showAlert('error','Error al Eliminar Firmante');
                }else{
                    showAlert('error',data['error']);
                }
            }
            loader.classList.remove('loading');
        })
        .catch(error => {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al Eliminar Firmante');
            loader.classList.remove('loading');
    });

    function successDelete(signer){
        signer.remove();
        if(typeof onSuccess === 'function'){
            onSuccess();
        }
        refreshSignatories();
    }
}

function dynamicMonthlyFee(){
    const preferencias = document.querySelector('.config_preferencias');
    if(preferencias){
        const cont_cuotas = preferencias.querySelector('.cuota_mensual .cont_cuota');
        const checkCuota = cont_cuotas.querySelector('.check_cuota .checkCuota');
        const listado_cuotas = cont_cuotas.querySelector('.listado_cuotas');
        const layout = cont_cuotas.querySelector('.not_available');
        const cuotas = listado_cuotas.querySelectorAll('.cuota input');

        checkCuota.addEventListener('change', () =>{
            saveChangeMonthlyFeeCheck(checkCuota.checked);
        })

        cuotas.forEach(cuota => {
            cuota.addEventListener('change', () =>{
                if(checkCuota.checked){
                    saveChangeMonthlyFee(cuota);
                }else{
                    openRamaAddForm(cont);
                }
            })
        })
    }
}

function saveChangeMonthlyFeeCheck(check){
    const preferencias = document.querySelector('.config_preferencias');
    const loader = preferencias.querySelector('.cont_loader');

    loader.classList.add('loading');
    fetch('/api/saveChangeMonthlyFeeCheck.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({'Check' : check})
        })
        .then(response => response.json())
        .then(data => {
            // console.log(data);
            if(data['response'] == 200){
                loader.classList.remove('loading');
                showAlert('success','Datos Guardados Correctamente');
                successSave();
            }else{
                console.error('Error en la solicitud:', data['error']);
                if(Object.keys(data['error']).length === 0){
                    loader.classList.remove('loading');
                    showAlert('error','Error al Guardar Datos');
                }else{
                    loader.classList.remove('loading');
                    showAlert('error',data['error']);
                }
            }
            loader.classList.remove('loading');
        })
        .catch(error => {
            // console.log(error);
            loader.classList.remove('loading');
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al Guardar Datos');
            loader.classList.remove('loading');
    });

    function successSave(){
        const cont_cuotas = preferencias.querySelector('.cuota_mensual .cont_cuota');
        const checkCuota = cont_cuotas.querySelector('.check_cuota .checkCuota');
        const listado_cuotas = cont_cuotas.querySelector('.listado_cuotas');
        const layout = cont_cuotas.querySelector('.layout_available');
        if(checkCuota.checked){
            listado_cuotas.classList.remove('not_available');
            layout.classList.remove('visible');
        }else{
            listado_cuotas.classList.add('not_available');
            layout.classList.add('visible');
        }
        hideMonthlyCobrosPanel(checkCuota.checked);
    }

    function hideMonthlyCobrosPanel(check){
        const panel_cobros = document.querySelector('section.panel_cobros');
        const panel_cuotas = panel_cobros.querySelector('.panel_cuotas');

        if(check){
            panel_cuotas.style.display = 'flex';
        }else{
            panel_cuotas.style.display = 'none';
        }

    }
}

function saveChangeMonthlyFee(month){
    const preferencias = document.querySelector('.config_preferencias');
    const loader = preferencias.querySelector('.cont_loader');

    const nameMonth = capitalizar(month.name.replace('check_',''));

    loader.classList.add('loading');
    fetch('/api/saveChangeMonthlyFee.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({'Month':nameMonth,'Check' : month.checked})
        })
        .then(response => response.json())
        .then(data => {
            // console.log(data);
            if(data['response'] == 200){
                loader.classList.remove('loading');
                showAlert('success','Datos Guardados Correctamente');
                successSave();
            }else{
                console.error('Error en la solicitud:', data['error']);
                if(Object.keys(data['error']).length === 0){
                    loader.classList.remove('loading');
                    showAlert('error','Error al Guardar Datos');
                }else{
                    loader.classList.remove('loading');
                    showAlert('error',data['error']);
                }
            }
            loader.classList.remove('loading');
        })
        .catch(error => {
            // console.log(error);
            loader.classList.remove('loading');
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al Guardar Datos');
            loader.classList.remove('loading');
    });

    function successSave(){
        const panelCobros = document.querySelector('section.panel_cobros');
        const info_miembro = panelCobros.querySelector(".info_miembro");
        const lista_busqueda = panelCobros.querySelector(".lista_busqueda");
        const idMiembro = info_miembro.getAttribute('data-id');
        const cuota = panelCobros.querySelector(".importes_cuotas.actual input#importe_" + nameMonth.toLowerCase());

        if(idMiembro){
            const busqueda = lista_busqueda.querySelector(`.busqueda[data-id="${idMiembro}"]`);
            if(busqueda){
                if(cuota.value != '$ 0' && !month.checked){
                    cuota.value = '';
                    cuota.dispatchEvent(new Event("input"));
                }
                busqueda.click();
            }
        }

    }
}

function getCuotasOmitidas(){
    const omitList = [];

    const preferencias = document.querySelector('.config_preferencias');
    if(preferencias){
        const cont_cuotas = preferencias.querySelector('.cuota_mensual .cont_cuota');
        const listado_cuotas = cont_cuotas.querySelector('.listado_cuotas');
        const cuotas = listado_cuotas.querySelectorAll('.cuota input');

        cuotas.forEach(cuota => {
            if(!cuota.checked){
                const nameMonth = capitalizar(cuota.name.replace('check_',''));
                omitList.push(nameMonth);
            }
        })
    }

    return omitList;
}

function activeCampRamaOptions(form='create'){

    let form_campa = '';
    if(form == 'create'){
        form_campa = document.querySelector('.form_campa_indv.create');
    }else{
        form_campa = form;
    }

    if(form_campa){
        const select_rama = form_campa.querySelector('.select_rama');
        const option_rama = select_rama.querySelectorAll('.opciones_rama');

        if(form_campa.classList.contains('create')){
            select_rama.dataset.wheelStepMultiplier = '0.26';
            select_rama.dataset.smoothWheelMode = 'direct';
            enableSmoothWheelScroll(select_rama);
        }

        option_rama.forEach((option)=>{
            option.addEventListener('click',()=>{
                if(!option.classList.contains('disable')){
                    option.classList.toggle('active');
                    if(option.classList.contains('all')){
                        if(option.classList.contains('active')){
                            option_rama.forEach((opt)=>{
                                opt.classList.add('disable');
                                opt.classList.remove('active');
                            })
                            option.classList.remove('disable');
                            option.classList.add('active');
                        }else{
                            option_rama.forEach((opt)=>{
                                opt.classList.remove('disable');
                            })
                        }
                    }
                }
            })
        })

    }
}

function activeEventRamaOptions(form='create'){
    let form_event = '';
    if(form == 'create'){
        form_event = document.querySelector('.form_evento_indv.create');
    }else{
        form_event = form;
    }

    if(form_event){
        const select_rama = form_event.querySelector('.select_rama');
        const option_rama = select_rama.querySelectorAll('.opciones_rama');

        if(form_event.classList.contains('create')){
            select_rama.dataset.wheelStepMultiplier = '0.26';
            select_rama.dataset.smoothWheelMode = 'direct';
            enableSmoothWheelScroll(select_rama);
        }

        option_rama.forEach((option)=>{
            option.addEventListener('click',()=>{
                if(!option.classList.contains('disable')){
                    option.classList.toggle('active');
                    if(option.classList.contains('all')){
                        if(option.classList.contains('active')){
                            option_rama.forEach((opt)=>{
                                opt.classList.add('disable');
                                opt.classList.remove('active');
                            })
                            option.classList.remove('disable');
                            option.classList.add('active');
                        }else{
                            option_rama.forEach((opt)=>{
                                opt.classList.remove('disable');
                            })
                        }
                    }
                }
            })
        })

    }
}

function saveUserSettings(){
    const config_panel = document.querySelector('.panel_config');
    if(config_panel){
        const loader = config_panel.querySelector('.cont_loader_config');
        const inputsInfo = config_panel.querySelectorAll('.config_info .cont_info input');
        const btn_submit = config_panel.querySelector('.config_info .cont_submit .btn_submit');
        const inputCaja = config_panel.querySelector('.config_info .cont_info input#caja');
        let oldValues = {};
        let newValues = {};
        inputCaja.value = formatCurrencyNegative(inputCaja.value,false);
        
        inputsInfo.forEach((input) => {
            oldValues[input.id] = input.value;
        })

        inputCaja.addEventListener('input',() => {
            inputCaja.value = formatCurrencyNegative(inputCaja.value);
        })
        
        btn_submit.addEventListener('click',() => {
            let changeInfo = false;
            inputsInfo.forEach((input) => {
                if(oldValues[input.id] != input.value){
                    changeInfo = true;
                }
            })

            const loader = document.querySelector('.panel_config .cont_info .cont_loader');
            if(!changeInfo){
                showAlert('error','No hay Cambio en los Datos');
            }else{
                loader.classList.add('loading');
                inputsInfo.forEach((input) => {
                    newValues[input.id] = input.value;
                })
                let rawCaja = inputCaja.value.replace('$', '').replace(/\./g, '').replace(',', '.');
                let valueCaja = parseFloat(rawCaja);
                let finalValueCaja = valueCaja.toFixed(2); // Esto asegura que tenga siempre dos decimales
                newValues['caja'] = finalValueCaja;

                // console.log(newValues);
                loader.classList.add('loading');
                fetch('/api/saveUserSettings.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(newValues)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        if(data['response'] == 200){
                            loader.classList.remove('loading');
                            showAlert('success','Datos Guardados Correctamente');
                            successSave(newValues)
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                loader.classList.remove('loading');
                                showAlert('error','Error al Guardar Datos');
                            }else{
                                loader.classList.remove('loading');
                                showAlert('error',data['error']);
                            }
                        }
                        loader.classList.remove('loading');
                    })
                    .catch(error => {
                        // console.log(error);
                        loader.classList.remove('loading');
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Guardar Datos');
                        loader.classList.remove('loading');
                });
            }
        })

        function successSave(newValues){
            const name_header = document.querySelector('.cont_header .cont_login h4')
            if(newValues['caja'] > 0){
                inputCaja.value = formatCurrencyNegative(newValues['caja'],false);
                inputCaja.readOnly = true;

                inputsInfo.forEach((input) => {
                    oldValues[input.id] = input.value;
                })

                refreshReceiptReport(); // Para que complete el 'Cierre Anterior' si hace falta
                refreshHeaderUserName(oldValues['organismo'],oldValues['nombre_organismo']); // Para que refresque el nombre del usuario en el header
            }
        }

    }
}

function saveNewPassword(){
    const config_panel = document.querySelector('.panel_config');
    if(config_panel){
        const cont_password = config_panel.querySelector('.cont_password');
        const oldPass = cont_password.querySelector('.campo.oldPass input');
        const newPass = cont_password.querySelector('.campo.newPass input');
        const btn_submit = cont_password.querySelector('.cont_submit .btn_submit');

        const loader = document.querySelector('.panel_config .cont_password .cont_loader');
        btn_submit.addEventListener('click', () => {
            if(!oldPass.value){
                showAlert('error','Debes colocar la Contraseña Actual')
            }
            else if(!newPass.value){
                showAlert('error','Debes colocar la Contraseña Nuvea')
            }
            else if(oldPass.value == newPass.value){
                showAlert('error','La contraseña Nueva no puede ser igual a la Actual')
            }
            else{
                loader.classList.add('loading');
                campos = {'NewPass':newPass.value,'OldPass':oldPass.value}
                // console.log(campos);
                fetch('/api/saveNewPassword.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(campos)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        if(data['response'] == 200){
                            successSave();
                            showAlert('success',"Contraseña Actualizada Correctamente")
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al Actualizar Contraseña');
                            }else{
                                showAlert('error',data['error']);
                            }
                        }
                        loader.classList.remove('loading');
                    })
                    .catch(error => {
                    console.error('Error en la solicitud:', error);
                    showAlert('error','Error al Actualizar Contraseña');
                    loader.classList.remove('loading');
                });
            }
        })

        function successSave(){
            newPass.value = null;
            oldPass.value = null;
        }

    }
}

function createAdminUser(){
    const form = document.querySelector('.form_admin_users');

    if(!form){return;}

    const idOrgInput = form.querySelector('#admin_idorg');

    idOrgInput.addEventListener('input', () => {
        idOrgInput.value = idOrgInput.value.replace(/\D/g, '').slice(0, 4);
    });

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const formData = new FormData(form);
        const payload = Object.fromEntries(formData.entries());

        try {
            const response = await fetch('/api/createUserByAdmin.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if(response.ok && data.response === 200){
                showAlert('success', 'Usuario creado correctamente');
                form.reset();
                return;
            }

            showAlert('error', data.error || 'No se pudo crear el usuario');
        } catch (error) {
            showAlert('error', 'Error de conexión al crear el usuario');
        }
    });
}

async function initPanelCobros(){
    const panelCobros = document.querySelector("section.panel_cobros");
    if(panelCobros){
        const members = await getMembersCobrosDicFromAPI();
    
        if(members){
            completePanelCobros(members);
            completeCobrosDetail(members);
            dynamicPanelCobros();
            toggleCobrosMemberPanels(panelCobros);
        }
    }
}

function toggleCobrosMemberPanels(panelCobros){
    if(!panelCobros){
        return;
    }

    const contenidoCobros = panelCobros.querySelector('.contenido_cobros');
    const infoMiembro = panelCobros.querySelector('.info_miembro');
    const panelLock = panelCobros.querySelector('.panel_cobros_lock');
    const firstPanel = panelCobros.querySelector('.panel_cobros');

    if(!contenidoCobros || !infoMiembro || !panelLock || !firstPanel){
        return;
    }

    if(panelCobros.memberLockResizeReady !== true){
        panelCobros.memberLockResizeReady = true;
        window.addEventListener('resize', () => toggleCobrosMemberPanels(panelCobros));
        window.addEventListener('load', () => toggleCobrosMemberPanels(panelCobros));
    }

    const hasSelectedMember = Boolean(infoMiembro.getAttribute('data-id'));
    contenidoCobros.classList.toggle('member-selected', hasSelectedMember);
    requestAnimationFrame(() => {
        panelLock.style.top = firstPanel.offsetTop + 'px';
    });
}

function togglePagosMemberLock(panelPagos){
    if(!panelPagos){
        return;
    }

    const contenidoPagos = panelPagos.querySelector('.contenido_pagos');
    const infoMiembro = panelPagos.querySelector('.info_miembro');
    const panelLock = panelPagos.querySelector('.panel_pagos_lock');
    const firstPanel = panelPagos.querySelector('.panel_pagos');

    if(!contenidoPagos || !infoMiembro || !panelLock || !firstPanel){
        return;
    }

    if(panelPagos.memberLockResizeReady !== true){
        panelPagos.memberLockResizeReady = true;
        window.addEventListener('resize', () => togglePagosMemberLock(panelPagos));
        window.addEventListener('load', () => togglePagosMemberLock(panelPagos));
    }

    const hasSelectedMember = Boolean(infoMiembro.getAttribute('data-id'));
    contenidoPagos.classList.toggle('member-required', !hasSelectedMember);
    requestAnimationFrame(() => {
        panelLock.style.top = firstPanel.offsetTop + 'px';
    });
}

// arrastrarDesdeBotones: permite empezar el arrastre sobre un botón (ej. filas de pestañas);
// el click que sigue a un arrastre igual se cancela más abajo.
function enableHorizontalGrabScroll(container, { arrastrarDesdeBotones = false } = {}){
    if(!container || container.grabScrollReady === true){
        return;
    }

    container.grabScrollReady = true;
    const noArrastrables = arrastrarDesdeBotones ? 'input, textarea, select, a, label' : 'input, textarea, select, button, a, label';

    let isPointerDown = false;
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let startScrollTop = 0;
    let dragMoved = false;
    let activePointerId = null;
    const dragThreshold = 8;

    const finishDrag = () => {
        isPointerDown = false;
        isDragging = false;
        container.classList.remove('active');
        activePointerId = null;
    };

    container.addEventListener('pointerdown', (event) => {
        if(event.button !== 0){
            return;
        }

        if(event.target.closest(noArrastrables)){
            return;
        }

        if(container.scrollWidth <= container.clientWidth){
            return;
        }

        isPointerDown = true;
        isDragging = false;
        dragMoved = false;
        activePointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        startScrollLeft = container.scrollLeft;
        startScrollTop = container.scrollTop;
    });

    container.addEventListener('pointermove', (event) => {
        if(!isPointerDown || event.pointerId !== activePointerId){
            return;
        }

        const distanceX = event.clientX - startX;
        const distanceY = event.clientY - startY;
        const canScrollX = container.scrollWidth > container.clientWidth;
        const canScrollY = container.scrollHeight > container.clientHeight;
        const movement = Math.max(Math.abs(distanceX), Math.abs(distanceY));

        if(!isDragging && movement >= dragThreshold){
            isDragging = true;
            dragMoved = true;
            container.classList.add('active');

            if(container.setPointerCapture){
                container.setPointerCapture(event.pointerId);
            }
        }

        if(isDragging){
            if(canScrollX){
                container.scrollLeft = startScrollLeft - distanceX;
            }
            if(canScrollY){
                container.scrollTop = startScrollTop - distanceY;
            }
            event.preventDefault();
        }
    });

    container.addEventListener('pointerup', finishDrag);
    container.addEventListener('pointercancel', finishDrag);
    container.addEventListener('lostpointercapture', finishDrag);

    container.addEventListener('click', (event) => {
        if(dragMoved){
            event.preventDefault();
            event.stopPropagation();
            dragMoved = false;
        }
    }, true);

    container.addEventListener('dragstart', (event) => {
        if(isDragging){
            event.preventDefault();
        }
    });
}

function enableSmoothWheelScroll(container){
    if(!container || container.smoothWheelReady === true){
        return;
    }

    container.smoothWheelReady = true;

    let targetScrollTop = container.scrollTop;
    let currentScrollTop = container.scrollTop;
    let animationFrameId = null;

    const wheelStepMultiplier = Number(container.dataset.wheelStepMultiplier) || 0.325;
    const easingFactor = Number(container.dataset.scrollEasingFactor) || 0.16;
    const useDirectWheel = container.dataset.smoothWheelMode === 'direct';

    const normalizeWheelDelta = (event) => {
        if(event.deltaMode === 1){
            return event.deltaY * 16;
        }

        if(event.deltaMode === 2){
            return event.deltaY * container.clientHeight;
        }

        return event.deltaY;
    };

    const animateScroll = () => {
        const distance = targetScrollTop - currentScrollTop;

        if(Math.abs(distance) < 0.5){
            currentScrollTop = targetScrollTop;
            container.scrollTop = targetScrollTop;
            animationFrameId = null;
            return;
        }

        currentScrollTop += distance * easingFactor;
        container.scrollTop = currentScrollTop;
        animationFrameId = requestAnimationFrame(animateScroll);
    };

    container.addEventListener('wheel', (event) => {
        if(container.scrollHeight <= container.clientHeight){
            return;
        }

        event.preventDefault();

        const delta = normalizeWheelDelta(event) * wheelStepMultiplier;
        const maxScrollTop = container.scrollHeight - container.clientHeight;

        if(useDirectWheel){
            container.scrollTop = Math.max(0, Math.min(maxScrollTop, container.scrollTop + delta));
            targetScrollTop = container.scrollTop;
            currentScrollTop = container.scrollTop;
            return;
        }

        targetScrollTop = Math.max(0, Math.min(maxScrollTop, targetScrollTop + delta));

        if(animationFrameId === null){
            currentScrollTop = container.scrollTop;
            animationFrameId = requestAnimationFrame(animateScroll);
        }
    }, { passive: false });
}

function preventInputTextSelection(container){
    if(!container){
        return;
    }

    const inputs = container.querySelectorAll('input[data-type="general"]');
    inputs.forEach((input) => {
        if(input.selectionLockReady === true){
            return;
        }

        input.selectionLockReady = true;

        input.addEventListener('select', () => {
            if(document.activeElement !== input){
                return;
            }

            const pos = input.selectionEnd ?? input.value.length;
            requestAnimationFrame(() => {
                input.setSelectionRange(pos, pos);
            });
        });

        input.addEventListener('mouseup', () => {
            if(document.activeElement !== input){
                return;
            }

            const pos = input.selectionEnd ?? input.value.length;
            requestAnimationFrame(() => {
                input.setSelectionRange(pos, pos);
            });
        });

        input.addEventListener('focus', () => {
            const pos = input.value.length;
            requestAnimationFrame(() => {
                input.setSelectionRange(pos, pos);
            });
        });

        input.addEventListener('dragstart', (event) => {
            event.preventDefault();
        });
    });
}

function dynamicPanelCobros(refreshCuotas = false){
    const panelCobros = document.querySelector("section.panel_cobros");
    if(panelCobros){
        const select_moneda = panelCobros.querySelector('.panel_preferencias select#moneda_cobro');
        const select_firmante_cobro = panelCobros.querySelector('.panel_firmante select#firmante_cobro');
        const select_metodo_cobro = panelCobros.querySelector('.panel_preferencias select#metodo_cobro');
        const importesGenerales = panelCobros.querySelector('.importes_generales');
        const importesEventos = panelCobros.querySelector('.importes_eventos');
        const listaCampasCobros = panelCobros.querySelector('.lista_campas_cobros');

        initCobrosCustomSelect(select_firmante_cobro);
        initCobrosCustomSelect(select_moneda);
        initCobrosCustomSelect(select_metodo_cobro);
        enableHorizontalGrabScroll(importesGenerales);
        enableHorizontalGrabScroll(importesEventos);
        enableHorizontalGrabScroll(listaCampasCobros);
        preventInputTextSelection(importesGenerales);
        syncCobrosGeneralLegendOverflowMarquee(importesGenerales);
        syncCobrosEventLegendOverflowMarquee(importesEventos);

        // El importe del campamento usa el signo de la moneda elegida en su selector (ej. "US$ 10").
        const getCampSigne = () => {
            const selectMonedaCampa = panelCobros.querySelector('#moneda_campa_cobro');
            return getCurrencySigne(selectMonedaCampa ? selectMonedaCampa.value : '');
        };

        const inputs = panelCobros.querySelectorAll('input[type="text"]');
        inputs.forEach(input => {
            input.addEventListener('input', () => {
                if(input.id == 'redondeo_cobros' || input.id == 'valor_total_cobros'){
                    const currSigne = getCurrencySigne(select_moneda.value);
                    input.value = formatCurrencyWithSigne(input.value,currSigne);
                }else if(input.getAttribute('data-type') == 'campa'){
                    input.value = formatCurrencyWithSigne(input.value,getCampSigne());
                }else{
                    input.value = formatCurrency(input.value);
                }
            });
            input.addEventListener('click',() => {

                if(!input.hasAttribute('readonly')){
                    const currSigne = input.getAttribute('data-type') == 'campa' ? getCampSigne() : getCurrencySigne(select_moneda.value);
                    if (input.value == '$ 0' || input.value == `${currSigne} 0`){
                        input.value = '';
                    }
                }
            })

            input.addEventListener('blur',() => {
                if (input.value == ''){
                    if(input.getAttribute('data-type') == 'campa'){
                        return;
                    }
                    if(input.id == 'redondeo_cobros' || input.id == 'valor_total_cobros'){
                        const currSigne = getCurrencySigne(select_moneda.value);
                        input.value = `${currSigne} 0`;
                    }else{
                        input.value = '$ 0';
                    }
                }
            })
        });

        dynamicCampas();
        dynamicSearchBar();

        dynamicCuotas();

        function initCobrosCustomSelect(select){
            if(!select){
                return;
            }

            const wrapper = select.closest('.selector_campa, .cont_monedas, .cont_metodos, .cont_firmante_select');
            if(!wrapper){
                return;
            }

            // La marca es una propiedad JS (no un data-*) porque cloneNode copia los atributos
            // pero no los listeners: si el panel fue clonado, el div no la tiene y se reconstruye.
            const existingCustomSelect = wrapper.querySelector('.custom_select_cobros');
            if(select.dataset.customSelectReady === 'true' && existingCustomSelect && existingCustomSelect._cobrosBound === true){
                syncCobrosCustomSelect(select);
                return;
            }

            if(existingCustomSelect){
                existingCustomSelect.remove();
            }

            select.dataset.customSelectReady = 'true';
            wrapper.classList.add('custom_select_ready');

            const customSelect = document.createElement('div');
            customSelect.className = 'custom_select_cobros';
            customSelect._cobrosBound = true;
            customSelect.innerHTML = `
                <button type="button" class="custom_select_cobros_btn"></button>
                <div class="custom_select_cobros_list"></div>
            `;
            wrapper.appendChild(customSelect);

            const button = customSelect.querySelector('.custom_select_cobros_btn');
            button.addEventListener('click',(event)=>{
                event.stopPropagation();
                closeOtherCobrosCustomSelects(customSelect);
                customSelect.classList.toggle('open');
                updateCobrosCustomSelectLayer(customSelect);
            })

            select.addEventListener('change',()=>{
                syncCobrosCustomSelect(select);
            })

            syncCobrosCustomSelect(select);
        }

        function syncCobrosCustomSelect(select){
            if(!select || select.dataset.customSelectReady !== 'true'){
                return;
            }
            const wrapper = select.closest('.selector_campa, .cont_monedas, .cont_metodos, .cont_firmante_select');
            const customSelect = wrapper ? wrapper.querySelector('.custom_select_cobros') : null;
            if(!customSelect){
                return;
            }

            const button = customSelect.querySelector('.custom_select_cobros_btn');
            const list = customSelect.querySelector('.custom_select_cobros_list');
            const selected = select.options[select.selectedIndex];
            button.textContent = selected ? selected.textContent : '-';
            list.innerHTML = '';

            Array.from(select.options).forEach((option)=>{
                const item = document.createElement('button');
                item.type = 'button';
                item.className = 'custom_select_cobros_option';
                item.classList.toggle('active', option.value === select.value);
                item.dataset.value = option.value;
                item.textContent = option.textContent;
                item.addEventListener('click',(event)=>{
                    event.stopPropagation();
                    select.value = option.value;
                    closeCobrosCustomSelect(customSelect);
                    select.dispatchEvent(new Event('change'));
                })
                list.appendChild(item);
            })
        }

        function updateCobrosCustomSelectLayer(customSelect){
            if(!customSelect){
                return;
            }

            const wrapper = customSelect.closest('.selector_campa, .cont_monedas, .cont_metodos, .cont_firmante_select');
            const panel = customSelect.closest('.panel_cobros');
            const campaAmount = customSelect.closest('.importe_campas');
            const campaScroll = customSelect.closest('.importe_campas_scroll');
            const isOpen = customSelect.classList.contains('open');

            if(wrapper){
                wrapper.classList.toggle('custom_select_open', isOpen);
            }

            if(campaAmount){
                campaAmount.classList.toggle('custom_select_open', !!campaAmount.querySelector('.custom_select_cobros.open'));
            }

            if(campaScroll){
                campaScroll.classList.toggle('custom_select_open', !!campaScroll.querySelector('.custom_select_cobros.open'));
            }

            if(panel){
                panel.classList.toggle('custom_select_panel_open', !!panel.querySelector('.custom_select_cobros.open'));
            }
        }

        function closeCobrosCustomSelect(customSelect){
            if(!customSelect){
                return;
            }

            customSelect.classList.remove('open');
            updateCobrosCustomSelectLayer(customSelect);
        }

        function closeOtherCobrosCustomSelects(currentSelect){
            panelCobros.querySelectorAll('.custom_select_cobros.open').forEach((customSelect)=>{
                if(customSelect !== currentSelect){
                    closeCobrosCustomSelect(customSelect);
                }
            })
        }

        if(panelCobros.dataset.customSelectCloseReady !== 'true'){
            panelCobros.dataset.customSelectCloseReady = 'true';
            document.addEventListener('click',()=>{
                panelCobros.querySelectorAll('.custom_select_cobros.open').forEach((customSelect)=>{
                    closeCobrosCustomSelect(customSelect);
                })
            })
        }

        function dynamicCampas(){
            
            const lista_campas = panelCobros.querySelector('.lista_campas_cobros');
            const importe_campas = panelCobros.querySelector('.importe_campas');
            const pagado = importe_campas.querySelector('.valor_pagado .valor');
            const valorTot = importe_campas.querySelector('.valor_total .valor');
            const inputCampa = importe_campas.querySelector('input');
            const selectMonedaCampa = importe_campas.querySelector('#moneda_campa_cobro');
            const selectTipoValorCampa = importe_campas.querySelector('#tipo_valor_campa_cobro');
            const selectMonedaPagadoCampa = importe_campas.querySelector('#moneda_pagado_campa');
            const campas = lista_campas.querySelectorAll('.campa');

            if(selectMonedaCampa && select_moneda){
                selectMonedaCampa.value = selectMonedaCampa.options[0] ? selectMonedaCampa.options[0].value : '';
            }
            if(selectMonedaPagadoCampa && selectMonedaCampa){
                selectMonedaPagadoCampa.value = selectMonedaCampa.value;
            }else if(selectMonedaPagadoCampa && select_moneda){
                selectMonedaPagadoCampa.value = select_moneda.value || (selectMonedaPagadoCampa.options[0] ? selectMonedaPagadoCampa.options[0].value : '');
            }
            initCobrosCustomSelect(selectMonedaCampa);
            initCobrosCustomSelect(selectTipoValorCampa);
            initCobrosCustomSelect(selectMonedaPagadoCampa);
            refreshCampCurrencyOptions(lista_campas.querySelector('.campa.selected'));
            syncCampPaidCurrencyWithPayment();
            renderCampPaidCurrencyOptions(null);
            setCampAmountLocked(!lista_campas.querySelector('.campa.selected'));

            campas.forEach((campa)=>{
                campa.addEventListener('click',()=>{
                    if(campa.hidden){ return; }
                    campas.forEach((cmp)=>{cmp.classList.remove('selected')})
                    const nombreCampa = campa.querySelector('.leyenda p').innerHTML;
                    const storedInput = campa.getAttribute('data-input');
                    const storedTipo = campa.getAttribute('data-tipo-input');
                    campa.classList.add('selected');
                    setCampAmountLocked(false);
                    inputCampa.id = 'importe_campa_' + campa.getAttribute('data-id');
                    inputCampa.name = nombreCampa;
                    inputCampa.value = '';
                    renderCampValueTypes(campa,nombreCampa,storedTipo);
                    syncCampPaidCurrencyWithPayment();
                    updateCampPaidDisplay(campa);
                    if(storedInput != '0' && storedInput != ''){
                        inputCampa.value = storedInput;
                        campa.setAttribute('data-input',storedInput);
                        inputCampa.dispatchEvent(new Event('input'));
                    }else if(!selectTipoValorCampa || selectTipoValorCampa.value == ''){
                        inputCampa.value = '$ 0';
                    }
                })
            })

            if(selectMonedaCampa){
                selectMonedaCampa.addEventListener('change',()=>{
                    const campaSelect = lista_campas.querySelector('.campa.selected');
                    if(campaSelect){
                        const nombreCampa = campaSelect.querySelector('.leyenda p').innerHTML;
                        const storedTipo = campaSelect.getAttribute('data-tipo-input');
                        campaSelect.dataset.currencyInput = selectMonedaCampa.value;
                        inputCampa.value = '';
                        campaSelect.setAttribute('data-input','');
                        inputCampa.dispatchEvent(new Event('input'));
                        renderCampValueTypes(campaSelect,nombreCampa,storedTipo);
                        syncCampPaidCurrencyWithPayment();
                        updateCampPaidDisplay(campaSelect);
                    }
                })
            }

            if(selectMonedaPagadoCampa){
                selectMonedaPagadoCampa.addEventListener('change',()=>{
                    const campaSelect = lista_campas.querySelector('.campa.selected');
                    syncCampPaymentCurrencyWithPaid();
                    updateCampPaidDisplay(campaSelect);
                })
            }

            if(selectTipoValorCampa){
                selectTipoValorCampa.addEventListener('change',()=>{
                    const campaSelect = lista_campas.querySelector('.campa.selected');
                    if(campaSelect){
                        const nombreCampa = campaSelect.querySelector('.leyenda p').innerHTML;
                        inputCampa.value = '';
                        campaSelect.setAttribute('data-input','');
                        inputCampa.dispatchEvent(new Event('input'));
                        applySelectedCampValue(campaSelect,nombreCampa);
                    }
                })
            }

            inputCampa.addEventListener('change',()=>{
                const campaSelect = lista_campas.querySelector('.campa.selected');
                if(campaSelect){
                    campaSelect.setAttribute('data-input',inputCampa.value);
                }
            })

            function syncCampPaidCurrencyWithPayment(){
                if(!selectMonedaPagadoCampa){
                    return;
                }

                const paymentCurrency = selectMonedaCampa ? selectMonedaCampa.value : (select_moneda ? select_moneda.value : '');
                selectMonedaPagadoCampa.value = paymentCurrency;
                syncCobrosCustomSelect(selectMonedaPagadoCampa);
            }

            function syncCampPaymentCurrencyWithPaid(){
                if(!selectMonedaPagadoCampa || !selectMonedaCampa){
                    return;
                }

                const paidCurrency = selectMonedaPagadoCampa.value;
                if(selectMonedaCampa.value === paidCurrency){
                    syncCobrosCustomSelect(selectMonedaCampa);
                    return;
                }

                selectMonedaCampa.value = paidCurrency;
                syncCobrosCustomSelect(selectMonedaCampa);
                selectMonedaCampa.dispatchEvent(new Event('change'));
            }

            function setCampAmountLocked(isLocked){
                if(!importe_campas){
                    return;
                }

                importe_campas.classList.toggle('locked', isLocked);
                if(isLocked){
                    closeOtherCobrosCustomSelects(null);
                    if(valorTot){
                        valorTot.innerHTML = '-';
                    }
                    if(pagado){
                        pagado.innerHTML = '-';
                    }
                    if(inputCampa){
                        inputCampa.value = '';
                    }
                }
            }

            function renderCampValueTypes(campa,nombreCampa,preferredTipo = ''){
                refreshCampCurrencyOptions(campa);
                const values = getCampValuesForCurrentCurrency(campa);
                if(!selectTipoValorCampa){
                    return;
                }
                selectTipoValorCampa.innerHTML = '';
                if(!selectMonedaCampa.value){
                    selectTipoValorCampa.innerHTML = '<option value="">-</option>';
                    valorTot.textContent = '-';
                    campa.setAttribute('data-tipo-input', '');
                    syncCobrosCustomSelect(selectTipoValorCampa);
                    return;
                }

                if(values.length === 0){
                    const legacyValue = campa.getAttribute('data-price') || '0';
                    const option = createCampValueOption({'Tipo':'x1','Valor':legacyValue});
                    selectTipoValorCampa.appendChild(option);
                    selectTipoValorCampa.value = 'x1';
                    syncCobrosCustomSelect(selectTipoValorCampa);
                    applySelectedCampValue(campa,nombreCampa);
                    return;
                }

                values.forEach((value)=>{
                    selectTipoValorCampa.appendChild(createCampValueOption(value));
                })

                const hasPreferredTipo = Array.from(selectTipoValorCampa.options).some((option)=>option.value === preferredTipo);
                selectTipoValorCampa.value = hasPreferredTipo ? preferredTipo : selectTipoValorCampa.options[0].value;
                syncCobrosCustomSelect(selectTipoValorCampa);
                applySelectedCampValue(campa,nombreCampa);
            }

            function createCampValueOption(value){
                const option = document.createElement('option');
                option.value = value.Tipo;
                option.dataset.value = value.Valor;
                option.textContent = value.Tipo;

                return option;
            }

            function refreshCampCurrencyOptions(campa){
                const userOptions = Array.from(select_moneda.options).filter(option => option.value);
                const codes = getCampCurrencyCodes(campa, userOptions.map(option => option.value));
                const preferred = (campa && campa.dataset.currencyInput) || selectMonedaCampa.value;
                const selectedCode = codes.includes(preferred) ? preferred : (codes[0] || '');
                [selectMonedaCampa, selectMonedaPagadoCampa].forEach(select => {
                    if(!select){ return; }
                    select.innerHTML = '';
                    userOptions.filter(option => codes.includes(option.value)).forEach(option => {
                        select.appendChild(option.cloneNode(true));
                    });
                    select.value = selectedCode;
                    syncCobrosCustomSelect(select);
                });
            }

            function applySelectedCampValue(campa,nombreCampa){
                if(!selectTipoValorCampa || selectTipoValorCampa.selectedIndex < 0){
                    return;
                }

                const selectedOption = selectTipoValorCampa.options[selectTipoValorCampa.selectedIndex];
                const tipo = selectedOption.value;
                const value = selectedOption.dataset.value || '0';
                const signo = getCurrencySigne(selectMonedaCampa ? selectMonedaCampa.value : '');
                valorTot.innerHTML = formatCurrencyWithSigne(String(value),signo,false);
                inputCampa.name = nombreCampa + ' ' + tipo;
                campa.setAttribute('data-tipo-input',tipo);
            }

            function getCampValuesForCurrentCurrency(campa){
                let valuesByCurrency = {};
                try{
                    valuesByCurrency = JSON.parse(campa.dataset.valoresMoneda || '{}');
                }catch(error){
                    valuesByCurrency = {};
                }

                const currency = selectMonedaCampa ? selectMonedaCampa.value : (select_moneda ? select_moneda.value : '');
                if(valuesByCurrency[currency] && valuesByCurrency[currency]['Valores']){
                    return valuesByCurrency[currency]['Valores'];
                }

                return [];
            }

            function updateCampPaidDisplay(campa){
                renderCampPaidCurrencyOptions(campa);
                if(!campa){
                    if(pagado){
                        pagado.innerHTML = '-';
                    }
                    return;
                }

                const currency = selectMonedaPagadoCampa ? selectMonedaPagadoCampa.value : (selectMonedaCampa ? selectMonedaCampa.value : '');
                if(pagado){
                    pagado.innerHTML = currency ? getFormattedCampPaidForCurrency(campa,currency) : '-';
                }
            }

            function renderCampPaidCurrencyOptions(campa){
                if(!selectMonedaPagadoCampa){
                    return;
                }

                Array.from(selectMonedaPagadoCampa.options).forEach((option)=>{
                    if(!option.value){ return; }
                    if(!option.dataset.label){
                        option.dataset.label = option.textContent;
                    }
                    option.title = option.dataset.label;
                    option.textContent = campa ? getFormattedCampPaidForCurrency(campa,option.value) : formatCurrencyWithSigne('0',getCurrencySigne(option.value),false);
                })

                syncCobrosCustomSelect(selectMonedaPagadoCampa);
            }

            function getFormattedCampPaidForCurrency(campa,currency){
                const paidValue = getCampPaidForCurrency(campa,currency);
                const signe = currency ? getCurrencySigne(currency) : '$';
                return formatCurrencyWithSigne(String(Number(paidValue).toFixed(2)),signe,false);
            }

            function getCampPaidForCurrency(campa,currency){
                if(!campa){
                    return 0;
                }

                let paidByCurrency = {};
                try{
                    paidByCurrency = JSON.parse(campa.dataset.paidByCurrency || '{}');
                }catch(error){
                    paidByCurrency = {};
                }

                if(currency && paidByCurrency[currency]){
                    return parseFloat(paidByCurrency[currency]['Pagado']) || 0;
                }

                return 0;
            }
        }

        function dynamicSearchBar(){
            const buscador_miembro = panelCobros.querySelector('.buscador_miembro');
            const buscador         = buscador_miembro.querySelector('.buscador');
            const searchInput      = buscador_miembro.querySelector('input#search_cobro');
            const listaBusquedas   = buscador_miembro.querySelector('.lista_busqueda');
            const busquedas        = listaBusquedas.querySelectorAll('.busqueda');
            let busquedaActivaIndex = -1;

            if(searchInput.searchEventsBound === true){
                return;
            }
            searchInput.searchEventsBound = true;

            // 1) Filtrar y ordenar al escribir
            searchInput.addEventListener('input', manejarBusquedaInput);
            searchInput.addEventListener('keydown', manejarBusquedaTeclado);

            // 2) Al hacer click sobre el input, abrir siempre el desplegable
            searchInput.addEventListener('click', (e) => {
                buscador.classList.add('mostrar');
                actualizarBusquedaActiva(0);
            });

            // 3) Evitamos que clicks dentro del componente suban al document
            buscador.addEventListener('click', (e) => {
                e.stopPropagation();
            });

            // 4) Cerrar SIEMPRE al click en cualquier otra parte
            document.addEventListener('click', () => {
                resetBusquedaMiembros(false);
            });

            function manejarBusquedaInput(event) {
                const valor = quitarAcentos(event.target.value.toLowerCase());
                buscador.classList.add('mostrar');

                busquedas.forEach(row => {
                    const texto = quitarAcentos(row.querySelector('p').textContent.toLowerCase());
                    row.classList.toggle('ocultar', texto.indexOf(valor) < 0);
                });

                const visibles = Array.from(busquedas)
                    .filter(row => !row.classList.contains('ocultar'))
                    .sort((a, b) => {
                        const ta = a.querySelector('p').textContent.trim();
                        const tb = b.querySelector('p').textContent.trim();
                        return ta.localeCompare(tb, 'es', { sensitivity: 'base' });
                    });

                visibles.forEach(row => listaBusquedas.appendChild(row));
                actualizarBusquedaActiva(visibles.length ? 0 : -1);
            }

            function manejarBusquedaTeclado(event) {
                const teclasNavegacion = ['ArrowDown', 'ArrowUp', 'Enter', 'Escape'];
                if(!teclasNavegacion.includes(event.key)){
                    return;
                }

                if(event.key === 'Escape'){
                    event.preventDefault();
                    resetBusquedaMiembros(false);
                    searchInput.blur();
                    return;
                }

                const visibles = obtenerBusquedasVisibles();
                if(!visibles.length){
                    return;
                }

                if(event.key === 'ArrowDown'){
                    event.preventDefault();
                    buscador.classList.add('mostrar');
                    actualizarBusquedaActiva(busquedaActivaIndex + 1);
                    return;
                }

                if(event.key === 'ArrowUp'){
                    event.preventDefault();
                    buscador.classList.add('mostrar');
                    actualizarBusquedaActiva(busquedaActivaIndex - 1);
                    return;
                }

                if(event.key === 'Enter'){
                    event.preventDefault();
                    const index = busquedaActivaIndex >= 0 ? busquedaActivaIndex : 0;
                    visibles[index].click();
                }
            }

            function obtenerBusquedasVisibles() {
                return Array.from(listaBusquedas.querySelectorAll('.busqueda:not(.ocultar)'));
            }

            function actualizarBusquedaActiva(index) {
                const visibles = obtenerBusquedasVisibles();
                limpiarBusquedaActiva();

                if(!visibles.length || index < 0){
                    busquedaActivaIndex = -1;
                    return;
                }

                busquedaActivaIndex = (index + visibles.length) % visibles.length;
                const activa = visibles[busquedaActivaIndex];
                activa.classList.add('activa');
                activa.scrollIntoView({ block: 'nearest' });
            }

            function limpiarBusquedaActiva() {
                busquedas.forEach(row => row.classList.remove('activa'));
                busquedaActivaIndex = -1;
            }

            function resetBusquedaMiembros(clearInput = true) {
                buscador.classList.remove('mostrar');
                if(clearInput){
                    searchInput.value = '';
                }
                busquedas.forEach(row => {
                    row.classList.remove('ocultar', 'activa');
                    listaBusquedas.appendChild(row);
                });
                busquedaActivaIndex = -1;
            }
        }

        function dynamicCuotas(){
            const cuotasActuales = panelCobros.querySelectorAll('.cuota.actual input');
            cuotasActuales.forEach((cuota) =>{
                if(cuota.partialEditReady === true){
                    return;
                }
                cuota.partialEditReady = true;

                cuota.addEventListener('dblclick', () => activarEdicion(cuota));
                
                if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
                    let lastTapTime = 0;
                
                    cuota.addEventListener('touchstart', function (e) {
                        const currentTime = new Date().getTime();
                        const tapLength = currentTime - lastTapTime;
                
                        if (tapLength < 300 && tapLength > 0) {
                            //e.preventDefault(); // evita zoom o eventos raros
                            //cuota.click();
                            //cuota.focus();
                            activarEdicion(cuota);
                        }
                
                        lastTapTime = currentTime;
                    });
                }
                
                // cuota.addEventListener('dblclick',()=>{
                //     cuota.readOnly = false;
                //     cuota.classList.add('mod_parcial');
                //     cuota.classList.remove('parcial');

                //     cuota.setAttribute('data-oldvalue',cuota.value);
                //     cuota.value = null;
                //     cuota.ontouchstart();
                //     cuota.focus();
                // })
                cuota.addEventListener('blur',()=>{

                    if(cuota.classList.contains('mod_parcial')){
                        if(cuota.value == '$ 0'){
                            cuota.classList.remove('mod_parcial');
                            cuota.classList.add('parcial');
                            cuota.readOnly = true;
    
                            cuota.value = cuota.getAttribute('data-oldvalue');
                        }
                    }

                })
            })

            function activarEdicion(cuota) {
                // Capturá el valor justo antes de editar
                if(cuota.classList.contains('parcial')){
                    cuotasActuales.forEach((cuota) =>{cuota.blur()});
                    const currentValue = cuota.value;
                    setTimeout(() => {
                        cuota.readOnly = false;
                        cuota.classList.add('mod_parcial');
                        cuota.classList.remove('parcial');
                        
                        cuota.setAttribute('data-oldvalue', currentValue);
                        cuota.value = '';
                        cuota.focus();
                        cuota.click();
                        setTimeout(() => cuota.focus(), 10); // iOS fix
                    }, 10);
                }
            }
            
        }
        
    }
}

function getMemberBranchUnitCode(codRama){
    const parts = String(codRama || '').split('-');
    return String(parts[parts.length - 1] || '').trim().toUpperCase();
}

function isCampAvailableForBranch(rawCampBranches, memberCodRama){
    const memberBranch = getMemberBranchUnitCode(memberCodRama);
    const campBranches = String(rawCampBranches || 'ALL')
        .split(',')
        .map(branch => branch.trim().toUpperCase())
        .filter(Boolean);

    return campBranches.includes('ALL') || (!!memberBranch && campBranches.includes(memberBranch));
}

function filterCobroActivitiesByMemberBranch(list, memberCodRama){
    if(!list){
        return;
    }

    list.querySelectorAll('.campa, .evento').forEach(activity => {
        const available = isCampAvailableForBranch(activity.dataset.ramas, memberCodRama);
        activity.hidden = !available;
        activity.style.display = available ? '' : 'none';
        if(!available){
            activity.classList.remove('selected');
        }
    });
}

function completePanelCobros(jsonCobros){
    const panelCobros = document.querySelector("section.panel_cobros");
    if(panelCobros){
        // const dicCobros =   Object.values(jsonCobros);
        const info_miembro =   panelCobros.querySelector('.info_miembro');
        const nombre_miembro =   info_miembro.querySelector('.nombre_miembro p');
        if(info_miembro.getAttribute('data-id')){
            const cobros = jsonCobros[info_miembro.getAttribute('data-id')];
            nombre_miembro.innerHTML = cobros['Nombre'];

            const rama_miembro =   info_miembro.querySelector('.rama_miembro');
            const rama_nombre =   rama_miembro.querySelector('p');
            const ramaClass = cobros['CodRama'].split('-')[1].replace(/[0-9-]/g, '').toLowerCase();

            const info_deudas =   panelCobros.querySelector('.info_deudas .info_importes');
            const deudaTotal =   info_deudas.querySelector('.importe_deuda .importe_total p');
            const deudaPagada =   info_deudas.querySelector('.importe_deuda .importe_parcial p');
            const deudaRestante =   info_deudas.querySelector('.importe_deuda .importe_actual p');
            const inputDeuda =   panelCobros.querySelector('.importe_saldar #importe_deuda');

            const info_general =   panelCobros.querySelector('.info_general .importes_generales');
            const generales = info_general.querySelectorAll('.imp_gral');

            const info_cuotas =   panelCobros.querySelector('.info_cuotas .importes_cuotas.actual');
            const cuotas =   info_cuotas.querySelectorAll('.cuota.actual');

            const info_cuotas_prev =   panelCobros.querySelector('.info_cuotas .importes_cuotas.previo');
            const cuotas_prev =   info_cuotas_prev.querySelectorAll('.cuota.previa');

            const info_eventos =   panelCobros.querySelector('.info_eventos .importes_eventos');
            const eventos =   info_eventos.querySelectorAll('.evento');

            const info_campas =   panelCobros.querySelector('.info_campas .lista_campas_cobros');
            const campas =   info_campas.querySelectorAll('.campa');

            filterCobroActivitiesByMemberBranch(info_campas, cobros['CodRama']);
            filterCobroActivitiesByMemberBranch(info_eventos, cobros['CodRama']);
            if(!info_campas.querySelector('.campa.selected')){
                const amounts = panelCobros.querySelector('.importe_campas');
                amounts.classList.add('locked');
                amounts.querySelectorAll('.valor_total .valor, .valor_pagado .valor').forEach(value => { value.textContent = '-'; });
                const input = amounts.querySelector('input');
                input.value = '';
                input.id = 'importe_campa';
                input.name = '';
            }
            
            rama_nombre.innerHTML = cobros['NombreRama'];
            rama_miembro.classList = ['rama_miembro ' + ramaClass];
            
            deudaTotal.innerHTML = formatCurrency(cobros['DeudaTotal'],false);
            deudaPagada.innerHTML = formatCurrency(cobros['Deuda'],false);
            deudaRestante.innerHTML = formatCurrency(String(cobros['DeudaTotal'] - cobros['Deuda']), false);
            inputDeuda.value = formatCurrency(inputDeuda.value, false);
            
            generales.forEach((general)=>{
                let textGeneral = general.querySelector('.valor_general p');
                let idGeneral = general.getAttribute('data-id');
                let pagadoGeneral = 0;
                if(cobros['General'] && cobros['General'][idGeneral]){
                    pagadoGeneral = cobros['General'][idGeneral]['Pagado'];
                }
                textGeneral.innerHTML = formatCurrency(pagadoGeneral,false);

            })
        
            omitCuotas = getCuotasOmitidas();
            cuotas.forEach((cuota)=>{
                let inputCuota =   cuota.querySelector('input');
                let valorCuota = cobros[capitalizar(cuota.id)];
                let checkPagada = cobros['Pago'+capitalizar(cuota.id)];
                const oldParcial = inputCuota.classList.contains('parcial')
                inputCuota.classList = [];
                if(checkPagada == 1 || omitCuotas.includes(capitalizar(cuota.id))){
                    inputCuota.classList.add('pagada');
                    if (valorCuota == 0){
                        inputCuota.value = '-';
                    }else{
                        inputCuota.value = '$ ' + valorCuota;
                        inputCuota.value = formatCurrency(inputCuota.value, false);
                    }
                    inputCuota.readOnly = true;
                }else{
                    if (valorCuota == 0){
                        inputCuota.classList.add('pendiente');
                        inputCuota.readOnly = false;
                    }else{
                        if(inputCuota.value  == '$ 0' || oldParcial){
                            inputCuota.value = '$ ' + valorCuota;
                            inputCuota.classList.add('parcial');
                            inputCuota.readOnly = true;
                        }else{
                            inputCuota.classList.add('mod_parcial');
                            inputCuota.readOnly = false;
                            inputCuota.setAttribute('data-oldvalue', '$ ' + valorCuota);
                        }
                    }
                    inputCuota.value = formatCurrency(inputCuota.value, false);
                }

            })
        
            cuotas_prev.forEach((cuota)=>{
                let inputCuota =   cuota.querySelector('input');
                let cuotaName = capitalizar(cuota.id.replace('_previo',''))
                let valorCuota = cobros['PrevCuotas'][cuotaName];
                let checkPagada = cobros['PrevCuotas']['Pago'+capitalizar(cuota.id)];
                inputCuota.classList = [];
                inputCuota.value = '$ 0'; // evita arrastrar el valor previo al cambiar de miembro

                if (Object.hasOwn(cobros['PrevCuotas'], cuotaName)) {
                    if(checkPagada == 1){
                        inputCuota.classList.add('pagada');
                        if (valorCuota == 0){
                            inputCuota.value = '-';
                        }else{
                            inputCuota.value = '$ ' + valorCuota;
                        }
                    }else{
                        if (valorCuota == 0){
                            inputCuota.classList.add('pendiente');
                        }else{
                            inputCuota.value = '$ ' + valorCuota;
                            inputCuota.classList.add('parcial');
                        }
                    }
                }else{
                    inputCuota.classList.add('pendiente');
                }

                inputCuota.value = formatCurrency(inputCuota.value, false);

            })

            campas.forEach((campa)=>{
                let idCampa = campa.getAttribute('data-id');
                let pagadoCampa = 0;
                if(cobros['Campamentos'] && cobros['Campamentos'][idCampa]){
                    pagadoCampa = cobros['Campamentos'][idCampa]['Pagado'];
                    campa.dataset.paidByCurrency = JSON.stringify(cobros['Campamentos'][idCampa]['PagadoPorMoneda'] || {});
                }else{
                    campa.dataset.paidByCurrency = '{}';
                }

                campa.setAttribute('data-paid',pagadoCampa);
            })

            eventos.forEach((evento)=>{
                let textEvento = evento.querySelector('.pagado p');
                let idEvento = evento.getAttribute('data-id');
                let pagadoEvento = 0;
                if(cobros['Eventos'] && cobros['Eventos'][idEvento]){
                    pagadoEvento = cobros['Eventos'][idEvento]['Pagado'];
                }
                textEvento.innerHTML = formatCurrency(pagadoEvento,false);
            })
            
        }
    }
}

// Punto de extension para una futura configuracion de moneda por concepto.
// Por ahora, la moneda principal es la primera moneda activa disponible.
function getCobroDetailCurrency(type, primaryCurrency, campCurrency = '', currencySettings = {}){
    if(type === 'Campa'){
        return campCurrency || primaryCurrency;
    }
    return currencySettings[type] || primaryCurrency;
}

function getCobroCurrencyError(charges, campCurrencies, primaryCurrency, receiptCurrency){
    const currencies = new Set();
    Object.entries(charges).forEach(([member, concepts]) => {
        if(member === 'Redondeo'){
            if(parseFloat(concepts)){
                currencies.add(getCobroDetailCurrency('Redondeo', primaryCurrency));
            }
            return;
        }
        Object.entries(concepts).forEach(([type, rows]) => {
            Object.keys(rows).forEach(id => {
                currencies.add(getCobroDetailCurrency(type, primaryCurrency, (campCurrencies[member] || {})[id]));
            });
        });
    });
    if(currencies.size > 1){
        return 'No se puede generar un recibo con conceptos en monedas distintas. Separá los cobros por moneda.';
    }
    if(receiptCurrency && currencies.size === 1 && !currencies.has(receiptCurrency)){
        return 'La moneda seleccionada para el recibo no coincide con la moneda del detalle. Seleccioná la misma moneda.';
    }
    return '';
}

function addCampPaidAmount(camp, currency, currencyName, amount){
    // PHP serializa los diccionarios vacios como []; las claves de moneda
    // agregadas a un Array se pierden al ejecutar JSON.stringify.
    camp.PagadoPorMoneda = Object.assign({}, camp.PagadoPorMoneda || {});
    const previous = camp.PagadoPorMoneda[currency] || {};
    camp.PagadoPorMoneda[currency] = {
        Moneda: currency,
        Nombre: currencyName,
        Pagado: String((parseFloat(previous.Pagado) || 0) + amount)
    };
}

function completeCobrosDetail(jsonCobros, refreshMember = false){

    const panelCobros = document.querySelector("section.panel_cobros");
    if(panelCobros){
        let dicCobros = {};
        let campDetailCurrencies = {};

        const loader = panelCobros.querySelector('.cont_loader_cobros');
        const precioCuota = panelCobros.querySelector('.valor_cuota').textContent.replace('$','').replace('.','');
        const buscador_miembro = panelCobros.querySelector('.buscador_miembro');
        const busquedas = buscador_miembro.querySelectorAll('.lista_busqueda .busqueda');
        const info_miembro = panelCobros.querySelector('.info_miembro');
        const btn_recibo = panelCobros.querySelector('.info_footer .gen_recibo');
        const id_miembro = info_miembro.getAttribute('data-id');
        const inputRedondeo = panelCobros.querySelector('input[type="text"]#redondeo_cobros');
        const inputTotal = panelCobros.querySelector('input[type="text"]#valor_total_cobros');
        const select_moneda = panelCobros.querySelector('.panel_preferencias select#moneda_cobro');
        const inputsCobros = panelCobros.querySelectorAll('input[type="text"]:not([readonly]):not(#redondeo_cobros)');

        if(select_moneda){
            select_moneda.addEventListener('change', () => {
                const currSigne = getCurrencySigne(select_moneda.value);
                syncCurrencyInputSigne(inputRedondeo, currSigne);
                syncCurrencyInputSigne(inputTotal, currSigne);
                completeDetailArea(dicCobros);
            })
        }

        function sanitizePlainText(value){
            return String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        }

        function getMemberNameText(){
            const nameNode = info_miembro.querySelector('.nombre_miembro p');
            return sanitizePlainText(nameNode ? nameNode.textContent : '');
        }

        function getCampValueTypes(campa){
            let valuesByCurrency = {};
            try{
                valuesByCurrency = JSON.parse(campa.dataset.valoresMoneda || '{}');
            }catch(error){
                valuesByCurrency = {};
            }

            const tipos = [];
            Object.values(valuesByCurrency).forEach((currencyData)=>{
                const values = currencyData && currencyData['Valores'] ? currencyData['Valores'] : [];
                values.forEach((value)=>{
                    if(value.Tipo && !tipos.includes(value.Tipo)){
                        tipos.push(value.Tipo);
                    }
                })
            })

            return tipos;
        }

        function getCampTipoFromDetailKey(campa,id){
            const campId = campa.getAttribute('data-id');
            const detailName = String(id || '').substring(String(campId).length + 1);
            const tipos = getCampValueTypes(campa).sort((a,b)=>b.length - a.length);
            const tipo = tipos.find((tipoValue)=>detailName.endsWith(' ' + tipoValue));

            return tipo || '';
        }

        function sanitizeCobrosPayload(dic){
            const sanitizedDic = {};

            Object.entries(dic).forEach(([memberKey, memberValue]) => {
                if(memberKey === 'Redondeo'){
                    sanitizedDic['Redondeo'] = sanitizePlainText(memberValue);
                    return;
                }

                const memberParts = memberKey.split('-');
                const memberId = sanitizePlainText(memberParts.shift());
                const memberName = sanitizePlainText(memberParts.join('-'));
                const sanitizedMemberKey = memberId + '-' + memberName;

                sanitizedDic[sanitizedMemberKey] = {'General':{},'Anual':{},'Evento':{},'Campa':{}};

                Object.keys(memberValue).forEach(type => {
                    sanitizedDic[sanitizedMemberKey][type] = {};
                    Object.entries(memberValue[type]).forEach(([key, value]) => {
                        const sanitizedKey = sanitizePlainText(key);
                        const sanitizedValue = sanitizePlainText(value);
                        sanitizedDic[sanitizedMemberKey][type][sanitizedKey] = sanitizedValue;
                    });
                });
            });

            return sanitizedDic;
        }

        if(!refreshMember){
            inputsCobros.forEach(input => {
                input.addEventListener('input',()=>{
                    const id_miembro = info_miembro.getAttribute('data-id');
                    if(id_miembro){
                        const nombre_miembro = getMemberNameText();
                        let masterId = id_miembro + '-' + nombre_miembro;
                        if(!(masterId in dicCobros)){
                            dicCobros[masterId] = {'General':{},'Anual':{},'Evento':{},'Campa':{}};
                        }
                        const keyType = capitalizar(input.getAttribute('data-type'));
                        let keyId = '';
                        
                        if(keyType == 'General'){
                            keyId = capitalizar(input.id.replace('importe_general_','').trim()) + '-' + capitalizar(input.name.trim());
                        }
                        else if(keyType == 'Anual'){
                            keyId = capitalizar(input.id.replace('importe_','').trim());
                        }
                        else if(keyType == 'Evento'){
                            keyId = capitalizar(input.id.replace('importe_evento_','').trim()) + '-' + capitalizar(input.name.trim());
                        }
                        else if(keyType == 'Campa'){
                            keyId = capitalizar(input.id.replace('importe_campa_','').trim()) + '-' + capitalizar(input.name.trim());
                        }
                        if(keyType != 'Campa' || input.id != 'importe_campa'){
    
                            let value;
                            if(keyType === 'Campa'){
                                // El importe del campamento puede tener otro signo ("US$ 10").
                                value = parseLocalizedCurrencyValue(input.value);
                            }else{
                                let raw = input.value.replace('$ ', '').replace(/\./g, '').replace(',', '.');
                                value = parseFloat(raw);
                            }
                            let finalValue = value.toFixed(2); // Esto asegura que tenga siempre dos decimales
                            dicCobros[masterId][keyType][keyId] = finalValue;
                            if(keyType === 'Campa'){
                                const currency = panelCobros.querySelector('#moneda_campa_cobro').value;
                                if(!campDetailCurrencies[masterId]){ campDetailCurrencies[masterId] = {}; }
                                campDetailCurrencies[masterId][keyId] = currency;
                                const selectedCamp = panelCobros.querySelector('.campa.selected');
                                if(selectedCamp){ selectedCamp.dataset.currencyInput = currency; }
                            }
                            
                            checkEmptyKeys(dicCobros);
                            completeDetailArea(dicCobros);
                        }
                    }
                })
            });

            listenDebtAmountWithConfirm();
    
            inputRedondeo.addEventListener('input',()=>{
                dicCobros['Redondeo'] = parseLocalizedCurrencyValue(inputRedondeo.value);
                            
                checkEmptyKeys(dicCobros);
                completeDetailArea(dicCobros);
            })
        }

        busquedas.forEach((row,i) =>{
    
            row.addEventListener('click',()=>{
                const buscador_miembro = panelCobros.querySelector('.buscador_miembro');
                const buscador = buscador_miembro.querySelector('.buscador');
                const searchInput = buscador_miembro.querySelector('input#search_cobro');
                const busquedas = buscador_miembro.querySelectorAll('.lista_busqueda .busqueda');
                const nombre_miembro =   info_miembro.querySelector('.nombre_miembro p');
                const idMember = row.getAttribute('data-id');
                const nombreMember = row.querySelector('p').textContent;
                const info_campas =   panelCobros.querySelector('.info_campas .lista_campas_cobros');
                const campas =   info_campas.querySelectorAll('.campa');
                const campaSelect = info_campas.querySelector('.campa.selected');
                let masterId = idMember + '-' + nombreMember;

                //Completa los datos de infoMiembro
                buscador.classList.remove('mostrar');
                busquedas.forEach((row,i) =>{row.classList.remove('ocultar');})
                searchInput.value = ''; 
                info_miembro.setAttribute('data-id',idMember);
                nombre_miembro.textContent = sanitizePlainText(nombreMember);
                toggleCobrosMemberPanels(panelCobros);
                
                //Completa los inputs con lo que ya hay en el dic
                inputsCobros.forEach(input => {
                    input.value = input.getAttribute('data-type') == 'campa' ? '' : '$ 0';
                })
                campas.forEach(campa => {
                    campa.setAttribute('data-input','');
                    campa.setAttribute('data-tipo-input','');
                })

                if(masterId in dicCobros){
                    Object.keys(dicCobros[masterId]).forEach(type => {
                        Object.keys(dicCobros[masterId][type]).forEach(id =>{
                            let value = dicCobros[masterId][type][id];
                            if (type == 'Anual') {
                                let idInput = 'importe_' + id;
                                let inputId = panelCobros.querySelector('input#'+idInput.toLowerCase());
                                if(inputId){
                                    inputId.value = value;
                                }
                            }
                            else if (type == 'General') {
                                let prefix = 'importe_general_';
                                let idInput = prefix + (id.split('-')[0]);
                                let inputId = panelCobros.querySelector('input#'+idInput.toLowerCase());
                                if(inputId){
                                    inputId.value = formatCurrency(value,false);
                                }
                            }
                            else if (type == 'Campa') {
                                let idCampa = id.split('-')[0];
                                let campaId = info_campas.querySelector('.campa[data-id="'+idCampa+'"]');
                                if(campaId){
                                    campaId.setAttribute('data-input',formatCurrency(value,false));
                                    campaId.setAttribute('data-tipo-input',getCampTipoFromDetailKey(campaId,id));
                                    campaId.dataset.currencyInput = (campDetailCurrencies[masterId] || {})[id] || '';
                                }
                            }
                            else if (type == 'Evento') {
                                let prefix = 'importe_evento_';
                                let idInput = prefix + (id.split('-')[0]);
                                let inputId = panelCobros.querySelector('input#'+idInput.toLowerCase());
                                if(inputId){
                                    inputId.value = formatCurrency(value,false);
                                }
                            }
                        })
                    })
                }
                //Completa los inpus con lo que ya hay en la base (Mas que nada las cuotas)
                completePanelCobros(jsonCobros);

                listenCuotaMenu();
                const cont_members = panelCobros.querySelector('.cont_member_bubble');
                const bubbleSelect = cont_members.querySelector(`.member_bubble.active`);
                const bubble = cont_members.querySelector(`.member_bubble[data-id="${idMember}"]`);

                if(bubbleSelect){
                    bubbleSelect.classList.remove('active');
                }
                if(bubble){
                    bubble.click();
                }
                if(campaSelect){
                    campaSelect.click();
                }
            })
        })

        let currentCobroIdemKey = null;

        function generateIdempotencyKey(){
            if(window.crypto && typeof window.crypto.randomUUID === 'function'){
                return window.crypto.randomUUID();
            }
            return 'idem-' + Date.now() + '-' + Math.random().toString(16).slice(2);
        }

        btn_recibo.addEventListener('click',()=>{
            if(!validateDetailCurrencies(true)){ return; }
            if(!receiptPreferences.validate(panelCobros)){ return; }
            // console.log('dicCobros')
            if (Object.keys(dicCobros).length > 0 && !(Object.keys(dicCobros).length === 1 && dicCobros.hasOwnProperty('Redondeo'))) {
                loader.classList.add('loading');
                if(!currentCobroIdemKey){
                    currentCobroIdemKey = generateIdempotencyKey();
                }
                if(!currentCobroIdemKey || currentCobroIdemKey === 'null' || currentCobroIdemKey === 'undefined'){
                    loader.classList.remove('loading');
                    currentCobroIdemKey = null;
                    showAlert('error','No se pudo generar una llave de seguridad para el cobro');
                    return;
                }
                checkIfAllowedTo(dicCobros).then(checkAllowed => {
                    if(checkAllowed == true){
                        if(!validateDetailCurrencies(true)){
                            loader.classList.remove('loading');
                            currentCobroIdemKey = null;
                            return;
                        }
                        if(!receiptPreferences.validate(panelCobros)){
                            loader.classList.remove('loading');
                            currentCobroIdemKey = null;
                            return;
                        }
                        const currency = select_moneda.value;
                        const userCodes = Array.from(select_moneda.options).map(option => option.value).filter(Boolean);
                        const unavailableCamp = Object.values(dicCobros).some(member =>
                            Object.entries(member.Campa || {}).some(([key]) => {
                                const id = key.split('-')[0];
                                const campa = Array.from(panelCobros.querySelectorAll('.campa')).find(item => item.dataset.id === id);
                                return !getCampCurrencyCodes(campa, userCodes).includes(currency);
                            })
                        );
                        if(unavailableCamp){
                            loader.classList.remove('loading');
                            currentCobroIdemKey = null;
                            showAlert('error', 'La moneda del cobro no esta habilitada para todos los campamentos seleccionados');
                            return;
                        }
                        const campos = getFieldsForCobro(dicCobros);
                        // console.log(campos);
                        fetch('/api/generateCobro.php', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Idempotency-Key': currentCobroIdemKey
                            },
                            body: JSON.stringify(campos)
                            })
                            .then(response => response.json())
                            .then(data => {
                                if(data['response'] == 200){
                                    loader.classList.remove('loading');
                                    showAlert('success','Cobro Generado Correctamente');
                                    successCobro(dicCobros);
                                    currentCobroIdemKey = null;
                                    if(data['reciboId']){
                                        window.open('comprobante/'+data['reciboId']+'/imprimir', '_blank');
                                    }
                                }else if(data['response'] == 202){
                                    loader.classList.remove('loading');
                                    showAlert('error','Este cobro ya se está procesando, espere unos segundos');
                                }else{
                                console.error('Error en la solicitud:', data['error']);
                                if(Object.keys(data['error']).length === 0){
                                    loader.classList.remove('loading');
                                    showAlert('error','Error al Generar Cobro');
                                }else{
                                    loader.classList.remove('loading');
                                    showAlert('error',data['error']);
                                }
                                currentCobroIdemKey = null;
                                //raiseMemberFields();
                                }
                            })
                            .catch(error => {
                                // console.log(error);
                                loader.classList.remove('loading');
                                // console.error('Error en la solicitud:', error);
                                showAlert('error','Error al Generar Cobro');
                                currentCobroIdemKey = null;
                                //raiseMemberFields();
                            });
                    }else{
                        loader.classList.remove('loading');
                        currentCobroIdemKey = null;
                        checkAllowed.forEach(member => {
                            const msg = "Recientemente se le realizo un cobro a " + member;
                            showAlert('error',msg);
                        })
                    }
                })
            }else{
                showAlert('error','No hay Cobros Realizados');
            }
        })
        
        function getFieldsForCobro(dicCobros){
            let campos = {};
            const select_firmante = panelCobros.querySelector('.panel_firmante select');
            const select_moneda = panelCobros.querySelector('.panel_preferencias select#moneda_cobro');
            const select_metodo = panelCobros.querySelector('.panel_preferencias select#metodo_cobro');
            const observ_cobros = panelCobros.querySelector('#observacion_cobros');
            const sanitizedCobros = sanitizeCobrosPayload(dicCobros);
            const estadoCoutas = getEstadoCuotas(sanitizedCobros)
            let firmante = '';
            let moneda = '';
            let metodo = '';
            let monedaName = '';
            let metodoName = '';

            if(select_firmante.value){
                firmante = sanitizePlainText(select_firmante.options[select_firmante.selectedIndex].text);
            }
            if(select_moneda.options.length > 0){
                moneda = sanitizePlainText(select_moneda.value);
                monedaName = sanitizePlainText(select_moneda.options[select_moneda.selectedIndex].text);
            }
            if(select_metodo.options.length > 0){
                metodo = sanitizePlainText(select_metodo.value);
                metodoName = sanitizePlainText(select_metodo.options[select_metodo.selectedIndex].text);
            }
            
            const total = parseLocalizedCurrencyValue(inputTotal.value);
            let redondeo = sanitizedCobros['Redondeo'];
            if(!redondeo){
                redondeo = 0;
            }
            let montoTotal = total - redondeo;// Solo los Cobros

            campos['Cobros'] = Object.fromEntries(
                Object.entries(sanitizedCobros).filter(([key]) => key !== 'Redondeo')
            );
            
            campos['Data'] = {"Firmante":firmante,"Total":montoTotal,"Redondeo":redondeo,
                "Detalle":JSON.stringify(sanitizedCobros),"EstadoCuotas":estadoCoutas,
                "Observaciones":sanitizePlainText(observ_cobros.value),
                "Moneda":moneda,"MonedaName":monedaName,"Metodo":metodo,"MetodoName":metodoName};

            return campos;
        }

        function getEstadoCuotas(dicCobros){
            const meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
            let cuotasDic = {};

            Object.keys(dicCobros).forEach(member => {
                let idMember =  member.split('-')[0];
                if(Object.keys(jsonCobros).includes(idMember)){
                    const memberJson = jsonCobros[idMember];
                    cuotasDic[member] = {};
                    meses.forEach(mes => {
                        const jsonValue = parseFloat(memberJson[mes]);
                        if(Object.keys(dicCobros[member]['Anual']).includes(mes)){
                            const value = parseFloat(dicCobros[member]['Anual'][mes]);
                            const monthValue = (jsonValue + value);
                            cuotasDic[member][mes] = String(monthValue.toFixed(2));
                        }else{
                            cuotasDic[member][mes] = String(jsonValue.toFixed(2));
                        }
                    })
                }
            })
            // console.log(cuotasDic);
            return JSON.stringify(cuotasDic);
        }

        function successCobro(){
            receiptPreferences.recordActivity();
            const detalle_cobros = panelCobros.querySelector('#detalle_cobros');
            const observ_cobros = panelCobros.querySelector('#observacion_cobros');
            const total_cobros = panelCobros.querySelector('#valor_total_cobros');
            const num_receipt = panelCobros.querySelector('.numero_recibo .num_recibo');
            const precioCuota = panelCobros.querySelector('.valor_cuota').textContent.replace('$','').replace('.','');
            const info_miembro = panelCobros.querySelector('.info_miembro');
            const nombre_miembro = info_miembro.querySelector('.nombre_miembro p');
            const rama_miembro = info_miembro.querySelector('.rama_miembro');
            const rama_nombre = rama_miembro.querySelector('p');
            const searchInput = panelCobros.querySelector('input#search_cobro');
            detalle_cobros.value = '';
            observ_cobros.value = '';
            total_cobros.value = '';

            getNextReceiptNr(num_receipt.textContent.trim());

            Object.keys(dicCobros).forEach(member => {
                let idMember =  member.split('-')[0];
                if(Object.keys(jsonCobros).includes(idMember)){
                    jsonCobros[idMember]['syncVersionCobros'] = String(parseInt(jsonCobros[idMember]['syncVersionCobros']) + 1);
                    Object.keys(dicCobros[member]).forEach(type => {
                        Object.keys(dicCobros[member][type]).forEach(id =>{
                            let value = parseFloat(dicCobros[member][type][id]);
                            if (['Anual'].includes(type)) {
                                let newValue = String(parseFloat(jsonCobros[idMember][id]) + value);
                                jsonCobros[idMember][id] = newValue;

                                if(id != 'Deuda'){
                                    if (parseFloat(newValue) >= parseFloat(precioCuota) || dicCobros[member][type][id].includes('(Abonado)')){
                                        let keyCheck = 'Pago'+capitalizar(id);
                                        if(Object.keys(jsonCobros[idMember]).includes(keyCheck)){
                                            jsonCobros[idMember][keyCheck] = 1;
                                        }
                                    }
                                }
                            }
                            else if (['General'].includes(type)) {
                                genId = id.split('-')[0];
                                let newValue = String(parseFloat(jsonCobros[idMember]['General'][genId]['Pagado']) + value);
                                jsonCobros[idMember]['General'][genId]['Pagado'] = newValue;
                            }
                            else if (['Campa'].includes(type)) {
                                campId = id.split('-')[0];
                                let newValue = String(parseFloat(jsonCobros[idMember]['Campamentos'][campId]['Pagado']) + value);
                                jsonCobros[idMember]['Campamentos'][campId]['Pagado'] = newValue;

                                const currency = select_moneda ? select_moneda.value : '';
                                const currencyName = select_moneda && select_moneda.options[select_moneda.selectedIndex] ? select_moneda.options[select_moneda.selectedIndex].text : '';
                                addCampPaidAmount(jsonCobros[idMember]['Campamentos'][campId], currency, currencyName, value);
                                jsonCobros[idMember]['Campamentos'][campId]['Asistencia'] = 1;
                                updateCampAttendanceState(idMember, campId, 1);
                            }
                            else if (['Evento'].includes(type)) {
                                evId = id.split('-')[0];
                                let newValue = String(parseFloat(jsonCobros[idMember]['Eventos'][evId]['Pagado']) + value);
                                jsonCobros[idMember]['Eventos'][evId]['Pagado'] = newValue;
                            }
                        })
                    })
                }
            })

            const inputs = panelCobros.querySelectorAll('input[type="text"]');
            inputs.forEach(input => {
                input.value = input.getAttribute('data-type') == 'campa' ? '' : '$ 0';
            })

            // inputs.forEach(input => {
            //     console.log(input.id);
            //     console.log(input.value);
            // })
            completePanelCobros(jsonCobros);
            dynamicPanelCobros(true);

            const info_campas = panelCobros.querySelector('.info_campas .lista_campas_cobros');
            const campas = info_campas.querySelectorAll('.campa');
            const campaSelect = info_campas.querySelector('.campa.selected');
            campas.forEach((campa)=>{
                campa.setAttribute('data-input',0);
                campa.setAttribute('data-tipo-input','');
            })
            if(campaSelect){
                campaSelect.click();
            }

            const cont_members = panelCobros.querySelector('.cont_member_bubble');
            cont_members.innerHTML = '';

            dicCobros = {};
            campDetailCurrencies = {};
            validateDetailCurrencies();
            info_miembro.setAttribute('data-id','');
            nombre_miembro.textContent = '';
            rama_nombre.textContent = '';
            rama_miembro.className = 'rama_miembro';
            if(searchInput){
                searchInput.value = '';
            }
            toggleCobrosMemberPanels(panelCobros);

            refreshReceiptReport();
            refreshReceiptTableList();

        }  
        
        function validateDetailCurrencies(showError = false){
            const primaryOption = Array.from(select_moneda.options).find(option => option.value);
            const error = getCobroCurrencyError(dicCobros, campDetailCurrencies, primaryOption ? primaryOption.value : '', select_moneda.value);
            const detail = panelCobros.querySelector('#detalle_cobros');
            const legend = panelCobros.querySelector('#detalle_cobros_currency_error');
            detail.classList.toggle('currency_error', !!error);
            detail.setAttribute('aria-invalid', error ? 'true' : 'false');
            legend.textContent = error;
            legend.hidden = !error;
            if(error && showError){ showAlert('error', error); }
            return !error;
        }

        function completeDetailArea(dicCobros){
            const detalle_cobros = panelCobros.querySelector('#detalle_cobros');
            const total_cobros = panelCobros.querySelector('#valor_total_cobros');
            const currSigne = getCurrencySigne(select_moneda.value);
            const primaryOption = Array.from(select_moneda.options).find(option => option.value);
            const primaryCurrency = primaryOption ? primaryOption.value : '';
            let totCobros = 0;
            detalle_cobros.value = '';
            total_cobros.value = '';
            Object.keys(dicCobros).forEach(member => {
                if(member != "Redondeo"){                    
                    detalle_cobros.value += member + ': ';
                    Object.keys(dicCobros[member]).forEach(type => {
                        Object.keys(dicCobros[member][type]).forEach(id =>{
                            let value = dicCobros[member][type][id];
                            const detailCurrency = getCobroDetailCurrency(type, primaryCurrency, (campDetailCurrencies[member] || {})[id]);
                            const detailSigne = getCurrencySigne(detailCurrency);
                            let textId = '';
                            if (['Anual'].includes(type)) {
                                textId = id;
                            }
                            else if (['General','Campa','Evento'].includes(type)) {
                                textId = id.split('-')[1];
                            }

                            if(!value.includes('(Abonado)')){
                                let textValue = formatCurrencyWithSigne(value,detailSigne,false);
                                detalle_cobros.value += textId + ': ' + textValue + ' / ';
                                totCobros += parseFloat(value);
                            }else{
                                let textValue = formatCurrencyWithSigne(value.replace('(Abonado)',''),detailSigne,false);
                                detalle_cobros.value += textId + ': ' + textValue + ' (Abonado)' + ' / ';
                                totCobros += parseFloat(value.replace('(Abonado)'));
                            }
                        })
                    })
                    detalle_cobros.value += '\n\n';
                }
            })

            if (Object.keys(dicCobros).includes('Redondeo')){
                let value = dicCobros['Redondeo'];
                let textValue = formatCurrencyWithSigne(value,getCurrencySigne(getCobroDetailCurrency('Redondeo', primaryCurrency)),false);

                detalle_cobros.value += 'Redondeo: ' + textValue;
                totCobros += parseFloat(value);
            }
            total_cobros.value = totCobros.toFixed(2);
            total_cobros.value = formatCurrencyWithSigne(total_cobros.value,currSigne,false);
            createMemberBubble(dicCobros);
            validateDetailCurrencies();
        }
        
        function checkEmptyKeys(dicCobros) {
            Object.keys(dicCobros).forEach(member => {
                let checkEmpty = 0;
                if(member != "Redondeo"){     
                    Object.keys(dicCobros[member]).forEach(type => {
                        Object.keys(dicCobros[member][type]).forEach(id =>{
                            // console.log(dicCobros[member][type][id])
                            if(dicCobros[member][type][id] == 0 || dicCobros[member][type][id] == 'NaN'){
                                delete dicCobros[member][type][id];
                            }
                        })
                        if(Object.keys(dicCobros[member][type]).length == 0){
                            checkEmpty += 1;
                        }
                    })
                    if(checkEmpty == 4){
                        delete dicCobros[member];
                    }
                }else{
                    if(dicCobros['Redondeo'] == 0 || dicCobros['Redondeo'] == 'NaN'){
                        delete dicCobros['Redondeo'];
                    }
                }
            })

        }

        function showCuotMenu(e) {
            e.preventDefault();
        
            if (!e.currentTarget) return;  // Asegurarse que el target existe
        
            document.querySelectorAll(".menu_cuota_abonada").forEach(m => m.style.display = "none");
            const menu = e.currentTarget.querySelector(".menu_cuota_abonada");
            if (!menu) return;  // Si no encontró el menú, salir
            menu.style.display = "block";
        }
        
        function handleMenuClick(e) {
            const menu = e.currentTarget;
            const cuota = menu.closest('.cuota');
            const input = cuota.querySelector("input");
            const option = menu.querySelector('.opt_menu');
            const data = getCuotaData(input);
            const id_miembro = info_miembro.getAttribute('data-id');
            const nombre_miembro = getMemberNameText();
            let masterId = id_miembro + '-' + nombre_miembro;
            // console.log(data);
        
            if (!(masterId in dicCobros)) {
                dicCobros[masterId] = { 'General': {}, 'Anual': {}, 'Evento': {}, 'Campa': {} };
            }
        
            if (menu.style.display == "block") {
                let keyId = capitalizar(input.id.replace('importe_', '').trim());
        
                if (option.classList.contains('abonar')) {

                    input.classList = [];
                    input.classList.add('pagada');
                    input.readOnly = true;
        
                    option.classList.remove('abonar');
                    option.classList.add('no_abonar');
                    option.textContent = 'No Abonar';
        
                    if (Object.keys(dicCobros[masterId]['Anual']).includes(keyId)) {
                        dicCobros[masterId]['Anual'][keyId] += ' (Abonado)';
                    } else {
                        dicCobros[masterId]['Anual'][keyId] = '0 (Abonado)';
                    }
        
                } else {
                    let inputValue = dicCobros[masterId]['Anual'][keyId].replace(' (Abonado)', '');
                    input.classList = [];
                    input.classList.add(data['Class']);
                    input.value = formatCurrency(data['Value'], false);
                    option.classList.add('abonar');
                    option.classList.remove('no_abonar');
                    option.textContent = 'Abonar';
        
                    if (input.classList.contains('pendiente') || input.classList.contains('mod_parcial')) {
                        input.readOnly = false;
                    }
        
                    if (dicCobros[masterId]['Anual'][keyId] == '0 (Abonado)') {
                        delete dicCobros[masterId]['Anual'][keyId];
                    } else {
                        dicCobros[masterId]['Anual'][keyId] = inputValue;
                    }
                }
        
                menu.style.display = "none";
            }
        
            checkEmptyKeys(dicCobros);
            completeDetailArea(dicCobros);
        }
        
        function listenCuotaMenu() {
            const cuotas = panelCobros.querySelectorAll(".cuota.actual");
            let justOpenedMenu = false;  // Bandera para evitar que el click lo cierre enseguida
        
            cuotas.forEach((cuota) => {
                const menu = cuota.querySelector(".menu_cuota_abonada");
                const option = menu.querySelector('.opt_menu');
                const input = cuota.querySelector("input");
                const data = getCuotaData(input);
                setMenuOption(input, option, data);
        
                cuota.removeEventListener("contextmenu", showCuotMenu);
                menu.removeEventListener('click', handleMenuClick);
        
                const touchStartHandler = (e) => {
                    if (menu.style.display === "block") return;
                    cuota._touchTimer = setTimeout(() => {
                        showCuotMenu(e);
                        justOpenedMenu = true;
                        setTimeout(() => justOpenedMenu = false, 500); // Evitar cierre inmediato
                    }, 600);
                };
        
                const touchEndHandler = () => clearTimeout(cuota._touchTimer);
        
                if (cuota._touchStartHandler) cuota.removeEventListener('touchstart', cuota._touchStartHandler);
                if (cuota._touchEndHandler) cuota.removeEventListener('touchend', cuota._touchEndHandler);
        
                cuota._touchStartHandler = touchStartHandler;
                cuota._touchEndHandler = touchEndHandler;
        
                if (!input.classList.contains('pagada') || data['Paid']) {
                    cuota.addEventListener("contextmenu", showCuotMenu);
                    cuota.addEventListener('touchstart', touchStartHandler, { passive: true });
                    cuota.addEventListener('touchend', touchEndHandler);
                    menu.addEventListener('click', handleMenuClick);
                }
            });
        
            document.addEventListener("click", function (e) {
                if (justOpenedMenu) return;
                if (!e.target.closest(".menu_cuota_abonada")) {
                    document.querySelectorAll(".menu_cuota_abonada").forEach(m => m.style.display = "none");
                }
            });
        }

        function getCuotaData(input){
            const id_miembro = info_miembro.getAttribute('data-id');
            const nombre_miembro = getMemberNameText();
            let masterId = id_miembro + '-' + nombre_miembro;
            let keyId = capitalizar(input.id.replace('importe_','').trim());

            let dicValue = 0;
            let jsonValue = 0;
            let oldClass = '';
            let oldValue = '';
            let paidCheck = false;
            
            if(masterId in dicCobros){
                if(keyId in dicCobros[masterId]['Anual']){
                    dicValue = parseFloat(dicCobros[masterId]['Anual'][keyId]);
                    if(dicCobros[masterId]['Anual'][keyId].includes('(Abonado)')){
                        paidCheck = true;
                    }
                }
            }
            jsonValue = parseFloat(jsonCobros[id_miembro][keyId]);

            if(dicValue == 0 && jsonValue == 0){
                oldClass = 'pendiente';
                oldValue = dicValue;
            }
            else if(dicValue != 0 && jsonValue != 0){
                oldClass = 'mod_parcial';
                oldValue = dicValue;
            }
            else if(dicValue == 0 && jsonValue != 0){
                oldClass = 'parcial';
                oldValue = jsonValue;
            }
            else if(dicValue != 0 && jsonValue == 0){
                oldClass = 'pendiente';
                oldValue = dicValue;
            }

            return {'Value':String(oldValue),'Class':oldClass,'Paid':paidCheck};
        }

        function setMenuOption(input,option,data){
            if(data['Paid']){
                input.classList = [];
                input.classList.add('pagada');
                input.readOnly = true;
                input.value = formatCurrency(data['Value'],false);

                option.classList.remove('abonar');
                option.classList.add('no_abonar');
                option.textContent = 'No Abonar';
            }else{
                option.classList.add('abonar');
                option.classList.remove('no_abonar');
                option.textContent = 'Abonar';
            }
        }
        
        function createMemberBubble(dicCobros){
            const cont_members = panelCobros.querySelector('.cont_member_bubble');
            cont_members.innerHTML = '';
            
            Object.keys(dicCobros).forEach(member => {
                if(member != "Redondeo"){
                    let idMember = member.split('-')[0];
                    let nameMember = member.split('-')[1];
    
                    const div = document.createElement('div');
                    const p = document.createElement('p');
                    const icon = document.createElement('i');
    
                    div.classList.add('member_bubble');
                    div.setAttribute('data-id', idMember);
    
                    p.textContent = nameMember;
    
                    icon.classList.add('fa-solid', 'fa-square-xmark', 'raise');
                    icon.setAttribute('title', 'Borrar Cobro');
                    icon.style.color = '#ad272d';
    
                    div.appendChild(p);
                    div.appendChild(icon);
    
                    cont_members.appendChild(div);
                }

            })

            const memberBubbles = cont_members.querySelectorAll('.member_bubble');
            memberBubbles.forEach(bubble =>{
                const btn_raise = bubble.querySelector('.raise');
                let dataId = bubble.getAttribute('data-id');
                const row = panelCobros.querySelector(`.lista_busqueda .busqueda[data-id="${dataId}"]`);
                bubble.addEventListener('touchend',()=>{
                    if(row){
                        row.click();
                    }
                    
                    memberBubbles.forEach(bubl =>{bubl.classList.remove('active');})
                    bubble.classList.add('active');
                    
                })
                bubble.addEventListener('click',()=>{
                    if(row){
                        row.click();
                    }
                    
                    memberBubbles.forEach(bubl =>{bubl.classList.remove('active');})
                    bubble.classList.add('active');
                    
                })
                if(btn_raise){
                    btn_raise.addEventListener('click',(e)=>{
                        e.stopPropagation();
                        e.preventDefault();
                        
                        const id_miembro = row.getAttribute('data-id');
                        const nombre_miembro = sanitizePlainText(row.querySelector('p').textContent);
                        let masterId = id_miembro + '-' + nombre_miembro;
                        
                        delete dicCobros[masterId];
                        checkEmptyKeys(dicCobros);
                        completeDetailArea(dicCobros);

                        const info_miembro = panelCobros.querySelector('.info_miembro');
                        const dataId = info_miembro.getAttribute('data-id');
                        const curRow = panelCobros.querySelector(`.lista_busqueda .busqueda[data-id="${dataId}"]`);
                        if(curRow){
                            curRow.click();
                        }
                    })
                    btn_raise.addEventListener('touchend',(e)=>{
                        e.stopPropagation();
                        e.preventDefault();
                        
                        const id_miembro = row.getAttribute('data-id');
                        const nombre_miembro = sanitizePlainText(row.querySelector('p').textContent);
                        let masterId = id_miembro + '-' + nombre_miembro;
                        
                        delete dicCobros[masterId];
                        checkEmptyKeys(dicCobros);
                        completeDetailArea(dicCobros);

                        const info_miembro = panelCobros.querySelector('.info_miembro');
                        const dataId = info_miembro.getAttribute('data-id');
                        const curRow = panelCobros.querySelector(`.lista_busqueda .busqueda[data-id="${dataId}"]`);
                        if(curRow){
                            curRow.click();
                        }
                    })
                }
            })
        }

        async function checkIfAllowedTo(dicCobros){
            const bodyJson = { 'Members': Object.keys(dicCobros) };
            let noSyncMembers = [];
        
            async function getCloudSyncVersion(){
                try {
                    const response = await fetch('/api/getCloudSyncVersion.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(bodyJson)
                    });
        
                    const data = await response.json();
        
                    if (data['response'] == 200) {
                        return data['data'];
                    } else {
                        console.error('Error en la solicitud:', data['error']);
                        // if (Object.keys(data['error']).length === 0) {
                        //     console.log('Error al Generar Cobro');
                        // } else {
                        //     console.log(data['error']);
                        // }
                        return {};
                    }
                } catch (error) {
                    console.error(error);
                    return {};
                }
            }
        
            const syncCloud = await getCloudSyncVersion();
        
            Object.keys(dicCobros).forEach(member => {
                if(member != "Redondeo"){     
                    const idMember = member.split('-')[0];
                    const nameMember = member.split('-')[1];
                    // console.log(idMember);
                    const localSync = jsonCobros[idMember]['syncVersionCobros'];
                    const cloudSync = syncCloud[idMember];
    
                    if(cloudSync != localSync){
                        noSyncMembers.push(nameMember);
                    }
                }
            });

            if(noSyncMembers.length == 0){
                return true;
            }else{
                return noSyncMembers;
            }
        }

        function listenDebtAmount(){
            const importeDeuda = panelCobros.querySelector('.info_deudas .importe_deuda .importe_total');

            importeDeuda.addEventListener('click', ()=>{
                const id_miembro = info_miembro.getAttribute('data-id');
                if(id_miembro){
                    let p = importeDeuda.querySelector('p');
                    if(p){
                        let valorActual = p.innerText;
                        let input = document.createElement("input");
        
                        input.type = "text";
                        input.classList.add('input_deuda');
                        input.value = valorActual;
        
                        p.replaceWith(input);
                        input.focus();
    
                        let enterPressed = false;

                        input.addEventListener('keydown', function(e) {
                            if (e.key === 'Enter') {
                                e.preventDefault();  // previene que cierre el teclado o haga un submit
                                enterPressed = true;
                                modifyDebtAmount(input);
                                input.blur();  // Forzamos el blur manualmente.
                            }
                        });
                        
                        // En celulares, cuando no se dispara keydown, al perder foco (tecla "Hecho" o tocar afuera) se ejecuta acá.
                        input.addEventListener('blur', function() {
                            if (!enterPressed) {
                                modifyDebtAmount(input);  // Guardás el valor igual.
                            }
                            enterPressed = false;
                        });
    
                        input.addEventListener('input',() => {
                            input.value = formatCurrency(input.value);
                        })
                        
                        function modifyDebtAmount(input){
                            let raw = input.value.replace('$ ', '').replace(/\./g, '').replace(',', '.');
                            let value = parseFloat(raw);
                            const id_miembro = info_miembro.getAttribute('data-id');
                            let campos = {'Member':id_miembro, 'Value':value}

                            fetch('/api/modifyDebtAmount.php', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(campos)
                                })
                                .then(response => response.json())
                                .then(data => {
                                    // console.log(data);
                                    if(data['response'] == 200){
                                        showAlert('success','Deuda Actualizada Correctamente');
                                        successModify(id_miembro)
                                    }else{
                                    console.error('Error en la solicitud:', data['error']);
                                    if(Object.keys(data['error']).length === 0){
                                        showAlert('error','Error al Actualizar Deuda');
                                    }else{
                                        showAlert('error',data['error']);
                                    }
                                    //raiseMemberFields();
                                    }
                                })
                                .catch(error => {
                                    // console.log(error);
                                    console.error('Error en la solicitud:', error);
                                    showAlert('error','Error al Actualizar Deuda');
                                    //raiseMemberFields();
                                });
                                
                            function successModify(id_miembro){
                                p.innerHTML = formatCurrency(String(value),false)
                                input.replaceWith(p);
                                jsonCobros[id_miembro]['DeudaTotal'] = String(value);
                            }
                        }
                    }
                }
            })
        }

        function listenDebtAmountWithConfirm(){
            const importeDeuda = panelCobros.querySelector('.info_deudas .importe_deuda .importe_total');

            importeDeuda.addEventListener('click', () => {
                const id_miembro = info_miembro.getAttribute('data-id');
                if(!id_miembro){
                    return;
                }

                let p = importeDeuda.querySelector('p');
                if(!p){
                    return;
                }

                const valorActual = p.innerText;
                const input = document.createElement('input');
                let confirmOpen = false;
                let editClosed = false;

                input.type = 'text';
                input.classList.add('input_deuda');
                input.value = valorActual;

                p.replaceWith(input);
                input.focus();

                input.addEventListener('keydown', (e) => {
                    if(e.key === 'Enter'){
                        e.preventDefault();
                        requestDebtAmountUpdate();
                    }
                    if(e.key === 'Escape'){
                        editClosed = true;
                        input.replaceWith(p);
                    }
                });

                input.addEventListener('blur', () => {
                    if(!confirmOpen && !editClosed){
                        requestDebtAmountUpdate();
                    }
                });

                input.addEventListener('input', () => {
                    input.value = formatCurrency(input.value);
                });

                function requestDebtAmountUpdate(){
                    if(confirmOpen){
                        return;
                    }

                    const value = parseDebtInputValue(input.value);
                    const currentValue = parseDebtInputValue(valorActual);

                    if(Number.isNaN(value)){
                        showAlert('error','Debes ingresar un monto valido');
                        editClosed = true;
                        input.replaceWith(p);
                        return;
                    }

                    if(value === currentValue){
                        editClosed = true;
                        input.replaceWith(p);
                        return;
                    }

                    confirmOpen = true;
                    showConfirmPopup({
                        title: 'Confirmar edicion de deuda',
                        message: 'Se modificara el total adeudado y la deuda actual del miembro.',
                        confirmText: 'Confirmar',
                        cancelText: 'Cancelar'
                    }).then((confirmed) => {
                        confirmOpen = false;
                        if(confirmed){
                            modifyDebtAmount(input, value);
                        }else{
                            editClosed = true;
                            input.replaceWith(p);
                        }
                    });
                }

                function parseDebtInputValue(value){
                    const raw = String(value).replace('$ ', '').replace(/\./g, '').replace(',', '.');
                    return parseFloat(raw);
                }

                function modifyDebtAmount(input, value){
                    const id_miembro = info_miembro.getAttribute('data-id');
                    const campos = {'Member':id_miembro, 'Value':value};

                    fetch('/api/modifyDebtAmount.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(campos)
                    })
                        .then(response => response.json())
                        .then(data => {
                            if(data['response'] == 200){
                                showAlert('success','Deuda Actualizada Correctamente');
                                successModify(id_miembro, value);
                            }else{
                                console.error('Error en la solicitud:', data['error']);
                                if(Object.keys(data['error']).length === 0){
                                    showAlert('error','Error al Actualizar Deuda');
                                }else{
                                    showAlert('error',data['error']);
                                }
                                editClosed = true;
                                input.replaceWith(p);
                            }
                        })
                        .catch(error => {
                            console.error('Error en la solicitud:', error);
                            showAlert('error','Error al Actualizar Deuda');
                            editClosed = true;
                            input.replaceWith(p);
                        });
                }

                function successModify(id_miembro, value){
                    const deudaActual = panelCobros.querySelector('.info_deudas .importe_deuda .importe_actual p');
                    const deudaPagada = parseFloat(jsonCobros[id_miembro]['Deuda']) || 0;

                    p.innerHTML = formatCurrency(String(value),false);
                    editClosed = true;
                    input.replaceWith(p);
                    jsonCobros[id_miembro]['DeudaTotal'] = String(value);

                    if(deudaActual){
                        deudaActual.innerHTML = formatCurrency(String(value - deudaPagada), false);
                    }
                }
            });
        }
    }
}

async function completePagosDetail(refreshMember = false, refreshCateg = false){
    const panelPagos = document.querySelector("section.panel_pagos");
    if(panelPagos){
        togglePagosMemberLock(panelPagos);
        let dicPagos = {};
        const loader = panelPagos.querySelector('.cont_loader_pagos');
        const btn_recibo = panelPagos.querySelector('.info_footer .gen_recibo');
        const buscador_miembro = panelPagos.querySelector('.buscador_miembro');
        const busquedas = buscador_miembro.querySelectorAll('.lista_busqueda .busqueda');
        const info_miembro = panelPagos.querySelector('.info_miembro');
        const inputRedondeo = panelPagos.querySelector('input[type="text"]#redondeo_pagos');
        const inputTotal = panelPagos.querySelector('input[type="text"]#valor_total_pagos');
        const select_moneda = panelPagos.querySelector('.panel_preferencias select#moneda_pago');
        const inputPago = panelPagos.querySelector('input[type="text"]#importe_ticket');
        const inputDescrip = panelPagos.querySelector('input#descripcion');
        const inputTicket = panelPagos.querySelector('input#num_ticket');
        const categorias = panelPagos.querySelectorAll('.categorias:not(.agregar):not(.new)');
        const descriptionFields = panelPagos.querySelector('.panel_descripcion .cont_descripcin');
        const select_firmante_pago = panelPagos.querySelector('.panel_firmante select#firmante_pago');
        const select_metodo_pago = panelPagos.querySelector('.panel_preferencias select#metodo_pago');
        let paymentSkeletonTimer = null;

        initPagosCustomSelect(select_firmante_pago);
        initPagosCustomSelect(select_moneda);
        initPagosCustomSelect(select_metodo_pago);
        syncPagoCategoryNameOverflowMarquee(panelPagos);
        if(panelPagos.pagoCategoryNameResizeReady !== true){
            panelPagos.pagoCategoryNameResizeReady = true;
            window.addEventListener('resize', () => syncPagoCategoryNameOverflowMarquee(panelPagos));
        }

        function showPaymentDescriptionSkeleton(){
            if(!descriptionFields){
                return;
            }

            window.clearTimeout(paymentSkeletonTimer);
            descriptionFields.classList.add('skeleton-loading');
            paymentSkeletonTimer = window.setTimeout(() => {
                descriptionFields.classList.remove('skeleton-loading');
            }, 220);
        }

        if(select_moneda){
            select_moneda.addEventListener('change', () => {
                const currSigne = getCurrencySigne(select_moneda.value);
                syncCurrencyInputSigne(inputRedondeo, currSigne);
                syncCurrencyInputSigne(inputTotal, currSigne);
                sumUpPagos(dicPagos);
            })
        }

        function initPagosCustomSelect(select){
            if(!select){
                return;
            }

            const wrapper = select.closest('.cont_monedas, .cont_metodos, .cont_firmante_select');
            if(!wrapper){
                return;
            }

            // La marca es una propiedad JS (no un data-*) porque cloneNode copia los atributos
            // pero no los listeners: si el panel fue clonado, el div no la tiene y se reconstruye.
            const existingCustomSelect = wrapper.querySelector('.custom_select_pagos');
            if(select.dataset.customSelectReady === 'true' && existingCustomSelect && existingCustomSelect._pagosBound === true){
                syncPagosCustomSelect(select);
                return;
            }

            if(existingCustomSelect){
                existingCustomSelect.remove();
            }

            select.dataset.customSelectReady = 'true';
            wrapper.classList.add('custom_select_ready');

            const customSelect = document.createElement('div');
            customSelect.className = 'custom_select_pagos';
            customSelect._pagosBound = true;
            customSelect.innerHTML = `
                <button type="button" class="custom_select_pagos_btn"></button>
                <div class="custom_select_pagos_list"></div>
            `;
            wrapper.appendChild(customSelect);

            const button = customSelect.querySelector('.custom_select_pagos_btn');
            button.addEventListener('click',(event)=>{
                event.stopPropagation();
                closeOtherPagosCustomSelects(customSelect);
                customSelect.classList.toggle('open');
            })

            select.addEventListener('change',()=>{
                syncPagosCustomSelect(select);
            })

            syncPagosCustomSelect(select);
        }

        function syncPagosCustomSelect(select){
            if(!select || select.dataset.customSelectReady !== 'true'){
                return;
            }
            const wrapper = select.closest('.cont_monedas, .cont_metodos, .cont_firmante_select');
            const customSelect = wrapper ? wrapper.querySelector('.custom_select_pagos') : null;
            if(!customSelect){
                return;
            }

            const button = customSelect.querySelector('.custom_select_pagos_btn');
            const list = customSelect.querySelector('.custom_select_pagos_list');
            const selected = select.options[select.selectedIndex];
            button.textContent = selected ? selected.textContent : '-';
            list.innerHTML = '';

            Array.from(select.options).forEach((option)=>{
                const item = document.createElement('button');
                item.type = 'button';
                item.className = 'custom_select_pagos_option';
                item.classList.toggle('active', option.value === select.value);
                item.dataset.value = option.value;
                item.textContent = option.textContent;
                item.addEventListener('click',(event)=>{
                    event.stopPropagation();
                    select.value = option.value;
                    customSelect.classList.remove('open');
                    select.dispatchEvent(new Event('change'));
                })
                list.appendChild(item);
            })
        }

        function closeOtherPagosCustomSelects(currentSelect){
            panelPagos.querySelectorAll('.custom_select_pagos.open').forEach((customSelect)=>{
                if(customSelect !== currentSelect){
                    customSelect.classList.remove('open');
                }
            })
        }

        if(panelPagos.dataset.customSelectCloseReady !== 'true'){
            panelPagos.dataset.customSelectCloseReady = 'true';
            document.addEventListener('click',()=>{
                panelPagos.querySelectorAll('.custom_select_pagos.open').forEach((customSelect)=>{
                    customSelect.classList.remove('open');
                })
            })
        }

        const inputList = [inputPago,inputDescrip,inputTicket];
        inputList.forEach((input) => {
            input.addEventListener('input',()=>{
                completePagosDic();
            })
        })

        inputRedondeo.addEventListener('input',()=>{
            dicPagos['Redondeo'] = parseLocalizedCurrencyValue(inputRedondeo.value);  
            checkEmptyKeys(dicPagos);
            sumUpPagos(dicPagos);
        })
        
        busquedas.forEach((row,i) =>{

            row.addEventListener('click',()=>{
                const buscador_miembro = panelPagos.querySelector('.buscador_miembro');
                const buscador = buscador_miembro.querySelector('.buscador');
                const searchInput = buscador_miembro.querySelector('input#search_pago');
                const busquedas = buscador_miembro.querySelectorAll('.lista_busqueda .busqueda');
                const nombre_miembro =   info_miembro.querySelector('.nombre_miembro p');
                const rama_miembro = info_miembro.querySelector('.rama_miembro');
                const rama_nombre = rama_miembro.querySelector('p');
                const idMember = row.getAttribute('data-id');
                const nombreMember = row.querySelector('p').textContent;
                const codRama = row.getAttribute('data-codrama');
                const nombreRama = row.getAttribute('data-rama');
                let masterId = idMember + '-' + nombreMember;
                if(!(masterId in dicPagos)){
                    dicPagos = {};
                    resetInputs(true);
                }

                //Completa los datos de infoMiembro
                buscador.classList.remove('mostrar');
                busquedas.forEach((row,i) =>{row.classList.remove('ocultar');})
                searchInput.value = ''; 
                info_miembro.setAttribute('data-id',idMember);
                nombre_miembro.innerHTML = nombreMember;
                if(codRama && nombreRama){
                    const ramaClass = codRama.split('-')[1].replace(/[0-9-]/g, '').toLowerCase();
                    rama_nombre.innerHTML = nombreRama;
                    rama_miembro.className = 'rama_miembro ' + ramaClass;
                }
                togglePagosMemberLock(panelPagos);

            })
        })

        categorias.forEach((categ) => {
            categ.addEventListener('click',()=>{
                const id_miembro = info_miembro.getAttribute('data-id');
                if(id_miembro){
                    showPaymentDescriptionSkeleton();
                    const categName = categ.querySelector('.nombre').innerHTML;
                    const catId = categ.getAttribute('data-id');
                    const keyId = catId + '-' + categName;

                    const nombre_miembro = info_miembro.querySelector('.nombre_miembro p').innerHTML;
                    let masterId = id_miembro + '-' + nombre_miembro;

                    inputPago.readOnly = false;
                    inputDescrip.readOnly = false;
                    inputTicket.readOnly = false;

                    if((masterId in dicPagos)){
                        if((Object.keys(dicPagos[masterId]).includes(keyId))){
                            inputPago.value = formatCurrency(dicPagos[masterId][keyId]['Value'],false);
                            inputDescrip.value = dicPagos[masterId][keyId]['Descripcion'];
                            inputTicket.value = dicPagos[masterId][keyId]['Ticket'];
                        }else{
                            resetInputs();
                        }
                    }else{
                        resetInputs();
                    }
                }
            })
        })

        let currentPagoIdemKey = null;

        function generateIdempotencyKey(){
            if(window.crypto && typeof window.crypto.randomUUID === 'function'){
                return window.crypto.randomUUID();
            }
            return 'idem-' + Date.now() + '-' + Math.random().toString(16).slice(2);
        }

        btn_recibo.addEventListener('click',()=>{
            if(!receiptPreferences.validate(panelPagos)){ return; }
            if (Object.keys(dicPagos).length > 0 && !(Object.keys(dicPagos).length === 1 && dicPagos.hasOwnProperty('Redondeo'))) {
                loader.classList.add('loading');
                if(!currentPagoIdemKey){
                    currentPagoIdemKey = generateIdempotencyKey();
                }
                if(!currentPagoIdemKey || currentPagoIdemKey === 'null' || currentPagoIdemKey === 'undefined'){
                    loader.classList.remove('loading');
                    currentPagoIdemKey = null;
                    showAlert('error','No se pudo generar una llave de seguridad para el pago');
                    return;
                }
                if(checkIfAllowedTo(dicPagos)){
                    const campos = getFieldsForPago(dicPagos);
                    // console.log(campos);
                    fetch('/api/generatePago.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Idempotency-Key': currentPagoIdemKey
                        },
                        body: JSON.stringify(campos)
                        })
                        .then(response => response.json())
                        .then(data => {
                            // console.log(data);
                            if(data['response'] == 200){
                                loader.classList.remove('loading');
                                showAlert('success','Pago Generado Correctamente');
                                successPago();
                                currentPagoIdemKey = null;
                                if(data['reciboId']){
                                    window.open('comprobante/'+data['reciboId']+'/imprimir', '_blank');
                                }
                            }else if(data['response'] == 202){
                                loader.classList.remove('loading');
                                showAlert('error','Este pago ya se está procesando, espere unos segundos');
                            }else{
                                console.error('Error en la solicitud:', data['error']);
                                if(Object.keys(data['error']).length === 0){
                                    loader.classList.remove('loading');
                                    showAlert('error','Error al Generar Pago');
                                }else{
                                    loader.classList.remove('loading');
                                    showAlert('error',data['error']);
                                }
                                currentPagoIdemKey = null;
                            }
                        })
                        .catch(error => {
                            // console.log(error);
                            loader.classList.remove('loading');
                            // console.error('Error en la solicitud:', error);
                            showAlert('error','Error al Generar Pago');
                            currentPagoIdemKey = null;
                        });
                }else{
                    loader.classList.remove('loading');
                    currentPagoIdemKey = null;
                }
            }else{
                showAlert('error','No hay Pagos Realizados');
            }
        })
  
        if(refreshCateg || refreshMember){
            completePagosDic();
        }

        await dynamicPanelPagos();

        function completePagosDic(){
            const id_miembro = info_miembro.getAttribute('data-id');
            if(id_miembro){
                const inputPago = panelPagos.querySelector('input[type="text"]#importe_ticket');
                const descripcion = panelPagos.querySelector('input#descripcion');
                const categoriaSelect = panelPagos.querySelector('.categorias.selected');
                const ticket = panelPagos.querySelector('input#num_ticket');
                const nombre_miembro = info_miembro.querySelector('.nombre_miembro p').innerHTML;
                let masterId = id_miembro + '-' + nombre_miembro;

                if(categoriaSelect){
                    const categName = categoriaSelect.querySelector('.nombre').innerHTML;
                    const catId = categoriaSelect.getAttribute('data-id');
                    const keyId = catId + '-' + categName;

                    let raw = inputPago.value.replace('$ ', '').replace(/\./g, '').replace(',', '.');
                    let value = parseFloat(raw);
                    let finalValue = value.toFixed(2); // Esto asegura que tenga siempre dos decimales
                    
                    if(!finalValue || finalValue == 'NaN'){
                        finalValue = 0;
                    }

                    categoriaSelect.setAttribute('data-value',finalValue);
                    categoriaSelect.setAttribute('data-description',descripcion.value);
                    categoriaSelect.setAttribute('data-ticket',ticket.value);
                }

                const categorias = panelPagos.querySelectorAll('.categorias:not(.agregar)');
                categorias.forEach(categoria =>{
                    const categName = categoria.querySelector('.nombre').innerHTML;
                    const catId = categoria.getAttribute('data-id');
                    const keyId = catId + '-' + categName;

                    if(!(masterId in dicPagos)){
                        dicPagos[masterId] = {};
                    }
                    if(!(Object.keys(dicPagos[masterId]).includes(keyId))){
                        dicPagos[masterId][keyId] = {};
                    }

                    const finalValue =categoria.getAttribute('data-value');
                    const descripcion = categoria.getAttribute('data-description');
                    const ticket = categoria.getAttribute('data-ticket');

                    if(finalValue){
                        dicPagos[masterId][keyId]['Value'] = finalValue;
                    }else{
                        dicPagos[masterId][keyId]['Value'] = 0;
                    }

                    if(descripcion){
                        dicPagos[masterId][keyId]['Descripcion'] = descripcion;
                    }else{
                        dicPagos[masterId][keyId]['Descripcion'] = '';
                    }

                    if(ticket){
                        dicPagos[masterId][keyId]['Ticket'] = ticket;
                    }else{
                        dicPagos[masterId][keyId]['Ticket'] = '';
                    }
                })
            }

            checkEmptyKeys(dicPagos);
            sumUpPagos(dicPagos);
            // console.log(dicPagos)
        }

        function checkIfAllowedTo(dicPagos){
            let allowed = true;
            Object.keys(dicPagos).forEach(member => {
                if(member != "Redondeo"){     
                    Object.keys(dicPagos[member]).forEach(category => {
                        const catName = category.split('-')[1];
                        if(dicPagos[member][category]['Value'] == 0 || dicPagos[member][category]['Value'] == 'NaN'){
                            allowed = false;
                            showAlert('error','Te falta el Monto de ' + catName)
                        }
                        if(dicPagos[member][category]['Ticket'] == ''){
                            allowed = false;
                            showAlert('error','Te falta el Numero de Ticket de ' + catName)
                        }
                        if(dicPagos[member][category]['Descripcion'] == ''){
                            allowed = false;
                            showAlert('error','Te falta la Descripcion de ' + catName)
                        }
                    })
                }
            })

            return allowed;
        }

        function sanitizePlainText(value){
            return String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        }

        function getFieldsForPago(dicPagos){
            let campos = {};
            const select_firmante = panelPagos.querySelector('.panel_firmante select');
            const inputTotal = panelPagos.querySelector('#valor_total_pagos');
            const select_metodo = panelPagos.querySelector('.panel_preferencias select#metodo_pago');
            let firmante = '';
            let moneda = '';
            let metodo = '';
            let monedaName = '';
            let metodoName = '';

            if(select_firmante.value){
                firmante = sanitizePlainText(select_firmante.options[select_firmante.selectedIndex].text);
            }
            if(select_moneda.options.length > 0){
                moneda = sanitizePlainText(select_moneda.value);
                monedaName = sanitizePlainText(select_moneda.options[select_moneda.selectedIndex].text);
            }
            if(select_metodo.options.length > 0){
                metodo = sanitizePlainText(select_metodo.value);
                metodoName = sanitizePlainText(select_metodo.options[select_metodo.selectedIndex].text);
            }
            
            const total = parseLocalizedCurrencyValue(inputTotal.value);
            let redondeo = dicPagos['Redondeo'];
            if(!redondeo){
                redondeo = 0;
            }
            let montoTotal = total - redondeo;// Solo los Cobros

            campos['Pagos'] = Object.fromEntries(
                Object.entries(dicPagos).filter(([key]) => key !== 'Redondeo')
            );
            
            campos['Data'] = {"Firmante":firmante,"Total":montoTotal,
                "Redondeo":redondeo,'Detalle':JSON.stringify(dicPagos),
                "Moneda":moneda,"MonedaName":monedaName,"Metodo":metodo,"MetodoName":metodoName};

            return campos;
        }

        function successPago(){
            receiptPreferences.recordActivity();
            const num_receipt = panelPagos.querySelector('.numero_recibo .num_recibo');
            const info_miembro = panelPagos.querySelector('.info_miembro');
            const nombre_miembro = info_miembro.querySelector('.nombre_miembro p');
            const rama_miembro = info_miembro.querySelector('.rama_miembro');
            const rama_nombre = rama_miembro.querySelector('p');
            const searchInput = panelPagos.querySelector('input#search_pago');

            getNextReceiptNr(num_receipt.textContent.trim());

            resetInputs(true);
            dicPagos = {};
            info_miembro.setAttribute('data-id','');
            nombre_miembro.textContent = '';
            rama_nombre.textContent = '';
            rama_miembro.className = 'rama_miembro';
            if(searchInput){
                searchInput.value = '';
            }
            togglePagosMemberLock(panelPagos);

            refreshReceiptReport();
            refreshReceiptTableList();
        }   

        function sumUpPagos(dicPagos){
            let totCobros = 0;
            const currSigne = getCurrencySigne(select_moneda.value);
            inputTotal.value = '';

            Object.keys(dicPagos).forEach(member => {
                if(member != "Redondeo"){                    
                    Object.keys(dicPagos[member]).forEach(category => {
                        let value = dicPagos[member][category]['Value'];
                        totCobros += parseFloat(value);
                        
                        const idCat = category.split('-')[0];
                        const categ = panelPagos.querySelector('.categorias[data-id="'+idCat+'"]');
                        if(categ){
                            const valor = categ.querySelector('.valor');
                            valor.innerHTML = formatCurrency(String(value),false);
                            syncCategoryValueState(categ);
                        }
                    })
                }
            })

            if (Object.keys(dicPagos).includes('Redondeo')){
                let value = dicPagos['Redondeo'];

                totCobros += parseFloat(value);
            }
            inputTotal.value = totCobros.toFixed(2);
            inputTotal.value = formatCurrencyWithSigne(inputTotal.value,currSigne,false);

            updateCategMeta();
            renderCategorySummary();
            applyCategoryFilters();
        }
        
        function checkEmptyKeys(dicPagos) {
            Object.keys(dicPagos).forEach(member => {
                if(member != "Redondeo"){     
                    Object.keys(dicPagos[member]).forEach(category => {
                        let checkDel = 0;
                        // console.log(dicPagos[member][category]);
                        if(dicPagos[member][category]['Value'] == 0 || dicPagos[member][category]['Value'] == 'NaN'){
                            checkDel += 1;
                        }
                        if(dicPagos[member][category]['Ticket'] == ''){
                            checkDel += 1;
                        }
                        if(dicPagos[member][category]['Descripcion'] == ''){
                            checkDel += 1;
                        }
                        if(checkDel == 3){
                            delete dicPagos[member][category];
                        }
                    })

                    if(Object.keys(dicPagos[member]).length == 0){
                        delete dicPagos[member];
                    }

                }else{
                    if(dicPagos['Redondeo'] == 0 || dicPagos['Redondeo'] == 'NaN'){
                        delete dicPagos['Redondeo'];
                    }
                }
            })

        }

        function resetInputs(member=false){
            inputPago.value = null;
            inputDescrip.value = null;
            inputTicket.value = null;
            if(member){
                const currSigne = getCurrencySigne(select_moneda.value);
                const categorias = panelPagos.querySelectorAll('.categorias:not(.agregar):not(.new)');
                inputRedondeo.value = `${currSigne} 0`;
                inputTotal.value = `${currSigne} 0`;
                categorias.forEach((cat) => {
                    cat.classList.remove('selected');
                    cat.removeAttribute('data-value');
                    cat.removeAttribute('data-description');
                    cat.removeAttribute('data-ticket');
                    const valor = cat.querySelector('.valor');
                    valor.innerHTML = '$ 0';
                    syncCategoryValueState(cat);
                })
                updateCategMeta();
                renderCategorySummary();
                applyCategoryFilters();
            }
        }

        // Devuelve la clave del miembro activo tal como se usa en dicPagos ("idMiembro-Nombre")
        function getCurrentMasterId(){
            const id_miembro = info_miembro.getAttribute('data-id');
            if(!id_miembro){
                return null;
            }
            const nombreEl = info_miembro.querySelector('.nombre_miembro p');
            const nombre_miembro = nombreEl ? nombreEl.innerHTML : '';
            return id_miembro + '-' + nombre_miembro;
        }

        // Pinta el resumen fijo (chips) de las categorias ya cargadas para el miembro activo
        function renderCategorySummary(){
            const summary = panelPagos.querySelector('.categ_summary');
            const scroll = panelPagos.querySelector('.categ_summary_scroll');
            const subtotalEl = panelPagos.querySelector('.subtotal_value');
            if(!summary || !scroll || !subtotalEl){
                return;
            }

            scroll.innerHTML = '';
            const masterId = getCurrentMasterId();
            const entradas = (masterId && dicPagos[masterId]) ? dicPagos[masterId] : {};
            const currSigne = getCurrencySigne(select_moneda.value);
            let subtotal = 0;
            let hayEntradas = false;

            Object.keys(entradas).forEach((keyId) => {
                const entrada = entradas[keyId];
                const value = parseFloat(entrada['Value']);
                if(!value || value <= 0){
                    return;
                }
                hayEntradas = true;
                subtotal += value;

                const catId = keyId.split('-')[0];
                const catName = keyId.slice(catId.length + 1);

                const chip = document.createElement('div');
                chip.className = 'categ_chip';
                chip.innerHTML = '<span class="chip_dot" aria-hidden="true"></span><p class="chip_name"></p><p class="chip_value"></p><div class="chip_remove" title="Quitar"><i class="fa-solid fa-xmark"></i></div>';
                chip.querySelector('.chip_dot').style.backgroundColor = categoryColorFor(catId);
                chip.querySelector('.chip_name').textContent = catName;
                chip.querySelector('.chip_value').textContent = formatCurrencyWithSigne(String(value), currSigne, false);

                chip.addEventListener('click', () => {
                    const categoria = panelPagos.querySelector('.categorias[data-id="'+catId+'"]');
                    if(categoria){
                        categoria.click();
                    }
                });
                chip.querySelector('.chip_remove').addEventListener('click', (e) => {
                    e.stopPropagation();
                    removeCategoryEntry(catId, keyId);
                });

                scroll.appendChild(chip);
            });

            summary.classList.toggle('activo', hayEntradas);
            subtotalEl.textContent = formatCurrencyWithSigne(subtotal.toFixed(2), currSigne, false);
        }

        // Quita una categoria ya cargada desde su chip en el resumen
        function removeCategoryEntry(catId, keyId){
            const masterId = getCurrentMasterId();
            if(masterId && dicPagos[masterId]){
                delete dicPagos[masterId][keyId];
                if(Object.keys(dicPagos[masterId]).length === 0){
                    delete dicPagos[masterId];
                }
            }

            const categoria = panelPagos.querySelector('.categorias[data-id="'+catId+'"]');
            if(categoria){
                categoria.removeAttribute('data-value');
                categoria.removeAttribute('data-description');
                categoria.removeAttribute('data-ticket');
                const valor = categoria.querySelector('.valor');
                if(valor){
                    valor.innerHTML = '$ 0';
                }
                syncCategoryValueState(categoria);

                if(categoria.classList.contains('selected')){
                    categoria.classList.remove('selected');
                    resetInputs();
                }
            }

            checkEmptyKeys(dicPagos);
            sumUpPagos(dicPagos);
        }
      
        async function dynamicPanelPagos(){
                const panelPagos = document.querySelector("section.panel_pagos");
                if(panelPagos){
                const select_moneda = panelPagos.querySelector('.panel_preferencias select#moneda_pago');
                const inputs = panelPagos.querySelectorAll('input[type="text"]:not(#num_ticket):not(#descripcion)');
                const cont_categorias = panelPagos.querySelector('.cont_categorias');
                const categorias = panelPagos.querySelectorAll('.categorias:not(.agregar):not(.new)');
        
                inputs.forEach(input => {
                    input.addEventListener('input', () => {
                        if(input.id == 'redondeo_pagos' || input.id == 'valor_total_pagos'){
                            const currSigne = getCurrencySigne(select_moneda.value);
                            input.value = formatCurrencyWithSigne(input.value,currSigne);
                        }else{
                            input.value = formatCurrency(input.value);
                        }
                    });
                    input.addEventListener('click',() => {
        
                        if(!input.hasAttribute('readonly')){
                            const currSigne = getCurrencySigne(select_moneda.value);
                            if (input.value == '$ 0' || input.value == `${currSigne} 0`){
                                input.value = '';
                            }
                        }
                    })
        
                    input.addEventListener('blur',() => {
                        if (input.value == ''){
                            if(input.id == 'redondeo_pagos' || input.id == 'valor_total_pagos'){
                                const currSigne = getCurrencySigne(select_moneda.value);
                                input.value = `${currSigne} 0`;
                            }else{
                                input.value = '$ 0';
                            }
                        }
                    })
                });
        
                categorias.forEach((categoria) => {
                    dynamicCategory(categoria);
                    applyCategoryTileColor(categoria);
                })
        
                dynamicSearchBar();
                dynamicAddCategory();
                dynamicCategorySearchControls();

                function dynamicCategorySearchControls(){
                    const searchInput = panelPagos.querySelector('#search_categoria_pago');
                    const clearBtn = panelPagos.querySelector('.categ_search_clear');
                    const soloConMontoBtn = panelPagos.querySelector('#toggle_solo_con_monto');

                    // Se usa una propiedad propia (no dataset) porque este bloque se clona y
                    // reemplaza al crear una categoria nueva (ver refreshCatPagosInPanel), y
                    // cloneNode copia los atributos data-* pero no las propiedades del objeto.
                    if(searchInput && searchInput._categSearchBound !== true){
                        searchInput._categSearchBound = true;

                        searchInput.addEventListener('input', () => {
                            if(clearBtn){
                                clearBtn.classList.toggle('visible', searchInput.value.length > 0);
                            }
                            applyCategoryFilters();
                        });

                        if(clearBtn){
                            clearBtn.addEventListener('click', () => {
                                searchInput.value = '';
                                clearBtn.classList.remove('visible');
                                applyCategoryFilters();
                                searchInput.focus();
                            });
                        }

                        if(soloConMontoBtn){
                            soloConMontoBtn.addEventListener('click', () => {
                                soloConMontoBtn.classList.toggle('active');
                                applyCategoryFilters();
                            });
                        }
                    }

                    updateCategMeta();
                    applyCategoryFilters();
                }
        
                function dynamicCategory(categoria){
                    categoria.addEventListener('click' , () => {
                        const info_miembro = document.querySelector('.panel_pagos .info_miembro');
                        const id_miembro = info_miembro.getAttribute('data-id');
                        if(id_miembro){
                            const categorias = panelPagos.querySelectorAll('.categorias:not(.agregar):not(.new)');
                            categorias.forEach((cat) => {cat.classList.remove('selected');})
                            categoria.classList.add('selected');
                            syncPagoCategoryNameOverflowMarquee(panelPagos);
                        }
                    })
                }
        
                function dynamicSearchBar() {
                    const buscador_miembro = panelPagos.querySelector('.buscador_miembro');
                    const buscador         = buscador_miembro.querySelector('.buscador');
                    const searchInput      = buscador_miembro.querySelector('input#search_pago');
                    const listaBusquedas   = buscador.querySelector('.lista_busqueda');
                    const busquedas        = listaBusquedas.querySelectorAll('.busqueda');
                    let busquedaActivaIndex = -1;

                    if(searchInput.searchEventsBound === true){
                        return;
                    }
                    searchInput.searchEventsBound = true;

                    // 1) Filtrar y ordenar al escribir
                    searchInput.addEventListener('input', manejarBusquedaInput);
                    searchInput.addEventListener('keydown', manejarBusquedaTeclado);

                    function manejarBusquedaInput(event) {
                        const valor = quitarAcentos(event.target.value.toLowerCase());
                        // if (!valor) {
                        // buscador.classList.remove('mostrar');
                        // return;
                        // }
                        buscador.classList.add('mostrar');

                        // 1a) Filtrado
                        busquedas.forEach(row => {
                        const texto = quitarAcentos(row.querySelector('p').textContent.toLowerCase());
                        row.classList.toggle('ocultar', texto.indexOf(valor) < 0);
                        });

                        // 1b) Orden alfabético solo de los visibles
                        const visibles = Array.from(busquedas)
                        .filter(row => !row.classList.contains('ocultar'))
                        .sort((a, b) => {
                            const ta = a.querySelector('p').textContent.trim();
                            const tb = b.querySelector('p').textContent.trim();
                            return ta.localeCompare(tb, 'es', { sensitivity: 'base' });
                        });

                        visibles.forEach(row => listaBusquedas.appendChild(row));
                        actualizarBusquedaActiva(visibles.length ? 0 : -1);
                    }

                    // 2) Al hacer click sobre el input, abrir siempre el desplegable
                    searchInput.addEventListener('click', () => {
                        buscador.classList.add('mostrar');
                        actualizarBusquedaActiva(0);
                    });

                    // 3) Evitamos que clicks dentro de buscador cierren el desplegable
                    buscador.addEventListener('click', (e) => {
                        e.stopPropagation();
                    });

                    // 5) Cerrar al click en cualquier otra parte de la página
                    document.addEventListener('click', () => {
                        resetBusquedaMiembros(false);
                    });

                    function manejarBusquedaTeclado(event) {
                        const teclasNavegacion = ['ArrowDown', 'ArrowUp', 'Enter', 'Escape'];
                        if(!teclasNavegacion.includes(event.key)){
                            return;
                        }

                        if(event.key === 'Escape'){
                            event.preventDefault();
                            resetBusquedaMiembros(false);
                            searchInput.blur();
                            return;
                        }

                        const visibles = obtenerBusquedasVisibles();
                        if(!visibles.length){
                            return;
                        }

                        if(event.key === 'ArrowDown'){
                            event.preventDefault();
                            buscador.classList.add('mostrar');
                            actualizarBusquedaActiva(busquedaActivaIndex + 1);
                            return;
                        }

                        if(event.key === 'ArrowUp'){
                            event.preventDefault();
                            buscador.classList.add('mostrar');
                            actualizarBusquedaActiva(busquedaActivaIndex - 1);
                            return;
                        }

                        if(event.key === 'Enter'){
                            event.preventDefault();
                            const index = busquedaActivaIndex >= 0 ? busquedaActivaIndex : 0;
                            visibles[index].click();
                        }
                    }

                    function obtenerBusquedasVisibles() {
                        return Array.from(listaBusquedas.querySelectorAll('.busqueda:not(.ocultar)'));
                    }

                    function actualizarBusquedaActiva(index) {
                        const visibles = obtenerBusquedasVisibles();
                        limpiarBusquedaActiva();

                        if(!visibles.length || index < 0){
                            busquedaActivaIndex = -1;
                            return;
                        }

                        busquedaActivaIndex = (index + visibles.length) % visibles.length;
                        const activa = visibles[busquedaActivaIndex];
                        activa.classList.add('activa');
                        activa.scrollIntoView({ block: 'nearest' });
                    }

                    function limpiarBusquedaActiva() {
                        busquedas.forEach(row => row.classList.remove('activa'));
                        busquedaActivaIndex = -1;
                    }

                    function resetBusquedaMiembros(clearInput = true) {
                        buscador.classList.remove('mostrar');
                        if(clearInput){
                            searchInput.value = '';
                        }
                        busquedas.forEach(row => {
                            row.classList.remove('ocultar', 'activa');
                            listaBusquedas.appendChild(row);
                        });
                        busquedaActivaIndex = -1;
                    }
                }

                // Alta de categoria: el tile "Nueva categoria" abre el popup compartido (openCategoryComposer)
                async function dynamicAddCategory(){
                    const btn_add = panelPagos.querySelector('.info_categorias .categorias.agregar');
                    if(!btn_add){
                        return;
                    }
                    btn_add.addEventListener('click',()=>{
                        openCategoryComposer({
                            returnFocus: btn_add,
                            onCreated: (intId, name, icon) => {
                                const newCategory = createCategoryTile(intId, name, icon);
                                cont_categorias.insertBefore(newCategory, btn_add);
                                newCategory.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                                refreshCatPagosInConfig(name,intId,icon);
                                refreshCatPagosListCaja(name,intId);
                            }
                        });
                    });

                    function createCategoryTile(intId, name, icono){
                        const newCategory = document.createElement('DIV');
                        const dot = document.createElement('DIV');
                        const dotIcon = document.createElement('I');
                        const tile = document.createElement('DIV');
                        const nombre = document.createElement('P');
                        const valor = document.createElement('P');
                        const badge = document.createElement('SPAN');

                        newCategory.classList.add('categorias','recien_creada');
                        newCategory.title = name;
                        newCategory.setAttribute('data-id',intId);
                        newCategory.setAttribute('data-icono',icono);

                        dot.classList.add('valor_dot');
                        dot.setAttribute('aria-hidden','true');
                        dotIcon.classList.add('fa-solid','fa-check');
                        dot.appendChild(dotIcon);

                        tile.classList.add('tile_icon');
                        tile.setAttribute('aria-hidden','true');
                        tile.innerHTML = buildIconsaxSvgMarkup(icono);

                        nombre.classList.add('nombre');
                        nombre.textContent = name;
                        valor.classList.add('valor');
                        valor.textContent = '$ 0';

                        badge.classList.add('badge_nueva');
                        badge.textContent = 'Nueva';

                        newCategory.append(badge, dot, tile, nombre, valor);
                        // La marca de "Nueva" se va sola despues de unos segundos
                        setTimeout(() => newCategory.classList.remove('recien_creada'), 6000);

                        dynamicCategory(newCategory);
                        applyCategoryTileColor(newCategory);
                        newCategory.addEventListener('click',()=>{
                            newCategory.classList.remove('recien_creada');
                            const id_miembro = info_miembro.getAttribute('data-id');
                            if(id_miembro){
                                showPaymentDescriptionSkeleton();
                                const categName = newCategory.querySelector('.nombre').innerHTML;
                                const catId = newCategory.getAttribute('data-id');
                                const keyId = catId + '-' + categName;

                                const nombre_miembro = info_miembro.querySelector('.nombre_miembro p').innerHTML;
                                let masterId = id_miembro + '-' + nombre_miembro;

                                inputPago.readOnly = false;
                                inputDescrip.readOnly = false;
                                inputTicket.readOnly = false;

                                if((masterId in dicPagos)){
                                    if((Object.keys(dicPagos[masterId]).includes(keyId))){
                                        inputPago.value = formatCurrency(dicPagos[masterId][keyId]['Value'],false);
                                        inputDescrip.value = dicPagos[masterId][keyId]['Descripcion'];
                                        inputTicket.value = dicPagos[masterId][keyId]['Ticket'];
                                    }else{
                                        resetInputs();
                                    }
                                }else{
                                    resetInputs();
                                }
                            }
                        });

                        // Se agregan al DOM despues de insertarla: syncs que dependen de medir la tarjeta
                        requestAnimationFrame(() => {
                            syncPagoCategoryNameOverflowMarquee(panelPagos);
                            updateCategMeta();
                            applyCategoryFilters();
                        });
                        return newCategory;
                    }
                }
                
            }
        }
        
    }
}

// Popup (<dialog> modal) para crear una categoria de pago: nombre + icono con vista previa.
// El icono se sugiere solo segun el nombre (findMatchingIcon) hasta que el usuario elige uno a mano.
// Se usa desde Pagos (tile "Nueva categoria") y desde Ajustes > General > Categorias;
// cada uno decide que hacer con la categoria creada en onCreated(intId, nombre, icono).
let activeCategoryComposer = null;
function openCategoryComposer({ onCreated, returnFocus = null } = {}){
    if(activeCategoryComposer){
        return;
    }
    const icons = getIconsaxIcons();
    const quickSlugs = CATEG_QUICK_ICONS.filter((slug) => icons[slug]);
    let manualIcon = null;
    let saving = false;

    const composer = document.createElement('DIALOG');
    activeCategoryComposer = composer;
    composer.className = 'categ_composer_dialog';
    composer.setAttribute('aria-labelledby','categ_composer_title');
    composer.innerHTML = `
        <div class="categ_composer">
        <div class="composer_preview">
            <p class="composer_kicker">Vista previa</p>
            <div class="composer_tile" aria-hidden="true">
                <div class="tile_icon"></div>
                <p class="nombre placeholder">Nombre</p>
                <p class="valor">$ 0</p>
            </div>
            <p class="composer_note">El color se asigna al crearla.</p>
        </div>
        <div class="composer_form">
            <div class="composer_head">
                <h3 id="categ_composer_title">Nueva categoría</h3>
                <button type="button" class="composer_close" aria-label="Cancelar"><i class="fa-solid fa-xmark"></i></button>
            </div>
            <div class="composer_field">
                <div class="composer_label_row">
                    <label for="categ_composer_nombre">Nombre</label>
                    <span class="composer_count">0/40</span>
                </div>
                <input type="text" id="categ_composer_nombre" class="composer_input" maxlength="40" autocomplete="off" placeholder="Ej: Campamento de verano" aria-describedby="categ_composer_help">
                <p class="composer_help" id="categ_composer_help" aria-live="polite"></p>
            </div>
            <div class="composer_field">
                <div class="composer_label_row start">
                    <span class="composer_label">Ícono</span>
                    <span class="composer_mode">Automático</span>
                    <button type="button" class="composer_reset">Volver al automático</button>
                </div>
                <div class="composer_icons" role="radiogroup" aria-label="Ícono de la categoría"></div>
                <button type="button" class="composer_more" aria-expanded="false">Ver todos los íconos</button>
                <div class="composer_all" hidden>
                    <div class="composer_all_search">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        <input type="text" placeholder="Buscar ícono..." aria-label="Buscar ícono">
                    </div>
                    <div class="composer_all_grid"></div>
                    <p class="composer_all_empty" hidden>No hay íconos que coincidan</p>
                </div>
            </div>
            <div class="composer_footer">
                <p class="composer_keys"><kbd>Enter</kbd> crear · <kbd>Esc</kbd> cancelar</p>
                <div class="composer_actions">
                    <button type="button" class="composer_cancel">Cancelar</button>
                    <button type="button" class="composer_submit" disabled><i class="fa-solid fa-check"></i><span>Crear categoría</span></button>
                </div>
            </div>
        </div>
        </div>`;

    const input = composer.querySelector('.composer_input');
    const count = composer.querySelector('.composer_count');
    const help = composer.querySelector('.composer_help');
    const previewIcon = composer.querySelector('.composer_tile .tile_icon');
    const previewName = composer.querySelector('.composer_tile .nombre');
    const modeTag = composer.querySelector('.composer_mode');
    const resetBtn = composer.querySelector('.composer_reset');
    const iconsRow = composer.querySelector('.composer_icons');
    const moreBtn = composer.querySelector('.composer_more');
    const allPanel = composer.querySelector('.composer_all');
    const allSearch = allPanel.querySelector('input');
    const allGrid = allPanel.querySelector('.composer_all_grid');
    const allEmpty = allPanel.querySelector('.composer_all_empty');
    const submitBtn = composer.querySelector('.composer_submit');
    const submitLabel = submitBtn.querySelector('span');

    // Primer boton "comodin": muestra el icono sugerido/elegido cuando no esta entre los rapidos
    const extraBtn = buildIconOption('tag-2');
    extraBtn.classList.add('extra');
    iconsRow.appendChild(extraBtn);
    const quickBtns = quickSlugs.map((slug) => {
        const btn = buildIconOption(slug);
        iconsRow.appendChild(btn);
        return btn;
    });
    let allOptions = null;

    function buildIconOption(slug){
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'composer_icon';
        btn.setAttribute('role','radio');
        setIconOption(btn, slug);
        btn.addEventListener('click', () => {
            manualIcon = btn.dataset.slug;
            update();
        });
        return btn;
    }

    function setIconOption(btn, slug){
        const label = icons[slug] ? icons[slug].Label : slug;
        btn.dataset.slug = slug;
        btn.title = label;
        btn.setAttribute('aria-label', label);
        btn.innerHTML = buildIconsaxSvgMarkup(slug);
    }

    function getDuplicate(name){
        const term = quitarAcentos(name.toLowerCase());
        if(!term){
            return null;
        }
        // Se compara contra las categorias de Pagos y de Ajustes (las que esten en pantalla)
        const nombres = Array.from(document.querySelectorAll('.panel_categorias .categorias:not(.agregar) .nombre'))
            .map((n) => n.textContent.trim())
            .concat(Array.from(document.querySelectorAll('.contenido_categorias .categ_general[data-id] .nombre_categ input'))
                .map((n) => n.value.trim()));
        return nombres.find((n) => quitarAcentos(n.toLowerCase()) === term) || null;
    }

    function update(){
        const name = input.value.trim();
        const suggested = findMatchingIcon(name);
        const icon = manualIcon || suggested || 'tag-2';
        const duplicate = getDuplicate(name);

        count.textContent = input.value.length + '/40';
        previewName.textContent = name || 'Nombre';
        previewName.classList.toggle('placeholder', !name);
        if(previewIcon.dataset.slug !== icon){
            previewIcon.dataset.slug = icon;
            previewIcon.innerHTML = buildIconsaxSvgMarkup(icon);
        }

        composer.querySelector('.categ_composer').classList.toggle('duplicada', !!duplicate);
        input.setAttribute('aria-invalid', duplicate ? 'true' : 'false');
        help.className = 'composer_help';
        if(duplicate){
            help.classList.add('error');
            help.innerHTML = '<i class="fa-solid fa-circle-exclamation"></i>';
            help.append('Ya existe una categoría llamada “' + duplicate + '”.');
        }else if(suggested && !manualIcon){
            help.classList.add('sugerencia');
            help.innerHTML = '<i class="fa-solid fa-wand-magic-sparkles"></i>';
            help.append('Ícono sugerido por el nombre: ');
            const strong = document.createElement('strong');
            strong.textContent = icons[suggested] ? icons[suggested].Label : suggested;
            help.appendChild(strong);
        }else{
            help.textContent = 'Usá un nombre corto: así aparece en la tarjeta y en el recibo.';
        }

        modeTag.textContent = manualIcon ? 'Elegido' : 'Automático';
        modeTag.classList.toggle('manual', !!manualIcon);
        resetBtn.hidden = !manualIcon;

        const showExtra = !quickSlugs.includes(icon);
        extraBtn.hidden = !showExtra;
        if(showExtra && extraBtn.dataset.slug !== icon){
            setIconOption(extraBtn, icon);
        }
        [extraBtn].concat(quickBtns).forEach((btn) => {
            const slug = btn.dataset.slug;
            btn.classList.toggle('active', slug === icon);
            btn.classList.toggle('sugerido', slug === suggested && slug !== icon);
            btn.setAttribute('aria-checked', slug === icon ? 'true' : 'false');
        });
        if(allOptions){
            allOptions.forEach((opt) => opt.el.classList.toggle('active', opt.slug === icon));
        }

        submitBtn.disabled = saving || !name || !!duplicate;
        submitLabel.textContent = saving ? 'Creando…' : 'Crear categoría';
        return { name, icon, duplicate };
    }

    function buildAllIcons(){
        allOptions = Object.keys(icons).map((slug) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'composer_icon';
            setIconOption(btn, slug);
            btn.addEventListener('click', () => {
                manualIcon = slug;
                update();
            });
            allGrid.appendChild(btn);
            return { slug, label: quitarAcentos(icons[slug].Label.toLowerCase()), el: btn };
        });
    }

    function closeComposer(){
        if(activeCategoryComposer !== composer){
            return;
        }
        composer.close();
        composer.remove();
        activeCategoryComposer = null;
        setPageScrollLocked(false);
        if(returnFocus){
            returnFocus.focus({ preventScroll: true });
        }
    }

    async function submit(){
        const { name, icon, duplicate } = update();
        if(saving || !name || duplicate){
            if(duplicate){
                input.focus();
            }
            return;
        }
        saving = true;
        update();
        const addCat = await addPaymentCategory(name, icon);
        saving = false;
        if(addCat){
            closeComposer();
            if(onCreated){
                onCreated(addCat, name, icon);
            }
        }else{
            // El alerta general queda detras del popup, asi que el error se muestra aca tambien
            update();
            help.className = 'composer_help error';
            help.innerHTML = '<i class="fa-solid fa-circle-exclamation"></i>';
            help.append('No se pudo crear la categoría. Probá de nuevo.');
            input.focus();
        }
    }

    input.addEventListener('input', update);
    input.addEventListener('keydown', (e) => {
        if(e.key === 'Enter'){
            e.preventDefault();
            submit();
        }
    });
    // Esc dispara "cancel" en el <dialog>: se cierra por closeComposer (o no, si esta guardando)
    composer.addEventListener('cancel', (e) => {
        e.preventDefault();
        if(!saving){
            closeComposer();
        }
    });
    // Click en el fondo oscuro: cierra solo si no se escribio nada, para no perder lo cargado
    composer.addEventListener('click', (e) => {
        if(e.target === composer && !saving && !input.value.trim()){
            closeComposer();
        }
    });
    resetBtn.addEventListener('click', () => {
        manualIcon = null;
        update();
    });
    moreBtn.addEventListener('click', () => {
        const abrir = allPanel.hidden;
        if(abrir && !allOptions){
            buildAllIcons();
            update();
        }
        allPanel.hidden = !abrir;
        moreBtn.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        moreBtn.textContent = abrir ? 'Ocultar íconos' : 'Ver todos los íconos';
        if(abrir){
            allSearch.focus({ preventScroll: true });
        }
    });
    allSearch.addEventListener('input', () => {
        const term = quitarAcentos(allSearch.value.trim().toLowerCase());
        let visibles = 0;
        allOptions.forEach((opt) => {
            const visible = !term || opt.label.indexOf(term) !== -1 || opt.slug.indexOf(term) !== -1;
            opt.el.hidden = !visible;
            if(visible){
                visibles += 1;
            }
        });
        allEmpty.hidden = visibles !== 0;
    });
    allSearch.addEventListener('keydown', (e) => {
        if(e.key === 'Enter'){
            e.preventDefault();
        }
    });
    composer.querySelector('.composer_close').addEventListener('click', closeComposer);
    composer.querySelector('.composer_cancel').addEventListener('click', closeComposer);
    submitBtn.addEventListener('click', submit);

    document.body.appendChild(composer);
    update();
    setPageScrollLocked(true);
    composer.showModal();
    input.focus();
}

// Bloquea el scroll de la pagina de fondo mientras hay un popup abierto. Se compensa el ancho
// de la barra de scroll para que el contenido no "salte" hacia la derecha al ocultarla.
function setPageScrollLocked(locked){
    const html = document.documentElement;
    if(locked){
        const scrollbarWidth = window.innerWidth - html.clientWidth;
        if(scrollbarWidth > 0){
            document.body.style.paddingRight = scrollbarWidth + 'px';
        }
        html.classList.add('scroll_bloqueado');
    }else{
        html.classList.remove('scroll_bloqueado');
        document.body.style.paddingRight = '';
    }
}

async function addPaymentCategory(nombre, icono='tag-2') {
    const campos = { 'Categoria': nombre, 'Icono': icono };

    try {
        const response = await fetch('/api/createPaymentCategory.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(campos)
        });

        const data = await response.json();

        // console.log(data);

        if (data['response'] == 200) {
            showAlert('success', 'Categoría Creada Correctamente');
            return data['IntId'];
        } else {
            console.error('Error en la solicitud:', data['error']);
            if (Object.keys(data['error']).length === 0) {
                showAlert('error', 'Error al Crear Categoría');
            } else {
                showAlert('error', data['error']);
            }
            return false;
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
        showAlert('error', 'Error al Crear Categoría');
        return false;
    }
}

async function dynamicZClosureConfigTable() {
    const panel_cierre = document.querySelector('.panel_config .config_cierres');
    if(panel_cierre){
        const lista_cierres = panel_cierre.querySelector('.lista_cierres');
        const select_period = panel_cierre.querySelector('.selector_mes_cierre select');
        const loader = lista_cierres.querySelector('.cont_loader');
        const closures = lista_cierres.querySelectorAll('.row_cierre:not(.header_cierre)');
        const searchBox = panel_cierre.querySelector('.buscador_cierres input');

        let saveRows = {};
        const valueSelect = select_period.value;
        saveRows[valueSelect] = closures;
        
        if(closures.length > 0){
            tableSearchZClosure();
        }
        sortZClosureList();

        select_period.addEventListener('change', async () => {
            let appendRows = [];
            loader.classList.add('loading');
            //if (Object.keys(saveRows).includes(select_period.value)) {
            if (false) {
                appendRows = saveRows[select_period.value];
            } else {
                const newRows = await getZClosureFromPeriod(select_period.value);

                for (const closure of Object.values(newRows)) {
                    const currSigne = getCurrencySigne(closure.Currency);
                    const rowHtml = `
                        <div class="row_cierre">
                            <div class="campo campo_internal" style="display: none;">
                                <p>${closure.internalId}</p>
                            </div>
                            <div class="campo campo_nombre" title="${closure.Codigo}">
                                <p>${closure.Codigo}</p>
                            </div>
                            <div class="campo campo_fecha" title="${closure.FechaF}">
                                <p>${closure.FechaF}</p>
                            </div>
                            <div class="campo campo_monto ingreso">
                                <p>${formatCurrencySigne(closure.MontoIngresos,currSigne)}</p>
                            </div>
                            <div class="campo campo_monto egreso">
                                <p>${formatCurrencySigne(closure.MontoEgresos,currSigne)}</p>
                            </div>
                            <div class="campo campo_monto cierre">
                                <p>${formatCurrencySigne(closure.MontoCierre,currSigne)}</p>
                            </div>
                            <div class="campo campo_firmante" title="${closure.Firmante}">
                                <p>${closure.Firmante}</p>
                            </div>
                        </div>
                    `;

                    const finalRow = document.createElement('div');
                    finalRow.innerHTML = rowHtml.trim();
                    const rowElement = finalRow.firstChild;
                    appendRows.push(rowElement);
                }

                saveRows[select_period.value] = appendRows; // opcional, si querés cachearlo
            }

            // console.log(appendRows);
            const headerRow = lista_cierres.querySelector(".row_cierre.header_cierre");
            const bodyClose = lista_cierres.querySelector(".body_cierre");
            lista_cierres.innerHTML = '';
            bodyClose.innerHTML = '';
            if(headerRow){
                lista_cierres.appendChild(headerRow);
            }
            lista_cierres.appendChild(bodyClose);

            if(appendRows.length > 0){
                appendRows.forEach(el => bodyClose.appendChild(el));
                tableSearchZClosure();
                searchBox.dispatchEvent(new Event('input'));
                sortNewZClosureList();

            }else{
                const emptyMessage = document.createElement('div');
                const message = document.createElement('p');

                emptyMessage.classList.add('emptyMessage');
                message.classList.add('message');
                message.textContent = "No se encontraron Cierres de este mes en la base";

                emptyMessage.appendChild(message);
                lista_cierres.appendChild(emptyMessage);
            }
            lista_cierres.appendChild(loader);
            loader.classList.remove('loading');

        });
        
    }
}

function sortNewZClosureList(){
    const sort_fecha = document.querySelector('.btn_sort_cierre.sort_fecha');

    if(sort_fecha){
        sort_fecha.classList.add('asc');
        sort_fecha.click();
    }
}

async function getZClosureFromPeriod(period){

    try {
        const response = await fetch('/api/getZClosureFromPeriod.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({'Period':period})
        });

        const data = await response.json();

        if (data['response'] == 200) {
            return data['data'];
        } else {
            console.error('Error en la solicitud:', data['error']);
            // if (Object.keys(data['error']).length === 0) {
            //     console.log('Error al Obtener Cierres');
            // } else {
            //     console.log(data['error']);
            // }
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

async function dynamicReceiptConfigTable() {
    const panel_recibos = document.querySelector('.panel_config .config_recibos');
    if(panel_recibos){
        const lista_recibos = panel_recibos.querySelector('.lista_recibos');
        const select_period = panel_recibos.querySelector('.selector_mes_recibo select');
        const loader = lista_recibos.querySelector('.cont_loader');
        const receipts = lista_recibos.querySelectorAll('.row_recibo:not(.header_recibo)');
        const searchBox = panel_recibos.querySelector('.buscador_recibos input');

        let saveRows = {};
        const valueSelect = select_period.value;
        saveRows[valueSelect] = receipts;

        if(receipts.length > 0){
            await activeReceiptTableActions(true);
            tableSearchReceipts();
        }
        sortReceiptList();

        select_period.addEventListener('change', async () => {
            let appendRows = [];
            loader.classList.add('loading');
            // if (Object.keys(saveRows).includes(select_period.value)) {
            if (false) {
                appendRows = saveRows[select_period.value];
            } else {
                const newRows = await getReceiptFromPeriod(select_period.value);
        
                for (const receipt of Object.values(newRows)) {
                    const currSigne = getCurrencySigne(receipt.Currency);
                    const payMethodName = escapeReceiptTooltipText(receipt.PayMethodName || 'Sin metodo');
                    let detalleHtml = '';
                    for (const member in receipt.Detalle) {
                        if (member !== 'Redondeo') {
                            const memberName = member.split('-')[1];
                            detalleHtml += `<p title="${memberName}">${memberName}</p>`;
                        }
                    }

                    const totalAmount = (parseFloat(receipt.MontoTotal) + parseFloat(receipt.Redondeo)).toFixed(2);
                    const rowHtml = `
                        <div class="row_recibo ${receipt.Anulado}">
                            <div class="campo campo_internal" style="display: none;">
                                <p>${receipt.internalId}</p>
                            </div>
                            <div class="campo campo_type" style="display: none;">
                                 <p>${receipt.Tipo}</p>
                            </div>
                            <div class="campo campo_cierre">
                                <div class="circulo_cierre ${receipt.CierreZ} ${receipt.Anulado}"></div>
                            </div>
                            <div class="campo campo_nombre" title="${receipt.CodRecibo}">
                                <p>${receipt.CodRecibo}</p>
                            </div>
                            <div class="campo campo_fecha" title="${receipt.Fecha}">
                                <p>${receipt.FechaF}</p>
                            </div>
                            <div class="campo campo_total">
                                <p tabindex="0">
                                    ${formatCurrencySigne(totalAmount,currSigne)}
                                    <span class="metodo_pago_tooltip">Metodo: ${payMethodName}</span>
                                </p>
                            </div>
                            <div class="campo campo_rama">
                                ${detalleHtml}
                            </div>
                            <div class="campo ver_recibo" title="Ver Comprobante"><img src="/build/img/icono_ver.svg" alt=""></div>
                            <div class="campo imprimir_recibo" title="Imprimir Comprobante"><img src="/build/img/icono_imprimir.svg" alt=""></div>
                            ${receipt.Anulado === 'no_anulado' && receipt.CierreZ === 'abierto' ? `
                                <div class="campo anular_recibo" title="Anular Comprobante">
                                    <i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i>
                                </div>` : `
                                <div class="campo invalido_anular" >
                                    <i class="fa-solid fa-square-xmark fa-xl" style="color:rgb(82, 82, 82);"></i>
                                </div>`
                            }
                        </div>
                    `;
                
                    const finalRow = document.createElement('div');
                    finalRow.innerHTML = rowHtml.trim();
                    const rowElement = finalRow.firstChild;
                    appendRows.push(rowElement);
                }
                
                saveRows[select_period.value] = appendRows; // opcional, si querés cachearlo
            }

            // console.log(appendRows);
            const headerRow = lista_recibos.querySelector(".row_recibo.header_recibo");
            const bodyReceipt = lista_recibos.querySelector(".body_recibo");
            lista_recibos.innerHTML = '';
            bodyReceipt.innerHTML = '';
            if(headerRow){
                lista_recibos.appendChild(headerRow);
            }
            lista_recibos.appendChild(bodyReceipt);
            if(appendRows.length > 0){
                appendRows.forEach(el => bodyReceipt.appendChild(el));
                await activeReceiptTableActions(); // si necesitás reactivar eventos
                tableSearchReceipts();
                searchBox.dispatchEvent(new Event('input'));
                sortNewReceiptList();

            }else{
                const emptyMessage = document.createElement('div');
                const message = document.createElement('p');

                emptyMessage.classList.add('emptyMessage');
                message.classList.add('message');
                message.textContent = "No se encontraron Comprobantes de este mes en la base";

                emptyMessage.appendChild(message);
                lista_recibos.appendChild(emptyMessage);
            }
            lista_recibos.appendChild(loader);
            loader.classList.remove('loading');

        });
        
    }
}

async function activeReceiptTableActions(first = false) {
    const panel_recibos = document.querySelector('.panel_config .config_recibos');
    if (panel_recibos) {
        const lista_recibos = panel_recibos.querySelector('.lista_recibos');
        const receipts = lista_recibos.querySelectorAll('.row_recibo:not(.header_recibo)');

        receipts.forEach((receipt) => {
            const ver = receipt.querySelector('.ver_recibo');
            const imprimir = receipt.querySelector('.imprimir_recibo');
            const anular = receipt.querySelector('.anular_recibo');

            const handleAnularClick = async () => anularRecibo(receipt);
            const handleVerClick = async () => verRecibo(receipt);
            const handleImprimirClick = async () => imprimirRecibo(receipt);

            if (!first) {
                if (anular && anular._handleAnularClick) {
                    anular.removeEventListener('click', anular._handleAnularClick);
                }
                if (ver && ver._handleVerClick) {
                    ver.removeEventListener('click', ver._handleVerClick);
                }
                if (imprimir && imprimir._handleImprimirClick) {
                    imprimir.removeEventListener('click', imprimir._handleImprimirClick);
                }
            }

            if (anular) {
                anular._handleAnularClick = handleAnularClick;
                anular.addEventListener('click', handleAnularClick);
            }

            if (ver) {
                ver._handleVerClick = handleVerClick;
                ver.addEventListener('click', handleVerClick);
            }

            if (imprimir) {
                imprimir._handleImprimirClick = handleImprimirClick;
                imprimir.addEventListener('click', handleImprimirClick);
            }
        });
    }
}

async function anularRecibo(receipt){
    const panel_recibos = document.querySelector('.panel_config .config_recibos');
    const lista_recibos = panel_recibos.querySelector('.lista_recibos');
    const loader = lista_recibos.querySelector('.cont_loader');
    const formAnular = document.querySelector('.form_recibo_indv');
    const legend = formAnular.querySelector('.anular_recibo .legend_delete');
    const btn_submit = formAnular.querySelector('.btn_submit.anular');
    const btn_x = formAnular.querySelector('.btn_x');
    const layout = document.querySelector('.layout');
    const intId = receipt.querySelector('.campo_internal p');
    const code = receipt.querySelector('.campo_nombre p');
    const type = receipt.querySelector('.campo_type p');
    let allowed = true;

    formAnular.classList.add('mostrar');
    formAnular.classList.remove('ocultar'); 
    layout.classList.add('mostrar');
    legend.innerHTML += code.innerHTML + '?';

    btn_submit.addEventListener('click',() => {
        // console.log(allowed);
        if(allowed){
            loader.classList.add('loading');
            fetch('/api/receiptAnnulation.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({'InternalId':intId.textContent,'Type':type.textContent})
                })
                .then(response => response.json())
                .then(data => {
                    // console.log(data);
                    if(data['response'] == 200){
                        successAnnulation(receipt)
                    }else{
                        console.error('Error en la solicitud:', data['error']);
                        if(Object.keys(data['error']).length === 0){
                            showAlert('error','Error al Anular Recibo');
                        }else{
                            showAlert('error',data['error']);
                        }
                    }
                    loader.classList.remove('loading');
                })
                .catch(error => {
                    // console.log(error);
                    // console.error('Error en la solicitud:', error);
                    showAlert('error','Error al Anular Recibo');
                    loader.classList.remove('loading');
                });

        }
    })

    btn_x.addEventListener("click",()=>{
        if(formAnular.classList.contains('mostrar')){
            formAnular.classList.remove('mostrar');
            formAnular.classList.add('ocultar');
            layout.classList.remove('mostrar');
            raiseReceiptFields();
        }
    })
    layout.addEventListener("click",()=>{
        if(formAnular.classList.contains('mostrar')){
            formAnular.classList.remove('mostrar');
            formAnular.classList.add('ocultar');
            layout.classList.remove('mostrar');
            raiseReceiptFields();
        }
    })

    function raiseReceiptFields(){
        legend.innerHTML = '¿Desea Anular el Comprobante: ';
        allowed = false;
    }
        
    function successAnnulation(receipt){
        const anular = receipt.querySelector('.anular_recibo');
        const circulo = receipt.querySelector('.campo_cierre .circulo_cierre');
        const colorAnular = anular.querySelector('i');

        showAlert('success','Comprobante Anulado Correctamente');

        anular.removeEventListener('click', anular._handleAnularClick);
        anular.classList.remove('anular_recibo');
        anular.classList.add('invalido_anular');
       
        colorAnular.style.color = 'rgb(82, 82, 82)';
        circulo.classList.add('anulado');
        receipt.classList.add('anulado');

        formAnular.classList.remove('mostrar');
        formAnular.classList.add('ocultar');
        layout.classList.remove('mostrar');
        raiseReceiptFields();

        refreshReceiptReport();
    }
}

async function verRecibo(receipt){
    const intId = receipt.querySelector('.campo_internal p').textContent;
    if(intId){
        window.open('comprobante/'+intId+'/ver', '_blank');
    }
}

async function imprimirRecibo(receipt){
    const intId = receipt.querySelector('.campo_internal p').textContent;
    if(intId){
        window.open('comprobante/'+intId+'/imprimir', '_blank');
    }
}

function sortNewReceiptList(){
    const sort_fecha = document.querySelector('.btn_sort_recibo.sort_fecha');

    if(sort_fecha){
        sort_fecha.classList.remove('desc');
        sort_fecha.click();
    }
}

async function getReceiptFromPeriod(period){

    try {
        const response = await fetch('/api/getReceiptFromPeriod.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({'Period':period})
        });

        const data = await response.json();

        if (data['response'] == 200) {
            return data['data'];
        } else {
            console.error('Error en la solicitud:', data['error']);
            // if (Object.keys(data['error']).length === 0) {
            //     console.log('Error al Obtener Recibos');
            // } else {
            //     console.log(data['error']);
            // }
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

async function getZClosureSyncVersion(){
    try {
        const response = await fetch('/api/getZClosureSyncVersion.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({'Filters':''})
        });

        const data = await response.json();
        if (data['response'] == 200) {
            return data['data'];
        } else {
            console.error('Error en la solicitud:', data['error']);
            // if (Object.keys(data['error']).length === 0) {
            //     console.log('Error al Obtener Recibos');
            // } else {
            //     console.log(data['error']);
            // }
            return false;
        }
    } catch (error) {
        console.error(error);
        return false;
    }
}

async function getLastClosureAmount(currency){
    try {
        const response = await fetch('/api/getLastClosureAmount.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({'Currency':currency})
        });

        const data = await response.json();
        if (data['response'] == 200) {
            return data['data'];
        } else {
            console.error('Error en la solicitud:', data['error']);
            // if (Object.keys(data['error']).length === 0) {
            //     console.log('Error al Obtener Recibos');
            // } else {
            //     console.log(data['error']);
            // }
            return 0;
        }
    } catch (error) {
        console.error(error);
        return 0;
    }
}

async function getReceiptFromFilters(filters){
    // console.log(filters);
    try {
        const response = await fetch('/api/getReceiptFromFilters.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({'Filters':filters})
        });

        const data = await response.json();
        if (data['response'] == 200) {
            return data['data'];
        } else {
            console.error('Error en la solicitud:', data['error']);
            // if (Object.keys(data['error']).length === 0) {
            //     console.log('Error al Obtener Recibos');
            // } else {
            //     console.log(data['error']);
            // }
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

function initCajaCurrencySelector(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(!panel_caja){
        return;
    }

    const select_moneda = panel_caja.querySelector('.cont_monedas select#moneda_caja');
    const selector_moneda = panel_caja.querySelector('.cont_monedas .selector_moneda_caja');
    const lista_monedas = panel_caja.querySelector('.cont_monedas .lista_monedas_caja');
    const filtro_caja_diaria = panel_caja.querySelector('.contenido_filtros .filtro_caja_diaria input');
    if(!select_moneda || !selector_moneda || !lista_monedas){
        return;
    }

    const getCurrenciesWithReceipts = () => {
        const currencies = new Set();
        panel_caja.querySelectorAll('.caja_diaria tr[data-currency]').forEach((row) => {
            currencies.add(row.getAttribute('data-currency'));
        });
        return currencies;
    };

    const renderCurrencyOptions = () => {
        lista_monedas.innerHTML = '';
        const savedIndicators = panel_caja.dataset.currencyReceiptIndicators
            ? JSON.parse(panel_caja.dataset.currencyReceiptIndicators)
            : null;
        const currenciesWithReceipts = savedIndicators ? new Set(savedIndicators) : getCurrenciesWithReceipts();
        const showReceiptIndicator = !filtro_caja_diaria || filtro_caja_diaria.checked;

        [...select_moneda.options].forEach((option) => {
            const optionItem = document.createElement('button');
            optionItem.type = 'button';
            optionItem.classList.add('opcion_moneda_caja');
            optionItem.setAttribute('data-value', option.value);
            optionItem.textContent = option.textContent;

            if(option.value === select_moneda.value){
                optionItem.classList.add('active');
            }
            if(showReceiptIndicator && currenciesWithReceipts.has(option.value)){
                optionItem.classList.add('has-receipts');
            }

            optionItem.addEventListener('click', () => {
                if(select_moneda.value === option.value){
                    return;
                }

                select_moneda.value = option.value;
                select_moneda.dispatchEvent(new Event('change'));
            });

            lista_monedas.appendChild(optionItem);
        });
    };

    if(select_moneda.dataset.customListReady !== 'true'){
        select_moneda.dataset.customListReady = 'true';
        select_moneda.addEventListener('change', renderCurrencyOptions);
    }

    renderCurrencyOptions();
}

function initCajaPaymentMethodSelector(){
    const panel = document.querySelector('.panel_cajadiaria');
    const list = panel && panel.querySelector('.lista_metodos_caja');
    if(!list){ return; }
    const currentCaja = panel.querySelector('#check_caja').checked;
    list.hidden = !currentCaja;
    const methods = Array.from(panel.querySelectorAll('.select_filtro.metodo .opciones_metodo:not(.all)'));
    if(!methods.some(method => method.id === panel.dataset.currentCashMethod)){
        panel.dataset.currentCashMethod = '';
    }
    const selected = panel.dataset.currentCashMethod || '';
    list.innerHTML = '';
    [{id: '', textContent: 'Todos'}, ...methods].forEach(method => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'opcion_metodo_caja';
        button.dataset.value = method.id;
        button.textContent = method.textContent;
        button.classList.toggle('active', selected === method.id);
        button.setAttribute('aria-pressed', String(selected === method.id));
        button.addEventListener('click', () => {
            panel.dataset.currentCashMethod = method.id;
            initCajaPaymentMethodSelector();
            panel.dispatchEvent(new Event('caja-method-change'));
        });
        list.appendChild(button);
    });
}

function getCajaReportRowSelector(includeAllMethods = false){
    return includeAllMethods ? 'tr:not(.oculta)' : 'tr:not(.oculta):not(.metodo_oculto)';
}

async function dynamicReceiptReport() {
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const contenedor_filtros = panel_caja.querySelector('.cont_filtros');
        const filtro_header = panel_caja.querySelector('.filtro_header');
        const filtro_label = panel_caja.querySelector('.filtro_header .filtro-label');
        const cont_filtros = panel_caja.querySelector('.contenido_filtros');
        const caja_ingresos = panel_caja.querySelector('.caja_diaria.caja_ingresos');
        const caja_egresos = panel_caja.querySelector('.caja_diaria.caja_egresos');
        const total_cierreZ = panel_caja.querySelector('.cont_cierreZ .total');
        const cierre_anterior = panel_caja.querySelector('.cierr_anterior .total');

        const loader = panel_caja.querySelector('.cont_loader');

        const filtro_caja_diaria = cont_filtros.querySelector('.filtro_caja_diaria input');
        const filtro_fecha_from = cont_filtros.querySelector('.filtro_fecha_from input, input.filtro_fecha_from');
        const filtro_fecha_to = cont_filtros.querySelector('.filtro_fecha_to input, input.filtro_fecha_to');
        const filtro_unidad = cont_filtros.querySelector('.filtro_unidad .select_filtro');
        const filtro_metodo = cont_filtros.querySelector('.filtro_metodo .select_filtro');
        const filtro_campa = cont_filtros.querySelector('.flitro_campa .select_filtro, .filtro_campa .select_filtro');
        const filtro_evento = cont_filtros.querySelector('.filtro_evento .select_filtro');
        const filtro_general = cont_filtros.querySelector('.filtro_general .select_filtro');
        const filtro_category = cont_filtros.querySelector('.filtro_categoria .select_filtro');
        const filtro_busqueda_caja = cont_filtros.querySelector('input#search_caja');
        const select_moneda = panel_caja.querySelector('.cont_monedas select#moneda_caja');
        const btn_aplicar = cont_filtros.querySelector('.aplicar_filtros .btn_submit');
        const btn_cierre = panel_caja.querySelector('.cont_btn_submit .cierreZ');
        const defaultFromDate = filtro_fecha_from.value;
        const defaultToDate = filtro_fecha_to.value;

        let saveRows = {};
        let lastAppliedFiltersKey = '';
        let lastEnabledSyncVersion = btn_cierre.getAttribute('data-syncV') || 0;
        let currencyIndicatorsRequestId = 0;

        function updateCashClosingAvailability(canClose, syncVersion = 0){
            btn_cierre.classList.toggle('not_allowed', !canClose);
            const nextSyncVersion = canClose ? syncVersion : 0;
            btn_cierre.setAttribute('data-syncV', nextSyncVersion);

            if(canClose){
                lastEnabledSyncVersion = nextSyncVersion;
            }
        }

        function hasReceiptsInCurrentCajaView(){
            return panel_caja.querySelectorAll('.caja_diaria tr').length > 0;
        }

        function restoreCashClosingAvailability(){
            updateCashClosingAvailability(
                filtro_caja_diaria.checked && hasReceiptsInCurrentCajaView(),
                lastEnabledSyncVersion
            );
        }

        function normalizeFilterValues(values = []){
            return [...values].sort((a, b) => String(a).localeCompare(String(b), 'es'));
        }

        function serializeReceiptFilters(filters){
            return JSON.stringify({
                ...filters,
                Ramas: normalizeFilterValues(filters.Ramas),
                Metodos: normalizeFilterValues(filters.Metodos),
                Campas: normalizeFilterValues(filters.Campas),
                Eventos: normalizeFilterValues(filters.Eventos),
                Generales: normalizeFilterValues(filters.Generales),
                Categorias: normalizeFilterValues(filters.Categorias)
            });
        }

        function getDefaultReceiptFilters(){
            const allMethods = [...filtro_metodo.querySelectorAll('.opciones_metodo:not(.all)')].map((option) => option.id);

            return {
                'FromDate': defaultFromDate,
                'ToDate': defaultToDate,
                'CierreZ': true,
                'Moneda': select_moneda.value,
                'Ramas': [],
                'Metodos': allMethods,
                'Campas': [],
                'Eventos': [],
                'Generales': [],
                'Categorias': []
            };
        }

        async function refreshBaseCurrencyIndicators(){
            if(!filtro_caja_diaria.checked){
                panel_caja.dataset.currencyReceiptIndicators = JSON.stringify([]);
                initCajaCurrencySelector();
                return;
            }

            const requestId = ++currencyIndicatorsRequestId;
            const baseFilters = getDefaultReceiptFilters();
            const currencyOptions = [...select_moneda.options];

            const currenciesWithReceipts = await Promise.all(
                currencyOptions.map(async (option) => {
                    const rows = await getReceiptFromFilters({
                        ...baseFilters,
                        Moneda: option.value
                    });

                    return Object.keys(rows).length > 0 ? option.value : null;
                })
            );

            if(requestId !== currencyIndicatorsRequestId){
                return;
            }

            panel_caja.dataset.currencyReceiptIndicators = JSON.stringify(
                currenciesWithReceipts.filter(Boolean)
            );
            initCajaCurrencySelector();
        }

        function shouldReloadBaseCajaData(){
            const defaultFiltersKey = serializeReceiptFilters(getDefaultReceiptFilters());
            return lastAppliedFiltersKey !== '' && lastAppliedFiltersKey !== defaultFiltersKey;
        }

        function clearCajaFilters(){
            filtro_fecha_from.value = defaultFromDate;
            filtro_fecha_to.value = defaultToDate;

            [
                filtro_unidad.querySelectorAll('.opciones_rama'),
                filtro_metodo.querySelectorAll('.opciones_metodo'),
                filtro_campa.querySelectorAll('.opciones_campa'),
                filtro_evento.querySelectorAll('.opciones_evento'),
                filtro_general.querySelectorAll('.opciones_general'),
                filtro_category.querySelectorAll('.opciones_categoria')
            ].forEach((options) => {
                options.forEach((option) => {
                    option.classList.remove('active');
                });
            });

            const option_metodo_all = filtro_metodo.querySelector('.opciones_metodo.all');
            if(option_metodo_all && !option_metodo_all.classList.contains('active')){
                option_metodo_all.click();
            }

            if(filtro_busqueda_caja){
                filtro_busqueda_caja.value = '';
                applyCajaTextSearch(false);
            }
        }

        function normalizeCajaSearchTerm(value){
            return quitarAcentos(String(value || '').toLowerCase()).trim();
        }

        function normalizeCajaAmountSearch(value){
            return String(value || '').replace(/[^0-9]/g, '');
        }

        function getCajaRowSearchText(row){
            const codeCell = row.querySelector('.campo.codigo');
            const dateCell = row.children[1];
            const amountCell = row.querySelector('.campo.precio');
            const code = codeCell ? codeCell.textContent : '';
            const date = dateCell ? dateCell.textContent : '';
            const names = [...row.querySelectorAll('.detalle_row p')]
                .map(item => item.textContent)
                .join(' ');
            const amount = amountCell ? amountCell.textContent : '';

            return normalizeCajaSearchTerm([code, date, names, amount].join(' '));
        }

        function hasVisibleCajaRows(container){
            return container.querySelectorAll(getCajaReportRowSelector()).length > 0;
        }

        function setCajaSearchEmptyMessage(container, shouldShow){
            let message = container.querySelector('.emptyMessage.search_empty');

            if(shouldShow && !message){
                message = document.createElement('div');
                const text = document.createElement('p');
                message.classList.add('emptyMessage', 'search_empty');
                text.classList.add('message');
                text.textContent = 'No hay comprobantes que coincidan con la busqueda';
                message.appendChild(text);
                container.appendChild(message);
            }

            if(message){
                message.style.display = shouldShow ? 'block' : 'none';
            }
        }

        function applyCajaTextSearch(updateTotals = true){
            const query = normalizeCajaSearchTerm(filtro_busqueda_caja ? filtro_busqueda_caja.value : '');
            const amountQuery = normalizeCajaAmountSearch(query);

            [caja_ingresos, caja_egresos].forEach((container) => {
                const rows = container.querySelectorAll('tr');

                rows.forEach((row) => {
                    const rowText = getCajaRowSearchText(row);
                    const amountCell = row.querySelector('.campo.precio');
                    const rowAmount = normalizeCajaAmountSearch(amountCell ? amountCell.textContent : '');
                    const matchesText = !query || rowText.includes(query);
                    const matchesAmount = Boolean(amountQuery) && rowAmount.includes(amountQuery);

                    row.classList.toggle('oculta', !(matchesText || matchesAmount));
                    const selectedMethod = filtro_caja_diaria.checked ? (panel_caja.dataset.currentCashMethod || '') : '';
                    row.classList.toggle('metodo_oculto', !!selectedMethod && row.dataset.paymentMethod !== selectedMethod);
                });

                setCajaSearchEmptyMessage(container, rows.length > 0 && !hasVisibleCajaRows(container));
            });

            if(updateTotals){
                sumUpReceipReport(filtro_caja_diaria.checked);
                updateCashClosingAvailability(
                    filtro_caja_diaria.checked && panel_caja.querySelectorAll('.caja_diaria tr:not(.oculta)').length > 0,
                    lastEnabledSyncVersion
                );
            }
        }

        activeCajaRamaOptions();
        activeCajaMethodOptions();
        activeCajaEventOptions();
        activeCajaCampaOptions();
        activeCajaGeneralOptions();
        activeCajaCategOptions();
        initCajaCurrencySelector();
        initCajaPaymentMethodSelector();
        panel_caja.addEventListener('caja-method-change', () => applyCajaTextSearch());
        if(filtro_busqueda_caja){
            filtro_busqueda_caja.addEventListener('input', () => {
                applyCajaTextSearch();
            });
            filtro_busqueda_caja.addEventListener('search', () => {
                applyCajaTextSearch();
            });
        }
        cont_filtros.querySelectorAll('.select_filtro').forEach((selectFiltro) => {
            enableHorizontalGrabScroll(selectFiltro);
            enableSmoothWheelScroll(selectFiltro);
        });

        function updateFiltroHeaderState(){
            const filtrosDesplegados = !filtro_caja_diaria.checked;
            contenedor_filtros.classList.toggle('active', filtrosDesplegados);

            if(filtro_label){
                filtro_label.textContent = filtrosDesplegados ? 'Ocultar filtros' : 'Desplegar filtros';
            }
        }

        if(contenedor_filtros && filtro_header){
            filtro_header.addEventListener('click', () => {
                const filtersExpanded = contenedor_filtros.classList.contains('active');

                filtro_caja_diaria.checked = filtersExpanded;
                filtro_caja_diaria.dispatchEvent(new Event('change'));

                if(filtersExpanded){
                    clearCajaFilters();
                    if(shouldReloadBaseCajaData()){
                        btn_aplicar.click();
                    }else{
                        restoreCashClosingAvailability();
                    }
                }else{
                    updateCashClosingAvailability(false);
                }
            });
        }

        filtro_caja_diaria.addEventListener('change', () =>{
            disableAllFilters(filtro_caja_diaria.checked);
            updateFiltroHeaderState();
            initCajaCurrencySelector();
            refreshBaseCurrencyIndicators();
            initCajaPaymentMethodSelector();
            applyCajaTextSearch();
        })

        select_moneda.addEventListener('change', () =>{
            btn_aplicar.click();
        })

        btn_aplicar.addEventListener('click', async () => {
            loader.classList.add('loading');


            let rowsIngresos = [];
            let rowsEgresos = [];
            // loader.classList.add('loading');
            // if (Object.keys(saveRows).includes(select_period.value)) {

            const filters = getReceiptFilters();
            const newRows = await getReceiptFromFilters(filters);
            const syncVer = await getZClosureSyncVersion();
            const lastClosureAmount = await getLastClosureAmount(select_moneda.value);
            const currSigne = getCurrencySigne(select_moneda.value);

            cierre_anterior.innerHTML = formatCurrencySigne(parseFloat(lastClosureAmount).toFixed(2),currSigne);
            // console.log(newRows);
            
            for (const receipt of Object.values(newRows)) {

                let monto = 0;
                let parcial = 0;
                if(receipt.Parcial && (receipt.MontoTotal != receipt.MontoRow)){
                    monto = parseFloat(receipt.MontoRow);
                    parcial = 1;
                }else{
                    monto = parseFloat(receipt.MontoTotal) + parseFloat(receipt.Redondeo);
                    parcial = 0;
                }
            
                // Armar el bloque de miembros
                let miembrosHTML = "";
                Object.keys(receipt.Detalle).forEach(member => {
                    if (member !== "Redondeo") {
                        const memberName = member.split("-")[1];
                        miembrosHTML += `<p title="${memberName}">${memberName}</p>`;
                    }
                });
        
                // Armar el row completo como string
                const row = document.createElement('tr');
                row.setAttribute('data-id',receipt.internalId)
                row.setAttribute('data-currency', receipt.Currency ?? select_moneda.value);
                row.dataset.paymentMethod = receipt.PayMethod || '';
                row.innerHTML = `
                    <td class="campo codigo" >${receipt.CodRecibo}</td>
                    <td>${receipt.FechaF.substring(0, 10)}</td>
                    <td class="campo detalle">
                        <div class="detalle_row">
                            ${miembrosHTML}
                        </div>
                    </td>
                    <td class="campo precio ${parcial === 1 ? 'parcial' : ''}">
                        ${currSigne}${monto.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                    </td>
                `;
                if (receipt.Tipo === 'COBRO') {
                    rowsIngresos.push(row);
                }else{
                    rowsEgresos.push(row); 
                }
            }

            caja_ingresos.innerHTML = '';
            if(rowsIngresos.length > 0){
                const tableIng = document.createElement('table');
                const tbodyIng = document.createElement('tbody');

                tableIng.classList.add('tabla_caja');

                rowsIngresos.forEach(el => tbodyIng.appendChild(el));
                tableIng.appendChild(tbodyIng);
                caja_ingresos.appendChild(tableIng);
            }else{
                const emptyMessage = document.createElement('div');
                const message = document.createElement('p');

                emptyMessage.classList.add('emptyMessage');
                message.classList.add('message');
                message.textContent = "No hay comprobantes para esta consulta";

                emptyMessage.appendChild(message);
                caja_ingresos.appendChild(emptyMessage);
            }

            caja_egresos.innerHTML = '';
            if(rowsEgresos.length > 0){
                const tableEg = document.createElement('table');
                const tbodyEg = document.createElement('tbody');

                tableEg.classList.add('tabla_caja');

                rowsEgresos.forEach(el => tbodyEg.appendChild(el));
                tableEg.appendChild(tbodyEg);
                caja_egresos.appendChild(tableEg);
            }else{
                const emptyMessage = document.createElement('div');
                const message = document.createElement('p');

                emptyMessage.classList.add('emptyMessage');
                message.classList.add('message');
                message.textContent = "No hay comprobantes para esta consulta";

                emptyMessage.appendChild(message);
                caja_egresos.appendChild(emptyMessage);
            }

            callOpenReceiptWindow();
            initCajaPaymentMethodSelector();
            applyCajaTextSearch(false);
            // loader.classList.remove('loading');            
            sumUpReceipReport(filtro_caja_diaria.checked);

            updateCashClosingAvailability(
                filtro_caja_diaria.checked && panel_caja.querySelectorAll('.caja_diaria tr:not(.oculta)').length > 0,
                syncVer
            );
            lastAppliedFiltersKey = serializeReceiptFilters(filters);
            initCajaCurrencySelector();
            refreshBaseCurrencyIndicators();

            loader.classList.remove('loading');
        });

        function getReceiptFilters(){
            const filters = {
                'FromDate':filtro_fecha_from.value,
                'ToDate':filtro_fecha_to.value,
                'CierreZ':filtro_caja_diaria.checked,
                'Moneda':select_moneda.value,
                'Ramas':[],
                'Metodos':[],
                'Campas':[],
                'Eventos':[],
                'Generales':[],
                'Categorias':[]
            };

            filters['Metodos'] = getSelectMethods();

            if (!filtro_caja_diaria.checked) {
                filters['Ramas'] = getSelectRamas();
                filters['Campas'] = getSelectCampas().filter(item => !isNaN(item));
                filters['Eventos'] = getSelectEventos().filter(item => !isNaN(item));
                filters['Generales'] = getSelectGenerales().filter(item => !isNaN(item));
                filters['Categorias'] = getSelectCategorias().filter(item => !isNaN(item));
            }
            
            return filters
        }

        function getSelectRamas(){
            const option_rama = filtro_unidad.querySelectorAll('.opciones_rama');
            let rama_list = [];

            option_rama.forEach((option)=>{
              if(option.classList.contains('active')){
                rama_list.push(option.id);
              }  
            })

            return rama_list;
        }

        function getSelectMethods(){
            const option_method = filtro_metodo.querySelectorAll('.opciones_metodo');
            let method_list = [];

            option_method.forEach((option)=>{
              if(option.classList.contains('active')){
                if(option.id != 'ALL'){
                    method_list.push(option.id);
                }
              }  
            })

            return method_list;
        }

        function getSelectCampas(){
            const option_campa = filtro_campa.querySelectorAll('.opciones_campa');
            let campa_list = [];

            option_campa.forEach((option)=>{
              if(option.classList.contains('active')){
                campa_list.push(parseInt(option.id.split('_')[1]));
              }  
            })

            return campa_list;
        }

        function getSelectEventos(){
            const option_evento = filtro_evento.querySelectorAll('.opciones_evento');
            let evento_list = [];

            option_evento.forEach((option)=>{
              if(option.classList.contains('active')){
                evento_list.push(parseInt(option.id.split('_')[1]));
              }  
            })

            return evento_list;
        }

        function getSelectGenerales(){
            const option_general = filtro_general.querySelectorAll('.opciones_general');
            let evento_list = [];

            option_general.forEach((option)=>{
              if(option.classList.contains('active')){
                evento_list.push(parseInt(option.id.split('_')[1]));
              }  
            })

            return evento_list;
        }

        function getSelectCategorias(){
            const option_category = filtro_category.querySelectorAll('.opciones_categoria');
            let category_list = [];

            option_category.forEach((option)=>{
              if(option.classList.contains('active')){
                category_list.push(parseInt(option.id.split('_')[1]));
              }  
            })

            return category_list;
        }

        initCajaDiaria();
        lastAppliedFiltersKey = serializeReceiptFilters(getDefaultReceiptFilters());
        refreshBaseCurrencyIndicators();
    }
}

function getCurrencySigne(value){
    
    let signe = '$';
    const preferencias = document.querySelector('.config_preferencias');
    if (preferencias){
        const cont_moneda = preferencias.querySelector('.cont_listado_monedas');
        const moneda = cont_moneda.querySelector(`.moneda[data-id="${value}"]`);
        if (moneda){
            const signo = moneda.querySelector('input.signo')
            signe = signo.value;
        }

    }

    return signe;
}

function callOpenReceiptWindow(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const caja_ingresos = panel_caja.querySelector('.caja_diaria.caja_ingresos');
        const caja_egresos = panel_caja.querySelector('.caja_diaria.caja_egresos');

        caja_ingresos.querySelectorAll('tr').forEach(row => {
            openReceiptWindow(row);
        })

        caja_egresos.querySelectorAll('tr').forEach(row => {
            openReceiptWindow(row);
        })
    }
}

function openReceiptWindow(row){
    const code = row.querySelector('.campo.codigo');
    const intId = row.getAttribute('data-id');
    code.addEventListener('click',() => {
        window.open('comprobante/'+intId+'/ver', '_blank');
    })
}

function initCajaDiaria(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const cont_filtros = panel_caja.querySelector('.contenido_filtros');
        const filtro_caja_diaria = cont_filtros.querySelector('.filtro_caja_diaria input');
        const select_metodo = panel_caja.querySelector('.select_filtro.metodo');
        const option_metodo_all = select_metodo.querySelector('.opciones_metodo.all');
        const btn_aplicar = cont_filtros.querySelector('.aplicar_filtros .btn_submit');

        filtro_caja_diaria.checked = true;
        filtro_caja_diaria.dispatchEvent(new Event('change'));
        option_metodo_all.click();
        // btn_aplicar.click();
    }
}

function disableAllFilters(checked){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const cont_filtros = panel_caja.querySelector('.contenido_filtros');
        const input_fecha_from = cont_filtros.querySelector('.filtro_fecha_from input, input.filtro_fecha_from');
        const input_fecha_to = cont_filtros.querySelector('.filtro_fecha_to input, input.filtro_fecha_to');
        const filtro_fecha_from = input_fecha_from.closest('.filtro_fecha_from, .filtro_fecha');
        const filtro_fecha_to = input_fecha_to.closest('.filtro_fecha_to, .filtro_fecha');

        const select_rama = panel_caja.querySelector('.select_filtro.rama');
        const option_rama = select_rama.querySelectorAll('.opciones_rama');
        const select_evento = panel_caja.querySelector('.select_filtro.evento');
        const option_evento = select_evento.querySelectorAll('.opciones_evento');
        const select_campa = panel_caja.querySelector('.select_filtro.campa');
        const option_campa = select_campa.querySelectorAll('.opciones_campa');
        const select_general = panel_caja.querySelector('.select_filtro.general');
        const option_general = select_general.querySelectorAll('.opciones_general');
        const select_categoria = panel_caja.querySelector('.select_filtro.categoria');
        const option_categoria = select_categoria.querySelectorAll('.opciones_categoria');


        input_fecha_from.readOnly = checked;
        input_fecha_to.readOnly = checked;

        if(checked){
            filtro_fecha_from.classList.add('readonly');
            filtro_fecha_to.classList.add('readonly');
        }else{
            filtro_fecha_from.classList.remove('readonly');
            filtro_fecha_to.classList.remove('readonly');
        }

        option_rama.forEach((option)=>{
            if(checked){
                option.classList.add('disable');
                option.classList.remove('active');
            }else{
                option.classList.remove('disable');
            }
        })
        option_evento.forEach((option)=>{
            if(checked){
                option.classList.add('disable');
                option.classList.remove('active');
            }else{
                option.classList.remove('disable');
            }
        })
        option_campa.forEach((option)=>{
            if(checked){
                option.classList.add('disable');
                option.classList.remove('active');
            }else{
                option.classList.remove('disable');
            }
        })
        option_general.forEach((option)=>{
            if(checked){
                option.classList.add('disable');
                option.classList.remove('active');
            }else{
                option.classList.remove('disable');
            }
        })
        option_categoria.forEach((option)=>{
            if(checked){
                option.classList.add('disable');
                option.classList.remove('active');
            }else{
                option.classList.remove('disable');
            }
        })
    }
}

// CHECKEAR SI ES NECESARIA
function disablePagoFilters(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const checked = checkIfDisablePagoFilters();
        const select_categoria = panel_caja.querySelector('.select_filtro.categoria');
        const option_categoria = select_categoria.querySelectorAll('.opciones_categoria');

        option_categoria.forEach((option)=>{
            if(checked){
                option.classList.add('disable');
                option.classList.remove('active');
            }else{
                option.classList.remove('disable');
            }
        })
    }
}

function checkIfDisablePagoFilters(){
    let check = false
    return false;
    const panel_caja = document.querySelector('.panel_cajadiaria');

    const select_evento = panel_caja.querySelector('.select_filtro.evento');
    const option_evento = select_evento.querySelectorAll('.opciones_evento');
    const select_campa = panel_caja.querySelector('.select_filtro.campa');
    const option_campa = select_campa.querySelectorAll('.opciones_campa');
    const select_general = panel_caja.querySelector('.select_filtro.general');
    const option_general = select_general.querySelectorAll('.opciones_general');

    option_evento.forEach((option)=>{
        if(option.classList.contains('active')){
            check = true;
        }  
    })
    option_campa.forEach((option)=>{
        if(option.classList.contains('active')){
            check = true;
        }  
    })
    option_general.forEach((option)=>{
        if(option.classList.contains('active')){
            check = true;
        }  
    })

    return check;
}

// CHECKEAR SI ES NECESARIA
function disableCobroFilters(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const checked = checkIfDisableCobroFilters();
        const select_evento = panel_caja.querySelector('.select_filtro.evento');
        const option_evento = select_evento.querySelectorAll('.opciones_evento');
        const select_campa = panel_caja.querySelector('.select_filtro.campa');
        const option_campa = select_campa.querySelectorAll('.opciones_campa');
        const select_general = panel_caja.querySelector('.select_filtro.general');
        const option_general = select_general.querySelectorAll('.opciones_general');

        option_evento.forEach((option)=>{
            if(checked){
                option.classList.add('disable');
                option.classList.remove('active');
            }else{
                option.classList.remove('disable');
            }
        })
        option_campa.forEach((option)=>{
            if(checked){
                option.classList.add('disable');
                option.classList.remove('active');
            }else{
                option.classList.remove('disable');
            }
        })
        option_general.forEach((option)=>{
            if(checked){
                option.classList.add('disable');
                option.classList.remove('active');
            }else{
                option.classList.remove('disable');
            }
        })
    }
}

function checkIfDisableCobroFilters(){
    let check = false
    return false;
    const panel_caja = document.querySelector('.panel_cajadiaria');
    const select_categoria = panel_caja.querySelector('.select_filtro.categoria');
    const option_categoria = select_categoria.querySelectorAll('.opciones_categoria');

    option_categoria.forEach((option)=>{
        if(option.classList.contains('active')){
            check = true;
        }  
    })

    return check;
}

function activeCajaRamaOptions(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const select_rama = panel_caja.querySelector('.select_filtro.rama');
        const option_rama = select_rama.querySelectorAll('.opciones_rama');
        option_rama.forEach((option)=>{
            option.addEventListener('click',()=>{
                if(!option.classList.contains('disable')){
                    option.classList.toggle('active');
                    if(option.classList.contains('all')){
                        if(option.classList.contains('active')){
                            option_rama.forEach((opt)=>{
                                opt.classList.remove('disable');
                                opt.classList.add('active');
                            })
                        }else{
                            option_rama.forEach((opt)=>{
                                opt.classList.remove('active');
                            })
                        }
                    }
                }
            })
        })

    }
}

function activeCajaMethodOptions(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const select_metodo = panel_caja.querySelector('.select_filtro.metodo');
        const option_metodo = select_metodo.querySelectorAll('.opciones_metodo');
        option_metodo.forEach((option)=>{
            option.addEventListener('click',()=>{
                if(!option.classList.contains('disable')){
                    option.classList.toggle('active');
                    if(option.classList.contains('all')){
                        if(option.classList.contains('active')){
                            option_metodo.forEach((opt)=>{
                                opt.classList.remove('disable');
                                opt.classList.add('active');
                            })
                        }else{
                            option_metodo.forEach((opt)=>{
                                opt.classList.remove('active');
                            })
                        }
                    }
                }
            })
        })

    }
}

function activeCajaEventOptions(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const select_evento = panel_caja.querySelector('.select_filtro.evento');
        const option_evento = select_evento.querySelectorAll('.opciones_evento');
        option_evento.forEach((option)=>{
            option.addEventListener('click',()=>{
                if(!option.classList.contains('disable')){
                    option.classList.toggle('active');
                    if(option.classList.contains('all')){
                        if(option.classList.contains('active')){
                            option_evento.forEach((opt)=>{
                                opt.classList.remove('disable');
                                opt.classList.add('active');
                            })
                        }else{
                            option_evento.forEach((opt)=>{
                                opt.classList.remove('active');
                            })
                        }
                    }
                    disablePagoFilters();
                }
            })
        })

    }
}

function activeCajaCampaOptions(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const select_campa = panel_caja.querySelector('.filtro_campa .select_filtro, .flitro_campa .select_filtro');
        const option_campa = select_campa.querySelectorAll('.opciones_campa');
        option_campa.forEach((option)=>{
            option.addEventListener('click',()=>{
                if(!option.classList.contains('disable')){
                    option.classList.toggle('active');
                    if(option.classList.contains('all')){
                        if(option.classList.contains('active')){
                            option_campa.forEach((opt)=>{
                                opt.classList.remove('disable');
                                opt.classList.add('active');
                            })
                        }else{
                            option_campa.forEach((opt)=>{
                                opt.classList.remove('active');
                            })
                        }
                    }
                    disablePagoFilters();
                }
            })
        })

    }
}

function activeCajaGeneralOptions(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const select_general = panel_caja.querySelector('.select_filtro.general');
        const option_general = select_general.querySelectorAll('.opciones_general');
        option_general.forEach((option)=>{
            option.addEventListener('click',()=>{
                if(!option.classList.contains('disable')){
                    option.classList.toggle('active');
                    if(option.classList.contains('all')){
                        if(option.classList.contains('active')){
                            option_general.forEach((opt)=>{
                                opt.classList.remove('disable');
                                opt.classList.add('active');
                            })
                        }else{
                            option_general.forEach((opt)=>{
                                opt.classList.remove('active');
                            })
                        }
                    }
                    disablePagoFilters();
                }
            })
        })

    }
}

function activeCajaCategOptions(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const select_categoria = panel_caja.querySelector('.select_filtro.categoria');
        const option_categoria = select_categoria.querySelectorAll('.opciones_categoria');
        option_categoria.forEach((option)=>{
            option.addEventListener('click',()=>{
                if(!option.classList.contains('disable')){
                    option.classList.toggle('active');
                    if(option.classList.contains('all')){
                        if(option.classList.contains('active')){
                            option_categoria.forEach((opt)=>{
                                opt.classList.remove('disable');
                                opt.classList.add('active');
                            })
                        }else{
                            option_categoria.forEach((opt)=>{
                                opt.classList.remove('active');
                            })
                        }
                    }
                    disableCobroFilters();
                }
            })
        })

    }
}

async function sumUpReceipReport(checkCierre, includeAllMethods = false) {
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const caja_ingresos = panel_caja.querySelector('.caja_diaria.caja_ingresos');
        const caja_egresos = panel_caja.querySelector('.caja_diaria.caja_egresos');

        const cont_tot = panel_caja.querySelector('.totales_caja');
        const total_ingreso = panel_caja.querySelector('.total_ingreso .total');
        const total_egreso = panel_caja.querySelector('.total_egreso .total');
        const total_cierreZ = panel_caja.querySelector('.cont_cierreZ .total');
        const cierre_anterior = panel_caja.querySelector('.cierr_anterior .total');
        const total_caja = panel_caja.querySelector('.total_caja .total');

        const select_moneda = panel_caja.querySelector('.cont_monedas select#moneda_caja');
        const currSigne = getCurrencySigne(select_moneda.value);

        const totCierreAnt = formatCurrencyToFloatNegative(cierre_anterior.innerHTML,currSigne);

        let totIngreso = 0;
        let totEgreso = 0;
        let totCierreZ = 0;
        let totCaja = 0;

        caja_ingresos.querySelectorAll(getCajaReportRowSelector(includeAllMethods)).forEach(row => {
            const monto = row.querySelector('td.campo.precio').innerHTML;
            totIngreso += formatCurrencyToFloatNegative(monto,currSigne);
        })

        caja_egresos.querySelectorAll(getCajaReportRowSelector(includeAllMethods)).forEach(row => {
            const monto = row.querySelector('td.campo.precio').innerHTML;
            totEgreso += formatCurrencyToFloatNegative(monto,currSigne);
        })

        totCierreZ = totIngreso - totEgreso;

        if(checkCierre){
            cierre_anterior.classList.remove('readonly');
            total_caja.classList.remove('readonly');
            totCaja = totCierreZ + totCierreAnt;
        }else{
            cierre_anterior.classList.add('readonly');
            total_caja.classList.add('readonly');
        }
        
        total_ingreso.innerHTML = formatCurrencySigne(totIngreso.toFixed(2),currSigne);
        total_egreso.innerHTML = formatCurrencySigne(totEgreso.toFixed(2),currSigne);
        total_cierreZ.innerHTML = formatCurrencySigne(totCierreZ.toFixed(2),currSigne);
        total_caja.innerHTML = formatCurrencySigne(totCaja.toFixed(2),currSigne);

    }
}

function listenCashClosing(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const layout = document.querySelector('.layout_cierre');
        const loader = panel_caja.querySelector('.cont_loader_config');
        const btn_cierre = panel_caja.querySelector('.cont_btn_submit .cierreZ');
        const formCierreCaja = document.querySelector('.form_cierre_caja');
        const btn_x = formCierreCaja.querySelector('.btn_x');

        btn_cierre.addEventListener('click',() => {
            if(!btn_cierre.classList.contains('not_allowed')){
                formCierreCaja.classList.add('mostrar');
                formCierreCaja.classList.remove('ocultar');
                layout.classList.add('mostrar');
                completeCierreZResume();
            }
        })

        layout.addEventListener('click',() => {
            formCierreCaja.classList.remove('mostrar');
            formCierreCaja.classList.add('ocultar');
            layout.classList.remove('mostrar');
        })

        btn_x.addEventListener('click',() => {
            formCierreCaja.classList.remove('mostrar');
            formCierreCaja.classList.add('ocultar');
            layout.classList.remove('mostrar');
        })

    }
}

function completeCierreZResume(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    const contenido_form_cierre = document.querySelector('.contenido_form_cierre');
    if(panel_caja && contenido_form_cierre){
        sumUpReceipReport(true, true);
        const total_ingreso = panel_caja.querySelector('.total_ingreso .total');
        const total_egreso = panel_caja.querySelector('.total_egreso .total');
        const total_cierreZ = panel_caja.querySelector('.cont_cierreZ .total');
        const total_caja = panel_caja.querySelector('.total_caja .total');

        const config_panel = document.querySelector('.panel_config');
        const inputs_organismo = config_panel.querySelector('.input_organismo');
        const input_org = inputs_organismo.querySelector('#organismo');
        const input_nombreOrg = inputs_organismo.querySelector('#nombre_organismo');

        const form_cierre = contenido_form_cierre.querySelector('.form_cierre');
        const cod_org_cierre = form_cierre.querySelector('input#cod_org_cierre');
        const name_org_cierre = form_cierre.querySelector('input#name_org_cierre');
        const date_cierre = form_cierre.querySelector('input#date_cierre');
        const ingresos_cierre = form_cierre.querySelector('input#ingresos_cierre');
        const egresos_cierre = form_cierre.querySelector('input#egresos_cierre');
        const monto_cierre = form_cierre.querySelector('input#monto_cierre');
        const total_caja_form = form_cierre.querySelector('input#total_caja');

        ingresos_cierre.value = total_ingreso.innerHTML;
        egresos_cierre.value = total_egreso.innerHTML;
        monto_cierre.value = total_cierreZ.innerHTML;
        total_caja_form.value = total_caja.innerHTML;
        sumUpReceipReport(true);

        cod_org_cierre.value = input_org.value;
        name_org_cierre.value = input_nombreOrg.value;
        
        const hoy = new Date();
        const year = hoy.getFullYear();
        const month = String(hoy.getMonth() + 1).padStart(2, '0'); // Mes empieza en 0
        const day = String(hoy.getDate()).padStart(2, '0');
        const hoyStr = `${year}-${month}-${day}`; // Formato YYYY-MM-DD
        date_cierre.value = hoyStr;

        
    }
}

function performZClosure(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    const contenido_form_cierre = document.querySelector('.contenido_form_cierre');
    if(panel_caja && contenido_form_cierre){
        const layout = document.querySelector('.layout_cierre');
        const formCierreCaja = document.querySelector('.form_cierre_caja');
        const form_cierre = contenido_form_cierre.querySelector('.form_cierre');
        const btn_cierre = panel_caja.querySelector('.cont_btn_submit .cierreZ');

        const btn_submit = contenido_form_cierre.querySelector('.btn_submit.cierre');
        const ingresos_cierre = form_cierre.querySelector('input#ingresos_cierre');
        const egresos_cierre = form_cierre.querySelector('input#egresos_cierre');
        const monto_cierre = form_cierre.querySelector('input#monto_cierre');
        const total_caja_form = form_cierre.querySelector('input#total_caja');
        const firma_cierre = form_cierre.querySelector('select#firma_cierre');
        const obser_cierre = form_cierre.querySelector('textarea#obser_cierre');

        const select_moneda = panel_caja.querySelector('.cont_monedas select#moneda_caja');

        btn_submit.addEventListener('click',() => {
            completeCierreZResume();
            const data = getDataForAPI();
            // console.log(data);
            fetch('/api/performZClosure.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
                })
                .then(response => response.json())
                .then(data => {
                    // console.log(data);
                    if(data['response'] == 200){
                        // loader.classList.remove('loading');
                        showAlert('success','Cierre realizado Correctamente');
                        successClosing()
                    }else{
                    console.error('Error en la solicitud:', data['error']);
                    if(Object.keys(data['error']).length === 0){
                        // loader.classList.remove('loading');
                        showAlert('error','Error al Realizar Cierre');
                    }else{
                        // loader.classList.remove('loading');
                        showAlert('error',data['error']);
                    }
                    }
                })
                .catch(error => {
                    // console.log(error);
                    //loader.classList.remove('loading');
                    // console.error('Error en la solicitud:', error);
                    showAlert('error','Error al Realizar Cierre');
            });

        })

        function successClosing(){

            const cont_filtros = panel_caja.querySelector('.contenido_filtros');
            const btn_aplicar = cont_filtros.querySelector('.aplicar_filtros .btn_submit');

            formCierreCaja.classList.remove('mostrar');
            formCierreCaja.classList.add('ocultar');
            layout.classList.remove('mostrar');

            btn_aplicar.click();

            refreshReceiptTableList();
            refreshZClosureTableList();
        }

        function getDataForAPI() {
            const currSigne = getCurrencySigne(select_moneda.value);
            const data = {
                'MontoIngreso': formatCurrencyToFloatNegative(ingresos_cierre.value,currSigne),
                'MontoEgreso': formatCurrencyToFloatNegative(egresos_cierre.value,currSigne),
                'MontoCierre': formatCurrencyToFloatNegative(monto_cierre.value,currSigne),
                'MontoCaja': formatCurrencyToFloatNegative(total_caja_form.value,currSigne),
                'Observaciones': obser_cierre.value,
                'Firmante': firma_cierre.selectedOptions[0].text,
                'Moneda': select_moneda.value,
                'MonedaName': select_moneda.options[select_moneda.selectedIndex].text,
                'SyncVersion': btn_cierre.getAttribute('data-syncV'),
                'ReceiptList': getReceiptList()
            };

            return data;
        }

        function getReceiptList(){
            let receiptList = [];
            const caja_ingresos = panel_caja.querySelector('.caja_diaria.caja_ingresos');
            const caja_egresos = panel_caja.querySelector('.caja_diaria.caja_egresos');

            caja_ingresos.querySelectorAll('tr:not(.oculta)').forEach(row => {
                const idReceipt = row.getAttribute('data-id');
                receiptList.push(idReceipt);
            })

            caja_egresos.querySelectorAll('tr:not(.oculta)').forEach(row => {
                const idReceipt = row.getAttribute('data-id');
                receiptList.push(idReceipt);
            })

            return receiptList;
        }
        
    }
}

function dynamicPaymentMethodList(){
    const preferencias = document.querySelector('.config_preferencias');
    if(preferencias){
        const cont_metodos = preferencias.querySelector('.cont_listado_metodos');
        const accionesMetodos = cont_metodos.querySelector('.acciones_metodos');
        const agregarMetodo = cont_metodos.querySelector('.agregar_metodo');
        const editarMetodo = cont_metodos.querySelector('.acciones_metodos > .acciones_metodos_selected .editar_metodo');
        const eliminarMetodo = cont_metodos.querySelector('.acciones_metodos > .acciones_metodos_selected .eliminar_metodo');
        const confirmarMetodo = cont_metodos.querySelector('.acciones_metodos > .acciones_metodos_editing .confirmar_metodo');
        const anularCreacion = cont_metodos.querySelector('.acciones_metodos > .acciones_metodos_editing .anular_creacion');
        const metodos = cont_metodos.querySelectorAll('.metodo');
        let creation = false;
        let editing = false;
        let selectedMethod = null;
        let currentMethod = null;
        let originalName = '';

        const syncMethodActions = () => {
            accionesMetodos.classList.remove('has-selection','editing');

            if(editing || creation){
                accionesMetodos.classList.add('editing');
                return;
            }

            if(selectedMethod){
                accionesMetodos.classList.add('has-selection');
                const active = selectedMethod.dataset.active !== '0';
                editarMetodo.style.display = active ? '' : 'none';
                eliminarMetodo.title = active ? 'Desactivar Metodo' : 'Reactivar Metodo';
                const icon = eliminarMetodo.querySelector('i');
                if(icon){
                    icon.className = active ? 'fa-solid fa-square-xmark fa-xl' : 'fa-solid fa-square-check fa-xl';
                }
            }
        };

        const bindMethodSelection = (method) => {
            if(method.dataset.methodBound === 'true'){
                return;
            }

            method.dataset.methodBound = 'true';
            method.addEventListener('click', (event) => {
                if(event.target.closest('.acciones_metodos')){
                    return;
                }
                event.stopPropagation();
                setSelectedMethod(method);
            });
        };

        const clearMethodSelection = () => {
            cont_metodos.querySelectorAll('.metodo.selected').forEach((method) => method.classList.remove('selected'));
            selectedMethod = null;
            if(!editing && !creation){
                syncMethodActions();
            }
        };

        const setSelectedMethod = (method) => {
            if(creation || editing){
                return;
            }

            if(selectedMethod === method){
                clearMethodSelection();
                return;
            }

            cont_metodos.querySelectorAll('.metodo.selected').forEach((item) => item.classList.remove('selected'));
            method.classList.add('selected');
            selectedMethod = method;
            syncMethodActions();
        };

        const clearMethodInputSelection = (input) => {
            if(!input){
                return;
            }

            const end = input.value.length;
            input.focus();
            input.setSelectionRange(end, end);
            input.blur();

            const selection = window.getSelection ? window.getSelection() : null;
            if(selection && typeof selection.removeAllRanges === 'function'){
                selection.removeAllRanges();
            }

            setTimeout(() => {
                try{
                    input.setSelectionRange(end, end);
                }catch(error){
                    return;
                }

                input.blur();

                const delayedSelection = window.getSelection ? window.getSelection() : null;
                if(delayedSelection && typeof delayedSelection.removeAllRanges === 'function'){
                    delayedSelection.removeAllRanges();
                }
            }, 0);
        };

        metodos.forEach((method) => {
            bindMethodSelection(method);
        });

        document.addEventListener('click', (event) => {
            if(creation || editing){
                return;
            }

            if(!cont_metodos.contains(event.target)){
                clearMethodSelection();
            }
        });

        agregarMetodo.addEventListener('click', () => {
            if(creation){
                return;
            }

            creation = true;
            clearMethodSelection();
            const newMethod = createNewMethod();
            cont_metodos.insertBefore(newMethod, accionesMetodos);
            const nombreInput = newMethod.querySelector('.metodo_nombre input');
            currentMethod = newMethod;
            syncMethodActions();

            nombreInput.focus();
        });

        editarMetodo.addEventListener('click', () => {
            if(!selectedMethod || creation || editing){
                return;
            }

            const nombreInput = selectedMethod.querySelector('.metodo_nombre input');
            if(!nombreInput){
                return;
            }

            originalName = nombreInput.value;
            editing = true;
            currentMethod = selectedMethod;

            nombreInput.readOnly = false;
            nombreInput.focus();
            nombreInput.select();
            syncMethodActions();
        });

        eliminarMetodo.addEventListener('click', () => {
            if(!selectedMethod || creation || editing){
                return;
            }

            const methodToDelete = selectedMethod;
            deletePaymentMethod(methodToDelete, () => {
                if(selectedMethod === methodToDelete){
                    selectedMethod = null;
                }
                syncMethodActions();
            });
        });

        confirmarMetodo.addEventListener('click', () => {
            const loader = preferencias.querySelector('.cont_loader');
            const nombreInput = currentMethod ? currentMethod.querySelector('.metodo_nombre input') : null;

            if(!currentMethod || !nombreInput){
                return;
            }

            if(!nombreInput.value){
                showAlert('error','Debes completar Nombre');
                return;
            }

            if(loader){
                loader.classList.add('loading');
            }

            if(creation){
                const campos = {'Nombre':nombreInput.value}
                fetch('/api/createPaymentMethod.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(campos)
                    })
                    .then(response => response.json())
                    .then(data => {
                        if(data['response'] == 200){
                            successCreateMethod(currentMethod,data['Code']);
                            showAlert('success',"Metodo Creado Correctamente")
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al Crear Metodo');
                            }else{
                                showAlert('error',data['error']);
                            }
                        }
                        if(loader){
                            loader.classList.remove('loading');
                        }
                    })
                    .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Crear Metodo');
                        if(loader){
                            loader.classList.remove('loading');
                        }
                    });
                return;
            }

            if(editing){
                const code = currentMethod.getAttribute('data-id');
                const campos = {'Nombre':nombreInput.value,'Code':code}
                fetch('/api/updatePaymentMethod.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(campos)
                    })
                    .then(response => response.json())
                    .then(data => {
                        if(data['response'] == 200){
                            successUpdateMethod(currentMethod, nombreInput.value);
                            showAlert('success',"Metodo Actualizado Correctamente")
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al Actualizar Metodo');
                            }else{
                                showAlert('error',data['error']);
                            }
                        }
                        if(loader){
                            loader.classList.remove('loading');
                        }
                    })
                    .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Actualizar Metodo');
                        if(loader){
                            loader.classList.remove('loading');
                        }
                    });
            }
        });

        cont_metodos.addEventListener('keydown', (event) => {
            if(event.key !== 'Enter'){
                return;
            }

            const nombreInput = currentMethod ? currentMethod.querySelector('.metodo_nombre input') : null;
            if(!nombreInput || event.target !== nombreInput){
                return;
            }

            event.preventDefault();
            confirmarMetodo.click();
        });

        anularCreacion.addEventListener('click', () => {
            if(creation && currentMethod){
                const nombreInput = currentMethod.querySelector('.metodo_nombre input');
                clearMethodInputSelection(nombreInput);
                currentMethod.remove();
                currentMethod = null;
                creation = false;
                selectedMethod = null;
                originalName = '';
                syncMethodActions();
                return;
            }

            if(editing && currentMethod){
                const nombreInput = currentMethod.querySelector('.metodo_nombre input');
                nombreInput.value = originalName;
                nombreInput.readOnly = true;
                clearMethodInputSelection(nombreInput);
                currentMethod.classList.remove('selected');
                editing = false;
                selectedMethod = null;
                currentMethod = null;
                originalName = '';
                syncMethodActions();
            }
        });

        [agregarMetodo, editarMetodo, eliminarMetodo, confirmarMetodo, anularCreacion].forEach((button) => {
            if(!button){
                return;
            }

            button.addEventListener('click', (event) => {
                event.stopPropagation();
            });
        });

        syncMethodActions();

        function successCreateMethod(method,code){
            const nombreInput = method.querySelector('.metodo_nombre input');

            creation = false;
            currentMethod = null;
            method.setAttribute('data-id', code);
            method.dataset.active = '1';
            method.classList.remove('nuevo');
            nombreInput.readOnly = true;
            nombreInput.name = `nombre_${code}`;
            clearMethodInputSelection(nombreInput);

            bindMethodSelection(method);
            syncMethodActions();
            refreshPayMethods(method,'create');
        }

        function successUpdateMethod(method,newName){
            const nombreInput = method.querySelector('.metodo_nombre input');
            nombreInput.value = newName;
            nombreInput.readOnly = true;
            clearMethodInputSelection(nombreInput);

            method.classList.remove('selected');
            editing = false;
            selectedMethod = null;
            currentMethod = null;
            originalName = '';
            syncMethodActions();
            refreshPayMethods(method,'update');
        }
    }
}

function createNewMethod() {

    const method = document.createElement('div');
    method.className = 'metodo nuevo';

    const contMethod = document.createElement('div');
    contMethod.className = 'cont_metodo_item';

    const nombreWrap = document.createElement('div');
    nombreWrap.className = 'metodo_nombre';

    const inputNombre = document.createElement('input');
    inputNombre.type = 'text';
    nombreWrap.appendChild(inputNombre);
    contMethod.appendChild(nombreWrap);
    method.appendChild(contMethod);

    return method;
}

function deletePaymentMethod(method, onSuccess = null) {
    const code = method.getAttribute('data-id');
    const activate = method.dataset.active === '0';
    const preferencias = document.querySelector('.config_preferencias');
    const loader = preferencias ? preferencias.querySelector('.cont_loader') : null;

    if(loader){
        loader.classList.add('loading');
    }
    campos = {'Code':code, 'Activo': activate ? 1 : 0}
    // console.log(campos);
    fetch('/api/deletePaymentMethod.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(campos)
        })
        .then(response => response.json())
        .then(data => {
            // console.log(data);
            if(data['response'] == 200){
                successDelete(method, code);
                showAlert('success', activate ? "Metodo Reactivado Correctamente" : "Metodo Desactivado Correctamente")
            }else{
                console.error('Error en la solicitud:', data['error']);
                if(Object.keys(data['error']).length === 0){
                    showAlert('error','Error al Eliminar Metodo');
                }else{
                    showAlert('error',data['error']);
                }
            }
            if(loader){
                loader.classList.remove('loading');
            }
        })
        .catch(error => {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al Eliminar Metodo');
            if(loader){
                loader.classList.remove('loading');
            }
        });

    function successDelete(method, code){
        method.dataset.active = activate ? '1' : '0';
        method.classList.toggle('inactivo', !activate);
        method.classList.remove('selected');
        if(typeof onSuccess === 'function'){
            onSuccess();
        }
        refreshPayMethods(method, activate ? 'create' : 'delete');
    }
}

function dynamicCurrencyList(){
    const preferencias = document.querySelector('.config_preferencias');
    if(preferencias){
        const cont_moneda = preferencias.querySelector('.cont_listado_monedas');
        const accionesMonedas = cont_moneda.querySelector('.acciones_monedas');
        const btn_agregar = cont_moneda.querySelector('.acciones_monedas .agregar_moneda');
        const btn_editar = cont_moneda.querySelector('.acciones_monedas .editar_moneda');
        const btn_eliminar = cont_moneda.querySelector('.acciones_monedas .eliminar_moneda');
        const btn_confirmar = cont_moneda.querySelector('.acciones_monedas .confirmar_moneda');
        const btn_anular = cont_moneda.querySelector('.acciones_monedas .anular_creacion');
        const monedas = cont_moneda.querySelectorAll('.moneda');
        let creation = false;
        let editing = false;
        let currentCurrency = null;
        let selectedCurrency = null;

        const syncCurrencyActions = () => {
            accionesMonedas.classList.remove('has-selection', 'editing');
            if(creation || editing){
                accionesMonedas.classList.add('editing');
                return;
            }

            if(selectedCurrency){
                accionesMonedas.classList.add('has-selection');
                const active = selectedCurrency.dataset.active !== '0';
                btn_editar.style.display = active ? '' : 'none';
                btn_eliminar.title = active ? 'Desactivar Moneda' : 'Reactivar Moneda';
                const icon = btn_eliminar.querySelector('i');
                if(icon){
                    icon.className = active ? 'fa-solid fa-square-xmark fa-xl' : 'fa-solid fa-square-check fa-xl';
                }
            }
        };

        const clearCurrencySelection = () => {
            cont_moneda.querySelectorAll('.moneda.selected').forEach((currency) => currency.classList.remove('selected'));
            selectedCurrency = null;
            if(!creation){
                syncCurrencyActions();
            }
        };

        const setSelectedCurrency = (currency) => {
            if(creation || editing){
                return;
            }

            if(selectedCurrency === currency){
                clearCurrencySelection();
                return;
            }

            cont_moneda.querySelectorAll('.moneda.selected').forEach((item) => item.classList.remove('selected'));
            currency.classList.add('selected');
            selectedCurrency = currency;
            syncCurrencyActions();
        };

        btn_agregar.addEventListener('click', () =>{
            if(creation || editing){
                return;
            }

            currentCurrency = createCurrency(cont_moneda, () => {
                currentCurrency = null;
                creation = false;
                syncCurrencyActions();
            });
            creation = !!currentCurrency;
            clearCurrencySelection();
            syncCurrencyActions();
        });

        btn_editar.addEventListener('click', () => {
            if(!selectedCurrency || creation || editing){
                return;
            }

            currentCurrency = selectedCurrency;
            editing = true;
            updateCurrency(currentCurrency, {
                onFinish: () => {
                    currentCurrency = null;
                    editing = false;
                    clearCurrencySelection();
                    syncCurrencyActions();
                }
            });
            syncCurrencyActions();
        });

        btn_eliminar.addEventListener('click', () => {
            if(!selectedCurrency || creation || editing){
                return;
            }

            const currencyToDelete = selectedCurrency;
            deleteCurrency(currencyToDelete, () => {
                if(selectedCurrency === currencyToDelete){
                    selectedCurrency = null;
                }
                currentCurrency = null;
                syncCurrencyActions();
            });
        });

        btn_confirmar.addEventListener('click', () => {
            if(!currentCurrency){
                return;
            }

            if(creation && typeof currentCurrency._submitCreateCurrency === 'function'){
                currentCurrency._submitCreateCurrency();
                return;
            }

            if(editing && typeof currentCurrency._submitEditCurrency === 'function'){
                currentCurrency._submitEditCurrency();
            }
        });

        btn_anular.addEventListener('click', () => {
            if((!creation && !editing) || !currentCurrency){
                return;
            }

            if(creation && typeof currentCurrency._cancelCreateCurrency === 'function'){
                currentCurrency._cancelCreateCurrency();
            }else if(editing && typeof currentCurrency._cancelEditCurrency === 'function'){
                currentCurrency._cancelEditCurrency();
            }

            currentCurrency = null;
            creation = false;
            editing = false;
            syncCurrencyActions();
        });

        monedas.forEach(moneda => {
            dynamicCurrency(moneda,cont_moneda);
        });

        cont_moneda.addEventListener('click', (event) => {
            if(creation || editing){
                return;
            }

            const currency = event.target.closest('.moneda');
            if(!currency || !cont_moneda.contains(currency)){
                return;
            }

            event.stopPropagation();
            setSelectedCurrency(currency);
        });

        document.addEventListener('click', (event) => {
            if(creation || editing){
                return;
            }

            if(!cont_moneda.contains(event.target)){
                clearCurrencySelection();
            }
        });

        [btn_agregar, btn_editar, btn_eliminar, btn_confirmar, btn_anular].forEach((button) => {
            if(!button){
                return;
            }

            button.addEventListener('click', (event) => {
                event.stopPropagation();
            });
        });

        syncCurrencyActions();
    }
}

function dynamicCurrency(moneda){
    return moneda;
}

function createCurrency(cont_moneda, onFinish = null){
    const newMethodActive = cont_moneda.querySelector('.moneda.nuevo');
    if(newMethodActive){return}

    newCurrency = createNewCurrency();
    const accionesMonedas = cont_moneda.querySelector('.acciones_monedas');
    cont_moneda.insertBefore(newCurrency, accionesMonedas);
    const nombreInput = newCurrency.querySelector("input.nombre");
    const signoInput = newCurrency.querySelector("input.signo");

    const clearInputSelection = (input) => {
        if(!input){
            return;
        }

        const end = input.value.length;
        input.focus();
        input.setSelectionRange(end, end);
        input.blur();

        const selection = window.getSelection ? window.getSelection() : null;
        if(selection && typeof selection.removeAllRanges === 'function'){
            selection.removeAllRanges();
        }

        setTimeout(() => {
            try{
                input.setSelectionRange(end, end);
            }catch(error){
                return;
            }

            input.blur();

            const delayedSelection = window.getSelection ? window.getSelection() : null;
            if(delayedSelection && typeof delayedSelection.removeAllRanges === 'function'){
                delayedSelection.removeAllRanges();
            }
        }, 0);
    };

    nombreInput.focus();
    if (typeof nombreInput.select === 'function') {
        nombreInput.select();
    }
    nombreInput.addEventListener("keydown", handleNombreEnter);
    signoInput.addEventListener("keydown", handleSignoEnter);

    const preferencias = document.querySelector('.config_preferencias');
    const loader = preferencias ? preferencias.querySelector('.cont_loader') : null;

    const submitCreateCurrency = () => {
        if(nombreInput.value && signoInput.value){
            if(loader){
                loader.classList.add('loading');
            }
            campos = {'Nombre':nombreInput.value,'Signo':signoInput.value}
            // console.log(campos);
            fetch('/api/createCurrency.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(campos)
                })
                .then(response => response.json())
                .then(data => {
                    // console.log(data);
                    if(data['response'] == 200){
                        successCreation(newCurrency,data['Code']);
                        showAlert('success',"Moneda Creada Correctamente")
                    }else{
                        console.error('Error en la solicitud:', data['error']);
                        if(Object.keys(data['error']).length === 0){
                            showAlert('error','Error al Crear Moneda');
                        }else{
                            showAlert('error',data['error']);
                        }
                        //raiseMemberFields();
                    }
                    if(loader){
                        loader.classList.remove('loading');
                    }
                })
                .catch(error => {
                    console.error('Error en la solicitud:', error);
                    showAlert('error','Error al Crear Moneda');
                    //raiseMemberFields();
                    if(loader){
                        loader.classList.remove('loading');
                    }
                });
        }else{
            showAlert('error','Debes completar Nombre y Signo');
            if(nombreInput.value){
                signoInput.focus();
            }else{
                nombreInput.focus();
            }
        }
    };

    const cancelCreateCurrency = () => {
        clearInputSelection(nombreInput);
        clearInputSelection(signoInput);
        newCurrency.remove();
    };

    newCurrency._submitCreateCurrency = submitCreateCurrency;
    newCurrency._cancelCreateCurrency = cancelCreateCurrency;

    function handleNombreEnter(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            signoInput.focus();
        }
    }

    function handleSignoEnter(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            submitCreateCurrency();
        }
    }

    function successCreation(curren,code){
        const nombreInput = curren.querySelector("input.nombre");
        const signoInput = curren.querySelector("input.signo");

        curren.classList.remove('nuevo');
        curren.setAttribute('data-id', code);
        
        nombreInput.readOnly = true;
        nombreInput.name = `nombre_${code}`;
        clearInputSelection(nombreInput);
        
        signoInput.readOnly = true;
        signoInput.name = `signo_${code}`;
        clearInputSelection(signoInput);

        nombreInput.removeEventListener("keydown", handleNombreEnter);
        signoInput.removeEventListener("keydown", handleSignoEnter);
        delete curren._submitCreateCurrency;
        delete curren._cancelCreateCurrency;

        dynamicCurrency(curren);

        refreshCurrency(curren,'create');
        if(typeof onFinish === 'function'){
            onFinish();
        }
    }

    return newCurrency;

}

function createNewCurrency() {

    const currency = document.createElement('div');
    currency.className = 'moneda nuevo';

    const contMonedaItem = document.createElement('div');
    contMonedaItem.className = 'cont_moneda_item';

    const nombreWrap = document.createElement('div');
    nombreWrap.className = 'moneda_nombre';
    const inputNombre = document.createElement('input');
    inputNombre.type = 'text';
    inputNombre.className = 'nombre';

    const signoWrap = document.createElement('div');
    signoWrap.className = 'moneda_signo';
    const inputSigno = document.createElement('input');
    inputSigno.type = 'text';
    inputSigno.className = 'signo';

    nombreWrap.appendChild(inputNombre);
    signoWrap.appendChild(inputSigno);
    contMonedaItem.appendChild(nombreWrap);
    contMonedaItem.appendChild(signoWrap);
    currency.appendChild(contMonedaItem);

    return currency;
}

function updateCurrency(currency, options = {}) {
    const nombreInput = currency.querySelector("input.nombre");
    const signoInput = currency.querySelector("input.signo");
    const originalName = nombreInput.value;
    const originalSign = signoInput.value;
    let changeMake = false;

    const clearInputSelection = (input) => {
        if(!input){
            return;
        }

        const end = input.value.length;
        input.focus();
        input.setSelectionRange(end, end);
        input.blur();

        const selection = window.getSelection ? window.getSelection() : null;
        if(selection && typeof selection.removeAllRanges === 'function'){
            selection.removeAllRanges();
        }

        setTimeout(() => {
            try{
                input.setSelectionRange(end, end);
            }catch(error){
                return;
            }

            input.blur();

            const delayedSelection = window.getSelection ? window.getSelection() : null;
            if(delayedSelection && typeof delayedSelection.removeAllRanges === 'function'){
                delayedSelection.removeAllRanges();
            }
        }, 0);
    };

    nombreInput.readOnly = false;
    signoInput.readOnly = false;
    nombreInput.focus();
    if (typeof nombreInput.select === 'function') {
        nombreInput.select();
    }
    setTimeout(() => {
        nombreInput.focus();
        if (typeof nombreInput.select === 'function') {
            nombreInput.select();
        }
    }, 10);

    nombreInput.addEventListener("keydown", handleNombreEnter);
    signoInput.addEventListener("keydown", handleSignoEnter);

    nombreInput.addEventListener('change',() => {changeMake = true;})
    signoInput.addEventListener('change',() => {changeMake = true;})

    const preferencias = document.querySelector('.config_preferencias');
    const loader = preferencias ? preferencias.querySelector('.cont_loader') : null;
    const submitEditCurrency = () => {
        if(changeMake){
            if(nombreInput.value && signoInput.value){
                if(loader){
                    loader.classList.add('loading');
                }
                const code = currency.getAttribute('data-id');
                campos = {'Nombre':nombreInput.value,'Signo':signoInput.value,'Code':code}
                // console.log(campos);
                fetch('/api/updateCurrency.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                        body: JSON.stringify(campos)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        if(data['response'] == 200){
                            successUpdate(currency);
                            showAlert('success',"Moneda Actualizada Correctamente")
                        }else{
                            console.error('Error en la solicitud:', data['error']);
                            if(Object.keys(data['error']).length === 0){
                                showAlert('error','Error al Actualizar Moneda');
                            }else{
                                showAlert('error',data['error']);
                            }
                            //raiseMemberFields();
                        }
                        if(loader){
                            loader.classList.remove('loading');
                        }
                    })
                    .catch(error => {
                        console.error('Error en la solicitud:', error);
                        showAlert('error','Error al Actualizar Moneda');
                        //raiseMemberFields();
                        if(loader){
                            loader.classList.remove('loading');
                        }
                    });
            }else{
                showAlert('error','Debes completar Nombre y Signo');
                if(nombreInput.value){
                    signoInput.focus();
                }else{
                    nombreInput.focus();
                }
            }
        }else{
            successUpdate(currency);
        }
    };

    const cancelEditCurrency = () => {
        nombreInput.value = originalName;
        signoInput.value = originalSign;
        successUpdate(currency, false);
    };

    currency._submitEditCurrency = submitEditCurrency;
    currency._cancelEditCurrency = cancelEditCurrency;

    function handleNombreEnter(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            signoInput.focus();
        }
    }

    function handleSignoEnter(e) {
        if (e.key === "Enter") {
            signoInput.blur();
            e.preventDefault();
            submitEditCurrency();
        }
    }

    function successUpdate(currency, shouldRefresh = true){
        const nombreInput = currency.querySelector("input.nombre");
        const signoInput = currency.querySelector("input.signo");

        changeMake = false;
        
        nombreInput.readOnly = true;
        signoInput.readOnly = true;
        clearInputSelection(nombreInput);
        clearInputSelection(signoInput);

        nombreInput.removeEventListener("keydown", handleNombreEnter);
        signoInput.removeEventListener("keydown", handleSignoEnter);
        delete currency._submitEditCurrency;
        delete currency._cancelEditCurrency;

        if(shouldRefresh){
            refreshCurrency(currency,'update');
        }

        if(typeof options.onFinish === 'function'){
            options.onFinish();
        }
    }

}

function deleteCurrency(currency, onSuccess = null) {
    const code = currency.getAttribute('data-id');
    const activate = currency.dataset.active === '0';
    const preferencias = document.querySelector('.config_preferencias');
    const loader = preferencias ? preferencias.querySelector('.cont_loader') : null;

    if(loader){
        loader.classList.add('loading');
    }
    campos = {'Code':code, 'Activo': activate ? 1 : 0}
    // console.log(campos);
    fetch('/api/deleteCurrency.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(campos)
        })
        .then(response => response.json())
        .then(data => {
            // console.log(data);
            if(data['response'] == 200){
                successDelete(currency, code);
                showAlert('success', activate ? "Moneda Reactivada Correctamente" : "Moneda Desactivada Correctamente")
            }else{
                console.error('Error en la solicitud:', data['error']);
                if(Object.keys(data['error']).length === 0){
                    showAlert('error','Error al Eliminar Moneda');
                }else{
                    showAlert('error',data['error']);
                }
            }
            if(loader){
                loader.classList.remove('loading');
            }
        })
        .catch(error => {
            console.error('Error en la solicitud:', error);
            showAlert('error','Error al Eliminar Moneda');
            if(loader){
                loader.classList.remove('loading');
            }
        });

    function successDelete(currency, code){
        currency.dataset.active = activate ? '1' : '0';
        currency.classList.toggle('inactivo', !activate);
        currency.classList.remove('selected');
        if(typeof onSuccess === 'function'){
            onSuccess();
        }
        refreshCurrency(currency, activate ? 'create' : 'delete')
    }
}

function dynamicPeriodChange(){
    const periodConfig = document.querySelector('.config_periodo');
    if(periodConfig){
        if(periodConfig.classList.contains('is-disabled') || periodConfig.getAttribute('aria-disabled') === 'true'){
            return;
        }

        const radioInputs = periodConfig.querySelectorAll('input[name="periodo_config"]');
        const btnCambio = periodConfig.querySelector('.btn_submit.cambiar_periodo');
        const btnCambioText = btnCambio ? btnCambio.querySelector('.btn_text') : null;
        const loader = periodConfig.querySelector('.cont_loader');

        if(!btnCambio || !btnCambioText || radioInputs.length === 0){
            return;
        }

        const getSelectedPeriod = () => periodConfig.querySelector('input[name="periodo_config"]:checked');

        const syncPeriodButton = () => {
            const selected = getSelectedPeriod();
            if(!selected){
                btnCambio.classList.add('disabled');
                btnCambioText.textContent = 'Seleccionar Periodo';
                return;
            }

            const selectedLabel = selected.closest('.periodo_option');
            const isCurrent = selectedLabel ? selectedLabel.classList.contains('is-current') : false;

            btnCambio.classList.toggle('disabled', isCurrent);
            btnCambioText.textContent = `Cambiar a ${selected.value}`;
        };

        radioInputs.forEach((input) => {
            input.addEventListener('change', syncPeriodButton);
        });

        btnCambio.addEventListener('click', () =>{
            const selected = getSelectedPeriod();
            if(!selected){
                showAlert('error','Debes seleccionar un periodo');
                return;
            }

            const selectedLabel = selected.closest('.periodo_option');
            if(selectedLabel && selectedLabel.classList.contains('is-current')){
                showAlert('error','Ese periodo ya esta activo');
                return;
            }

            changeUserSettPeriod(selected.value);
        });

        syncPeriodButton();

        function changeUserSettPeriod(selectedPeriod){
            loader.classList.add('loading');
            fetch('/api/changeUserSettPeriod.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ Period: selectedPeriod })
                })
                .then(response => response.json())
                .then(data => {
                    // console.log(data);
                    if(data['response'] == 200){
                        successChange(data['Period'],data['PrevPeriod']);
                        showAlert('success',"Cambio Realizado Correctamente")
                    }else{
                        console.error('Error en la solicitud:', data['error']);
                        if(Object.keys(data['error']).length === 0){
                            showAlert('error','Error al Realizar Cambio');
                        }else{
                            showAlert('error',data['error']);
                        }
                    }
                    loader.classList.remove('loading');
                })
                .catch(error => {
                    console.error('Error en la solicitud:', error);
                    showAlert('error','Error al Realizar Cambio');
                    loader.classList.remove('loading');
            });
        }
        
        function successChange(period, prevPeriod){
            const periodoCuota = document.querySelector('.panel_cobros .cambiar_periodo .periodo p');
            const periodoPrevCuota = document.querySelector('.panel_cobros .cambiar_periodo .periodo.prev p');
            const radioToCheck = periodConfig.querySelector(`input[name="periodo_config"][value="${period}"]`);

            periodConfig.querySelectorAll('.periodo_option').forEach((label) => {
                label.classList.remove('is-current');
            });

            if(radioToCheck){
                radioToCheck.checked = true;
                const currentLabel = radioToCheck.closest('.periodo_option');
                if(currentLabel){
                    currentLabel.classList.add('is-current');
                }
            }

            periodoCuota.textContent = period;
            periodoPrevCuota.textContent = prevPeriod;
            syncPeriodButton();
            syncPastPeriodSidebar(period);
            refreshAllMembers();
        }

    }
}

// Marca la sidebar en rojo cuando se trabaja en un periodo anterior al año en curso
function syncPastPeriodSidebar(period){
    const sidebar = document.querySelector('.cont_botones');
    if(!sidebar){
        return;
    }

    const currentYear = parseInt(sidebar.dataset.anioActual, 10) || new Date().getFullYear();
    const isPastPeriod = parseInt(period, 10) < currentYear;
    const notice = sidebar.querySelector('.aviso_periodo');
    const noticeYear = sidebar.querySelector('.aviso_periodo_anio');

    sidebar.classList.toggle('periodo_anterior', isPastPeriod);
    if(notice){
        notice.hidden = !isPastPeriod;
    }
    if(noticeYear){
        noticeYear.textContent = period;
    }
}

function openDebtReviewScreenOptimized(){
    const reviewButton = document.querySelector('.config_periodo .revision_deuda');
    const reviewScreen = document.querySelector('.revision_deuda_screen');

    if(!reviewButton || !reviewScreen){
        return;
    }

    const closeButton = reviewScreen.querySelector('.revision_deuda_close');
    const periodLabel = reviewScreen.querySelector('[data-revision-period]');
    const navButtons = reviewScreen.querySelectorAll('.revision_deuda_nav');
    const panelViews = reviewScreen.querySelectorAll('.revision_deuda_view');
    const reviewTable = reviewScreen.querySelector('.revision_deuda_table');
    const reviewTableBody = reviewTable ? reviewTable.querySelector('tbody') : null;
    const revisionRows = reviewTable ? Array.from(reviewTable.querySelectorAll('tbody tr[data-revision-row]')) : [];
    const revisionEmptyRow = reviewTable ? reviewTable.querySelector('tbody tr:not([data-revision-row])') : null;
    const reviewCheckAll = reviewScreen.querySelector('.revision_check_all');
    const searchInput = reviewScreen.querySelector('.revision_deuda_search input[type="search"]');
    const filterButton = reviewScreen.querySelector('.revision_deuda_filter_btn');
    const filterMenu = reviewScreen.querySelector('.revision_deuda_filter_menu');
    const filterChips = reviewScreen.querySelector('.revision_deuda_filter_chips');
    const filterClearButton = reviewScreen.querySelector('.revision_deuda_filter_clear');
    const pageStatus = reviewScreen.querySelector('.revision_deuda_page_status');
    const pageButtons = reviewScreen.querySelectorAll('.revision_deuda_page_btn');
    const ramaFeeChecks = reviewScreen.querySelectorAll('.revision_rama_fee_check');
    const currencyRateInputs = reviewScreen.querySelectorAll('.revision_currency_rate');
    const configSaveButton = reviewScreen.querySelector('.revision_deuda_config_save');
    const currentDebtSummaryValue = reviewScreen.querySelector('[data-revision-total-current]');
    const affiliationDebtSummaryValue = reviewScreen.querySelector('[data-revision-affiliation-debt]');
    const revisionConfigStorageKey = 'revisionDebtFeeRamasConfig';
    const revisionCurrencyRatesStorageKey = 'revisionDebtCurrencyRatesConfig';
    const rowsPerPage = 50;
    let currentPage = 1;
    let filteredRevisionRows = revisionRows;

    // El panel siempre revisa el periodo activo (independiente del cambio de periodo)
    const getSelectedPeriod = () => {
        const current = document.querySelector('.config_periodo .periodo_option.is-current input[name="periodo_config"]');
        return current ? current.value : (periodLabel ? periodLabel.textContent.trim() : '');
    };

    const showRevisionPanel = (panelName) => {
        navButtons.forEach((button) => {
            button.classList.toggle('active', button.dataset.revisionView === panelName);
        });

        panelViews.forEach((view) => {
            view.classList.toggle('active', view.dataset.revisionPanel === panelName);
        });

        closeDetailMenus();
    };

    const openScreen = (period = null) => {
        if(periodLabel){
            periodLabel.textContent = period || getSelectedPeriod();
        }

        reviewScreen.classList.add('mostrar');
        reviewScreen.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('revision_deuda_lock');
        document.body.classList.add('revision_deuda_lock');
    };

    const refreshBeforeOpen = () => {
        sessionStorage.setItem('openRevisionDebtAfterRefresh', '1');
        sessionStorage.setItem('revisionDebtPeriod', getSelectedPeriod());
        reviewButton.disabled = true;
        reviewButton.classList.add('disabled');
        window.location.reload();
    };

    const closeScreen = () => {
        reviewScreen.classList.remove('mostrar');
        reviewScreen.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('revision_deuda_lock');
        document.body.classList.remove('revision_deuda_lock');
    };

    const formatRevisionCurrency = (value, decimals = 2) => {
        const amount = Number(value) || 0;

        return '$ ' + amount.toLocaleString('es-AR', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
    };

    const escapeRevisionHtml = (value) => String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

    const normalizeRevisionSearch = (value) => String(value ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();

    const getRevisionRowSearchText = (row) => {
        if(!row){
            return '';
        }

        if(!row.dataset.searchText){
            const nameCell = row.querySelector('.revision_nombre_cell');
            const rowCheck = row.querySelector('.revision_row_check');
            const ramaBadge = row.querySelector('.revision_rama_badge');
            const memberName = nameCell ? nameCell.textContent : '';
            const memberDoc = rowCheck ? rowCheck.value : '';
            const ramaTitle = ramaBadge ? ramaBadge.getAttribute('title') : '';
            const ramaText = ramaBadge ? ramaBadge.textContent : '';
            row.dataset.searchText = normalizeRevisionSearch(`${memberName} ${memberDoc} ${ramaTitle} ${ramaText}`);
        }

        return row.dataset.searchText;
    };

    const getRevisionActiveFilters = () => {
        if(!filterMenu){
            return {};
        }

        return Array.from(filterMenu.querySelectorAll('.revision_deuda_filter_option.active'))
            .filter((option) => normalizeRevisionSearch(option.textContent) !== 'todas')
            .reduce((filters, option) => {
                const group = getFilterGroupLabel(option);
                const value = normalizeRevisionSearch(option.textContent);

                if(!filters[group]){
                    filters[group] = new Set();
                }

                filters[group].add(value);
                return filters;
            }, {});
    };

    const getRevisionRowFilterValue = (row, group) => {
        if(group === 'rama'){
            const ramaBadge = row.querySelector('.revision_rama_badge');
            return normalizeRevisionSearch(ramaBadge ? ramaBadge.getAttribute('title') : '');
        }

        if(group === 'estado'){
            const state = row.querySelector('.revision_estado');
            return normalizeRevisionSearch(state ? state.textContent : '');
        }

        if(group === 'afiliacion'){
            const affiliation = row.querySelector('.revision_afiliacion');
            return normalizeRevisionSearch(affiliation ? affiliation.textContent : '');
        }

        return '';
    };

    const rowMatchesRevisionFilters = (row, activeFilters) => Object.entries(activeFilters).every(([group, values]) => {
        const rowValue = getRevisionRowFilterValue(row, group);
        return values.size === 0 || values.has(rowValue);
    });

    const getVisibleRows = () => reviewTableBody ? Array.from(reviewTableBody.querySelectorAll('tr[data-revision-row]')) : [];
    const getVisibleRowChecks = () => getVisibleRows()
        .map((row) => row.querySelector('.revision_row_check'))
        .filter(Boolean);

    const syncReviewCheckAll = () => {
        const visibleChecks = getVisibleRowChecks();

        if(!reviewCheckAll || visibleChecks.length === 0){
            if(reviewCheckAll){
                reviewCheckAll.checked = false;
                reviewCheckAll.indeterminate = false;
            }
            return;
        }

        const checkedCount = visibleChecks.filter((input) => input.checked).length;

        reviewCheckAll.checked = checkedCount === visibleChecks.length;
        reviewCheckAll.indeterminate = checkedCount > 0 && checkedCount < visibleChecks.length;
    };

    const getRowCurrentDebt = (row) => {
        const currentDebtInput = row ? row.querySelector('.revision_deuda_actual') : null;

        if(!currentDebtInput){
            return 0;
        }

        const affiliationButton = row.querySelector('.revision_afiliacion');
        const affiliationDebt = Number(affiliationButton ? affiliationButton.dataset.debtValue : currentDebtInput.dataset.affiliationDebt) || 0;
        const feesDebt = Number(currentDebtInput.dataset.feesDebt) || 0;
        const campsDebt = Number(currentDebtInput.dataset.campsDebt) || 0;

        return affiliationDebt + feesDebt + campsDebt;
    };

    const syncCurrentDebtSummary = () => {
        if(!currentDebtSummaryValue){
            return;
        }

        const rowDebts = revisionRows.map((row) => getRowCurrentDebt(row));
        const totalCurrentDebt = rowDebts.reduce((total, debt) => total + debt, 0);
        const membersWithDebt = rowDebts.filter((debt) => debt > 0).length;

        reviewScreen.querySelectorAll('[data-revision-total-current]').forEach((element) => {
            element.textContent = formatRevisionCurrency(totalCurrentDebt);
        });
        reviewScreen.querySelectorAll('[data-revision-members-debt]').forEach((element) => {
            element.textContent = String(membersWithDebt);
        });
        reviewScreen.querySelectorAll('[data-revision-members-ok]').forEach((element) => {
            element.textContent = String(rowDebts.length - membersWithDebt);
        });
    };

    const syncAffiliationDebtSummary = () => {
        if(!affiliationDebtSummaryValue){
            return;
        }

        const totalAffiliationDebt = revisionRows.reduce((total, row) => {
            const button = row.querySelector('.revision_afiliacion');
            return total + (Number(button ? button.dataset.debtValue : 0) || 0);
        }, 0);

        affiliationDebtSummaryValue.textContent = formatRevisionCurrency(totalAffiliationDebt);
    };

    const getDetailMenu = (select) => {
        if(!select){
            return null;
        }

        return select.querySelector('.revision_cuotas_menu, .revision_generales_menu, .revision_eventos_menu, .revision_campamentos_menu');
    };

    const closeDetailMenus = (currentSelect = null) => {
        reviewScreen.querySelectorAll('[data-revision-detail]').forEach((select) => {
            if(currentSelect && select === currentSelect){
                return;
            }

            const button = select.querySelector('button[aria-expanded]');
            const menu = getDetailMenu(select);

            if(button && menu){
                button.setAttribute('aria-expanded', 'false');
                menu.classList.remove('mostrar');
                menu.setAttribute('aria-hidden', 'true');
            }
        });
    };

    const applyTableFilters = () => {
        const searchValue = normalizeRevisionSearch(searchInput ? searchInput.value : '');
        const activeFilters = getRevisionActiveFilters();

        filteredRevisionRows = searchValue
            ? revisionRows.filter((row) => getRevisionRowSearchText(row).includes(searchValue) && rowMatchesRevisionFilters(row, activeFilters))
            : revisionRows.filter((row) => rowMatchesRevisionFilters(row, activeFilters));

        currentPage = 1;
        syncPagination();
    };

    const getFilterGroupLabel = (option) => {
        const group = option ? option.closest('.revision_deuda_filter_group') : null;
        const label = group ? group.querySelector('p') : null;
        return normalizeRevisionSearch(label ? label.textContent : 'filtro') || 'filtro';
    };

    const renderFilterChips = () => {
        if(!filterChips || !filterMenu){
            return;
        }

        const activeOptions = Array.from(filterMenu.querySelectorAll('.revision_deuda_filter_option.active'))
            .filter((option) => normalizeRevisionSearch(option.textContent) !== 'todas');
        const activeCount = activeOptions.length;

        filterChips.innerHTML = activeOptions.map((option) => {
            const group = getFilterGroupLabel(option);
            const value = option.textContent.trim();

            return `
                <div class="revision_deuda_filter_chip" data-filter-group="${escapeRevisionHtml(group)}" data-filter-value="${escapeRevisionHtml(value)}">
                    <span>${escapeRevisionHtml(value)}</span>
                    <button type="button" aria-label="Quitar filtro ${escapeRevisionHtml(value)}">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
            `;
        }).join('');

        if(filterClearButton){
            filterClearButton.textContent = `Eliminar todos (${activeCount})`;
            filterClearButton.disabled = activeCount === 0;
            filterClearButton.hidden = activeCount === 0;
        }
    };

    const getRevisionEmptyTableRow = (message) => {
        const row = document.createElement('tr');
        const cell = document.createElement('td');
        const columnCount = reviewTable ? reviewTable.querySelectorAll('thead th').length : 1;

        cell.colSpan = columnCount || 1;
        cell.className = 'revision_deuda_empty';
        cell.textContent = message;
        row.appendChild(cell);

        return row;
    };

    const syncPagination = () => {
        const pageCount = Math.max(1, Math.ceil(filteredRevisionRows.length / rowsPerPage));
        currentPage = Math.min(Math.max(currentPage, 1), pageCount);
        const firstRow = (currentPage - 1) * rowsPerPage;
        const lastRow = firstRow + rowsPerPage;

        if(reviewTableBody){
            if(filteredRevisionRows.length > 0){
                reviewTableBody.replaceChildren(...filteredRevisionRows.slice(firstRow, lastRow));
            }else{
                const hasSearchValue = normalizeRevisionSearch(searchInput ? searchInput.value : '') !== '';
                const hasFilterValue = Object.keys(getRevisionActiveFilters()).length > 0;
                const emptyMessage = revisionRows.length === 0 && !hasSearchValue && !hasFilterValue
                    ? 'No hay miembros para mostrar.'
                    : 'No se encontraron resultados';

                reviewTableBody.replaceChildren(getRevisionEmptyTableRow(emptyMessage));
            }
        }

        if(pageStatus){
            pageStatus.textContent = filteredRevisionRows.length > 0
                ? `Pagina ${currentPage} de ${pageCount}`
                : 'Sin resultados';
        }

        pageButtons.forEach((button) => {
            const action = button.dataset.pageAction;
            button.disabled = (action === 'prev' && currentPage <= 1) || (action === 'next' && currentPage >= pageCount);
        });

        closeDetailMenus();
        syncReviewCheckAll();
    };

    const parseDetailData = (select) => {
        if(!select){
            return [];
        }

        try {
            return JSON.parse(select.dataset.detail || '[]');
        } catch (error) {
            console.error('Error al leer detalle de revision de deuda:', error);
            return [];
        }
    };

    const parseRevisionJson = (value, fallback = {}) => {
        try {
            return JSON.parse(value || JSON.stringify(fallback));
        } catch (error) {
            console.error('Error al leer datos de revision de deuda:', error);
            return fallback;
        }
    };

    const getCurrencyRates = () => Array.from(currencyRateInputs).reduce((rates, input) => {
        const code = input.dataset.currencyCode;
        const rate = Number(input.value);

        if(code){
            rates[code] = Number.isFinite(rate) && rate > 0 ? rate : 1;
        }

        return rates;
    }, {});

    const convertPaidToPesos = (breakdown, fallbackPaid = 0) => {
        const rates = getCurrencyRates();
        const entries = breakdown && typeof breakdown === 'object' ? Object.entries(breakdown) : [];

        if(entries.length === 0){
            return Number(fallbackPaid) || 0;
        }

        return entries.reduce((total, [currencyCode, amount]) => {
            const rate = Number(rates[currencyCode]) || 1;
            return total + ((Number(amount) || 0) * rate);
        }, 0);
    };

    const getConvertedPayment = (payment) => convertPaidToPesos(payment.paidBreakdown, payment.paidFallback ?? payment.paid);

    const renderFeesMenu = (select) => {
        const menu = select.querySelector('.revision_cuotas_menu');

        if(!menu || select.dataset.rendered === '1'){
            return;
        }

        const fees = parseDetailData(select);
        const items = fees.map((fee) => {
            const paidText = fee.state === 'no-abona'
                ? 'No corresponde'
                : `${formatRevisionCurrency(getConvertedPayment(fee), 0)} de ${formatRevisionCurrency(fee.amount, 0)}`;

            return `
                <div class="revision_cuota_mes ${escapeRevisionHtml(fee.state)}" title="${escapeRevisionHtml(fee.name)}">
                    <div class="revision_cuota_mes_cab">
                        <span>${escapeRevisionHtml(fee.short)}</span>
                        <i></i>
                    </div>
                    <strong>${escapeRevisionHtml(getRevisionStateLabel(fee.state, 'fee'))}</strong>
                    <small>${escapeRevisionHtml(paidText)}</small>
                </div>
            `;
        }).join('');

        menu.innerHTML = `<div class="revision_cuotas_grid">${items}</div>`;
        select.dataset.rendered = '1';
    };

    const getRevisionStateLabel = (state, kind = 'item') => {
        const labels = kind === 'fee'
            ? { abonada: 'Abonada', parcial: 'Parcial', pendiente: 'Impaga', 'no-abona': 'No abona' }
            : { abonada: 'Abonado', parcial: 'Parcial', pendiente: 'Pendiente', 'no-abona': 'No abona' };

        return labels[state] || '';
    };

    // Resumen dentro de la celda: barritas de los 12 meses, o monto pagado con barra de progreso
    const renderDetailSummary = (select) => {
        if(!select){
            return;
        }

        const type = select.dataset.revisionDetail;
        const items = parseDetailData(select);

        if(type === 'fees'){
            const strip = select.querySelector('.revision_cuotas_barras');

            if(strip){
                strip.innerHTML = items.map((fee) => `
                    <span class="revision_barra_mes ${escapeRevisionHtml(fee.state)}" title="${escapeRevisionHtml(fee.name)}: ${escapeRevisionHtml(getRevisionStateLabel(fee.state, 'fee'))}"></span>
                `).join('');
            }

            return;
        }

        const bar = select.querySelector('.revision_progreso span');
        const sub = select.querySelector('.revision_resumen_sub');

        if(!bar){
            return;
        }

        // En campamentos solo cuentan los que el miembro asiste
        const summaryItems = type === 'camps' ? items.filter((camp) => camp.attends) : items;
        const paid = summaryItems.reduce((total, item) => total + (Number(item.paid ?? getConvertedPayment(item)) || 0), 0);
        const amount = summaryItems.reduce((total, item) => total + (Number(item.amount) || 0), 0);
        const percent = amount > 0 ? Math.min(100, Math.round((paid / amount) * 100)) : 0;
        let state = 'pendiente';

        if(amount > 0 && paid >= amount){
            state = 'abonada';
        }else if(paid > 0){
            state = 'parcial';
        }

        select.classList.toggle('sin-cargos', summaryItems.length === 0);
        bar.className = state;
        bar.style.width = `${percent}%`;

        if(sub){
            sub.textContent = summaryItems.length === 0
                ? 'No asiste a campamentos'
                : `pagó ${formatRevisionCurrency(paid, 0)} de ${formatRevisionCurrency(amount, 0)}`;
        }
    };

    const renderSimplePaymentsMenu = (select, config) => {
        const menu = select.querySelector(config.menuSelector);

        if(!menu || select.dataset.rendered === '1'){
            return;
        }

        const payments = parseDetailData(select);

        if(payments.length === 0){
            menu.innerHTML = `<p class="${config.emptyClass}">${config.emptyText}</p>`;
            select.dataset.rendered = '1';
            return;
        }

        const items = payments.map((payment) => `
            <div class="${config.itemClass} ${escapeRevisionHtml(payment.state)}">
                <span>${escapeRevisionHtml(payment.name)}</span>
                <div class="revision_item_monto">
                    <strong>${formatRevisionCurrency(getConvertedPayment(payment), 0)} de ${formatRevisionCurrency(payment.amount, 0)}</strong>
                    <small>${escapeRevisionHtml(getRevisionStateLabel(payment.state))}</small>
                </div>
            </div>
        `).join('');

        menu.innerHTML = `<div class="${config.listClass}">${items}</div>`;
        select.dataset.rendered = '1';
    };

    const renderCampsMenu = (select) => {
        const menu = select.querySelector('.revision_campamentos_menu');

        if(!menu || select.dataset.rendered === '1'){
            return;
        }

        const camps = parseDetailData(select);

        if(camps.length === 0){
            menu.innerHTML = '<p class="revision_campamentos_empty">Sin campamentos</p>';
            select.dataset.rendered = '1';
            return;
        }

        const items = camps.map((camp) => {
            const paid = getConvertedPayment(camp);
            const amount = Number(camp.amount) || 0;
            const debt = Math.max(amount - paid, 0);
            const visibleDebt = camp.countsDebt ? debt : 0;
            const countsDebt = camp.countsDebt ? '1' : '0';
            const toggleClass = camp.countsDebt ? 'cuenta' : 'no-abona';
            const toggleText = camp.countsDebt ? 'Cuenta' : 'No abona';
            const toggle = camp.state === 'abonada' ? '' : `
                <button type="button" class="revision_campamento_toggle ${toggleClass}" data-counts-debt="${countsDebt}">
                    ${toggleText}
                </button>
            `;

            return `
                <div
                    class="revision_campamento_item ${escapeRevisionHtml(camp.state)}"
                    data-camp-debt="${debt}"
                    data-camp-amount="${amount}"
                    data-camp-paid="${paid}"
                >
                    <div class="revision_campamento_info">
                        <span>${escapeRevisionHtml(camp.name)}</span>
                        <strong>${formatRevisionCurrency(paid)}</strong>
                    </div>
                    <div class="revision_campamento_deuda">
                        <span>Deuda</span>
                        <strong>${formatRevisionCurrency(visibleDebt)}</strong>
                    </div>
                    ${toggle}
                </div>
            `;
        }).join('');

        menu.innerHTML = `<div class="revision_campamentos_list">${items}</div>`;
        select.dataset.rendered = '1';
    };

    const renderDetailMenu = (select) => {
        const type = select ? select.dataset.revisionDetail : '';

        if(type === 'fees'){
            renderFeesMenu(select);
        }else if(type === 'general'){
            renderSimplePaymentsMenu(select, {
                menuSelector: '.revision_generales_menu',
                listClass: 'revision_generales_list',
                itemClass: 'revision_general_item',
                emptyClass: 'revision_generales_empty',
                emptyText: 'Sin pagos generales'
            });
        }else if(type === 'events'){
            renderSimplePaymentsMenu(select, {
                menuSelector: '.revision_eventos_menu',
                listClass: 'revision_eventos_list',
                itemClass: 'revision_evento_item',
                emptyClass: 'revision_eventos_empty',
                emptyText: 'Sin eventos'
            });
        }else if(type === 'camps'){
            renderCampsMenu(select);
        }
    };

    const recalculateCurrentDebt = (row, syncSummary = true) => {
        const currentDebtInput = row ? row.querySelector('.revision_deuda_actual') : null;

        if(!currentDebtInput){
            return;
        }

        const currentDebt = getRowCurrentDebt(row);
        const formattedDebt = formatRevisionCurrency(currentDebt);
        const debtStatus = row.querySelector('.revision_estado');

        currentDebtInput.value = formattedDebt;
        currentDebtInput.placeholder = formattedDebt;
        currentDebtInput.classList.toggle('sin-deuda', currentDebt <= 0);

        if(debtStatus){
            debtStatus.classList.toggle('con-deuda', currentDebt > 0);
            debtStatus.classList.toggle('sin-deuda', currentDebt <= 0);
            debtStatus.textContent = currentDebt > 0 ? 'Con deuda' : 'Sin deuda';
        }

        if(syncSummary){
            syncCurrentDebtSummary();
        }
    };

    const updateCampsDebt = (row) => {
        const currentDebtInput = row ? row.querySelector('.revision_deuda_actual') : null;
        const campsButton = row ? row.querySelector('.revision_campamentos') : null;

        if(!currentDebtInput){
            return;
        }

        let campsDebt = 0;
        row.querySelectorAll('.revision_campamento_item').forEach((item) => {
            const toggle = item.querySelector('.revision_campamento_toggle');
            const amount = Number(item.dataset.campAmount) || 0;
            const paid = Number(item.dataset.campPaid) || 0;
            const debt = Math.max(amount - paid, 0);

            item.dataset.campDebt = String(debt);

            if(toggle && toggle.dataset.countsDebt === '1'){
                campsDebt += debt;
            }
        });

        currentDebtInput.dataset.campsDebt = String(campsDebt);

        if(campsButton){
            const paidTotal = Number(campsButton.dataset.paidTotal) || 0;

            campsButton.textContent = formatRevisionCurrency(campsDebt);
            campsButton.classList.remove('sin-pagos', 'con-pagos', 'parcial');

            if(campsDebt > 0){
                campsButton.classList.add('parcial');
            }else if(paidTotal > 0){
                campsButton.classList.add('con-pagos');
            }else{
                campsButton.classList.add('sin-pagos');
            }
        }

        recalculateCurrentDebt(row);
    };

    const updateDetailData = (select, detail) => {
        if(!select){
            return;
        }

        select.dataset.detail = JSON.stringify(detail);
        select.dataset.rendered = '0';
        const menu = getDetailMenu(select);

        if(menu){
            menu.innerHTML = '';
        }

        renderDetailSummary(select);
    };

    const getAffiliationStateFromPayment = (paid, amount, wasPaid) => {
        if(wasPaid || (amount > 0 && paid >= amount)){
            return { state: 'abonada', text: 'Abonada', debt: 0 };
        }

        if(paid > 0){
            return { state: 'parcial', text: 'Parcial', debt: Math.max(amount - paid, 0) };
        }

        return { state: 'pendiente', text: 'Impaga', debt: Math.max(amount, 0) };
    };

    const recalculateAffiliationCurrency = (row) => {
        const button = row.querySelector('.revision_afiliacion');
        const hiddenInput = row.querySelector('.revision_afiliacion_value');
        const currentDebtInput = row.querySelector('.revision_deuda_actual');

        if(!button){
            return 0;
        }

        const amount = Number(button.dataset.affiliationAmount) || 0;
        const paid = convertPaidToPesos(
            parseRevisionJson(button.dataset.paidBreakdown, {}),
            button.dataset.paidFallback
        );
        const original = getAffiliationStateFromPayment(paid, amount, button.dataset.paidComplete === '1');

        button.dataset.originalState = original.state;
        button.dataset.originalText = original.text;
        button.dataset.originalDebtValue = String(original.debt);

        const isWithoutAffiliation = button.dataset.state === 'sin-afiliacion';
        const nextState = isWithoutAffiliation ? 'sin-afiliacion' : original.state;
        const nextText = isWithoutAffiliation ? 'Sin Afiliacion' : original.text;
        const nextDebt = isWithoutAffiliation ? 0 : original.debt;

        button.classList.remove('pendiente', 'abonada', 'parcial', 'sin-afiliacion');
        button.classList.add(nextState);
        button.dataset.state = nextState;
        button.dataset.debtValue = String(nextDebt);
        button.textContent = nextText;

        if(hiddenInput){
            hiddenInput.value = nextState;
        }

        if(currentDebtInput){
            currentDebtInput.dataset.affiliationDebt = String(nextDebt);
        }

        return nextDebt;
    };

    const recalculateFeesCurrency = (row) => {
        const currentDebtInput = row.querySelector('.revision_deuda_actual');
        const select = row.querySelector('.revision_cuotas_select');
        const button = row.querySelector('.revision_cuotas');

        if(!currentDebtInput || !select || !button){
            return 0;
        }

        if(!currentDebtInput.dataset.feesDetailBase){
            currentDebtInput.dataset.feesDetailBase = currentDebtInput.dataset.feesDetail || '[]';
        }

        const fees = parseRevisionJson(currentDebtInput.dataset.feesDetailBase, []);
        let totalDebt = 0;
        const recalculatedFees = fees.map((fee) => {
            const paid = getConvertedPayment(fee);
            const amount = Number(fee.amount) || 0;
            const active = fee.active !== false;
            const paidComplete = Boolean(fee.paidComplete) || (amount > 0 && paid >= amount);
            let state = 'pendiente';
            let debt = amount;

            if(!active){
                state = 'no-abona';
                debt = 0;
            }else if(paidComplete){
                state = 'abonada';
                debt = 0;
            }else if(paid > 0){
                state = 'parcial';
                debt = Math.max(amount - paid, 0);
            }

            totalDebt += debt;

            return {
                ...fee,
                value: paid,
                debt,
                state
            };
        });

        currentDebtInput.dataset.feesDetail = JSON.stringify(recalculatedFees);
        currentDebtInput.dataset.feesDetailActive = JSON.stringify(recalculatedFees);
        currentDebtInput.dataset.originalFeesDebt = String(totalDebt);
        currentDebtInput.dataset.feesDebt = String(totalDebt);
        updateDetailData(select, recalculatedFees);

        button.textContent = formatRevisionCurrency(totalDebt);
        button.classList.remove('sin-pagos', 'con-pagos', 'ok-pagos', 'parcial');
        button.classList.add(totalDebt > 0 ? 'parcial' : 'ok-pagos');

        return totalDebt;
    };

    const recalculateSimplePaymentsCurrency = (row, selector, buttonSelector) => {
        const select = row.querySelector(selector);
        const button = row.querySelector(buttonSelector);

        if(!select || !button){
            return;
        }

        const payments = parseDetailData(select).map((payment) => {
            const paid = getConvertedPayment(payment);
            const amount = Number(payment.amount) || 0;
            let state = 'pendiente';

            if(amount > 0 && paid >= amount){
                state = 'abonada';
            }else if(paid > 0){
                state = 'parcial';
            }

            return { ...payment, paid, state };
        });
        const totalPaid = payments.reduce((total, payment) => total + (Number(payment.paid) || 0), 0);

        updateDetailData(select, payments);
        button.textContent = formatRevisionCurrency(totalPaid);
        button.classList.remove('sin-pagos', 'con-pagos', 'ok-pagos', 'parcial');
        button.classList.add(totalPaid > 0 ? 'parcial' : 'ok-pagos');
    };

    const recalculateCampsCurrency = (row) => {
        const currentDebtInput = row.querySelector('.revision_deuda_actual');
        const select = row.querySelector('.revision_campamentos_select');
        const button = row.querySelector('.revision_campamentos');

        if(!currentDebtInput || !select || !button){
            return 0;
        }

        const camps = parseDetailData(select).map((camp) => {
            const paid = getConvertedPayment(camp);
            const amount = Number(camp.amount) || 0;
            let state = 'no-abona';
            let debt = Math.max(amount - paid, 0);

            // Suma deuda si el miembro confirmó asistencia y no pagó el total
            if(amount > 0 && paid >= amount){
                state = 'abonada';
                debt = 0;
            }else if(paid > 0){
                state = 'parcial';
            }else if(camp.attends){
                state = 'pendiente';
            }

            const countsDebt = Boolean(camp.attends) && debt > 0;
            const visibleDebt = countsDebt ? debt : 0;

            return {
                ...camp,
                paid,
                debt,
                visibleDebt,
                countsDebt,
                state
            };
        });
        const totalPaid = camps.reduce((total, camp) => total + (Number(camp.paid) || 0), 0);
        const totalDebt = camps.reduce((total, camp) => total + (camp.countsDebt ? Number(camp.debt) || 0 : 0), 0);
        const hasPartialDebt = camps.some((camp) => camp.countsDebt && (Number(camp.debt) || 0) > 0);

        currentDebtInput.dataset.campsDebt = String(totalDebt);
        updateDetailData(select, camps);
        button.dataset.paidTotal = String(totalPaid);
        button.textContent = formatRevisionCurrency(totalDebt);
        button.classList.remove('sin-pagos', 'con-pagos', 'parcial');

        if(hasPartialDebt){
            button.classList.add('parcial');
        }else if(totalPaid > 0){
            button.classList.add('con-pagos');
        }else{
            button.classList.add('sin-pagos');
        }

        return totalDebt;
    };

    const recalculateDebtCurrencyValues = () => {
        revisionRows.forEach((row) => {
            recalculateAffiliationCurrency(row);
            recalculateFeesCurrency(row);
            recalculateSimplePaymentsCurrency(row, '.revision_generales_select', '.revision_generales');
            recalculateSimplePaymentsCurrency(row, '.revision_eventos_select', '.revision_eventos');
            recalculateCampsCurrency(row);
            recalculateCurrentDebt(row, false);
        });

        syncAffiliationDebtSummary();
        syncCurrentDebtSummary();
    };

    const syncFeesVisualCriteria = (row, shouldPayFees) => {
        const currentDebtInput = row.querySelector('.revision_deuda_actual');
        const select = row.querySelector('.revision_cuotas_select');
        const button = row.querySelector('.revision_cuotas');

        if(!currentDebtInput || !select || !button){
            return;
        }

        const baseFees = parseRevisionJson(currentDebtInput.dataset.feesDetailActive || currentDebtInput.dataset.feesDetail, []);

        if(shouldPayFees){
            updateDetailData(select, baseFees);
            button.textContent = formatRevisionCurrency(Number(currentDebtInput.dataset.feesDebt) || 0);
            button.classList.remove('sin-pagos', 'con-pagos', 'ok-pagos', 'parcial');
            button.classList.add((Number(currentDebtInput.dataset.feesDebt) || 0) > 0 ? 'parcial' : 'ok-pagos');
            return;
        }

        const disabledFees = baseFees.map((fee) => ({
            ...fee,
            debt: 0,
            state: 'no-abona'
        }));

        updateDetailData(select, disabledFees);
        button.textContent = formatRevisionCurrency(0);
        button.classList.remove('sin-pagos', 'con-pagos', 'parcial');
        button.classList.add('ok-pagos');
    };

    const applyRamaFeeCriteria = () => {
        const ramasWithoutFees = new Set(
            Array.from(ramaFeeChecks)
                .filter((input) => !input.checked)
                .map((input) => input.value)
        );

        revisionRows.forEach((row) => {
            const currentDebtInput = row.querySelector('.revision_deuda_actual');

            if(!currentDebtInput){
                return;
            }

            const originalFeesDebt = currentDebtInput.dataset.originalFeesDebt || currentDebtInput.dataset.feesDebt || '0';
            const shouldPayFees = !ramasWithoutFees.has(row.dataset.ramaCode);
            currentDebtInput.dataset.feesDebt = shouldPayFees ? originalFeesDebt : '0';
            syncFeesVisualCriteria(row, shouldPayFees);
            recalculateCurrentDebt(row, false);
        });

        syncCurrentDebtSummary();
    };

    const saveRamaFeeCriteria = () => {
        const config = Array.from(ramaFeeChecks).reduce((data, input) => {
            data[input.value] = input.checked;
            return data;
        }, {});

        sessionStorage.setItem(revisionConfigStorageKey, JSON.stringify(config));
    };

    const loadRamaFeeCriteria = () => {
        const savedConfig = sessionStorage.getItem(revisionConfigStorageKey);

        if(!savedConfig){
            return;
        }

        try {
            const config = JSON.parse(savedConfig);

            ramaFeeChecks.forEach((input) => {
                if(Object.prototype.hasOwnProperty.call(config, input.value)){
                    input.checked = Boolean(config[input.value]);
                }
            });
        } catch (error) {
            console.error('Error al cargar configuracion de revision de deuda:', error);
        }
    };

    const saveCurrencyRates = () => {
        const rates = getCurrencyRates();
        sessionStorage.setItem(revisionCurrencyRatesStorageKey, JSON.stringify(rates));
    };

    const loadCurrencyRates = () => {
        const savedRates = sessionStorage.getItem(revisionCurrencyRatesStorageKey);

        if(!savedRates){
            return;
        }

        try {
            const rates = JSON.parse(savedRates);

            currencyRateInputs.forEach((input) => {
                const code = input.dataset.currencyCode;

                if(code && Object.prototype.hasOwnProperty.call(rates, code)){
                    input.value = rates[code];
                }
            });
        } catch (error) {
            console.error('Error al cargar conversion de monedas de revision de deuda:', error);
        }
    };

    reviewButton.addEventListener('click', refreshBeforeOpen);

    if(closeButton){
        closeButton.addEventListener('click', closeScreen);
    }

    navButtons.forEach((button) => {
        button.addEventListener('click', () => {
            showRevisionPanel(button.dataset.revisionView || 'deudas');
        });
    });

    if(reviewTable){
        reviewTable.addEventListener('change', (event) => {
            if(event.target.classList.contains('revision_check_all')){
                getVisibleRowChecks().forEach((input) => {
                    input.checked = event.target.checked;
                });

                syncReviewCheckAll();
                return;
            }

            if(event.target.classList.contains('revision_row_check')){
                syncReviewCheckAll();
            }
        });

        reviewTable.addEventListener('click', (event) => {
            const campToggle = event.target.closest('.revision_campamento_toggle');
            const affiliationButton = event.target.closest('.revision_afiliacion');
            const detailButton = event.target.closest('.revision_cuotas, .revision_generales, .revision_eventos, .revision_campamentos');

            if(campToggle && reviewTable.contains(campToggle)){
                event.stopPropagation();

                const item = campToggle.closest('.revision_campamento_item');
                const row = campToggle.closest('tr');
                const countsDebt = campToggle.dataset.countsDebt !== '1';
                const paid = Number(item ? item.dataset.campPaid : 0) || 0;
                const amount = Number(item ? item.dataset.campAmount : 0) || 0;
                const debt = Math.max(amount - paid, 0);
                const debtLabel = item ? item.querySelector('.revision_campamento_deuda strong') : null;

                if(item){
                    item.dataset.campDebt = String(debt);
                }

                campToggle.dataset.countsDebt = countsDebt ? '1' : '0';
                campToggle.classList.toggle('cuenta', countsDebt);
                campToggle.classList.toggle('no-abona', !countsDebt);
                campToggle.textContent = countsDebt ? 'Cuenta' : 'No abona';

                if(debtLabel){
                    debtLabel.textContent = formatRevisionCurrency(countsDebt ? debt : 0);
                }

                if(item){
                    item.classList.toggle('excluida', !countsDebt);
                }

                updateCampsDebt(row);
                return;
            }

            if(affiliationButton && reviewTable.contains(affiliationButton)){
                const select = affiliationButton.closest('.revision_afiliacion_select');
                const hiddenInput = select ? select.querySelector('.revision_afiliacion_value') : null;
                const row = affiliationButton.closest('tr');
                const currentDebtInput = row ? row.querySelector('.revision_deuda_actual') : null;
                const originalState = affiliationButton.dataset.originalState || 'pendiente';
                const originalText = affiliationButton.dataset.originalText || 'Impaga';
                const originalDebtValue = affiliationButton.dataset.originalDebtValue || '0';
                const isWithoutAffiliation = affiliationButton.dataset.state === 'sin-afiliacion';
                const nextState = isWithoutAffiliation ? originalState : 'sin-afiliacion';
                const nextText = isWithoutAffiliation ? originalText : 'Sin Afiliacion';
                const nextDebtValue = isWithoutAffiliation ? originalDebtValue : '0';

                closeDetailMenus();

                affiliationButton.classList.remove('pendiente', 'abonada', 'parcial', 'sin-afiliacion');
                affiliationButton.classList.add(nextState);
                affiliationButton.dataset.state = nextState;
                affiliationButton.dataset.debtValue = nextDebtValue;
                affiliationButton.textContent = nextText;

                if(hiddenInput){
                    hiddenInput.value = nextState;
                }

                if(currentDebtInput){
                    currentDebtInput.dataset.affiliationDebt = nextDebtValue;
                    recalculateCurrentDebt(row);
                    syncAffiliationDebtSummary();
                    applyTableFilters();
                }

                return;
            }

            if(detailButton && reviewTable.contains(detailButton)){
                const select = detailButton.closest('[data-revision-detail]');
                const menu = getDetailMenu(select);

                if(!select || !menu){
                    return;
                }

                const isOpen = menu.classList.toggle('mostrar');

                closeDetailMenus(select);
                renderDetailMenu(select);
                detailButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
            }
        });
    }

    pageButtons.forEach((button) => {
        button.addEventListener('click', () => {
            currentPage += button.dataset.pageAction === 'next' ? 1 : -1;
            syncPagination();
        });
    });

    if(searchInput){
        searchInput.addEventListener('input', applyTableFilters);
    }

    ramaFeeChecks.forEach((input) => {
        input.addEventListener('change', applyRamaFeeCriteria);
    });

    currencyRateInputs.forEach((input) => {
        input.addEventListener('change', () => {
            saveCurrencyRates();
            recalculateDebtCurrencyValues();
            applyRamaFeeCriteria();
        });
    });

    if(configSaveButton){
        configSaveButton.addEventListener('click', () => {
            saveRamaFeeCriteria();
            saveCurrencyRates();
            recalculateDebtCurrencyValues();
            applyRamaFeeCriteria();
            syncPagination();
            showRevisionPanel('deudas');

            if(typeof showAlert === 'function'){
                showAlert('success', 'Configuracion guardada correctamente');
            }
        });
    }

    const campDebtSelect = reviewScreen.querySelector('.revision_deuda_camp_select');
    const campDebtValue = reviewScreen.querySelector('[data-revision-camp-debt]');

    if(campDebtSelect && campDebtValue){
        campDebtSelect.addEventListener('change', () => {
            campDebtValue.textContent = formatRevisionCurrency(campDebtSelect.value);
        });
    }

    if(filterButton && filterMenu){
        filterButton.addEventListener('click', () => {
            const isOpen = filterMenu.classList.toggle('mostrar');
            filterButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            filterMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        });

        filterMenu.addEventListener('click', (event) => {
            const option = event.target.closest('.revision_deuda_filter_option');

            if(!option){
                return;
            }

            const isAllOption = normalizeRevisionSearch(option.textContent) === 'todas';

            if(isAllOption){
                filterMenu.querySelectorAll('.revision_deuda_filter_option').forEach((item) => item.classList.remove('active'));
                option.classList.add('active');
            }else{
                option.classList.toggle('active');
                const allOption = filterMenu.querySelector('.revision_deuda_filter_option');

                if(allOption && normalizeRevisionSearch(allOption.textContent) === 'todas'){
                    allOption.classList.remove('active');
                }

                if(filterMenu.querySelectorAll('.revision_deuda_filter_option.active').length === 0){
                    const allOptionFallback = Array.from(filterMenu.querySelectorAll('.revision_deuda_filter_option'))
                        .find((item) => normalizeRevisionSearch(item.textContent) === 'todas');

                    if(allOptionFallback){
                        allOptionFallback.classList.add('active');
                    }
                }
            }

            renderFilterChips();
            applyTableFilters();
        });
    }

    if(filterChips && filterMenu){
        filterChips.addEventListener('click', (event) => {
            const closeButton = event.target.closest('button');
            const chip = closeButton ? closeButton.closest('.revision_deuda_filter_chip') : null;

            if(!chip){
                return;
            }

            const chipGroup = chip.dataset.filterGroup || '';
            const chipValue = chip.dataset.filterValue || '';

            filterMenu.querySelectorAll('.revision_deuda_filter_option.active').forEach((option) => {
                const sameGroup = getFilterGroupLabel(option) === chipGroup;
                const sameValue = option.textContent.trim() === chipValue;

                if(sameGroup && sameValue){
                    option.classList.remove('active');
                }
            });

            if(filterMenu.querySelectorAll('.revision_deuda_filter_option.active').length === 0){
                const allOption = Array.from(filterMenu.querySelectorAll('.revision_deuda_filter_option'))
                    .find((option) => normalizeRevisionSearch(option.textContent) === 'todas');

                if(allOption){
                    allOption.classList.add('active');
                }
            }

            renderFilterChips();
            applyTableFilters();
        });
    }

    if(filterClearButton && filterMenu){
        filterClearButton.addEventListener('click', () => {
            filterMenu.querySelectorAll('.revision_deuda_filter_option').forEach((option) => option.classList.remove('active'));

            const allOption = Array.from(filterMenu.querySelectorAll('.revision_deuda_filter_option'))
                .find((option) => normalizeRevisionSearch(option.textContent) === 'todas');

            if(allOption){
                allOption.classList.add('active');
            }

            renderFilterChips();
            applyTableFilters();
        });
    }

    document.addEventListener('click', (event) => {
        const clickedDetailSelect = event.target.closest('[data-revision-detail]');

        if(filterMenu && filterMenu.classList.contains('mostrar') && !filterMenu.contains(event.target) && !filterButton.contains(event.target)){
            filterMenu.classList.remove('mostrar');
            filterButton.setAttribute('aria-expanded', 'false');
            filterMenu.setAttribute('aria-hidden', 'true');
        }

        if(clickedDetailSelect && reviewScreen.contains(clickedDetailSelect)){
            return;
        }

        closeDetailMenus();
    });

    document.addEventListener('keydown', (event) => {
        if(event.key === 'Escape' && reviewScreen.classList.contains('mostrar')){
            closeScreen();
        }

        if(event.key === 'Escape' && filterMenu && filterMenu.classList.contains('mostrar')){
            filterMenu.classList.remove('mostrar');
            filterButton.setAttribute('aria-expanded', 'false');
            filterMenu.setAttribute('aria-hidden', 'true');
        }

        if(event.key === 'Escape'){
            closeDetailMenus();
        }
    });

    renderFilterChips();
    loadRamaFeeCriteria();
    loadCurrencyRates();
    recalculateDebtCurrencyValues();
    syncPagination();
    applyRamaFeeCriteria();

    if(sessionStorage.getItem('openRevisionDebtAfterRefresh') === '1'){
        const refreshedPeriod = sessionStorage.getItem('revisionDebtPeriod') || getSelectedPeriod();

        sessionStorage.removeItem('openRevisionDebtAfterRefresh');
        sessionStorage.removeItem('revisionDebtPeriod');
        openScreen(refreshedPeriod);
    }

    if(reviewScreen.classList.contains('mostrar')){
        document.documentElement.classList.add('revision_deuda_lock');
        document.body.classList.add('revision_deuda_lock');
    }
}

function openDebtReviewScreen(){
    const reviewButton = document.querySelector('.config_periodo .revision_deuda');
    const reviewScreen = document.querySelector('.revision_deuda_screen');

    if(!reviewButton || !reviewScreen){
        return;
    }

    const closeButton = reviewScreen.querySelector('.revision_deuda_close');
    const periodLabel = reviewScreen.querySelector('[data-revision-period]');
    const periodInputs = document.querySelectorAll('.config_periodo input[name="periodo_config"]');
    const reviewCheckAll = reviewScreen.querySelector('.revision_check_all');
    const reviewRowChecks = reviewScreen.querySelectorAll('.revision_row_check');
    const filterButton = reviewScreen.querySelector('.revision_deuda_filter_btn');
    const filterMenu = reviewScreen.querySelector('.revision_deuda_filter_menu');
    const filterOptions = reviewScreen.querySelectorAll('.revision_deuda_filter_option');
    const affiliationSelects = reviewScreen.querySelectorAll('.revision_afiliacion_select');
    const feesSelects = reviewScreen.querySelectorAll('.revision_cuotas_select');
    const generalSelects = reviewScreen.querySelectorAll('.revision_generales_select');
    const eventSelects = reviewScreen.querySelectorAll('.revision_eventos_select');
    const campSelects = reviewScreen.querySelectorAll('.revision_campamentos_select');

    const getSelectedPeriod = () => {
        const selected = document.querySelector('.config_periodo input[name="periodo_config"]:checked');
        return selected ? selected.value : '2026';
    };

    const selectedPeriodIsCurrent = () => {
        const selected = document.querySelector('.config_periodo input[name="periodo_config"]:checked');
        const selectedLabel = selected ? selected.closest('.periodo_option') : null;
        return selectedLabel ? selectedLabel.classList.contains('is-current') : true;
    };

    const syncReviewButton = () => {
        const isDisabled = selectedPeriodIsCurrent();
        reviewButton.classList.toggle('disabled', isDisabled);
        reviewButton.disabled = isDisabled;
        reviewButton.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
    };

    const openScreen = (period = null) => {
        if(selectedPeriodIsCurrent()){
            return;
        }

        if(periodLabel){
            periodLabel.textContent = period || getSelectedPeriod();
        }

        reviewScreen.classList.add('mostrar');
        reviewScreen.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('revision_deuda_lock');
        document.body.classList.add('revision_deuda_lock');
    };

    const refreshBeforeOpen = () => {
        if(selectedPeriodIsCurrent()){
            return;
        }

        sessionStorage.setItem('openRevisionDebtAfterRefresh', '1');
        sessionStorage.setItem('revisionDebtPeriod', getSelectedPeriod());
        reviewButton.disabled = true;
        reviewButton.classList.add('disabled');
        window.location.reload();
    };

    const closeScreen = () => {
        reviewScreen.classList.remove('mostrar');
        reviewScreen.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('revision_deuda_lock');
        document.body.classList.remove('revision_deuda_lock');
    };

    reviewButton.addEventListener('click', refreshBeforeOpen);
    periodInputs.forEach((input) => input.addEventListener('change', syncReviewButton));

    if(closeButton){
        closeButton.addEventListener('click', closeScreen);
    }

    const syncReviewCheckAll = () => {
        if(!reviewCheckAll || reviewRowChecks.length === 0){
            return;
        }

        const checkedCount = Array.from(reviewRowChecks).filter((input) => input.checked).length;

        reviewCheckAll.checked = checkedCount === reviewRowChecks.length;
        reviewCheckAll.indeterminate = checkedCount > 0 && checkedCount < reviewRowChecks.length;
    };

    if(reviewCheckAll && reviewRowChecks.length > 0){
        reviewCheckAll.addEventListener('change', () => {
            reviewRowChecks.forEach((input) => {
                input.checked = reviewCheckAll.checked;
            });

            syncReviewCheckAll();
        });

        reviewRowChecks.forEach((input) => {
            input.addEventListener('change', syncReviewCheckAll);
        });

        syncReviewCheckAll();
    }

    if(filterButton && filterMenu){
        filterButton.addEventListener('click', () => {
            const isOpen = filterMenu.classList.toggle('mostrar');
            filterButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            filterMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        });

        filterOptions.forEach((option) => {
            option.addEventListener('click', () => {
                filterOptions.forEach((item) => item.classList.remove('active'));
                option.classList.add('active');
                filterMenu.classList.remove('mostrar');
                filterButton.setAttribute('aria-expanded', 'false');
                filterMenu.setAttribute('aria-hidden', 'true');
            });
        });

        document.addEventListener('click', (event) => {
            if(!filterMenu.classList.contains('mostrar')){
                return;
            }

            if(filterMenu.contains(event.target) || filterButton.contains(event.target)){
                return;
            }

            filterMenu.classList.remove('mostrar');
            filterButton.setAttribute('aria-expanded', 'false');
            filterMenu.setAttribute('aria-hidden', 'true');
        });
    }

    const closeAffiliationMenus = (currentSelect = null) => {
        affiliationSelects.forEach((select) => {
            const button = select.querySelector('.revision_afiliacion');

            if(button){
                button.classList.remove('is-open');
            }
        });
    };

    const closeFeesMenus = (currentSelect = null) => {
        feesSelects.forEach((select) => {
            if(currentSelect && select === currentSelect){
                return;
            }

            const button = select.querySelector('.revision_cuotas');
            const menu = select.querySelector('.revision_cuotas_menu');

            if(button && menu){
                button.setAttribute('aria-expanded', 'false');
                menu.classList.remove('mostrar');
                menu.setAttribute('aria-hidden', 'true');
            }
        });
    };

    const closeGeneralMenus = (currentSelect = null) => {
        generalSelects.forEach((select) => {
            if(currentSelect && select === currentSelect){
                return;
            }

            const button = select.querySelector('.revision_generales');
            const menu = select.querySelector('.revision_generales_menu');

            if(button && menu){
                button.setAttribute('aria-expanded', 'false');
                menu.classList.remove('mostrar');
                menu.setAttribute('aria-hidden', 'true');
            }
        });
    };

    const closeEventMenus = (currentSelect = null) => {
        eventSelects.forEach((select) => {
            if(currentSelect && select === currentSelect){
                return;
            }

            const button = select.querySelector('.revision_eventos');
            const menu = select.querySelector('.revision_eventos_menu');

            if(button && menu){
                button.setAttribute('aria-expanded', 'false');
                menu.classList.remove('mostrar');
                menu.setAttribute('aria-hidden', 'true');
            }
        });
    };

    const closeCampMenus = (currentSelect = null) => {
        campSelects.forEach((select) => {
            if(currentSelect && select === currentSelect){
                return;
            }

            const button = select.querySelector('.revision_campamentos');
            const menu = select.querySelector('.revision_campamentos_menu');

            if(button && menu){
                button.setAttribute('aria-expanded', 'false');
                menu.classList.remove('mostrar');
                menu.setAttribute('aria-hidden', 'true');
            }
        });
    };

    const formatRevisionCurrency = (value) => {
        const amount = Number(value) || 0;

        return '$ ' + amount.toLocaleString('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    const recalculateCurrentDebt = (row) => {
        const currentDebtInput = row ? row.querySelector('.revision_deuda_actual') : null;

        if(!currentDebtInput){
            return;
        }

        const affiliationButton = row.querySelector('.revision_afiliacion');
        const affiliationDebt = Number(affiliationButton ? affiliationButton.dataset.debtValue : currentDebtInput.dataset.affiliationDebt) || 0;
        const feesDebt = Number(currentDebtInput.dataset.feesDebt) || 0;
        const campsDebt = Number(currentDebtInput.dataset.campsDebt) || 0;
        const currentDebt = affiliationDebt + feesDebt + campsDebt;
        const formattedDebt = formatRevisionCurrency(currentDebt);
        const debtStatus = row.querySelector('.revision_estado');

        currentDebtInput.value = formattedDebt;
        currentDebtInput.placeholder = formattedDebt;
        currentDebtInput.classList.toggle('sin-deuda', currentDebt <= 0);

        if(debtStatus){
            debtStatus.classList.toggle('con-deuda', currentDebt > 0);
            debtStatus.classList.toggle('sin-deuda', currentDebt <= 0);
            debtStatus.textContent = currentDebt > 0 ? 'Con deuda' : 'Sin deuda';
        }
    };

    const updateCampsDebt = (row) => {
        const currentDebtInput = row ? row.querySelector('.revision_deuda_actual') : null;
        const campsButton = row ? row.querySelector('.revision_campamentos') : null;

        if(!currentDebtInput){
            return;
        }

        let campsDebt = 0;
        row.querySelectorAll('.revision_campamento_item').forEach((item) => {
            const toggle = item.querySelector('.revision_campamento_toggle');

            if(toggle && toggle.dataset.countsDebt === '1'){
                campsDebt += Number(item.dataset.campDebt) || 0;
            }
        });

        currentDebtInput.dataset.campsDebt = String(campsDebt);

        if(campsButton){
            const paidTotal = Number(campsButton.dataset.paidTotal) || 0;

            campsButton.textContent = formatRevisionCurrency(campsDebt);
            campsButton.classList.remove('sin-pagos', 'con-pagos', 'parcial');

            if(campsDebt > 0){
                campsButton.classList.add('parcial');
            }else if(paidTotal > 0){
                campsButton.classList.add('con-pagos');
            }else{
                campsButton.classList.add('sin-pagos');
            }
        }

        recalculateCurrentDebt(row);
    };

    affiliationSelects.forEach((select) => {
        const button = select.querySelector('.revision_afiliacion');
        const hiddenInput = select.querySelector('.revision_afiliacion_value');
        const updateCurrentDebtFromAffiliation = () => {
            const row = select.closest('tr');
            const currentDebtInput = row ? row.querySelector('.revision_deuda_actual') : null;

            if(currentDebtInput){
                currentDebtInput.dataset.affiliationDebt = button.dataset.debtValue || '0';
                recalculateCurrentDebt(row);
            }
        };

        if(!button){
            return;
        }

        button.addEventListener('click', () => {
            const originalState = button.dataset.originalState || 'pendiente';
            const originalText = button.dataset.originalText || 'Impaga';
            const originalDebtValue = button.dataset.originalDebtValue || '0';
            const isWithoutAffiliation = button.dataset.state === 'sin-afiliacion';
            const nextState = isWithoutAffiliation ? originalState : 'sin-afiliacion';
            const nextText = isWithoutAffiliation ? originalText : 'Sin Afiliacion';
            const nextDebtValue = isWithoutAffiliation ? originalDebtValue : '0';

            closeFeesMenus();
            closeGeneralMenus();
            closeEventMenus();
            closeCampMenus();

            button.classList.remove('pendiente', 'abonada', 'parcial', 'sin-afiliacion');
            button.classList.add(nextState);
            button.dataset.state = nextState;
            button.dataset.debtValue = nextDebtValue;
            button.textContent = nextText;

            if(hiddenInput){
                hiddenInput.value = nextState;
            }

            updateCurrentDebtFromAffiliation();
        });

        updateCurrentDebtFromAffiliation();
    });

    feesSelects.forEach((select) => {
        const button = select.querySelector('.revision_cuotas');
        const menu = select.querySelector('.revision_cuotas_menu');

        if(!button || !menu){
            return;
        }

        button.addEventListener('click', () => {
            const isOpen = menu.classList.toggle('mostrar');

            closeFeesMenus(select);
            closeAffiliationMenus();
            closeGeneralMenus();
            closeEventMenus();
            closeCampMenus();
            button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        });
    });

    generalSelects.forEach((select) => {
        const button = select.querySelector('.revision_generales');
        const menu = select.querySelector('.revision_generales_menu');

        if(!button || !menu){
            return;
        }

        button.addEventListener('click', () => {
            const isOpen = menu.classList.toggle('mostrar');

            closeGeneralMenus(select);
            closeAffiliationMenus();
            closeFeesMenus();
            closeEventMenus();
            closeCampMenus();
            button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        });
    });

    eventSelects.forEach((select) => {
        const button = select.querySelector('.revision_eventos');
        const menu = select.querySelector('.revision_eventos_menu');

        if(!button || !menu){
            return;
        }

        button.addEventListener('click', () => {
            const isOpen = menu.classList.toggle('mostrar');

            closeEventMenus(select);
            closeAffiliationMenus();
            closeFeesMenus();
            closeGeneralMenus();
            closeCampMenus();
            button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        });
    });

    campSelects.forEach((select) => {
        const button = select.querySelector('.revision_campamentos');
        const menu = select.querySelector('.revision_campamentos_menu');
        const campToggles = select.querySelectorAll('.revision_campamento_toggle');

        if(!button || !menu){
            return;
        }

        button.addEventListener('click', () => {
            const isOpen = menu.classList.toggle('mostrar');

            closeCampMenus(select);
            closeAffiliationMenus();
            closeFeesMenus();
            closeGeneralMenus();
            closeEventMenus();
            button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        });

        campToggles.forEach((toggle) => {
            toggle.addEventListener('click', (event) => {
                event.stopPropagation();

                const item = toggle.closest('.revision_campamento_item');
                const row = select.closest('tr');
                const countsDebt = toggle.dataset.countsDebt !== '1';
                const paid = Number(item ? item.dataset.campPaid : 0) || 0;
                const amount = Number(item ? item.dataset.campAmount : 0) || 0;
                const debtLabel = item ? item.querySelector('.revision_campamento_deuda strong') : null;

                toggle.dataset.countsDebt = countsDebt ? '1' : '0';
                toggle.classList.toggle('cuenta', countsDebt);
                toggle.classList.toggle('no-abona', !countsDebt);
                toggle.textContent = countsDebt ? 'Cuenta' : 'No abona';

                if(debtLabel){
                    debtLabel.textContent = formatRevisionCurrency(countsDebt ? item.dataset.campDebt : 0);
                }

                if(item && paid < amount){
                    item.classList.toggle('parcial', countsDebt);
                    item.classList.toggle('no-abona', !countsDebt);
                    item.classList.remove('pendiente');
                }

                updateCampsDebt(row);
            });
        });
    });

    document.addEventListener('keydown', (event) => {
        if(event.key === 'Escape' && reviewScreen.classList.contains('mostrar')){
            closeScreen();
        }

        if(event.key === 'Escape' && filterMenu && filterMenu.classList.contains('mostrar')){
            filterMenu.classList.remove('mostrar');
            filterButton.setAttribute('aria-expanded', 'false');
            filterMenu.setAttribute('aria-hidden', 'true');
        }

        if(event.key === 'Escape'){
            closeAffiliationMenus();
            closeFeesMenus();
            closeGeneralMenus();
            closeEventMenus();
            closeCampMenus();
        }
    });

    document.addEventListener('click', (event) => {
        const clickedAffiliationSelect = event.target.closest('.revision_afiliacion_select');
        const clickedFeesSelect = event.target.closest('.revision_cuotas_select');
        const clickedGeneralSelect = event.target.closest('.revision_generales_select');
        const clickedEventSelect = event.target.closest('.revision_eventos_select');
        const clickedCampSelect = event.target.closest('.revision_campamentos_select');

        if(
            (clickedAffiliationSelect && reviewScreen.contains(clickedAffiliationSelect)) ||
            (clickedFeesSelect && reviewScreen.contains(clickedFeesSelect)) ||
            (clickedGeneralSelect && reviewScreen.contains(clickedGeneralSelect)) ||
            (clickedEventSelect && reviewScreen.contains(clickedEventSelect)) ||
            (clickedCampSelect && reviewScreen.contains(clickedCampSelect))
        ){
            return;
        }

        closeAffiliationMenus();
        closeFeesMenus();
        closeGeneralMenus();
        closeEventMenus();
        closeCampMenus();
    });

    syncReviewButton();

    if(sessionStorage.getItem('openRevisionDebtAfterRefresh') === '1'){
        const refreshedPeriod = sessionStorage.getItem('revisionDebtPeriod') || getSelectedPeriod();

        sessionStorage.removeItem('openRevisionDebtAfterRefresh');
        sessionStorage.removeItem('revisionDebtPeriod');

        if(periodLabel){
            periodLabel.textContent = refreshedPeriod;
        }

        reviewScreen.classList.add('mostrar');
        reviewScreen.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('revision_deuda_lock');
        document.body.classList.add('revision_deuda_lock');
    }

    if(reviewScreen.classList.contains('mostrar')){
        document.documentElement.classList.add('revision_deuda_lock');
        document.body.classList.add('revision_deuda_lock');
    }
}

// INICIO REFRESHS

// MONEDAS
function refreshCurrency(curren,action){
    const panel_cobros = document.querySelector('section.panel_cobros');
    const panel_pagos = document.querySelector('section.panel_pagos');
    const panel_caja = document.querySelector('section.panel_cajadiaria');
    const select_cobro = panel_cobros.querySelector('select#moneda_cobro');
    const select_campa_cobro = panel_cobros.querySelector('select#moneda_campa_cobro');
    const select_campa_pagado = panel_cobros.querySelector('select#moneda_pagado_campa');
    const select_pago = panel_pagos.querySelector('select#moneda_pago');
    const select_caja = panel_caja.querySelector('select#moneda_caja');
    const currCode = curren.getAttribute('data-id');
    const currNombre = curren.querySelector("input.nombre").value;
    const currSigno = curren.querySelector("input.signo").value;

    if (action == 'create'){
        const newOption = document.createElement('OPTION');
        newOption.classList.add('moneda');
        newOption.value = currCode;
        newOption.text = currNombre + ' ' + currSigno;

        select_cobro.appendChild(newOption.cloneNode(true));
        if(select_campa_cobro){select_campa_cobro.appendChild(newOption.cloneNode(true));}
        if(select_campa_pagado){select_campa_pagado.appendChild(newOption.cloneNode(true));}
        select_pago.appendChild(newOption.cloneNode(true));
        select_caja.appendChild(newOption.cloneNode(true));
        initCajaCurrencySelector();
    }
    else if (action == 'update'){
        [select_cobro,select_campa_cobro,select_campa_pagado,select_pago,select_caja].forEach(select => {
            if(!select){return;}
            const option = select.querySelector(`option[value="${currCode}"]`);
            if(option){
                option.text = currNombre + ' ' + currSigno;
            }
        })

        initCajaCurrencySelector();
        select_caja.dispatchEvent(new Event('change'));
        refreshReceiptTableList();
        refreshZClosureTableList();
    }
    else if (action == 'delete'){
        [select_cobro,select_campa_cobro,select_campa_pagado,select_pago,select_caja].forEach(select => {
            if(!select){return;}
            const option = select.querySelector(`option[value="${currCode}"]`);
            if(option){
                option.remove();
            }
        })

        initCajaCurrencySelector();
    }

    [select_cobro,select_campa_cobro,select_campa_pagado,select_pago].forEach(select => {
        if(select){
            select.dispatchEvent(new Event('change'));
        }
    })
}

// METODOS
function refreshPayMethods(method,action){
    const panel_cobros = document.querySelector('section.panel_cobros');
    const panel_pagos = document.querySelector('section.panel_pagos');
    const panel_caja = document.querySelector('section.panel_cajadiaria');
    const select_cobro = panel_cobros.querySelector('select#metodo_cobro');
    const select_pago = panel_pagos.querySelector('select#metodo_pago');
    const select_caja = panel_caja.querySelector('.select_filtro.metodo');
    const methCode = method.getAttribute('data-id');
    const methNombre = method.querySelector("input").value;

    if (action == 'create'){
        const newOption = document.createElement('OPTION');
        newOption.classList.add('metodo');
        newOption.value = methCode;
        newOption.text = methNombre;

        select_cobro.appendChild(newOption.cloneNode(true));
        select_pago.appendChild(newOption.cloneNode(true));

        // Filtro caja
        const option = document.createElement('div');
        option.id = methCode;
        option.classList.add('opciones_metodo');
        option.textContent = methNombre;
        select_caja.appendChild(option);

        const newSelect = select_caja.cloneNode(true); // true = clona hijos también
        select_caja.parentNode.replaceChild(newSelect, select_caja);

        activeCajaMethodOptions();
        // const filtro_caja_diaria = panel_caja.querySelector('.contenido_filtros .filtro_caja_diaria input');
        // filtro_caja_diaria.dispatchEvent(new Event('change'));
}
    else if (action == 'update'){
        [select_cobro,select_pago].forEach(select => {
            const option = select.querySelector(`option[value="${methCode}"]`);
            if(option){option.text = methNombre;}})

        const option_caja = select_caja.querySelector(`.opciones_metodo[id="${methCode}"]`);
        if(option_caja){option_caja.textContent = methNombre;}
        
    }
    else if (action == 'delete'){
        [select_cobro,select_pago].forEach(select => {
            const option = select.querySelector(`option[value="${methCode}"]`);
            if(option){option.remove();}})
        
        const option_caja = select_caja.querySelector(`.opciones_metodo[id="${methCode}"]`);
        if(option_caja){option_caja.remove();}
    }

    [select_cobro,select_pago].forEach(select => {
        if(select){
            select.dispatchEvent(new Event('change'));
        }
    })
    initCajaPaymentMethodSelector();
    panel_caja.dispatchEvent(new Event('caja-method-change'));
}

// MIEMBROS
async function refreshAllMembers(){
    const members = await getMembersCobrosDicFromAPI();
    refreshMemberListCobros(members);
    refreshMemberListPagos(members);
}

async function getMembersCobrosDicFromAPI(){
    try {
        const response = await fetch('/api/getMembersCobrosDicFromAPI.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();
        if (data['response'] == 200) {
            return data['data'];
        } else {
            console.error('Error en la solicitud:', data['error']);
            // if (Object.keys(data['error']).length === 0) {
            //     console.log('Error al Obtener Miembros');
            // } else {
            //     console.log(data['error']);
            // }
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

function refreshMemberListCobros(members){
    const panel_cobros = document.querySelector('section.panel_cobros');
    if(panel_cobros){
        const lista_busqueda = panel_cobros.querySelector('.lista_busqueda');
        const buscador = panel_cobros.querySelector('.buscador');
        const inputSearch = buscador.querySelector('input#search_cobro');

        inputSearch.remove();
        newInput = document.createElement('INPUT');
        newInput.type = 'search';
        newInput.name = 'search_cobro';
        newInput.id = 'search_cobro';
        newInput.placeholder = 'Buscar...';

        buscador.insertBefore(newInput, lista_busqueda);

        lista_busqueda.innerHTML = '';

        // Ordenar miembros por nombre (alfabéticamente, sin distinguir mayúsculas/minúsculas ni acentos)
        const miembrosOrdenados = Object.values(members).sort((a, b) => {
            const nombreA = quitarAcentos(a.Nombre.toLowerCase());
            const nombreB = quitarAcentos(b.Nombre.toLowerCase());
            return nombreA.localeCompare(nombreB, 'es', { sensitivity: 'base' });
        });
        miembrosOrdenados.forEach(member => {
            row = document.createElement('DIV');
            p = document.createElement('P');
            row.classList.add('busqueda');
            row.setAttribute('data-id',member.IdMiembro)
            p.textContent = member.Nombre

            row.appendChild(p);
            lista_busqueda.appendChild(row);
        })

        const newPanelCobro = panel_cobros.cloneNode(true); // true = clona hijos también
        panel_cobros.parentNode.replaceChild(newPanelCobro, panel_cobros);

        const panelCobros = document.querySelector("section.panel_cobros");
        const inputsCobros = panelCobros.querySelectorAll('input[type="text"]:not(#valor_total_cobros)');

        completePanelCobros(members);
        completeCobrosDetail(members);
        dynamicPanelCobros();
        syncCobrosGeneralLegendOverflowMarquee(newPanelCobro);
        resetPanelCobrosInputs(panelCobros,inputsCobros,members);
        switchPanelCuota();
        toggleCobrosMemberPanels(panelCobros);

    }
}

function resetPanelCobrosInputs(panelCobros,inputsCobros,members){
    const info_miembro = panelCobros.querySelector(".info_miembro");
    const lista_busqueda = panelCobros.querySelector(".lista_busqueda");

    const idMiembro = info_miembro.getAttribute('data-id');
    
    if(idMiembro){
        const nombre = info_miembro.querySelector('.nombre_miembro p');
        const rama_miembro =   info_miembro.querySelector('.rama_miembro');
        const rama_nombre =   rama_miembro.querySelector('p');
        const ramaClass = members[idMiembro]['CodRama'].split('-')[1].replace(/[0-9-]/g, '').toLowerCase();
        const newName = members[idMiembro]['Nombre']
        const cont_members = panelCobros.querySelector('.cont_member_bubble');
        const bubble = cont_members.querySelector(`.member_bubble[data-id="${idMiembro}"]`);
        
        nombre.textContent = newName;
        rama_nombre.innerHTML = members[idMiembro]['NombreRama'];
        rama_miembro.classList = ['rama_miembro ' + ramaClass];

        if(bubble){
            const nombreBubble = bubble.querySelector('p');
            if(nombreBubble){
                nombreBubble.textContent = newName;
            }
        }
    }
    
    inputsCobros.forEach(input => {
        if(!input.readOnly){
            const event = new Event('input', { bubbles: true });
            input.dispatchEvent(event);
        }else{
            input.value = '$ 0';
        }
    })

    if(idMiembro){
        const busqueda = lista_busqueda.querySelector(`.busqueda[data-id="${idMiembro}"]`);
        if(busqueda){
            busqueda.click();
        }
    }

    toggleCobrosMemberPanels(panelCobros);

}

function refreshMemberListPagos(members){
    const panel_pagos = document.querySelector('.panel_pagos');
    if(panel_pagos){
        const lista_busqueda = panel_pagos.querySelector('.lista_busqueda');
        const buscador = panel_pagos.querySelector('.buscador');
        const inputSearch = buscador.querySelector('input#search_pago');

        inputSearch.remove();
        newInput = document.createElement('INPUT');
        newInput.type = 'search';
        newInput.name = 'search_pago';
        newInput.id = 'search_pago';
        newInput.placeholder = 'Buscar...';

        buscador.insertBefore(newInput, lista_busqueda);

        lista_busqueda.innerHTML = '';
        // Ordenar miembros por nombre (alfabéticamente, sin distinguir mayúsculas/minúsculas ni acentos)
        const miembrosOrdenados = Object.values(members).sort((a, b) => {
            const nombreA = quitarAcentos(a.Nombre.toLowerCase());
            const nombreB = quitarAcentos(b.Nombre.toLowerCase());
            return nombreA.localeCompare(nombreB, 'es', { sensitivity: 'base' });
        });
        miembrosOrdenados.forEach(member => {
            row = document.createElement('DIV');
            p = document.createElement('P');
            row.classList.add('busqueda');
            row.setAttribute('data-id',member.IdMiembro)
            row.setAttribute('data-codrama',member.CodRama)
            row.setAttribute('data-rama',member.NombreRama)
            p.textContent = member.Nombre

            row.appendChild(p);
            lista_busqueda.appendChild(row);
        })

        const newPanelPagos = panel_pagos.cloneNode(true); // true = clona hijos también
        panel_pagos.parentNode.replaceChild(newPanelPagos, panel_pagos);

        const panelPagos = document.querySelector("section.panel_pagos");

        resetPanelPagos(panelPagos, members);
        togglePagosMemberLock(panelPagos);
        completePagosDetail(true);
    }
}

function resetPanelPagos(panelPagos,members){
    const info_miembro = panelPagos.querySelector(".info_miembro");
    const lista_busqueda = panelPagos.querySelector(".lista_busqueda");
    const idMiembro = info_miembro.getAttribute('data-id');
    
    if(idMiembro){
        const nombre = info_miembro.querySelector('.nombre_miembro p');
        const rama_miembro =   info_miembro.querySelector('.rama_miembro');
        const rama_nombre =   rama_miembro.querySelector('p');
        const ramaClass = members[idMiembro]['CodRama'].split('-')[1].replace(/[0-9-]/g, '').toLowerCase();
        const newName = members[idMiembro]['Nombre']
        
        nombre.textContent = newName;
        rama_nombre.innerHTML = members[idMiembro]['NombreRama'];
        rama_miembro.classList = ['rama_miembro ' + ramaClass];
    }
    
    // if(idMiembro){
    //     const busqueda = lista_busqueda.querySelector(`.busqueda[data-id="${idMiembro}"]`);
    //     if(busqueda){
    //         busqueda.click();
    //     }
    // }

    togglePagosMemberLock(panelPagos);
}

// EVENTOS
async function refreshEvents(){
    const events = await getEventsDicFromAPI();
    const members = await getMembersCobrosDicFromAPI();
    refreshEventsListCobros(events,members);
    refreshEventsListCaja(events);
}

async function getEventsDicFromAPI(){
    try {
        const response = await fetch('/api/getEventsDicFromAPI.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();
        if (data['response'] == 200) {
            return data['data'];
        } else {
            console.error('Error en la solicitud:', data['error']);
            // if (Object.keys(data['error']).length === 0) {
            //     console.log('Error al Obtener Eventos');
            // } else {
            //     console.log(data['error']);
            // }
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

function refreshEventsListCobros(events,members){
    const panel_cobros = document.querySelector('section.panel_cobros');
    if(panel_cobros){
        const importes_eventos = panel_cobros.querySelector('.importes_eventos');

        importes_eventos.innerHTML = '';

        // Ordenar evetnos por fecha de alta
        const eventosOrdenados = Object.values(events).sort((a, b) => {
            const fechaA = quitarAcentos(a.FechaAlta.toLowerCase());
            const fechaB = quitarAcentos(b.FechaAlta.toLowerCase());
            return fechaA.localeCompare(fechaB, 'es', { sensitivity: 'base' });
        });

        eventosOrdenados.forEach(event => {
            const row = document.createElement('DIV');
            const leyend = document.createElement('DIV');
            const pay = document.createElement('DIV');
            const leyendP = document.createElement('P');
            const payP = document.createElement('P');
            const input = document.createElement('INPUT');

            row.classList.add('evento');
            row.setAttribute('data-id',event.internalId)
            row.dataset.ramas = event.Ramas || 'ALL';

            leyend.classList.add('leyenda');
            pay.classList.add('pagado');
            input.type = 'text';
            input.setAttribute('data-type','evento');
            input.name = event.Nombre;
            input.id = 'importe_evento_' + event.internalId;
            input.value = '$ 0';

            leyendP.textContent = event.Nombre;
            payP.textContent = formatCurrency('0', false);


            leyend.appendChild(leyendP);
            pay.appendChild(payP);

            row.appendChild(leyend);
            row.appendChild(pay);
            row.appendChild(input);

            importes_eventos.appendChild(row);
        })

        const newPanelCobro = panel_cobros.cloneNode(true); // true = clona hijos también
        panel_cobros.parentNode.replaceChild(newPanelCobro, panel_cobros);

        const panelCobros = document.querySelector("section.panel_cobros");
        const inputsCobros = panelCobros.querySelectorAll('input[type="text"]:not(#valor_total_cobros)');

        completePanelCobros(members);
        completeCobrosDetail(members);
        dynamicPanelCobros();
        syncCobrosEventLegendOverflowMarquee(newPanelCobro);
        resetPanelCobrosInputs(panelCobros,inputsCobros,members);

    }
}

function refreshEventsListCaja(events){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const filtro_evento = panel_caja.querySelector('.contenido_filtros .filtro_evento');
        const select_filtro = filtro_evento.querySelector('.select_filtro');

        select_filtro.innerHTML = '';

        const allOption = document.createElement('div');
        allOption.id = 'ALL';
        allOption.classList.add('opciones_evento', 'all');
        allOption.textContent = 'Todos';
        select_filtro.appendChild(allOption);

        // Ordenar evetnos por fecha de alta
        const eventosOrdenados = Object.values(events).sort((a, b) => {
            const fechaA = quitarAcentos(a.FechaAlta.toLowerCase());
            const fechaB = quitarAcentos(b.FechaAlta.toLowerCase());
            return fechaA.localeCompare(fechaB, 'es', { sensitivity: 'base' });
        });

        eventosOrdenados.forEach(event => {
            const option = document.createElement('div');
            option.id = 'evento_' + event.internalId;
            option.classList.add('opciones_evento');
            option.textContent = event.Nombre;
            select_filtro.appendChild(option);
        });

        activeCajaEventOptions();
        const filtro_caja_diaria = panel_caja.querySelector('.contenido_filtros .filtro_caja_diaria input');
        filtro_caja_diaria.dispatchEvent(new Event('change'));
    }
}

// CAMPAMENTOS
async function refreshCamps(){
    const camps = await getCampsDicFromAPI();
    const members = await getMembersCobrosDicFromAPI();
    refreshCampsListCobros(camps,members);
    refreshCampsListCaja(camps);
}

async function getCampsDicFromAPI(){
    try {
        const response = await fetch('/api/getCampsDicFromAPI.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();
        if (data['response'] == 200) {
            return data['data'];
        } else {
            console.error('Error en la solicitud:', data['error']);
            // if (Object.keys(data['error']).length === 0) {
            //     console.log('Error al Obtener Campamentos');
            // } else {
            //     console.log(data['error']);
            // }
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

function refreshCampsListCobros(camps,members){
    const panel_cobros = document.querySelector('section.panel_cobros');
    if(panel_cobros){
        const lista_campas_cobros = panel_cobros.querySelector('.lista_campas_cobros');

        lista_campas_cobros.innerHTML = '';

        // Ordenar campamentos por fecha de alta
        const campasOrdenados = Object.values(camps).sort((a, b) => {
            const fechaA = getDateSortValue(a.FechaAlta || '');
            const fechaB = getDateSortValue(b.FechaAlta || '');
            return fechaB - fechaA;
        });

        campasOrdenados.forEach(camp => {
            const campa = document.createElement('div');
            campa.classList.add('campa');
            campa.setAttribute('data-price', camp.Precio)
            campa.setAttribute('data-paid', '0')
            campa.setAttribute('data-input', '0')
            campa.setAttribute('data-tipo-input', '')
            campa.setAttribute('data-id', camp.internalId)
            campa.dataset.ramas = camp.Ramas || 'ALL';
            campa.dataset.paidByCurrency = '{}';
            campa.dataset.valoresMoneda = JSON.stringify(camp.ValoresPorMoneda || {});

            const leyenda = document.createElement('div');
            leyenda.classList.add('leyenda');

            const p = document.createElement('p');
            p.textContent = camp.Nombre;

            leyenda.appendChild(p);
            campa.appendChild(leyenda);
            lista_campas_cobros.appendChild(campa);

        });

        const newPanelCobro = panel_cobros.cloneNode(true); // true = clona hijos también
        panel_cobros.parentNode.replaceChild(newPanelCobro, panel_cobros);

        const panelCobros = document.querySelector("section.panel_cobros");
        const inputsCobros = panelCobros.querySelectorAll('input[type="text"]:not(#valor_total_cobros)');

        completePanelCobros(members);
        completeCobrosDetail(members);
        dynamicPanelCobros();
        resetPanelCobrosInputs(panelCobros,inputsCobros,members);

    }
}

function refreshCampsListCaja(camps){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const filtro_campa = panel_caja.querySelector('.contenido_filtros .filtro_campa, .contenido_filtros .flitro_campa');
        const select_filtro = filtro_campa.querySelector('.select_filtro');

        select_filtro.innerHTML = '';

        const allOption = document.createElement('div');
        allOption.id = 'ALL';
        allOption.classList.add('opciones_campa', 'all');
        allOption.textContent = 'Todos';
        select_filtro.appendChild(allOption);

        // Ordenar evetnos por fecha de alta
        const campasOrdenados = Object.values(camps).sort((a, b) => {
            const fechaA = quitarAcentos(a.FechaAlta.toLowerCase());
            const fechaB = quitarAcentos(b.FechaAlta.toLowerCase());
            return fechaA.localeCompare(fechaB, 'es', { sensitivity: 'base' });
        });

        campasOrdenados.forEach(camp => {
            const option = document.createElement('div');
            option.id = 'campa_' + camp.internalId;
            option.classList.add('opciones_campa');
            option.textContent = camp.Nombre;
            select_filtro.appendChild(option);
        });

        activeCajaEventOptions();
        const filtro_caja_diaria = panel_caja.querySelector('.contenido_filtros .filtro_caja_diaria input');
        filtro_caja_diaria.dispatchEvent(new Event('change'));
    }
}

// MONTOS GENERALES
async function refreshGeneralAmounts(){
    const genAmounts = await getGeneralAmountsDicFromAPI();
    const members = await getMembersCobrosDicFromAPI();
    refreshGeneralAmountsListCobros(genAmounts,members);
    refreshGeneralAmountsListCaja(genAmounts);
}

async function getGeneralAmountsDicFromAPI(){
    try {
        const response = await fetch('/api/getGeneralAmountsDicFromAPI.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();
        if (data['response'] == 200) {
            return data['data'];
        } else {
            console.error('Error en la solicitud:', data['error']);
            // if (Object.keys(data['error']).length === 0) {
            //     console.log('Error al Obtener Montos Generales');
            // } else {
            //     console.log(data['error']);
            // }
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

function refreshGeneralAmountsListCobros(genAmounts,members){
    const panel_cobros = document.querySelector('section.panel_cobros');
    if(panel_cobros){
        const importes_generales = panel_cobros.querySelector('.importes_generales');

        importes_generales.innerHTML = '';

        // Ordenar montos por fecha de alta
        const generalesOrdenados = Object.values(genAmounts).sort((a, b) => {
            const fechaA = quitarAcentos(a.FechaAlta.toLowerCase());
            const fechaB = quitarAcentos(b.FechaAlta.toLowerCase());
            return fechaA.localeCompare(fechaB, 'es', { sensitivity: 'base' });
        });

        generalesOrdenados.forEach(gen => {
            const impGral = document.createElement('div');
            impGral.classList.add('imp_gral');
            impGral.setAttribute('data-id', gen.internalId);

            // .valor_general
            const valorGeneral = document.createElement('div');
            valorGeneral.classList.add('valor_general');
            const pValorActual = document.createElement('p');
            pValorActual.textContent = '$0';
            valorGeneral.appendChild(pValorActual);

            // input
            const input = document.createElement('input');
            input.setAttribute('type', 'text');
            input.setAttribute('data-type', 'general');
            input.setAttribute('name', gen.Nombre);
            input.setAttribute('id', 'importe_general_' + gen.internalId);
            input.setAttribute('value', '$ 0');

            // .leyenda
            const leyenda = document.createElement('div');
            leyenda.classList.add('leyenda');
            leyenda.setAttribute('title', gen.Nombre);
            const pLeyenda = document.createElement('p');
            pLeyenda.textContent = gen.Nombre;
            pLeyenda.setAttribute('title', gen.Nombre);
            leyenda.appendChild(pLeyenda);

            // .leyenda_valor
            const leyendaValor = document.createElement('div');
            leyendaValor.classList.add('leyenda_valor');
            const pLeyendaValor = document.createElement('p');
            const precioFormateado = formatCurrency(String(gen.Precio),false,false);
            pLeyendaValor.textContent = precioFormateado;
            leyendaValor.appendChild(pLeyendaValor);

            // Armar todo el bloque .imp_gral
            impGral.appendChild(valorGeneral);
            impGral.appendChild(input);
            impGral.appendChild(leyenda);
            impGral.appendChild(leyendaValor);

            importes_generales.appendChild(impGral);

        });

        const newPanelCobro = panel_cobros.cloneNode(true); // true = clona hijos también
        panel_cobros.parentNode.replaceChild(newPanelCobro, panel_cobros);

        const panelCobros = document.querySelector("section.panel_cobros");
        const inputsCobros = panelCobros.querySelectorAll('input[type="text"]:not(#valor_total_cobros)');

        completePanelCobros(members);
        completeCobrosDetail(members);
        dynamicPanelCobros();
        syncCobrosGeneralLegendOverflowMarquee(newPanelCobro);
        resetPanelCobrosInputs(panelCobros,inputsCobros,members);

    }
}

function refreshGeneralAmountsListCaja(genAmounts){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const filtro_general = panel_caja.querySelector('.contenido_filtros .filtro_general');
        const select_filtro = filtro_general.querySelector('.select_filtro');

        select_filtro.innerHTML = '';

        const allOption = document.createElement('div');
        allOption.id = 'ALL';
        allOption.classList.add('opciones_general', 'all');
        allOption.textContent = 'Todos';
        select_filtro.appendChild(allOption);

        // Ordenar Montos por fecha de alta
        const generalesOrdenados = Object.values(genAmounts).sort((a, b) => {
            const fechaA = quitarAcentos(a.FechaAlta.toLowerCase());
            const fechaB = quitarAcentos(b.FechaAlta.toLowerCase());
            return fechaA.localeCompare(fechaB, 'es', { sensitivity: 'base' });
        });

        generalesOrdenados.forEach(gen => {
            const option = document.createElement('div');
            option.id = 'general_' + gen.internalId;
            option.classList.add('opciones_general');
            option.textContent = gen.Nombre;
            select_filtro.appendChild(option);
        });

        activeCajaGeneralOptions();
        const filtro_caja_diaria = panel_caja.querySelector('.contenido_filtros .filtro_caja_diaria input');
        filtro_caja_diaria.dispatchEvent(new Event('change'));
    }
}

// CUOTA
function refreshCuotaAmount(amount){
    const panel_cobros = document.querySelector('section.panel_cobros');
    if(panel_cobros){
        const valor_cuota = document.querySelector('.info_cuotas .valor_cuota');
        valor_cuota.textContent = formatCurrency(String(amount),false,false);
    }
}

// CATEGORIA PAGOS
function refreshCatPagosInPanel(categ,intId,action='create',icono='tag-2'){
    const panel_pagos = document.querySelector('.panel_pagos');
    if(panel_pagos){
        const cont_categorias = panel_pagos.querySelector('.cont_categorias');
        const agregar_categ = panel_pagos.querySelector('.categorias.agregar');

        if(action == 'create'){
            const category = document.createElement('DIV');
            const dot = document.createElement('DIV');
            const dotIcon = document.createElement('I');
            const tile = document.createElement('DIV');
            const nombre = document.createElement('P');
            const valor = document.createElement('P');

            category.classList.add('categorias');
            category.title = categ;
            category.setAttribute('data-id',intId);
            category.setAttribute('data-icono',icono);

            dot.classList.add('valor_dot');
            dot.setAttribute('aria-hidden','true');
            dotIcon.classList.add('fa-solid','fa-check');
            dot.appendChild(dotIcon);

            tile.classList.add('tile_icon');
            tile.setAttribute('aria-hidden','true');
            tile.innerHTML = buildIconsaxSvgMarkup(icono);

            nombre.classList.add('nombre');
            valor.classList.add('valor');
            nombre.textContent = categ;
            valor.textContent = '$ 0'

            category.appendChild(dot);
            category.appendChild(tile);
            category.appendChild(nombre);
            category.appendChild(valor);

            cont_categorias.insertBefore(category, agregar_categ);

            const newPanelPagos = panel_pagos.cloneNode(true); // true = clona hijos también
            panel_pagos.parentNode.replaceChild(newPanelPagos, panel_pagos);

            completePagosDetail(false,true);
        }else if(action == 'delete'){
            const category = cont_categorias.querySelector(`.categorias[data-id="${intId}"]`);
            if(category){
                category.remove();
            }
            syncPagoCategoryNameOverflowMarquee(panel_pagos);
            updateCategMeta();
            applyCategoryFilters();
        }else if(action == 'update'){
            const category = cont_categorias.querySelector(`.categorias[data-id="${intId}"]`);
            if (category){
                const nombre = category.querySelector(`.nombre`);
                category.title = categ;
                nombre.textContent = categ;
                syncPagoCategoryNameOverflowMarquee(panel_pagos);
            }
            updateCategMeta();
            applyCategoryFilters();
        }
    }
}

function escapeReceiptTooltipText(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

function refreshCatPagosInConfig(categ,intId,icono='tag-2'){
    const cont_categ = document.querySelector(".contenido_categorias");
    if(cont_categ){
        const agregar_categ = cont_categ.querySelector(".agregar_categ");

        newCateg = createNewCategory(true);
        completeCategory(newCateg,categ,intId,icono)
        cont_categ.insertBefore(newCateg, agregar_categ);
        syncCategoryRows(cont_categ);


        function completeCategory(categ,nombre,intId,icono){
            const nombreInput = categ.querySelector(".nombre_categ input");
            const accionesCateg = categ.querySelector(".acciones_categ");
            const confirmCateg = categ.querySelector(".confirmar_categ");
            const anularCreacion = categ.querySelector(".anular_creacion");
            const tile = categ.querySelector(".tile_icon");

            creation = false;
            categ.setAttribute('data-id', intId);
            categ.setAttribute('data-icono', icono);
            if(tile){
                tile.innerHTML = buildIconsaxSvgMarkup(icono);
            }
            applyCategoryTileColor(categ);

            nombreInput.value = nombre;
            nombreInput.readOnly = true;
            nombreInput.name = `nombre_${intId}`;
            nombreInput.id = `nombre_${intId}`;

            confirmCateg.remove();
            anularCreacion.remove();

            const editar = document.createElement('div');
            editar.className = 'campo editar_categ';
            editar.title = 'Editar Categoria';
            editar.innerHTML = `<i class="fa-solid fa-square-pen fa-xl" style="color: #0071bc;"></i>`;

            const eliminar = document.createElement('div');
            eliminar.className = 'campo eliminar_categ';
            eliminar.title = 'Eliminar Categoria';
            eliminar.innerHTML = `<i class="fa-solid fa-square-xmark fa-xl" style="color: #ad272d;"></i>`;

            accionesCateg.appendChild(editar);
            accionesCateg.appendChild(eliminar);

            activeCategoryAction(categ);
            syncCategoryNameOverflowMarquee(categ);
        }
    }
}

function refreshCatPagosListCaja(categ,intId,action='create'){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const filtro_general = panel_caja.querySelector('.contenido_filtros .filtro_categoria');
        const select_filtro = filtro_general.querySelector('.select_filtro');

        if(action == 'create'){            
            const option = document.createElement('div');
            option.id = 'category_' + intId;
            option.classList.add('opciones_categoria');
            option.textContent = categ;
            select_filtro.appendChild(option);
    
    
            const newSelect = select_filtro.cloneNode(true); // true = clona hijos también
            select_filtro.parentNode.replaceChild(newSelect, select_filtro);
    
            activeCajaCategOptions();
            const filtro_caja_diaria = panel_caja.querySelector('.contenido_filtros .filtro_caja_diaria input');
            filtro_caja_diaria.dispatchEvent(new Event('change'));

        }else if(action == 'delete'){
            const category = select_filtro.querySelector(`#category_${intId}`);
            if(category){
                category.remove();
            }

        }else if(action == 'update'){
            const category = select_filtro.querySelector(`#category_${intId}`);
            if (category){
                category.textContent = categ;
            }
        }
    }
}

// FIRMANTES
async function refreshSignatories(){
    const signatories = await getSignatoriesDicFromAPI();
    refreshSignatoriesCobros(signatories);
    refreshSignatoriesPagos(signatories);
    refreshSignatoriesListCaja(signatories);
}

async function getSignatoriesDicFromAPI(){
    try {
        const response = await fetch('/api/getSignatoriesDicFromAPI.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();
        if (data['response'] == 200) {
            return data['data'];
        } else {
            console.error('Error en la solicitud:', data['error']);
            // if (Object.keys(data['error']).length === 0) {
            //     console.log('Error al Obtener Firmantes');
            // } else {
            //     console.log(data['error']);
            // }
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

function refreshSignatoriesCobros(signatories){
    const panel_cobros = document.querySelector('section.panel_cobros');
    if (panel_cobros) {
        const select_signatory = panel_cobros.querySelector('#firmante_cobro');
        const valorSeleccionado = select_signatory.value;

        select_signatory.innerHTML = '<option value="">Seleccionar firmante</option>';

        const signatoriesOrdenadas = Object.values(signatories).sort((a, b) => {
            const ordenA = quitarAcentos(a.Orden.toLowerCase());
            const ordenB = quitarAcentos(b.Orden.toLowerCase());
            return ordenA.localeCompare(ordenB, 'es', { sensitivity: 'base' });
        });

        signatoriesOrdenadas.forEach(signa => {
            const signatory = document.createElement('OPTION');
            signatory.classList.add('firmante');
            signatory.value = signa.internalId;
            signatory.textContent = signa.Nombre;

            if (signa.internalId == valorSeleccionado) {
                signatory.selected = true;
            }

            select_signatory.appendChild(signatory);
        });

        select_signatory.dispatchEvent(new Event('change'));
    }

}

function refreshSignatoriesPagos(signatories){
    const panel_pagos = document.querySelector('.panel_pagos');
    if (panel_pagos) {
        const select_signatory = panel_pagos.querySelector('#firmante_pago');
        const valorSeleccionado = select_signatory.value;

        select_signatory.innerHTML = '<option value="">Seleccionar firmante</option>';

        const signatoriesOrdenadas = Object.values(signatories).sort((a, b) => {
            const ordenA = quitarAcentos(a.Orden.toLowerCase());
            const ordenB = quitarAcentos(b.Orden.toLowerCase());
            return ordenA.localeCompare(ordenB, 'es', { sensitivity: 'base' });
        });

        signatoriesOrdenadas.forEach(signa => {
            const signatory = document.createElement('OPTION');
            signatory.classList.add('firmante');
            signatory.value = signa.internalId;
            signatory.textContent = signa.Nombre;

            if (signa.internalId == valorSeleccionado) {
                signatory.selected = true;
            }

            select_signatory.appendChild(signatory);
        });

        select_signatory.dispatchEvent(new Event('change'));
    }

}

function refreshSignatoriesListCaja(signatories){
    const form_cierre_caja = document.querySelector('.form_cierre_caja');
    if (form_cierre_caja) {
        const select_signatory = form_cierre_caja.querySelector('#firma_cierre');
        const valorSeleccionado = select_signatory.value;

        select_signatory.innerHTML = '';

        const signatoriesOrdenadas = Object.values(signatories).sort((a, b) => {
            const ordenA = quitarAcentos(a.Orden.toLowerCase());
            const ordenB = quitarAcentos(b.Orden.toLowerCase());
            return ordenA.localeCompare(ordenB, 'es', { sensitivity: 'base' });
        });

        signatoriesOrdenadas.forEach(signa => {
            const signatory = document.createElement('OPTION');
            signatory.classList.add('firmante');
            signatory.value = signa.internalId;
            signatory.textContent = signa.Nombre;

            if (signa.internalId == valorSeleccionado) {
                signatory.selected = true;
            }

            select_signatory.appendChild(signatory);
        });

        select_signatory.dispatchEvent(new Event('change'));
    }

}

// UNIDADES 
async function refreshRamas(){

    const ramas = await getRamasDicFromAPI();
    refreshRamasInListCaja(ramas);
    refreshRamasInMembersPanel(ramas);
    refreshRamasInMembersForm(ramas);
    refreshRamasInCampasPanel(ramas);
    refreshRamasInCampasForm(ramas);
    refreshRamasInEventosPanel(ramas);
    refreshRamasInEventosForm(ramas);
}

async function getRamasDicFromAPI(){
    try {
        const response = await fetch('/api/getRamasDicFromAPI.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();
        if (data['response'] == 200) {
            return data['data'];
        } else {
            console.error('Error en la solicitud:', data['error']);
            // if (Object.keys(data['error']).length === 0) {
            //     console.log('Error al Obtener Unidades');
            // } else {
            //     console.log(data['error']);
            // }
            return {};
        }
    } catch (error) {
        console.error(error);
        return {};
    }
}

function refreshRamasInListCaja(ramas){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const filtro_general = panel_caja.querySelector('.contenido_filtros .filtro_unidad');
        const select_filtro = filtro_general.querySelector('.select_filtro');

        select_filtro.innerHTML = '';

        const allOption = document.createElement('div');
        allOption.id = 'ALL';
        allOption.classList.add('opciones_rama', 'all');
        allOption.textContent = 'Todos';
        select_filtro.appendChild(allOption);

        const ramasOrdenadas = Object.values(ramas).sort((a, b) => {
            const indA = quitarAcentos(String(a.IndRama).toLowerCase());
            const indB = quitarAcentos(String(b.IndRama).toLowerCase());
            return indA.localeCompare(indB, 'es', { sensitivity: 'base' });
        });

        ramasOrdenadas.forEach(ram => {
            const option = document.createElement('div');
            option.id = ram.CodRama;
            option.classList.add('opciones_rama');
            option.textContent = ram.Nombre;
            select_filtro.appendChild(option);
        });

        activeCajaRamaOptions();
        const filtro_caja_diaria = panel_caja.querySelector('.contenido_filtros .filtro_caja_diaria input');
        filtro_caja_diaria.dispatchEvent(new Event('change'));
    }
}

function refreshRamasInMembersPanel(ramas){
    const configMembers = document.querySelector('.panel_config.config_miembros')

    if(configMembers){
        const selectRama = configMembers.querySelectorAll('.campo.campo_rama select');

        const ramasOrdenadas = Object.values(ramas).sort((a, b) => {
            const indA = quitarAcentos(String(a.IndRama).toLowerCase());
            const indB = quitarAcentos(String(b.IndRama).toLowerCase());
            return indA.localeCompare(indB, 'es', { sensitivity: 'base' });
        });

        selectRama.forEach(select => {
            const valorSeleccionado = select.value;
    
            select.innerHTML = '';
            ramasOrdenadas.forEach(rama => {
                const optRama = document.createElement('OPTION');
                const codRama = rama.CodRama.split('-')[1]; 
                optRama.value = codRama;
                optRama.textContent = rama.Nombre;

                if (codRama == valorSeleccionado) {
                    optRama.selected = true;
                }
    
                select.appendChild(optRama);
            });

        })

    }
}

function refreshRamasInMembersForm(ramas){
    const formMiembros = document.querySelectorAll('.form_miembro_indv:not(.delete)')

    if(formMiembros.length > 0){

        const ramasOrdenadas = Object.values(ramas).sort((a, b) => {
            const indA = quitarAcentos(String(a.IndRama).toLowerCase());
            const indB = quitarAcentos(String(b.IndRama).toLowerCase());
            return indA.localeCompare(indB, 'es', { sensitivity: 'base' });
        });

        formMiembros.forEach(form => {
            const selectRama = form.querySelector('.campo.rama select')
            selectRama.innerHTML = '';

            const defRama = document.createElement('OPTION');
            defRama.value = 0;
            defRama.textContent = '--Seleccione--';
            defRama.disabled = true;
            defRama.selected = true;
            selectRama.appendChild(defRama);

            ramasOrdenadas.forEach(rama => {
                const optRama = document.createElement('OPTION');
                const codRama = rama.CodRama.split('-')[1]; 
                optRama.value = codRama;
                optRama.textContent = rama.Nombre;
    
                selectRama.appendChild(optRama);
            });
            selectRama.dispatchEvent(new Event('change'));
        })

    }
}

function refreshRamasInCampasPanel(ramas){
    const configCampas = document.querySelector('.panel_config.config_campas')

    if(configCampas){
        const selectRama = configCampas.querySelector('.select_rama.opcion_ramas');
        if(!selectRama){
            return;
        }

        const ramasOrdenadas = Object.values(ramas).sort((a, b) => {
            const indA = quitarAcentos(String(a.IndRama).toLowerCase());
            const indB = quitarAcentos(String(b.IndRama).toLowerCase());
            return indA.localeCompare(indB, 'es', { sensitivity: 'base' });
        });

        const activeOptions = [];
        selectRama.querySelectorAll('.opciones_rama.active').forEach(option =>{
            activeOptions.push(option.id);
        })

        selectRama.innerHTML = '';

        const defRama = document.createElement('DIV');
        defRama.classList.add('opciones_rama', 'all');
        defRama.id = 'ALL';
        defRama.textContent = 'Todos';
        selectRama.appendChild(defRama);

        ramasOrdenadas.forEach(rama => {
            const optRama = document.createElement('DIV');
            const codRama = rama.CodRama.split('-')[1]; 
            optRama.classList.add('opciones_rama');
            optRama.id = codRama;
            optRama.textContent = rama.Nombre;

            selectRama.appendChild(optRama);
        });

        activeCampRamaOptions();

        activeOptions.forEach(opt => {
            const option = selectRama.querySelector(`#${opt}`);

            if(option){
                option.click();
            }
        })
    }
}

function refreshRamasInCampasForm(ramas){
    const formCampa = document.querySelectorAll('.form_campa_indv:not(.delete)')

    if(formCampa.length > 0){

        const ramasOrdenadas = Object.values(ramas).sort((a, b) => {
            const indA = quitarAcentos(String(a.IndRama).toLowerCase());
            const indB = quitarAcentos(String(b.IndRama).toLowerCase());
            return indA.localeCompare(indB, 'es', { sensitivity: 'base' });
        });

        formCampa.forEach(form => {

            const selectRama = form.querySelector('.campo.rama .select_rama');

            selectRama.innerHTML = '';

            const defRama = document.createElement('DIV');
            defRama.classList.add('opciones_rama', 'all');
            defRama.id = 'ALL';
            defRama.textContent = 'Todos';
            selectRama.appendChild(defRama);

            ramasOrdenadas.forEach(rama => {
                const optRama = document.createElement('DIV');
                const codRama = rama.CodRama.split('-')[1]; 
                optRama.classList.add('opciones_rama');
                optRama.id = codRama;
                optRama.textContent = rama.Nombre;

                selectRama.appendChild(optRama);
            });

            activeCampRamaOptions(form);

        })

    }
}

function refreshRamasInEventosPanel(ramas){
    const configEventos = document.querySelector('.panel_config.config_eventos')

    if(configEventos){
        const selectRama = configEventos.querySelector('.select_rama.opcion_ramas');
        if(!selectRama){
            return;
        }

        const ramasOrdenadas = Object.values(ramas).sort((a, b) => {
            const indA = quitarAcentos(String(a.IndRama).toLowerCase());
            const indB = quitarAcentos(String(b.IndRama).toLowerCase());
            return indA.localeCompare(indB, 'es', { sensitivity: 'base' });
        });

        const activeOptions = [];
        selectRama.querySelectorAll('.opciones_rama.active').forEach(option =>{
            activeOptions.push(option.id);
        })

        selectRama.innerHTML = '';

        const defRama = document.createElement('DIV');
        defRama.classList.add('opciones_rama', 'all');
        defRama.id = 'ALL';
        defRama.textContent = 'Todos';
        selectRama.appendChild(defRama);

        ramasOrdenadas.forEach(rama => {
            const optRama = document.createElement('DIV');
            const codRama = rama.CodRama.split('-')[1]; 
            optRama.classList.add('opciones_rama');
            optRama.id = codRama;
            optRama.textContent = rama.Nombre;

            selectRama.appendChild(optRama);
        });

        activeEventRamaOptions();

        activeOptions.forEach(opt => {
            const option = selectRama.querySelector(`#${opt}`);

            if(option){
                option.click();
            }
        })
    }
}

function refreshRamasInEventosForm(ramas){
    const formEvento = document.querySelectorAll('.form_evento_indv:not(.delete)')

    if(formEvento.length > 0){

        const ramasOrdenadas = Object.values(ramas).sort((a, b) => {
            const indA = quitarAcentos(String(a.IndRama).toLowerCase());
            const indB = quitarAcentos(String(b.IndRama).toLowerCase());
            return indA.localeCompare(indB, 'es', { sensitivity: 'base' });
        });

        formEvento.forEach(form => {

            const selectRama = form.querySelector('.campo.rama .select_rama');

            selectRama.innerHTML = '';

            const defRama = document.createElement('DIV');
            defRama.classList.add('opciones_rama', 'all');
            defRama.id = 'ALL';
            defRama.textContent = 'Todos';
            selectRama.appendChild(defRama);

            ramasOrdenadas.forEach(rama => {
                const optRama = document.createElement('DIV');
                const codRama = rama.CodRama.split('-')[1]; 
                optRama.classList.add('opciones_rama');
                optRama.id = codRama;
                optRama.textContent = rama.Nombre;

                selectRama.appendChild(optRama);
            });

            activeEventRamaOptions(form);

        })

    }
}

// COMPROBANTES Y CAJA
function refreshReceiptReport(){
    const panel_caja = document.querySelector('.panel_cajadiaria');
    if(panel_caja){
        const cont_filtros = panel_caja.querySelector('.contenido_filtros');
        const btn_aplicar = cont_filtros.querySelector('.aplicar_filtros .btn_submit');
        if (btn_aplicar){
            btn_aplicar.click();
        }
    }
}

function refreshReceiptTableList(){
    const panel_recibos = document.querySelector('.panel_config .config_recibos');
    if(panel_recibos){
        const select_period = panel_recibos.querySelector('.selector_mes_recibo select');

        select_period.dispatchEvent(new Event('change'));
    }
}

function refreshZClosureTableList(){
    const panel_cierre = document.querySelector('.panel_config .config_cierres');
    if(panel_cierre){
        const select_period = panel_cierre.querySelector('.selector_mes_cierre select');

        select_period.dispatchEvent(new Event('change'));
    }
}

// HEADER
function refreshHeaderUserName(idorg,name){

    const headerLogin = document.querySelector('.header .cont_header .cont_login');
    if(headerLogin){
        const userName = headerLogin.querySelector('h4');

        userName.textContent = idorg + ' - ' + name;
    }
}

// FIN REFRESHS

const ALERT_TYPES = {
    error: 'error',
    success: 'success',
    warning: 'warning',
    info: 'info'
};

const ALERT_DEFAULT_TYPE = ALERT_TYPES.error;
const ALERT_DEFAULT_MESSAGE = 'Algo Salio Mal';
const ALERT_DURATION = 3000;
const ALERT_EXIT_DURATION = 450;

function normalizeAlertType(type) {
    return Object.prototype.hasOwnProperty.call(ALERT_TYPES, type) ? ALERT_TYPES[type] : ALERT_DEFAULT_TYPE;
}

function getAlertIcon() {
    return `
        <svg
            class="alertMsg__icon"
            stroke="currentColor"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                d="M13 16h-1v-4h1m0-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                stroke-width="2"
                stroke-linejoin="round"
                stroke-linecap="round"
            ></path>
        </svg>
    `;
}

function setAlertContent(alerta,msg) {
    alerta.setAttribute('role', 'alert');
    alerta.innerHTML = getAlertIcon();

    const text = document.createElement('p');
    text.classList.add('alertMsg__text');
    text.textContent = msg;
    alerta.appendChild(text);
}

function getNextReceiptNr(receipt) {
    const panelCobros = document.querySelector("section.panel_cobros");
    const num_receipt_cobro = panelCobros.querySelector('.numero_recibo .num_recibo');
    const panelPagos = document.querySelector("section.panel_pagos");
    const num_receipt_pago = panelPagos.querySelector('.numero_recibo .num_recibo');

    let partes = receipt.replace('Nº', '').trim().split('-');
    let prefijo = partes[0];               // '0074'
    let tipoYNumero = partes[1];           // 'P00000000000007' o 'C00000000000007'

    let tipo = tipoYNumero.charAt(0);      // 'P' o 'C'
    let numero = tipoYNumero.slice(1);     // '00000000000007'

    let numeroNuevo = (parseInt(numero, 10) + 1).toString().padStart(14, '0');
    let nuevoTexto = `Nº ${prefijo}-${tipo}${numeroNuevo}`;

    num_receipt_cobro.textContent = nuevoTexto.replace('P', 'C');
    num_receipt_pago.textContent = nuevoTexto.replace('C', 'P');
}     

function showConfirmPopup({title, message, confirmText = 'Confirmar', cancelText = 'Cancelar'} = {}) {
    return new Promise((resolve) => {
        const previousPopup = document.querySelector('.confirm_popup_overlay');
        if(previousPopup){
            previousPopup.remove();
        }

        const overlay = document.createElement('div');
        overlay.className = 'confirm_popup_overlay';

        const popup = document.createElement('div');
        popup.className = 'confirm_popup';
        popup.setAttribute('role', 'dialog');
        popup.setAttribute('aria-modal', 'true');

        const titleElement = document.createElement('p');
        titleElement.className = 'confirm_popup__title';
        titleElement.textContent = title || 'Confirmar accion';

        const messageElement = document.createElement('p');
        messageElement.className = 'confirm_popup__message';
        messageElement.textContent = message || 'Queres confirmar esta modificacion?';

        const actions = document.createElement('div');
        actions.className = 'confirm_popup__actions';

        const cancelButton = document.createElement('button');
        cancelButton.type = 'button';
        cancelButton.className = 'confirm_popup__button confirm_popup__button--cancel';
        cancelButton.innerHTML = `
            <span class="btn_text">${cancelText}</span>
            <div class="boton_individual"><i class="fa-solid fa-xmark"></i></div>
        `;

        const confirmButton = document.createElement('button');
        confirmButton.type = 'button';
        confirmButton.className = 'confirm_popup__button confirm_popup__button--confirm';
        confirmButton.innerHTML = `
            <span class="btn_text">${confirmText}</span>
            <div class="boton_individual"><i class="fa-solid fa-check"></i></div>
        `;

        const close = (confirmed) => {
            overlay.remove();
            document.removeEventListener('keydown', onKeydown);
            resolve(confirmed);
        };

        const onKeydown = (event) => {
            if(event.key === 'Escape'){
                close(false);
            }
        };

        cancelButton.addEventListener('click', () => close(false));
        confirmButton.addEventListener('click', () => close(true));
        overlay.addEventListener('click', (event) => {
            if(event.target === overlay){
                close(false);
            }
        });
        document.addEventListener('keydown', onKeydown);

        actions.appendChild(cancelButton);
        actions.appendChild(confirmButton);
        popup.appendChild(titleElement);
        popup.appendChild(messageElement);
        popup.appendChild(actions);
        overlay.appendChild(popup);
        document.body.appendChild(overlay);
        confirmButton.focus();
    });
}

function showAlert(type = ALERT_DEFAULT_TYPE,msg=ALERT_DEFAULT_MESSAGE) {
    let alerta = document.querySelector(".alertMsg.default");
    if(!alerta){
        return;
    }

    const alertType = normalizeAlertType(type);
    alerta.className = ''; // Se le elimina por si ya tuvo otro estilo
    alerta.classList.add('alertMsg','default'); // Se le vuelven a agregar los basicos

    alerta.style.display = "flex";
    alerta.style.opacity = "1";
    alerta.classList.add(alertType, 'alertMsg--show');
    setAlertContent(alerta,msg);

    setTimeout(() => {
        alerta.classList.remove('alertMsg--show');
        alerta.classList.add('alertMsg--hide');
        setTimeout(() => {
            alerta.style.display = "none";
            alerta.classList.remove('alertMsg--hide');
        }, ALERT_EXIT_DURATION);
    }, ALERT_DURATION); // El mensaje dura 3 segundos antes de desaparecer
    
}

function showFormAlert(type = ALERT_DEFAULT_TYPE) {
    let alertas = document.querySelectorAll(".alertMsg.form");
    const alertType = normalizeAlertType(type);
    let top = 0;

    alertas.forEach((alerta)=>{
        const msg = alerta.textContent;

        alerta.className = ''; // Se le elimina por si ya tuvo otro estilo
        alerta.classList.add('alertMsg','default'); // Se le vuelven a agregar los basicos
    
        alerta.style.display = "flex";
        alerta.style.opacity = "1";
        if(top > 0){
            alerta.style.top = top + 'rem';
        }
        top += 6
        alerta.classList.add(alertType, 'alertMsg--show');
        setAlertContent(alerta,msg);
    
        setTimeout(() => {
            alerta.classList.remove('alertMsg--show');
            alerta.classList.add('alertMsg--hide');
            setTimeout(() => {
                alerta.style.display = "none";
                alerta.classList.remove('alertMsg--hide');
            }, ALERT_EXIT_DURATION);
        }, ALERT_DURATION); // El mensaje dura 3 segundos antes de desaparecer
    })

}

function capitalizar(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function quitarAcentos(cadena){
	const acentos = {'á':'a','é':'e','í':'i','ó':'o','ú':'u','Á':'A','É':'E','Í':'I','Ó':'O','Ú':'U'};

    cadena = cadena.trim().replace(/,/g, '');

	return cadena.split('').map( letra => acentos[letra] || letra).join('').toString();	
}

function parseLocalizedCurrencyValue(value){
    if(value === undefined || value === null){
        return 0;
    }

    let parseValue = String(value).replace(/\s/g, '').replace(/[^0-9,.-]/g, '');

    if (parseValue.includes(',') && parseValue.includes('.')) {
        parseValue = parseValue.replace(/\./g, '').replace(',', '.');
    } else if (parseValue.includes(',')) {
        parseValue = parseValue.replace(',', '.');
    } else if (parseValue.includes('.')) {
        parseValue = parseValue.replace(/\./g, '');
    }

    const parsed = parseFloat(parseValue);

    if(isNaN(parsed)){
        return 0;
    }

    return parsed;
}

function formatCurrencyWithSigne(value,signe='$',input=true,ignoreDecimal=true) {
    let currValue = formatCurrency(String(value),input,ignoreDecimal);
    currValue = currValue.replace('$', signe);

    return currValue;
}

function syncCurrencyInputSigne(input,signe='$') {
    if(!input){return;}

    const parseValue = parseLocalizedCurrencyValue(input.value);
    input.value = formatCurrencyWithSigne(String(parseValue.toFixed(2)),signe,false);
}

// Se usa para valores que solo son positivos
function formatCurrency(value,input=true,ignoreDecimal=true) {
    value = String(value ?? '');

    if(!input){
        if(ignoreDecimal){
            value = String(value);
            value = value.replace('.00', '');
        }
        value = value.replace('.', ',');
    }

    // Permitir solo números y una coma, eliminando caracteres inválidos
    value = value.replace(/[^0-9,]/g, '');

    // Quitar cualquier coma al principio si la hay
    if (value.startsWith(',')) {
        value = value.substring(1);
    }

    // Quitar comas adicionales, dejando solo la primera
    let commaIndex = value.indexOf(',');
    if (commaIndex !== -1) {
        // Mantener la primera coma y eliminar las demás
        value = value.substring(0, commaIndex + 1) + value.substring(commaIndex + 1).replace(/,/g, '');
    }

    // Quitar cualquier punto existente para evitar duplicaciones
    value = value.replace(/\./g, '');

    // Formatear la parte entera del número con puntos como separador de miles
    let parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    if((parts[0][0] == 0) && (parts[0][1] != ',')){
        parts[0] = parts[0].substring(1);  
    }
    if(parts[0] == ''){
        parts[0] = 0;
    }

    // Combinar la parte entera y decimal (si existe)
    formValue = '$ ' + parts.join(',');

    return formValue;
}

function formatCurrencyInteger(value){
    let cleanValue = String(value || '').replace('$', '').trim();
    if(cleanValue.includes(',')){
        cleanValue = cleanValue.split(',')[0];
    }else if(/^-?\d+\.\d{1,2}$/.test(cleanValue)){
        cleanValue = cleanValue.split('.')[0];
    }
    return formatCurrency(cleanValue);
}

// Se usa para valores que solo son positivos
function formatCurrencyToFloat(value){
    return parseFloat(value.replace('$', '').replace(/\./g, '').replace(',', '.'));
}

// Se usa para valores que pueden o no ser negativos
function formatCurrencyNegative(value,input=true,ignoreDecimal=true) {

    if(!input){
        if(ignoreDecimal){
            value = value.replace('.00', '');
        }
        value = value.replace('.', ',');
    }

    negative = false;
    // Detectar negativo al inicio y quitarlo de la cadena
    if (value.startsWith('-')) {
        negative = true;
        value = value.substring(1);
    }

    // Permitir solo números y una coma, eliminando caracteres inválidos
    value = value.replace(/[^0-9,]/g, '');

    // Quitar cualquier coma al principio si la hay
    if (value.startsWith(',')) {
        value = value.substring(1);
    }

    // Quitar comas adicionales, dejando solo la primera
    let commaIndex = value.indexOf(',');
    if (commaIndex !== -1) {
        // Mantener la primera coma y eliminar las demás
        value = value.substring(0, commaIndex + 1) + value.substring(commaIndex + 1).replace(/,/g, '');
    }

    // Quitar cualquier punto existente para evitar duplicaciones
    value = value.replace(/\./g, '');

    // Formatear la parte entera del número con puntos como separador de miles
    let parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    if((parts[0][0] == 0) && (parts[0][1] != ',')){
        parts[0] = parts[0].substring(1);  
    }
    if(parts[0] == ''){
        parts[0] = 0;
    }

    // Combinar la parte entera y decimal (si existe)
    const numberFormatted = parts.join(',');
    const prefix = (negative ? '- $' : '$');
    return prefix + numberFormatted;

}

// Se usa para valores con cambio de signo ($, US$)
function formatCurrencySigne(value,signe='$') {

    currValue = formatCurrencyNegative(value,false,false);
    currValue = currValue.replace('$', signe);

    return currValue
}

// Se usa para valores que pueden o no ser negativos
function formatCurrencyToFloatNegative(value,signe='$'){

    negative = false;
    // Detectar negativo al inicio y quitarlo de la cadena
    if (value.startsWith('-')) {
        negative = true;
        value = value.substring(1);
    }

    parseValue = parseFloat(value.replace(signe, '').replace(/\./g, '').replace(',', '.'));

    if(negative){parseValue = (parseValue * -1)}

    return parseValue
}
